import { useParams } from 'react-router-dom';
import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
import moment from 'moment';
import axios from 'axios';
import { Form, Row, Col, Table,FormControl, Container, InputGroup, Button, Modal } from 'react-bootstrap';
import { Tooltip } from 'reactstrap';
import { MDBIcon } from 'mdb-react-ui-kit';
import { toast } from 'react-toastify';
import apiService from '../../services/api.services';
import approvedStamp from '../../images/approvedStamp.png';
import '../../css/entcsform.css';
import '../../index.css';
import Navbar from '../common/Navbar';
import Select, { components } from 'react-select';
import Swal from 'sweetalert2';
import { jwtDecode as jwt_decode } from 'jwt-decode';

const CostSheetEntForm = () => {

  const { encParam } = useParams();
  // const token = decodeURIComponent(encParam);
  // const decoded = jwt_decode(String(token));
  // const series = decoded.series;
  const { series } = useParams();


  const [formReopenCount, setformReopenCount] = useState();
  const [userName, setuserName] = useState('');
  const [userId, setuserId] = useState('');
  const [userRole, setuserRole] = useState('');
  const [status, setStatus] = useState('');
  const [crmData, setcrmData] = useState([]);
  const [allFunctionalHeadList, setAllFunctionalHeadList] = useState([]);
  
  const [searchTerm, setSearchTerm] = useState('');
  const [showDropdown, setShowDropdown] = useState(false);
  const [customerName, setcustomerName] = useState('');
  const [sendForAppv, setSendForAppv] = useState('')
  const [salesPersonName, setsalesPersonName] = useState('');
  const [salesPersonID, setsalesPersonID] = useState('');
  const [panNumber, setpanNumber] = useState('');
  const [approvalRequestDate, setapprovalRequestDate] = useState(moment().format('dddd, DD MMMM, YYYY'));
  const [sendForAppvReqDate, setSendForAppvReqDate] = useState('');
  const [opportunityName, setopportunityName] = useState('');
  const [vendorBillingCycle, setvendorBillingCycle] = useState('');
  const [transactionCurrency, settransactionCurrency] = useState('');
  const [secondaryOptions, setSecondaryOptions] = useState([]);
  const [secondaryTransactionCurrency, setsecondaryTransactionCurrency] = useState('');  
  const [vendorPaymentTerms, setvendorPaymentTerms] = useState('');
  const [customerPaymentTerms, setcustomerPaymentTerms] = useState('');
  const [hitachiRoleinthisDeal, sethitachiRoleinthisDeal] = useState('');
  const [materialDeliveryDate, setMaterialDeliveryDate] = useState('');
  const [lowMarginReason, setLowMarginReason] = useState('');
  const [rebateAmountIfAny, setrebateAmountIfAny] = useState('');
  const [confirmRebate, setConfirmRebate] = useState('');
  const [conversionRate, setconversionRate] = useState();
  const [dealType, setDealType] = useState('');
  const [dirtyFCTable, setDirtyFCTable] = useState(false);
  // ✅ True only once apiService.getFinancialTable has actually resolved and
  // rows contains REAL amounts (or has confirmed there's none yet for a brand
  // new record). Every payment-term calculation/save that divides by a row's
  // transfer price / selling value must check this first — otherwise it can
  // divide by the placeholder "0" that rows starts with, producing 0 values,
  // Infinity/NaN percentages, and Invalid Date fields that then get saved.
  const [financialTableLoaded, setFinancialTableLoaded] = useState(false);

  const [remarksIfAny, setremarksIfAny] = useState('');
  const [expectedDtCustomerRecipt, setexpectedDtCustomerRecipt] = useState(''); 
  const [expectedDtVendorPayment, setexpectedDtVendorPayment] = useState('');  

  const [cashFlowExpertAdvice, setcashFlowExpertAdvice] = useState('');
  const [marginExpertAdvice, setmarginExpertAdvice] = useState('');

  const [file1, setFile1] = useState(null);
  const [fileName1, setFileName1] = useState('No File Selected');
  const [file1url, setFile1url] = useState('')
  const [file2, setFile2] = useState(null);
  const [fileName2, setFileName2] = useState('No File Selected');
  const [file2url, setFile2url] = useState('')
  const [file3, setFile3] = useState(null);
  const [fileName3, setFileName3] = useState('No File Selected');
  const [file3url, setFile3url] = useState('')
  const [file4, setFile4] = useState(null);
  const [fileName4, setFileName4] = useState('No File Selected');
  const [file4url, setFile4url] = useState('')
  const [file5, setFile5] = useState(null);
  const [fileName5, setFileName5] = useState('No File Selected');
  const [file5url, setFile5url] = useState('')
  const [file6, setFile6] = useState(null);
  const [fileName6, setFileName6] = useState('No File Selected');
  const [file6url, setFile6url] = useState('')
  const [file7, setFile7] = useState(null);
  const [fileName7, setFileName7] = useState('No File Selected');
  const [file7url, setFile7url] = useState('')
  const [file8, setFile8] = useState(null);
  const [fileName8, setFileName8] = useState('No File Selected');
  const [file8url, setFile8url] = useState('')
  const [file9, setFile9] = useState(null);
  const [fileName9, setFileName9] = useState('No File Selected');
  const [file9url, setFile9url] = useState('')
  const [file10, setFile10] = useState(null);
  const [fileName10, setFileName10] = useState('No File Selected');
  const [file10url, setFile10url] = useState('')

  const [editingCell, setEditingCell] = useState(null); // tracks { rowId, colIndex }
  const [editingValue, setEditingValue] = useState("");

  const [answer, setAnswer] = useState(null);

  const [appvTeamLeaderId, setAppvTeamLeaderId] = useState('');
  const [appvBranchHeadId, setAppvBranchHeadId] = useState('');
  const [appvRegionBusinessHeadId, setAppvRegionBusinessHeadId] = useState('');
  const [appvBusinessFinanceId, setAppvBusinessFinanceId] = useState('');
  const [appvExportComplianceId, setAppvExportComplianceId] = useState('');
  const [appvCreditInsuranceId, setAppvCreditInsuranceId] = useState('');
  const [appvCEOId, setAppvCEOId] = useState('');
  const [appvCOOId, setAppvCOOId] = useState('');
  const [appvCFOId, setAppvCFOId] = useState('');
  const [appvSVPDirectorId, setAppvSVPDirectorId] = useState('');
  const [appvFunctionalHeadId, setAppvFunctionalHeadId] = useState('');
  const [appvLegalHeadId, setAppvLegalHeadId] = useState('');
  const [appvDytCFOId, setAppvDytCFOId] = useState('');


  const [functionalHead1ID, setFunctionalHead1ID] = useState("");
  const [functionalHead1Name, setFunctionalHead1Name] = useState("");
  const [functionalHead2ID, setFunctionalHead2ID] = useState("");
  const [functionalHead2Name, setFunctionalHead2Name] = useState("");
  const [functionalHead3ID, setFunctionalHead3ID] = useState("");
  const [functionalHead3Name, setFunctionalHead3Name] = useState("");
  const [functionalHead4ID, setFunctionalHead4ID] = useState("");
  const [functionalHead4Name, setFunctionalHead4Name] = useState("");
  const [functionalHead5ID, setFunctionalHead5ID] = useState("");
  const [functionalHead5Name, setFunctionalHead5Name] = useState("");
  const [functionalHead6ID, setFunctionalHead6ID] = useState("");
  const [functionalHead6Name, setFunctionalHead6Name] = useState("");

  const [mgmtappvRegionBusinessHeadID, setMgmtAppvRegionBusinessHeadID] = useState('');
  const [mgmtappvBusinessFinanceID, setMgmtAppvBusinessFinanceID] = useState('');
  const [mgmtappvCEOID, setMgmtAppvCEOID] = useState('');
  const [mgmtappvCOOID, setMgmtAppvCOOID] = useState('');
  const [mgmtappvCFOID, setMgmtAppvCFOID] = useState('');

  const [hoveredRole, setHoveredRole] = useState(null);
  const [response, setResponse] = useState('');
  const [appvTeamLeaderReq, setAppvTeamLeaderReq] = useState('');
  const [appvBranchHeadReq, setAppvBranchHeadReq] = useState('');
  const [appvRegionBusinessHeadReq, setAppvRegionBusinessHeadReq] = useState('');
  const [appvBusinessFinanceReq, setAppvBusinessFinanceReq] = useState('');
  const [appvExportComplianceReq, setAppvExportComplianceReq] = useState('');
  const [appvCreditInsuranceReq, setAppvCreditInsuranceReq] = useState('');
  const [appvCEOReq, setAppvCEOReq] = useState('');
  const [appvCOOReq, setAppvCOOReq] = useState('');
  const [appvCFOReq, setAppvCFOReq] = useState('');
  const [appvSVPDirectorReq, setAppvSVPDirectorReq] = useState('');  
  const [appvlegalHeadReq, setAppvlegalHeadReq] = useState('');
  const [appvDytCFOReq, setAppvDytCFOReq] = useState('');
  const [appvFunctionalHeadReq, setAppvFunctionalHeadReq] = useState('');
  const [appvFunctionalHead2Req, setAppvFunctionalHead2Req] = useState('');
  const [appvFunctionalHead3Req, setAppvFunctionalHead3Req] = useState('');
  const [appvFunctionalHead4Req, setAppvFunctionalHead4Req] = useState(''); 
  const [appvFunctionalHead5Req, setAppvFunctionalHead5Req] = useState(''); 
  const [appvFunctionalHead6Req, setAppvFunctionalHead6Req] = useState('');  
  const [mgmtappvRegionBusinessHeadReq, setMgmtAppvRegionBusinessHeadReq] = useState('');
  const [mgmtappvBusinessFinanceReq, setMgmtAppvBusinessFinanceReq] = useState('');
  const [mgmtappvCEOReq, setMgmtAppvCEOReq] = useState('');
  const [mgmtappvCOOReq, setMgmtAppvCOOReq] = useState('');
  const [mgmtappvCFOReq, setMgmtAppvCFOReq] = useState('');

  const [appvTeamLeaderStatus, setAppvTeamLeaderStatus] = useState('');
  const [appvBranchHeadStatus, setAppvBranchHeadStatus] = useState('');
  const [appvRegionBusinessHeadStatus, setAppvRegionBusinessHeadStatus] = useState('');
  const [appvBusinessFinanceStatus, setAppvBusinessFinanceStatus] = useState('');
  const [appvExportComplianceStatus, setAppvExportComplianceStatus] = useState('');
  const [appvCreditInsuranceStatus, setAppvCreditInsuranceStatus] = useState('');
  const [appvCEOStatus, setAppvCEOStatus] = useState('');
  const [appvCOOStatus, setAppvCOOStatus] = useState('');
  const [appvCFOStatus, setAppvCFOStatus] = useState('');
  const [appvSVPDirectorStatus, setAppvSVPDirectorStatus] = useState('');  
  const [appvLegalHeadStatus, setAppvLegalHeadStatus] = useState('');
  const [appvDytCFOStatus, setAppvDytCFOStatus] = useState('');
  const [appvFunctionalHeadStatus, setAppvFunctionalHeadStatus] = useState('');
  const [appvFunctionalHead2Status, setAppvFunctionalHead2Status] = useState('');
  const [appvFunctionalHead3Status, setAppvFunctionalHead3Status] = useState('');
  const [appvFunctionalHead4Status, setAppvFunctionalHead4Status] = useState(''); 
  const [appvFunctionalHead5Status, setAppvFunctionalHead5Status] = useState(''); 
  const [appvFunctionalHead6Status, setAppvFunctionalHead6Status] = useState('');  
  const [mgmtappvRegionBusinessHeadStatus, setMgmtAppvRegionBusinessHeadStatus] = useState('');
  const [mgmtappvBusinessFinanceStatus, setMgmtAppvBusinessFinanceStatus] = useState('');
  const [mgmtappvCEOStatus, setMgmtAppvCEOStatus] = useState('');
  const [mgmtappvCOOStatus, setMgmtAppvCOOStatus] = useState('');
  const [mgmtappvCFOStatus, setMgmtAppvCFOStatus] = useState('');

  const [appvTeamLeaderMessage, setAppvTeamLeaderMessage] = useState('');
  const [appvBranchHeadMessage, setAppvBranchHeadMessage] = useState('');
  const [appvRegionBusinessHeadMessage, setAppvRegionBusinessHeadMessage] = useState('');
  const [appvBusinessFinanceMessage, setAppvBusinessFinanceMessage] = useState('');
  const [appvExportComplianceMessage, setAppvExportComplianceMessage] = useState('');
  const [appvCreditInsuranceMessage, setAppvCreditInsuranceMessage] = useState('');
  const [appvCEOMessage, setAppvCEOMessage] = useState('');
  const [appvCOOMessage, setAppvCOOMessage] = useState('');
  const [appvCFOMessage, setAppvCFOMessage] = useState('');
  const [appvSVPDirectorMessage, setAppvSVPDirectorMessage] = useState('');  
  const [appvFunctionalHeadMessage, setAppvFunctionalHeadMessage] = useState('');
  const [appvFunctionalHead2Message, setAppvFunctionalHead2Message] = useState('');
  const [appvFunctionalHead3Message, setAppvFunctionalHead3Message] = useState('');
  const [appvFunctionalHead4Message, setAppvFunctionalHead4Message] = useState(''); 
  const [appvFunctionalHead5Message, setAppvFunctionalHead5Message] = useState(''); 
  const [appvFunctionalHead6Message, setAppvFunctionalHead6Message] = useState('');  
  const [appvLegalHeadMessage, setAppvLegalHeadMessage] = useState('');
  const [appvDytCFOMessage, setAppvDytCFOMessage] = useState('');
  const [mgmtappvRegionBusinessHeadMessage, setMgmtAppvRegionBusinessHeadMessage] = useState('');
  const [mgmtappvBusinessFinanceMessage, setMgmtAppvBusinessFinanceMessage] = useState('');
  const [mgmtappvCEOMessage, setMgmtAppvCEOMessage] = useState('');
  const [mgmtappvCOOMessage, setMgmtAppvCOOMessage] = useState('');
  const [mgmtappvCFOMessage, setMgmtAppvCFOMessage] = useState('');
  
  const [approvalMessage, setApprovalMessage] = useState('');
  const [rejectionMessage, setRejectionMessage] = useState("");
  const [appvCIMessage, setAppvCIMessage] = useState("");
  const [ciMgmtReason, setCIMgmtReason] = useState("");
  const [mgmtApprovalMessage, setMgmtApprovalMessage] = useState('');
  const [mgmtRejectionMessage, setMgmtRejectionMessage] = useState("");
  const [mgmtApprovalRequire, setMgmtApprovalRequire] = useState("");
  const [showThankYou, setShowThankYou] = useState(false);
  const [mgmtResponse, setMgmtResponse] = useState("");
  const [showMGMTThankYou, setShowMGMTThankYou] = useState(false);

  
  const [modalSentForAppv, setModalSentForAppv] = useState(false);
  const [showReopen, setShowReopen] = useState(false);
  const [step, setStep] = useState(1);
  const [ques1, setQues1] = useState('');
  const [ques2, setQues2] = useState('');
  const [ques3, setQues3] = useState('');
  const [ques4, setQues4] = useState('');
  const [ques5, setQues5] = useState('');
  const [ques6, setQues6] = useState('');
  const [ques7, setQues7] = useState('');
  const [ques8, setQues8] = useState('');
  const [ques9, setQues9] = useState('');
  const [ques10, setQues10] = useState('');
  const [ques11, setQues11] = useState('');
  const [ques12, setQues12] = useState('');
  const [ques13, setQues13] = useState('');
  const [ques14, setQues14] = useState('');
  const [showExCompRemark, setExCompRemark] = useState(false);
  const [ExCompMessage, setExCompMessage] = useState('');
  const [isVendorPaymentTermModalOpen, setIsVendorPaymentTermModalOpen] = useState(false);
  const [isCustomerPaymentTermModalOpen, setIsCustomerPaymentTermModalOpen] = useState(false);
  const [fileSaveTrigger, setfileSaveTrigger] = useState(0);

  const [isReadOnly, setIsReadOnly] = useState(true);
  const [isNoteVisible, setIsNoteVisible] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState('');


  const [tooltipOpen, setTooltipOpen] = useState(false);
  const [teamLeaderTooltip, setTeamLeaderTooltip] = useState(false);
  const [branchHeadTooltip, setBranchHeadTooltip] = useState(false);
  const [regionBusinessHeadTooltip, setRegionBusinessHeadTooltip] = useState(false);
  const [businessFinanceTooltip, setBusinessFinanceTooltip] = useState(false);
  const [creditInsuranceTooltip, setCreditInsuranceTooltip] = useState(false);
  const [exportComplianceTooltip, setExportComplianceTooltip] = useState(false);
  const [cfoTooltip, setCfoTooltip] = useState(false);
  const [ceoTooltip, setCeoTooltip] = useState(false);
  const [cooTooltip, setCooTooltip] = useState(false);
  const [svpDirectorTooltip, setSvpDirectorTooltip] = useState(false);
  const [legalHeadTooltip, setLegalHeadTooltip] = useState(false);
  const [dytCfoTooltip, setDytCfoTooltip] = useState(false);
  const [functionalHead1Tooltip, setFunctionalHead1Tooltip] = useState(false);
  const [functionalHead2Tooltip, setFunctionalHead2Tooltip] = useState(false);
  const [functionalHead3Tooltip, setFunctionalHead3Tooltip] = useState(false);
  const [functionalHead4Tooltip, setFunctionalHead4Tooltip] = useState(false);
  const [functionalHead5Tooltip, setFunctionalHead5Tooltip] = useState(false);
  const [functionalHead6Tooltip, setFunctionalHead6Tooltip] = useState(false);
  const [mgmtRegionBusinessHeadTooltip, setMgmtRegionBusinessHeadTooltip] = useState(false);
  const [mgmtBusinessFinanceTooltip, setMgmtBusinessFinanceTooltip] = useState(false);
  const [mgmtCeoTooltip, setMgmtCeoTooltip] = useState(false);
  const [mgmtCooTooltip, setMgmtCooTooltip] = useState(false);
  const [mgmtCfoTooltip, setMgmtCfoTooltip] = useState(false);
  const toggle = () => setTooltipOpen(!tooltipOpen);

      
  const oemOptions = [
    { label: "1KOSMOS", value: "1KOSMOS" },
    { label: "3C3", value: "3C3" },
    { label: "3COM", value: "3COM" },
    { label: "3M", value: "3M" },
    { label: "42GEARS", value: "42GEARS" },
    { label: "A10", value: "A10" },
    { label: "ABAS", value: "ABAS" },
    { label: "ACCOPS", value: "ACCOPS" },
    { label: "ACCORD", value: "ACCORD" },
    { label: "ACER", value: "ACER" },
    { label: "ACRONIS", value: "ACRONIS" },
    { label: "ADATA", value: "ADATA" },
    { label: "ADOBE", value: "ADOBE" },
    { label: "AFL", value: "AFL" },
    { label: "AKAMAI", value: "AKAMAI" },
    { label: "ALGOSEC", value: "ALGOSEC" },
    { label: "AMD", value: "AMD" },
    { label: "AMP", value: "AMP" },
    { label: "ANKER", value: "ANKER" },
    { label: "APC", value: "APC" },
    { label: "APP", value: "APP" },
    { label: "APPDYNAMIC", value: "APPDYNAMIC" },
    { label: "APPKNOX", value: "APPKNOX" },
    { label: "APPLE", value: "APPLE" },
    { label: "APW", value: "APW" },
    { label: "ARBOR", value: "ARBOR" },
    { label: "ARCHER", value: "ARCHER" },
    { label: "ARCON", value: "ARCON" },
    { label: "ARCOS", value: "ARCOS" },
    { label: "ARCSERVE", value: "ARCSERVE" },
    { label: "ARCSIGHT", value: "ARCSIGHT" },
    { label: "ARI", value: "ARI" },
    { label: "ARRAY", value: "ARRAY" },
    { label: "ARRCUS", value: "ARRCUS" },
    { label: "ARUBA", value: "ARUBA" },
    { label: "ASUS", value: "ASUS" },
    { label: "ATEMPO", value: "ATEMPO" },
    { label: "ATEN", value: "ATEN" },
    { label: "AUTODESK", value: "AUTODESK" },
    { label: "AVAYA", value: "AVAYA" },
    { label: "AWIROS", value: "AWIROS" },
    { label: "AMAZON", value: "AMAZON" },
    { label: "AZURE", value: "AZURE" },
    { label: "BARACUDA", value: "BARACUDA" },
    { label: "BARCO", value: "BARCO" },
    { label: "BARRACUDA", value: "BARRACUDA" },
    { label: "BEHRINGER", value: "BEHRINGER" },
    { label: "BELDEN", value: "BELDEN" },
    { label: "BEYONDTRUS", value: "BEYONDTRUS" },
    { label: "BITBUCKET", value: "BITBUCKET" },
    { label: "BITTITAN", value: "BITTITAN" },
    { label: "BLACKBERRY", value: "BLACKBERRY" },
    { label: "BLUEBEAM", value: "BLUEBEAM" },
    { label: "BLUECOAT", value: "BLUECOAT" },
    { label: "BMC", value: "BMC" },
    { label: "BOSCH", value: "BOSCH" },
    { label: "BPE", value: "BPE" },
    { label: "BROADCOM", value: "BROADCOM" },
    { label: "BROCADE", value: "BROCADE" },
    { label: "BROTHER", value: "BROTHER" },
    { label: "BROWS", value: "BROWS" },
    { label: "BURPSUITE", value: "BURPSUITE" },
    { label: "C3C", value: "C3C" },
    { label: "CA", value: "CA" },
    { label: "CAMBIUM", value: "CAMBIUM" },
    { label: "CANON", value: "CANON" },
    { label: "CARBONITE", value: "CARBONITE" },
    { label: "CASIO", value: "CASIO" },
    { label: "CENTREON", value: "CENTREON" },
    { label: "CHECKMARX", value: "CHECKMARX" },
    { label: "CHECKPOINT", value: "CHECKPOINT" },
    { label: "CISCO", value: "CISCO" },
    { label: "CIT", value: "CIT" },
    { label: "CITRIX", value: "CITRIX" },
    { label: "CLAROTY", value: "CLAROTY" },
    { label: "CLOUDERA", value: "CLOUDERA" },
    { label: "CLOUDFLARE", value: "CLOUDFLARE" },
    { label: "CLOUDSEK", value: "CLOUDSEK" },
    { label: "COLOUR TOK", value: "COLOUR TOK" },
    { label: "COMMSCOPE", value: "COMMSCOPE" },
    { label: "COMMVAULT", value: "COMMVAULT" },
    { label: "COMODO", value: "COMODO" },
    { label: "COMPTEK", value: "COMPTEK" },
    { label: "COMRACK", value: "COMRACK" },
    { label: "COMSCOPE", value: "COMSCOPE" },
    { label: "CONFLUENCE", value: "CONFLUENCE" },
    { label: "CORP", value: "CORP" },
    { label: "COSOSYS", value: "COSOSYS" },
    { label: "CROWDSTRIK", value: "CROWDSTRIK" },
    { label: "CROWN", value: "CROWN" },
    { label: "C-SYSTEM", value: "C-SYSTEM" },
    { label: "CUSTOM", value: "CUSTOM" },
    { label: "CYB", value: "CYB" },
    { label: "CYBER", value: "CYBER" },
    { label: "CYBLE", value: "CYBLE" },
    { label: "CYWARE", value: "CYWARE" },
    { label: "DATA SAFE", value: "DATA SAFE" },
    { label: "DATADOG", value: "DATADOG" },
    { label: "DATALOAD", value: "DATALOAD" },
    { label: "DATALOGIC", value: "DATALOGIC" },
    { label: "DATAMOTIVE", value: "DATAMOTIVE" },
    { label: "DECLINK", value: "DECLINK" },
    { label: "DELL", value: "DELL" },
    { label: "DELPHI", value: "DELPHI" },
    { label: "DELTA", value: "DELTA" },
    { label: "DELTON", value: "DELTON" },
    { label: "DENSO", value: "DENSO" },
    { label: "DESKO", value: "DESKO" },
    { label: "DEVICE XPL", value: "DEVICE XPL" },
    { label: "DG", value: "DG" },
    { label: "DIGIBOX", value: "DIGIBOX" },
    { label: "DIGICERT", value: "DIGICERT" },
    { label: "DIGISOL", value: "DIGISOL" },
    { label: "D-LINK", value: "D-LINK" },
    { label: "DNIF", value: "DNIF" },
    { label: "DRUVA", value: "DRUVA" },
    { label: "DYNATRACE", value: "DYNATRACE" },
    { label: "EATON", value: "EATON" },
    { label: "EDB", value: "EDB" },
    { label: "EKAHAU", value: "EKAHAU" },
    { label: "ELASTIC", value: "ELASTIC" },
    { label: "EMC", value: "EMC" },
    { label: "EPSON", value: "EPSON" },
    { label: "ESDS", value: "ESDS" },
    { label: "ESET", value: "ESET" },
    { label: "EXAGRID", value: "EXAGRID" },
    { label: "EXTREME NW", value: "EXTREME NW" },
    { label: "F5", value: "F5" },
    { label: "FATPIPE", value: "FATPIPE" },
    { label: "FIREEYE", value: "FIREEYE" },
    { label: "FORCEPOINT", value: "FORCEPOINT" },
    { label: "FORESCOUT", value: "FORESCOUT" },
    { label: "FORTIGATE", value: "FORTIGATE" },
    { label: "FORTINET", value: "FORTINET" },
    { label: "FORTRA", value: "FORTRA" },
    { label: "FUJITSU", value: "FUJITSU" },
    { label: "GEMALTO", value: "GEMALTO" },
    { label: "GEOTRUST", value: "GEOTRUST" },
    { label: "GGNOME", value: "GGNOME" },
    { label: "GLOBALSCAP", value: "GLOBALSCAP" },
    { label: "GOOGLE", value: "GOOGLE" },
    { label: "GURUCUL", value: "GURUCUL" },
    { label: "HFCL", value: "HFCL" },
    { label: "HSI", value: "HSI" },
    { label: "HITACHI VANTARA", value: "HITACHI VANTARA" },
    { label: "HONEYWELL", value: "HONEYWELL" },
    { label: "HP", value: "HP" },
    { label: "HPE", value: "HPE" },
    { label: "H-REL", value: "H-REL" },
    { label: "HULASI", value: "HULASI" },
    { label: "HULFT8", value: "HULFT8" },
    { label: "HYNIX", value: "HYNIX" },
    { label: "IBALL", value: "IBALL" },
    { label: "IBM", value: "IBM" },
    { label: "IER", value: "IER" },
    { label: "IMPERVA", value: "IMPERVA" },
    { label: "INDYGEN", value: "INDYGEN" },
    { label: "INFINEON", value: "INFINEON" },
    { label: "INFOBLOX", value: "INFOBLOX" },
    { label: "INFORMATIC", value: "INFORMATIC" },
    { label: "INHOUSE", value: "INHOUSE" },
    { label: "INNSPARKS", value: "INNSPARKS" },
    { label: "INTEL", value: "INTEL" },
    { label: "IRAJE", value: "IRAJE" },
    { label: "ISI", value: "ISI" },
    { label: "ITEXT", value: "ITEXT" },
    { label: "IVANTI", value: "IVANTI" },
    { label: "IXIA", value: "IXIA" },
    { label: "JBL", value: "JBL" },
    { label: "JIRA", value: "JIRA" },
    { label: "JP1", value: "JP1" },
    { label: "JREBEL", value: "JREBEL" },
    { label: "JUNIPER", value: "JUNIPER" },
    { label: "KEMP1", value: "KEMP1" },
    { label: "KINGSTON", value: "KINGSTON" },
    { label: "KISOK", value: "KISOK" },
    { label: "KLASSIFY", value: "KLASSIFY" },
    { label: "KONG", value: "KONG" },
    { label: "KOSMOS", value: "KOSMOS" },
    { label: "KRAMER", value: "KRAMER" },
    { label: "KVMP", value: "KVMP" },
    { label: "KYOCERA", value: "KYOCERA" },
    { label: "LABELARY", value: "LABELARY" },
    { label: "LENOVO", value: "LENOVO" },
    { label: "LEPIDE", value: "LEPIDE" },
    { label: "LEVIA", value: "LEVIA" },
    { label: "LG", value: "LG" },
    { label: "LIFESIZE", value: "LIFESIZE" },
    { label: "LINK PROOF", value: "LINK PROOF" },
    { label: "LIPI", value: "LIPI" },
    { label: "LOADBALANC", value: "LOADBALANC" },
    { label: "LOCAL", value: "LOCAL" },
    { label: "LOGITECH", value: "LOGITECH" },
    { label: "LOGRHYTHM", value: "LOGRHYTHM" },
    { label: "LUMINOUS", value: "LUMINOUS" },
    { label: "MAGE", value: "MAGE" },
    { label: "MAN ENG", value: "MAN ENG" },
    { label: "ManageEngine", value: "ManageEngine" },
    { label: "MANDIANT", value: "MANDIANT" },
    { label: "MANSCHAFT IT", value: "MANSCHAFT IT" },
    { label: "MAT", value: "MAT" },
    { label: "MCAFEE", value: "MCAFEE" },
    { label: "MCIPL", value: "MCIPL" },
    { label: "MELLANOX", value: "MELLANOX" },
    { label: "MERAKI", value: "MERAKI" },
    { label: "MICROFOCUS", value: "MICROFOCUS" },
    { label: "MICRON", value: "MICRON" },
    { label: "MICROSOFT", value: "MICROSOFT" },
    { label: "MILESTONE", value: "MILESTONE" },
    { label: "MILLENIUM", value: "MILLENIUM" },
    { label: "MIPRO", value: "MIPRO" },
    { label: "MIZPAH", value: "MIZPAH" },
    { label: "MOLEX", value: "MOLEX" },
    { label: "MOTA", value: "MOTA" },
    { label: "MOVEIT", value: "MOVEIT" },
    { label: "MX", value: "MX" },
    { label: "NEC", value: "NEC" },
    { label: "NESSUS", value: "NESSUS" },
    { label: "NET RACK", value: "NET RACK" },
    { label: "NetApp", value: "NetApp" },
    { label: "NETCORE", value: "NETCORE" },
    { label: "NETGEAR", value: "NETGEAR" },
    { label: "NETRACK", value: "NETRACK" },
    { label: "NETSCOUT", value: "NETSCOUT" },
    { label: "NETSKOPE", value: "NETSKOPE" },
    { label: "NETWRIX", value: "NETWRIX" },
    { label: "NOKIA", value: "NOKIA" },
    { label: "NUTANIX", value: "NUTANIX" },
    { label: "NVIDIA", value: "NVIDIA" },
    { label: "OKTA", value: "OKTA" },
    { label: "OMNISSA", value: "OMNISSA" },
    { label: "OPENGEAR", value: "OPENGEAR" },
    { label: "OPENTEXT", value: "OPENTEXT" },
    { label: "OPSWAT", value: "OPSWAT" },
    { label: "OPTIEMUS", value: "OPTIEMUS" },
    { label: "ORACLE", value: "ORACLE" },
    { label: "ORCA", value: "ORCA" },
    { label: "PALOALTO", value: "PALOALTO" },
    { label: "PANACHE", value: "PANACHE" },
    { label: "PERPUITUIT", value: "PERPUITUIT" },
    { label: "PERSISTENT", value: "PERSISTENT" },
    { label: "PICUS", value: "PICUS" },
    { label: "POLYCAB", value: "POLYCAB" },
    { label: "POLYCOM", value: "POLYCOM" },
    { label: "PRESIDENT", value: "PRESIDENT" },
    { label: "PRODMARC", value: "PRODMARC" },
    { label: "PROGIST", value: "PROGIST" },
    { label: "PROGRESS S", value: "PROGRESS S" },
    { label: "PROOFPOINT", value: "PROOFPOINT" },
    { label: "PROTEK", value: "PROTEK" },
    { label: "PULSE", value: "PULSE" },
    { label: "PURE", value: "PURE" },
    { label: "QUALYS", value: "QUALYS" },
    { label: "QUANTUM", value: "QUANTUM" },
    { label: "QUEST", value: "QUEST" },
    { label: "QUICKHEAL", value: "QUICKHEAL" },
    { label: "Quilr", value: "Quilr" },
    { label: "R&M", value: "R&M" },
    { label: "RACKWARE", value: "RACKWARE" },
    { label: "RADWARE", value: "RADWARE" },
    { label: "RAPID7", value: "RAPID7" },
    { label: "RARITAN", value: "RARITAN" },
    { label: "RASPBERRY", value: "RASPBERRY" },
    { label: "REALVNC", value: "REALVNC" },
    { label: "REDHAT", value: "REDHAT" },
    { label: "RETROSPECT", value: "RETROSPECT" },
    { label: "RISKPROFIL", value: "RISKPROFIL" },
    { label: "RITAL", value: "RITAL" },
    { label: "RITTAL", value: "RITTAL" },
    { label: "RSA", value: "RSA" },
    { label: "RUBRIK", value: "RUBRIK" },
    { label: "RUCKUS", value: "RUCKUS" },
    { label: "SAHI PRO", value: "SAHI PRO" },
    { label: "SAMSUNG", value: "SAMSUNG" },
    { label: "SANDISK", value: "SANDISK" },
    { label: "SAPPHIRE", value: "SAPPHIRE" },
    { label: "SCALE FUSI", value: "SCALE FUSI" },
    { label: "SCHNEI", value: "SCHNEI" },
    { label: "SCHNEIDER", value: "SCHNEIDER" },
    { label: "SEAGATE", value: "SEAGATE" },
    { label: "SECEON", value: "SECEON" },
    { label: "SECLOGIC", value: "SECLOGIC" },
    { label: "SECLORE", value: "SECLORE" },
    { label: "SECONIZE", value: "SECONIZE" },
    { label: "SECURBAY", value: "SECURBAY" },
    { label: "SECUREYE", value: "SECUREYE" },
    { label: "SECURITYSC", value: "SECURITYSC" },
    { label: "SECURONIX", value: "SECURONIX" },
    { label: "SENTINELONE", value: "SENTINELONE" },
    { label: "SERTEL", value: "SERTEL" },
    { label: "SERVICENOW", value: "SERVICENOW" },
    { label: "SHAREPLEX", value: "SHAREPLEX" },
    { label: "SHURE", value: "SHURE" },
    { label: "SITA", value: "SITA" },
    { label: "SKY BOX", value: "SKY BOX" },
    { label: "SKY HIGH", value: "SKY HIGH" },
    { label: "SLIDO", value: "SLIDO" },
    { label: "SOLARWIND", value: "SOLARWIND" },
    { label: "SONICWALL", value: "SONICWALL" },
    { label: "SONY", value: "SONY" },
    { label: "SOPHOS", value: "SOPHOS" },
    { label: "SOTI MOBI", value: "SOTI MOBI" },
    { label: "SOUNDCRAFT", value: "SOUNDCRAFT" },
    { label: "SPARSH", value: "SPARSH" },
    { label: "SPK", value: "SPK" },
    { label: "STANDARD", value: "STANDARD" },
    { label: "SUSE", value: "SUSE" },
    { label: "SUVIRA/TRU", value: "SUVIRA/TRU" },
    { label: "SYMANTEC", value: "SYMANTEC" },
    { label: "SYMPHONY", value: "SYMPHONY" },
    { label: "SYNOLOGY", value: "SYNOLOGY" },
    { label: "SYROTECH", value: "SYROTECH" },
    { label: "SYSTIMAX", value: "SYSTIMAX" },
    { label: "SYSTOOLS", value: "SYSTOOLS" },
    { label: "TABLEAU", value: "TABLEAU" },
    { label: "TANDBERG", value: "TANDBERG" },
    { label: "TARGUS", value: "TARGUS" },
    { label: "TEAMVIEWER", value: "TEAMVIEWER" },
    { label: "TEJAS NETWORK", value: "TEJAS NETWORK" },
    { label: "TENABLE", value: "TENABLE" },
    { label: "TETHERFI", value: "TETHERFI" },
    { label: "TH", value: "TH" },
    { label: "THALES", value: "THALES" },
    { label: "THREATCOP", value: "THREATCOP" },
    { label: "TINTRI", value: "TINTRI" },
    { label: "TITUS", value: "TITUS" },
    { label: "TOSHIBA", value: "TOSHIBA" },
    { label: "TPLINK", value: "TPLINK" },
    { label: "TRELLIX", value: "TRELLIX" },
    { label: "TRENDMICRO", value: "TRENDMICRO" },
    { label: "TSC", value: "TSC" },
    { label: "TUFIN", value: "TUFIN" },
    { label: "TYCO", value: "TYCO" },
    { label: "UBIQUITI", value: "UBIQUITI" },
    { label: "UBUNTU", value: "UBUNTU" },
    { label: "UIPATH", value: "UIPATH" },
    { label: "UNB", value: "UNB" },
    { label: "VAL", value: "VAL" },
    { label: "VALRACK", value: "VALRACK" },
    { label: "VANTAGEO", value: "VANTAGEO" },
    { label: "VARONIS", value: "VARONIS" },
    { label: "VEEAM", value: "VEEAM" },
    { label: "VERGER3D", value: "VERGER3D" },
    { label: "VERITAS", value: "VERITAS" },
    { label: "VERTIV", value: "VERTIV" },
    { label: "VIP", value: "VIP" },
    { label: "VMWARE", value: "VMWARE" },
    { label: "WATCHDOG", value: "WATCHDOG" },
    { label: "WESTERN", value: "WESTERN" },
    { label: "WHATSUP", value: "WHATSUP" },
    { label: "WILDCARD", value: "WILDCARD" },
    { label: "WIPRO", value: "WIPRO" },
    { label: "WQ", value: "WQ" },
    { label: "WS FTP", value: "WS FTP" },
    { label: "XAAS", value: "XAAS" },
    { label: "XEROX", value: "XEROX" },
    { label: "YAMAHA", value: "YAMAHA" },
    { label: "Yotta", value: "Yotta" },
    { label: "YUBICO", value: "YUBICO" },
    { label: "ZEBRA", value: "ZEBRA" },
    { label: "ZEBRONICS", value: "ZEBRONICS" },
    { label: "ZOHO", value: "ZOHO" },
    { label: "ZOOM", value: "ZOOM" },
    { label: "ZSCALER", value: "ZSCALER" },
  ];

  const [selectedOem, setSelectedOem] = useState([]);

    const CurrencyyearMultiplier = {
      "Year 1": 1,
      "Year 2": 1.05,
      "Year 3": 1.05 ** 2,
      "Year 4": 1.05 ** 3,
      "Year 5": 1.05 ** 4,
      "Year 6": 1.05 ** 5,
      "Year 7": 1.05 ** 6,
    };

    const conversionRateyear1 = (conversionRate * 1).toFixed(2);
    const conversionRateyear2 = (conversionRate * CurrencyyearMultiplier["Year 2"]).toFixed(2);
    const conversionRateyear3 = (conversionRate * CurrencyyearMultiplier["Year 3"]).toFixed(2);
    const conversionRateyear4 = (conversionRate * CurrencyyearMultiplier["Year 4"]).toFixed(2);
    const conversionRateyear5 = (conversionRate * CurrencyyearMultiplier["Year 5"]).toFixed(2);
    const conversionRateyear6 = (conversionRate * CurrencyyearMultiplier["Year 6"]).toFixed(2);
    const conversionRateyear7 = (conversionRate * CurrencyyearMultiplier["Year 7"]).toFixed(2);

    // const conversionRateyear1 = (conversionRate * 1).toFixed(2);
    // const conversionRateyear2 = (conversionRateyear1 * 1.05).toFixed(2);
    // const conversionRateyear3 = (conversionRateyear2 * 1.05).toFixed(2);
    // const conversionRateyear4 = (conversionRateyear3 * 1.05).toFixed(2);
    // const conversionRateyear5 = (conversionRateyear4 * 1.05).toFixed(2);
    // const conversionRateyear6 = (conversionRateyear5 * 1.05).toFixed(2);
    // const conversionRateyear7 = (conversionRateyear6 * 1.05).toFixed(2);


    useEffect(() => {
      const JWTtoken = window.sessionStorage.getItem('token')
      const loginID = window.sessionStorage.getItem('userId')
      const loginRole = window.sessionStorage.getItem('role')
      apiService.getNonTenderCrmDetails(JWTtoken, loginID, loginRole)
        .then(response => {
          console.log('Non Tender CRM Data>>>>>>>>>>>',response.data)
          setcrmData(response.data);
          setLoading(false);
        })
        .catch(error => {
          setError(error);
          setLoading(false);
        });

        getdataforcostsheet(JWTtoken)
        // ❌ Removed: no automatic background rate refresh on page load.
        // The DB-saved ConversionRate is seeded straight into the currencyRates
        // cache inside getdataforcostsheet's .then() above — that saved value is
        // the source of truth on load. Fresh rates are only ever fetched at two
        // explicit trigger points: (1) when a new transactionCurrency is picked
        // and confirmed via handleCurrencyChange, and (2) when "Send for Approval"
        // is clicked (see refreshRatesAndGetFreshTotals below).
        
      apiService.getFunctionalHeadList(JWTtoken)
        .then(response => {
          // console.log("10101010101101010",response.data)
          setAllFunctionalHeadList(response.data);
        })
        .catch(error => {
          setError(error);
        });

      apiService.getFinancialTable(JWTtoken, series)
        .then((res) => {
          const fetchedRows = res.data.data;
          if (!fetchedRows || fetchedRows.length === 0) {
            setFinancialTableLoaded(true); // ✅ brand-new record, nothing to load — but no longer "loading"
            return;
          }

          // Separate Total row from data rows
          const dataRows = fetchedRows.filter((r) => r.name !== "Total");
          
          const enrichedRows = dataRows.map((row) => {
            const rowCurrency = row.currency || "INR"; // ✅ restore row-level currency

            const normalizedValues = (row.values || []).map((v) => {
              if (typeof v === "object" && v !== null) {
                return { amount: v.amount || 0, currency: v.currency || rowCurrency };
              }
              return { amount: Number(v) || 0, currency: rowCurrency };
            });

            return enrichRow({
              ...row,
              currency: rowCurrency,        // ✅ restore at row level
              values: normalizedValues,
            });
          });

          // ✅ Always append a fresh Total row — it will be recalculated by useEffect
          setRows([
            ...enrichedRows,
            { id: 999, name: "Total", currency: "INR", values: makeValues(9) },
          ]);
          setFinancialTableLoaded(true); // ✅ real row amounts are now in state — safe to calculate/save against them
        })
        .catch((err) => {
          console.error("Failed to fetch financial table:", err);
          setFinancialTableLoaded(true); // ✅ don't permanently lock the UI on a fetch failure
          toast.error("Failed to load financial table data. Payment term figures may be inaccurate — please reload.");
        });
      
      apiService.getENTCSAppvByFormseries(JWTtoken, series)
        .then((response) => {
          console.log('ENTCOSTSHEET - getENTCSAppvByFormseries ::::>>', response.data)
          setAppvTeamLeaderId(response.data.appvTeamLeaderID)
          setAppvBranchHeadId(response.data.appvBranchHeadID)
          setAppvRegionBusinessHeadId(response.data.appvRegionBusinessHeadID)
          setAppvBusinessFinanceId(response.data.appvBusinessFinanceID)
          setAppvExportComplianceId(response.data.appvExportComplianceID)
          setAppvCreditInsuranceId(response.data.appvCreditInsuranceID)
          setAppvCEOId(response.data.appvCEOID)
          setAppvCOOId(response.data.appvCOOID)
          setAppvCFOId(response.data.appvCFOID)
          setAppvSVPDirectorId(response.data.appvSVPDirectorID)
          setAppvLegalHeadId(response.data.appvLegalHeadID)
          setAppvDytCFOId(response.data.appvDytCFOID)
          setMgmtAppvRegionBusinessHeadID(response.data.mgmtAppvRegionBusinessHeadID) 
          setMgmtAppvBusinessFinanceID(response.data.mgmtAppvBusinessFinanceID)
          setMgmtAppvCEOID(response.data.mgmtAppvCEOID)
          setMgmtAppvCOOID(response.data.mgmtAppvCOOID)
          setMgmtAppvCFOID(response.data.mgmtAppvCFOID)

          setAppvTeamLeaderReq(response.data.appvTeamLeaderReq)
          setAppvBranchHeadReq(response.data.appvBranchHeadReq)
          setAppvRegionBusinessHeadReq(response.data.appvRegionBusinessHeadReq)
          setAppvBusinessFinanceReq(response.data.appvBusinessFinanceReq)
          setAppvExportComplianceReq(response.data.appvExportComplianceReq)
          setAppvCreditInsuranceReq(response.data.appvCreditInsuranceReq)
          setAppvCEOReq(response.data.appvCEOReq)
          setAppvCOOReq(response.data.appvCOOReq)
          setAppvCFOReq(response.data.appvCFOReq)
          setAppvSVPDirectorReq(response.data.appvSVPDirectorReq)
          setAppvFunctionalHeadReq(response.data.appvFunctionalHeadReq)
          setAppvFunctionalHead2Req(response.data.appvFunctionalHead2Req)
          setAppvFunctionalHead3Req(response.data.appvFunctionalHead3Req)
          setAppvFunctionalHead4Req(response.data.appvFunctionalHead4Req)
          setAppvFunctionalHead5Req(response.data.appvFunctionalHead5Req)
          setAppvFunctionalHead6Req(response.data.appvFunctionalHead6Req)
          setAppvlegalHeadReq(response.data.appvLegalHeadReq)
          setAppvDytCFOReq(response.data.appvDytCFOReq)
          setMgmtAppvRegionBusinessHeadReq(response.data.mgmtAppvRegionBusinessHeadReq) 
          setMgmtAppvBusinessFinanceReq(response.data.mgmtAppvBusinessFinanceReq)
          setMgmtAppvCEOReq(response.data.mgmtAppvCEOReq)
          setMgmtAppvCOOReq(response.data.mgmtAppvCOOReq)
          setMgmtAppvCFOReq(response.data.mgmtAppvCFOReq)

          setAppvTeamLeaderStatus(response.data.appvTeamLeaderStatus)
          setAppvBranchHeadStatus(response.data.appvBranchHeadStatus)
          setAppvRegionBusinessHeadStatus(response.data.appvRegionBusinessHeadStatus)
          setAppvBusinessFinanceStatus(response.data.appvBusinessFinanceStatus)
          setAppvExportComplianceStatus(response.data.appvExportComplianceStatus)
          setAppvCreditInsuranceStatus(response.data.appvCreditInsuranceStatus)
          setAppvCEOStatus(response.data.appvCEOStatus)
          setAppvCOOStatus(response.data.appvCOOStatus)
          setAppvCFOStatus(response.data.appvCFOStatus)
          setAppvSVPDirectorStatus(response.data.appvSVPDirectorStatus)
          setAppvFunctionalHeadStatus(response.data.appvFunctionalHeadStatus)
          setAppvFunctionalHead2Status(response.data.appvFunctionalHead2Status)
          setAppvFunctionalHead3Status(response.data.appvFunctionalHead3Status)
          setAppvFunctionalHead4Status(response.data.appvFunctionalHead4Status)
          setAppvFunctionalHead5Status(response.data.appvFunctionalHead5Status)
          setAppvFunctionalHead6Status(response.data.appvFunctionalHead6Status)
          setAppvLegalHeadStatus(response.data.appvLegalHeadStatus)
          setAppvDytCFOStatus(response.data.appvDytCFOStatus)
          setMgmtAppvRegionBusinessHeadStatus(response.data.mgmtAppvRegionBusinessHeadStatus)
          setMgmtAppvBusinessFinanceStatus(response.data.mgmtAppvBusinessFinanceStatus)
          setMgmtAppvCEOStatus(response.data.mgmtAppvCEOStatus)
          setMgmtAppvCOOStatus(response.data.mgmtAppvCOOStatus)
          setMgmtAppvCFOStatus(response.data.mgmtAppvCFOStatus)
          
        })
        .catch((error) => {
          console.error("Failed to ENTCSAPPV records by formseries:", error);
        });

      let user_name = window.sessionStorage.getItem('userName');
      if (user_name) {
        setuserName(user_name);
      }

      let user_id = window.sessionStorage.getItem('userId');
      if (user_id) {
        setuserId(user_id);
      }

      let user_role = window.sessionStorage.getItem('role');
      if (user_role) {
        setuserRole(user_role);
      }

    }, [series]);

    const getdataforcostsheet = async(JWTtoken)=> {
      await apiService.getDataAgainstEntCostSheet(JWTtoken, series)
      .then(response => {
          setSendForAppv(response.data.entCostSheetLogs.sentForAppv)
          setformReopenCount(response.data.entCostSheetLogs.formReopenCount)
          const rawOEM = response.data.entCostSheetLogs?.OEM;
          const oemArray = rawOEM ? rawOEM.split(',').map(item => item.trim()) : [];
          const formattedOem = oemArray.map(item => ({ label: item, value: item }));
          const secondaryOptionsArray = response.data.entCostSheetLogs?.secondaryOptions?.split(",") || [];
          // console.log('response.data.entCostSheetLogs?.secondaryOptions>>>', response.data.entCostSheetLogs?.secondaryOptions);
          setStatus(response.data.entCostSheetLogs.status)
          setSearchTerm(response.data.entCostSheetLogs.crmNumber)
          setcustomerName(response.data.entCostSheetLogs.customerName)
          setsalesPersonName(response.data.entCostSheetLogs.salesPersonName)
          setsalesPersonID(response.data.entCostSheetLogs.salesPersonID)
          setLowMarginReason(response.data.entCostSheetLogs.ReasonForMarginLessThanSixPercent)
          setSendForAppvReqDate(response.data.entCostSheetLogs.approvalRequestDate)
          setopportunityName(response.data.entCostSheetLogs.opportunityName)
          setpanNumber(response.data.entCostSheetLogs.pan);
          setSelectedOem(formattedOem)
          settransactionCurrency(response.data.entCostSheetLogs.transactionCurrency)
          setsecondaryTransactionCurrency(response.data.entCostSheetLogs.secondaryTransactionCurrency)
          setSecondaryOptions(secondaryOptionsArray)
          setvendorBillingCycle(response.data.entCostSheetLogs.vendorBillingCycle)
          setcashFlowExpertAdvice(response.data.entCostSheetLogs.expertAdviceCashflow)
          setmarginExpertAdvice(response.data.entCostSheetLogs.expertAdviceMargin)
          setvendorPaymentTerms(response.data.entCostSheetLogs.vendorPaymentTerms)
          setcustomerPaymentTerms(response.data.entCostSheetLogs.customerPaymentTerms)
          setDealType(response.data.entCostSheetLogs.dealType)
          sethitachiRoleinthisDeal(response.data.entCostSheetLogs.HitachiRoleInThisDeal)
          // setMaterialDeliveryDate(new Date (response.data.entCostSheetLogs.materialDeliveryDate))
          setMaterialDeliveryDate(response.data.entCostSheetLogs.materialDeliveryDate)
          setConfirmRebate(response.data.entCostSheetLogs.RebateAmountDetails)
          setconversionRate(response.data.entCostSheetLogs.ConversionRate)
          // ✅ Seed the shared rate cache with the DB-saved rate for this currency,
          // so getRate()/currencyRates becomes the single source of truth from the
          // very first render — no separate/duplicate forex fetch needed for it later.
          if (
            response.data.entCostSheetLogs.transactionCurrency &&
            response.data.entCostSheetLogs.transactionCurrency !== "INR" &&
            response.data.entCostSheetLogs.ConversionRate
          ) {
            setCurrencyRates((prev) => ({
              ...prev,
              [response.data.entCostSheetLogs.transactionCurrency]: response.data.entCostSheetLogs.ConversionRate,
            }));
          }
          setremarksIfAny(response.data.entCostSheetLogs.remarks)
          setexpectedDtCustomerRecipt(response.data.entCostSheetLogs.ExpectedDateCustomerRecipt)
          setexpectedDtVendorPayment(response.data.entCostSheetLogs.ExpectedDateVendorPayment)
          setcashFlowExpertAdvice(response.data.entCostSheetLogs.expertAdviceCashFlow)
          setmarginExpertAdvice(response.data.entCostSheetLogs.expertAdviceMargin)

          setFile1url(response.data.entCostSheetLogs.file1url)
          setFile2url(response.data.entCostSheetLogs.file2url)
          setFile3url(response.data.entCostSheetLogs.file3url)
          setFile4url(response.data.entCostSheetLogs.file4url)
          setFile5url(response.data.entCostSheetLogs.file5url)
          setFile6url(response.data.entCostSheetLogs.file6url)
          setFile7url(response.data.entCostSheetLogs.file7url)
          setFile8url(response.data.entCostSheetLogs.file8url)
          setFile9url(response.data.entCostSheetLogs.file9url)
          setFile10url(response.data.entCostSheetLogs.file10url)
          setFileName1(response.data.entCostSheetLogs.fileName1)
          setFileName2(response.data.entCostSheetLogs.fileName2)
          setFileName3(response.data.entCostSheetLogs.fileName3)
          setFileName4(response.data.entCostSheetLogs.fileName4)
          setFileName5(response.data.entCostSheetLogs.fileName5)
          setFileName6(response.data.entCostSheetLogs.fileName6)
          setFileName7(response.data.entCostSheetLogs.fileName7)
          setFileName8(response.data.entCostSheetLogs.fileName8)
          setFileName9(response.data.entCostSheetLogs.fileName9)
          setFileName10(response.data.entCostSheetLogs.fileName10)
          setQues1(response.data.entCostSheetLogs.ExCompQues1)
          setQues2(response.data.entCostSheetLogs.ExCompQues2)
          setQues3(response.data.entCostSheetLogs.ExCompQues3)
          setQues4(response.data.entCostSheetLogs.ExCompQues4)
          setQues5(response.data.entCostSheetLogs.ExCompQues5)
          setQues6(response.data.entCostSheetLogs.ExCompQues6)
          setQues7(response.data.entCostSheetLogs.ExCompQues7)
          setQues8(response.data.entCostSheetLogs.ExCompQues8)
          setQues9(response.data.entCostSheetLogs.ExCompQues9)
          setQues10(response.data.entCostSheetLogs.ExCompQues10)
          setQues11(response.data.entCostSheetLogs.ExCompQues11)
          setQues12(response.data.entCostSheetLogs.ExCompQues12)
          setQues13(response.data.entCostSheetLogs.ExCompQues13)
          setQues14(response.data.entCostSheetLogs.ExCompQues14)
          setFunctionalHead1ID(response.data.entCostSheetLogs.functionalHead1ID)
          setFunctionalHead1Name(response.data.entCostSheetLogs.functionalHead1Name)
          setFunctionalHead2ID(response.data.entCostSheetLogs.functionalHead2ID)
          setFunctionalHead2Name(response.data.entCostSheetLogs.functionalHead2Name)
          setFunctionalHead3ID(response.data.entCostSheetLogs.functionalHead3ID)
          setFunctionalHead3Name(response.data.entCostSheetLogs.functionalHead3Name)
          setFunctionalHead4ID(response.data.entCostSheetLogs.functionalHead4ID)
          setFunctionalHead4Name(response.data.entCostSheetLogs.functionalHead4Name)
          setFunctionalHead5ID(response.data.entCostSheetLogs.functionalHead5ID)
          setFunctionalHead5Name(response.data.entCostSheetLogs.functionalHead5Name)
          setFunctionalHead6ID(response.data.entCostSheetLogs.functionalHead6ID)
          setFunctionalHead6Name(response.data.entCostSheetLogs.functionalHead6Name)
          // console.log('VPTDetails>>>>',response.data.vendorPaymentTerms)
          if (response.data.vendorPaymentTerms && response.data.vendorPaymentTerms.length > 0) {
              const mappedData = response.data.vendorPaymentTerms.map(item => ({
              formSeries: item.formSeries || series,
              vendorpayemntTermsParticular: item.particulars || "",
              vendorpaymentTermsDays: item.days || "",
              vendorpaymentTermsPercentage: item.percentage || "",
              vendorpaymentTermsValue: item.value || ""
            }));

            setVendorPaymentTermsDetails(mappedData);
          }
          // console.log('CCCCCCCCPTDetails>>>>',response.data.customerPaymentTerms)
          if (response.data.customerPaymentTerms && response.data.customerPaymentTerms.length > 0) {
              const mappedCPTData = response.data.customerPaymentTerms.map(item => ({
              formSeries: item.formSeries || series,
              customerpaymentTermsParticular: item.particulars || "",
              customerpaymentTermsDays: item.days || "",
              customerpaymentTermsPercentage: item.percentage || "",
              customerpaymentTermsValue: item.value || ""
            }));
            setCustomerPaymentTermsDetails(mappedCPTData);

            
          }
        })
        .catch(error => {
          setError(error);
        });
    }
     // ❌ Removed: getUseeffectforexRate — no longer used. Page-load rate now
     // comes purely from the DB-saved ConversionRate seeded into currencyRates
     // (see getdataforcostsheet above). Fresh fetches only happen at the two
     // explicit trigger points: currency save (handleCurrencyChange) and
     // Send for Approval (refreshRatesAndGetFreshTotals).

    useEffect(() => {
      let approvalRole = window.sessionStorage.getItem('role');
      let approvalid = window.sessionStorage.getItem('userId');
      const JWTtoken = window.sessionStorage.getItem('token')
      apiService.confirmedENTCSAppv(series).then((response) => {

      const status = response.data.appvStatus;
      if(status.appvCreditInsuranceStatus === "Management Approval"){
        setMgmtApprovalRequire("YES")
        setCIMgmtReason(status.appvCreditInsuranceMessage)
      }

      setAppvTeamLeaderMessage(status.appvTeamLeaderMessage);
      setAppvBranchHeadMessage(status.appvBranchHeadMessage);
      setAppvRegionBusinessHeadMessage(status.appvRegionBusinessHeadMessage);
      setAppvBusinessFinanceMessage(status.appvBusinessFinanceMessage);
      setAppvExportComplianceMessage(status.appvExportComplianceMessage);
      setAppvCreditInsuranceMessage(status.appvCreditInsuranceMessage);
      setAppvCEOMessage(status.appvCEOMessage);
      setAppvCOOMessage(status.appvCOOMessage);
      setAppvCFOMessage(status.appvCFOMessage);
      setAppvSVPDirectorMessage(status.appvSVPDirectorMessage);  
      setAppvFunctionalHeadMessage(status.appvFunctionalHeadMessage);
      setAppvFunctionalHead2Message(status.appvFunctionalHead2Message);
      setAppvFunctionalHead3Message(status.appvFunctionalHead3Message);
      setAppvFunctionalHead4Message(status.appvFunctionalHead4Message); 
      setAppvFunctionalHead5Message(status.appvFunctionalHead5Message); 
      setAppvFunctionalHead6Message(status.appvFunctionalHead6Message);  
      setAppvLegalHeadMessage(status.appvlegalHeadMessage);
      setAppvDytCFOMessage(status.appvDytCFOMessage);
      setMgmtAppvRegionBusinessHeadMessage(status.mgmtAppvRegionBusinessHeadMessage);
      setMgmtAppvBusinessFinanceMessage(status.mgmtAppvBusinessFinanceMessage);
      setMgmtAppvCEOMessage(status.mgmtAppvCEOMessage);
      setMgmtAppvCOOMessage(status.mgmtAppvCOOMessage);
      setMgmtAppvCFOMessage(status.mgmtAppvCFOMessage);

      // console.log(`
      //     approvalid ${approvalid}
      //     appvTeamLeaderId ${status.appvTeamLeaderID}
      //     status.appvTeamLeaderStatus ${status.appvTeamLeaderStatus}
      //     appvBranchHeadId ${status.appvBranchHeadID}
      //     status.appvBranchHeadStatus ${status.appvBranchHeadStatus}
      //     appvRegionBusinessHeadId ${status.appvRegionBusinessHeadID}
      //     status.appvRegionBusinessHeadStatus ${status.appvRegionBusinessHeadStatus}
      //     `)

      if (approvalRole === "TEAM LEADER") {

        // const tlDone = approvalid === status.appvTeamLeaderID && (status.appvTeamLeaderStatus === "Approved" || status.appvTeamLeaderStatus === "Rejected");
        // const bhDone = approvalid === status.appvBranchHeadID && (status.appvBranchHeadStatus === "Approved" || status.appvBranchHeadStatus === "Rejected");
        // const rbhDone = approvalid === status.appvRegionBusinessHeadID && (status.appvRegionBusinessHeadStatus === "Approved" || status.appvRegionBusinessHeadStatus === "Rejected");
        const tlDone = approvalid === status.appvTeamLeaderID && (status.appvTeamLeaderStatus !== "Pending");
        const bhDone = approvalid === status.appvBranchHeadID && (status.appvBranchHeadStatus !== "Pending");
        const rbhDone = approvalid === status.appvRegionBusinessHeadID && (status.appvRegionBusinessHeadStatus !== "Pending");

        // Block only when ALL roles assigned to this person are already completed
        const allAssignedRolesDone =
          (!status.appvTeamLeaderID || status.appvTeamLeaderID !== approvalid || tlDone) &&
          (!status.appvBranchHeadID || status.appvBranchHeadID !== approvalid || bhDone) &&
          (!status.appvRegionBusinessHeadID || status.appvRegionBusinessHeadID !== approvalid || rbhDone);

        if (allAssignedRolesDone) {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        }

        if((status.mgmtAppvRegionBusinessHeadStatus === "Approved" || status.mgmtAppvRegionBusinessHeadStatus === "Rejected")){
                setMgmtResponse("Your Management Approval is already recorded for this Deal!");
                setShowMGMTThankYou(true);
        }
      } else if ( approvalRole === "BRANCH HEAD" && approvalid === status.appvBranchHeadID && (status.appvBranchHeadStatus === "Approved" ||status.appvBranchHeadStatus === "Rejected")) {
        setResponse("Your approval is already recorded for this Deal!");
        setShowThankYou(true);
      } else if (approvalRole === "REGION BUSINESS HEAD" && approvalid === status.appvRegionBusinessHeadID) {
        if (status.appvRegionBusinessHeadStatus === "Approved" || status.appvRegionBusinessHeadStatus === "Rejected") {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        }
        if (status.mgmtAppvRegionBusinessHeadStatus === "Approved" || status.mgmtAppvRegionBusinessHeadStatus === "Rejected") {
          setMgmtResponse("Your Management Approval is already recorded for this Deal!");
          setShowMGMTThankYou(true);
        }
      } else if (approvalRole === "BUSINESS FINANCE") {
        if (status.appvBusinessFinanceStatus === "Approved" || status.appvBusinessFinanceStatus === "Rejected") {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        }
        if (status.mgmtAppvBusinessFinanceStatus === "Approved" || status.mgmtAppvBusinessFinanceStatus === "Rejected") {
          setMgmtResponse("Your Management Approval is already recorded for this Deal!");
          setShowMGMTThankYou(true);
        }
      } else if ( approvalRole === "EXPORT COMPLIANCE" && (status.appvExportComplianceStatus === "Approved" || status.appvExportComplianceStatus === "Rejected")) {
        setResponse("Your approval is already recorded for this Deal!");
        setShowThankYou(true);
      } else if ( approvalRole === "CREDIT INSURANCE" && (status.appvCreditInsuranceStatus === "Approved" || status.appvCreditInsuranceStatus === "Rejected" || status.appvCreditInsuranceStatus === "Management Approval")) {
        setResponse("Your approval is already recorded for this Deal!");
        setShowThankYou(true);
      } else if (approvalRole === "CEO") {
        if (status.appvCEOStatus === "Approved" || status.appvCEOStatus === "Rejected") {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        }
        if (status.mgmtAppvCEOStatus === "Approved" || status.mgmtAppvCEOStatus === "Rejected") {
          setMgmtResponse("Your Management Approval is already recorded for this Deal!");
          setShowMGMTThankYou(true);
        }
      } else if (approvalRole === "CFO") {
        if (status.appvCFOStatus === "Approved" || status.appvCFOStatus === "Rejected") {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        }
        if (status.mgmtAppvCFOStatus === "Approved" || status.mgmtAppvCFOStatus === "Rejected") {
          setMgmtResponse("Your Management Approval is already recorded for this Deal!");
          setShowMGMTThankYou(true);
        }
      } else if (approvalRole === "COO") {
        if (status.appvCOOStatus === "Approved" || status.appvCOOStatus === "Rejected") {
          setResponse("Your approval is already recorded for this Deal!");
          setShowThankYou(true);
        }
        if (status.mgmtAppvCOOStatus === "Approved" || status.mgmtAppvCOOStatus === "Rejected") {
          setMgmtResponse("Your Management Approval is already recorded for this Deal!");
          setShowMGMTThankYou(true);
        }
      } else if ( approvalRole === "SVP-director" && (status.appvSVPDirectorStatus === "Approved" || status.appvSVPDirectorStatus === "Rejected") ) {
        setResponse("Your approval is already recorded for this Deal!");
        setShowThankYou(true);
      } else if ( approvalRole === "FUNCTIONAL HEAD") {

          let approverStatus = "";

          if (approvalid === status.appvFunctionalHeadID) {
                  approverStatus = status.appvFunctionalHeadStatus;
              }else if (approvalid === status.appvFunctionalHead2ID) {
                  approverStatus = status.appvFunctionalHead2Status;
              }else if (approvalid === status.appvFunctionalHead3ID) {
                  approverStatus = status.appvFunctionalHead3Status;
              }else if (approvalid === status.appvFunctionalHead4ID) {
                  approverStatus = status.appvFunctionalHead4Status;
              }else if (approvalid === status.appvFunctionalHead5ID) {
                  approverStatus = status.appvFunctionalHead5Status;
              }else if (approvalid === status.appvFunctionalHead6ID) {
                  approverStatus = status.appvFunctionalHead6Status;
              }

          if ( approverStatus === "Approved" || approverStatus === "Rejected") {
              setResponse("Your approval is already recorded for this Deal!");
              setShowThankYou(true);
          }
      } else if ( approvalRole === "LEGAL HEAD" && (status.appvLegalHeadStatus === "Approved" || status.appvlegalHeadStatus === "Rejected") ) {
        setResponse("Your approval is already recorded for this Deal!");
        setShowThankYou(true);
      } else if ( approvalRole === "DYT-CFO" && (status.appvDytCFOStatus === "Approved" || status.appvDytCFOStatus === "Rejected") ) {
        setResponse("Your approval is already recorded for this Deal!");
        setShowThankYou(true);
      }
      })
      .catch((error) => {
        setError(error);
      });
  
    }, []);
    
  
    // const filteredCrmData = crmData.filter(item =>
    //   item.crmNumber.toLowerCase().includes(searchTerm.toLowerCase())
    // );

    useEffect(() => {
      if (searchTerm === '') {
        setcustomerName('');
        setsalesPersonName('');
        setopportunityName('');
        setsalesPersonID('');
        setpanNumber('');
      }
    }, [searchTerm]);

    useEffect(() => {
        if(fileSaveTrigger === 0) return;
        const timer = setTimeout(() => {
          handleAutoSave();
        }, 1000);
        return () => clearTimeout(timer);
      }, [file1,fileName1,file2,fileName2,file3,fileName3,file4,fileName4,file5,fileName5,file6,fileName6,file7,fileName7 ,file8,fileName8 ,file9,fileName9,file10,fileName10]);
    
    const handleEdit = () => {
      toast.success("EDIT Form");
      setIsReadOnly(false);
    };

    const handleAppvUserValidation = async () => {
      // ✅ Guard against the load race: refuse to proceed with Send for
      // Approval while the financial table's real row amounts haven't loaded
      // yet — otherwise the Total row / payment-term derived figures being
      // saved could still reflect the placeholder "0" state.
      if (!financialTableLoaded) {
        toast.error("Financial table is still loading. Please wait a moment and try again.");
        return;
      }
      setIsReadOnly(true);
       try {
            const JWTtoken = window.sessionStorage.getItem('token');
            const loginRole = window.sessionStorage.getItem('role');

            // ✅ Explicit refresh trigger #2: Send for Approval. Force-refetches
            // every currency in use, recomputes the Total row, and returns the
            // fresh totals directly (state updates from this call are async, so
            // we cannot rely on reading `rows` right after — we use the return
            // value below to build rowsToSave instead).
            const freshTotals = await refreshRatesAndGetFreshTotals();
      
            const response = await apiService.getDataAgainstEntCostSheet(JWTtoken, series);
            // console.log('response:::::::::::::', response)

            const buildRowsToSave = () => rows.map((row) => {
              if (row.name === "Total") {
                return {
                  id: row.id,
                  name: row.name,
                  currency: row.currency ?? "INR",
                  values: freshTotals.map((amt) => ({ amount: amt, currency: "INR" })), // ✅ freshly refreshed totals
                };
              }
              return {
                id: row.id,
                name: row.name,
                currency: row.currency,
                values: row.values.map((v) => ({
                  amount: v.amount,
                  currency: v.currency,
                })),
              };
            });
      
            if (loginRole === 'SALES') {
              // currency: row.currency || "INR"
            if (response.data.entCostSheetLogs.userId === response.data.entCostSheetLogs.salesPersonID) {
                  const rowsToSave = buildRowsToSave();
                await apiService.saveFinancialTable(JWTtoken, series, rowsToSave)
                  .then((response) => {
                    if (response.data.message === "Financial table saved successfully") {
                      setTimeout(() => toast.success("Financial Table Saved"), 1000);
                    }
                  })
                  .catch((error) => {
                    setError(error);
                    console.error("Failed to save financial table:", error);
                  });
                await handleOpenModal();
                await handleAutoSave();
                await setStep(1);
            } else {
                toast.error("Please proceed with your own opportunity");
            }
            } else {
              // currency: row.currency || "INR",
                  const rowsToSave = buildRowsToSave();
              await apiService.saveFinancialTable(JWTtoken, series, rowsToSave)
                .then((response) => {
                  if (response.data.message === "Financial table saved successfully") {
                    setTimeout(() => toast.success("Financial Table Saved"), 1000);
                  }
                })
                .catch((error) => {
                  setError(error);
                  console.error("Failed to save financial table:", error);
                });
            await handleOpenModal();
            await handleAutoSave();
            await setStep(1);
            }
        } catch (error) {
            // console.log(':::::Error while verifying sales user before approval:', error);
            toast.error(`Error while verifying sales user before approval: ${error}`);
        }
    }

     const handleAdminAppvVal = async () => {
      // ✅ Same load-race guard as handleAppvUserValidation.
      if (!financialTableLoaded) {
        toast.error("Financial table is still loading. Please wait a moment and try again.");
        return;
      }
      try {
        const JWTtoken = window.sessionStorage.getItem('token')
        const approvalSenderEmail = window.sessionStorage.getItem('emailID');
        const approvalSenderEmpId = window.sessionStorage.getItem('userId');
        const approverSenderName = window.sessionStorage.getItem('userName');

        // ✅ Same explicit refresh trigger as handleAppvUserValidation: Send for
        // Approval force-refetches rates and recomputes the Total row in local
        // state. NOTE: this function does not currently call saveFinancialTable
        // at all (unlike handleAppvUserValidation) — so the refreshed Total row
        // is updated in state/UI here, but not persisted to the backend by this
        // flow. If BUSINESS FINANCE's "Send for Approval" should also persist
        // it, add a saveFinancialTable call here the same way it's done in
        // handleAppvUserValidation (using the returned freshTotals).
        await refreshRatesAndGetFreshTotals();

          //   handleAutoSave()
        await apiService.requestENTCSApproval(JWTtoken, series, approvalSenderEmail, approverSenderName, approvalSenderEmpId)
        .then(response => {
          response.data.map(async (approver) => {
            let approvalRole = approver.role;
            let approvalId = approver.userId;
            console.log(':::::Approval Role::::>', approvalRole)
            if (approvalRole === 'TEAM LEADER') {
              setAppvTeamLeaderReq('YES')
            } else if (approvalRole === 'BRANCH HEAD') {
              setAppvBranchHeadReq('YES')
            } else if (approvalRole === 'REGION BUSINESS HEAD') {
              setAppvRegionBusinessHeadReq('YES')
            } else if (approvalRole === 'BUSINESS FINANCE') {
              setAppvBusinessFinanceReq('YES')
            } else if (approvalRole === 'EXPORT COMPLIANCE') {
              setAppvExportComplianceReq('YES')
            } else if (approvalRole === 'CREDIT INSURANCE') {
              setAppvCreditInsuranceReq('YES')
            } else if (approvalRole === 'CEO') {
              setAppvCEOReq('YES')
            } else if (approvalRole === 'COO') {
              setAppvCOOReq('YES')
            } else if (approvalRole === 'CFO') {
              setAppvCFOReq('YES')
            } else if (approvalRole === 'SVP-DIRECTOR') {
              setAppvSVPDirectorReq('YES')
            } else if (approvalRole === 'FUNCTIONAL HEAD') {
             if (approvalId === functionalHead1ID){
                  setAppvFunctionalHeadReq('YES')
                }
                if (approvalId === functionalHead2ID){
                  setAppvFunctionalHead2Req('YES')
                }
                if (approvalId === functionalHead3ID){
                  setAppvFunctionalHead3Req('YES')
                }
                if (approvalId === functionalHead4ID){
                  setAppvFunctionalHead4Req('YES')
                }
                if (approvalId === functionalHead5ID){
                  setAppvFunctionalHead5Req('YES')
                }
                if (approvalId === functionalHead6ID){
                  setAppvFunctionalHead6Req('YES')
                }
            } else if (approvalRole === 'LEGAL HEAD') {
              setAppvlegalHeadReq('YES')
            } else if (approvalRole === 'DYT-CFO') {
              setAppvDytCFOReq('YES')
            }
          });

          if (response.status == 200) {
            console.log("ENTCOSTSHEET - Handle Admin Appv ::::>>", response)
            setTimeout(() => { window.location.reload() }, 2000);
            toast.success("All Approval Mails Sent", {
              autoClose: 2000,
            });
          }
        })

        // await apiService.postAppNotifyRequestApproval(JWTtoken, series)

      } catch (error) {
        console.log(':::::Error while verifying sales user before approval:', error)
        toast.error(`Error while verifying sales user before approval:${error}`)
      }
    }

    const handleOpenModal = async () => {
        try {
          const JWTtoken = window.sessionStorage.getItem('token')
    
          await apiService.checkOpenOppType(JWTtoken, searchTerm)
            .then(response => {
    
              if (response.data.opportunityType === 'Open') {
              let hasError = false;
              const loginRole = window.sessionStorage.getItem('role');
              const errorCheck = (condition, message) => {
                  if (condition) {
                  toast.error(message);
                  hasError = true;
                  }
              };
  
              errorCheck(!searchTerm || searchTerm.trim() === '', 'Please Select CRM Number');
              // errorCheck(!oem || oem.trim() === '', 'Please select Opportunity Category(OEM)');
              errorCheck(!transactionCurrency || transactionCurrency.trim() === '', 'Please select Transaction Currency');
              errorCheck(!materialDeliveryDate || materialDeliveryDate.trim() === '', 'Please select Expected date of Delivery');
              errorCheck(!vendorBillingCycle || vendorBillingCycle.trim() === '', 'Please select Vendor Billing Cycle');
              errorCheck(!hitachiRoleinthisDeal || hitachiRoleinthisDeal.trim() === '', 'Please fill Hitachi Role in this Deal');
              errorCheck(!vendorPaymentTerms || vendorPaymentTerms.trim() === '', 'Please fill Vendor Payment Terms');
              errorCheck(!customerPaymentTerms || customerPaymentTerms.trim() === '', 'Please fill Customer Payment Terms');
              errorCheck(totalVendorPaymentTermsPercentage < 100 || totalVendorPaymentTermsPercentage > 100 , 'Please Validate Vendor Payment Terms');
              errorCheck(totalCustomerPaymentTermsPercentage < 100 || totalCustomerPaymentTermsPercentage > 100 , 'Please Validate Customer Payment Terms');
              
              if (confirmRebate === 'YES'){
                errorCheck(!fileName4 || fileName4.trim() === '' || fileName4 === 'No File Selected', 'Please Upload Supporting Document for Rebate');  
              }
              errorCheck(!fileName1 || fileName1.trim() === '' || fileName1 === 'No File Selected', 'Please Upload Customer accepted PO');
              errorCheck(!fileName2 || fileName2.trim() === '' || fileName2 === 'No File Selected', 'Please Upload Vendor TP with their payment terms and delivery timeline of that product');

              // ✅ Final check: only proceed if no errors
              if (!hasError) {
                  console.log('All checks passed. Setting modal.');
                  setModalSentForAppv(true);
              }
  
              } else if (response.data.opportunityType === 'Won') {
              toast.error('This opportunity is already WON');
              } else if (response.data.opportunityType === 'Lost') {
              toast.error('This opportunity is already LOST');
              }

            })
          //  setModalSentForAppv(true);
        } catch (error) {
          // console.log(':::::Error while sending preloading for approval', error)
          toast.error(`Error while sending preloading for approval: ${error}`)
        }
      };
    // const handleSelectChange = async () => {}
    const handleCloseModal = () => setModalSentForAppv(false);

    const handleQuesNext = async (e) => {
      e.preventDefault();
      const JWTtoken = window.sessionStorage.getItem('token')
      const confirmation = 'Required';
      await handleAutoSave({ event: e, fromButton: false });
      await apiService.checkENTCSApprovalTable(JWTtoken, series, confirmation ).then((response) => {
        const approverRoles = response.data.map((a) => a.role); 
  
        const roleSetters = {
          "TEAM LEADER": setAppvTeamLeaderReq,
          "BRANCH HEAD": setAppvBranchHeadReq,
          "REGION BUSINESS HEAD": setAppvRegionBusinessHeadReq,
          "BUSINESS FINANCE": setAppvBusinessFinanceReq,
          "EXPORT COMPLIANCE": setAppvExportComplianceReq,
          "CREDIT INSURANCE": setAppvCreditInsuranceReq,
          "CEO": setAppvCEOReq,
          "COO": setAppvCOOReq,
          "CFO": setAppvCFOReq,
          "SVP-Director": setAppvSVPDirectorReq,
          "FUNCTIONAL HEAD - 1": setAppvFunctionalHeadReq,
          "FUNCTIONAL HEAD - 2": setAppvFunctionalHead2Req,
          "FUNCTIONAL HEAD - 3": setAppvFunctionalHead3Req,
          "FUNCTIONAL HEAD - 4": setAppvFunctionalHead4Req,
          "FUNCTIONAL HEAD - 5": setAppvFunctionalHead5Req,
          "FUNCTIONAL HEAD - 6": setAppvFunctionalHead6Req,
          "Legal Head": setAppvlegalHeadReq, 
          "DYT-CFO": setAppvDytCFOReq
        };
  
        Object.entries(roleSetters).forEach(([role, setter]) => {
          if (approverRoles.includes(role)) {
            setter("YES");
          } else {
            setter("NA");
          }
        });
      });
  
      setStep(2);
    };

    const renderEXCompQuestions = (index, label, value, onChange, readonly = false) => (
        <tr key={index}>
          <td>{index + 1}</td>
          <td><i className="fa-solid fa-star-of-life" style={{ color: '#e91717', fontSize: '10px', marginLeft: '1px' }} /> {label}</td>
          <td>
            <Form.Check inline label="Yes" name={label} type="radio" value="Yes" checked={value === 'Yes'} onChange={() => {onChange('Yes'); setExCompMessage(''); setExCompRemark(false); }}  disabled={readonly} />
            <Form.Check inline label="No" name={label} type="radio" value="No" checked={value === 'No'} onChange={() => {onChange('No'); setExCompMessage('');  setExCompRemark(false); }} disabled={readonly} />
          </td>
        </tr>
    );
    
    const handleExCompAppvRemark = async () => {
    const questions = [ques1, ques2, ques3, ques4, ques5, ques6, ques7, ques8, ques9, ques10, ques11, ques12, ques13, ques14 ];

      //  console.log("hellloo..",ques14);
       

    const isValid = questions.every(q => q === 'Yes' || q === 'No');

    if (!isValid) {
        alert('All questions are mandatory and must be either "Yes" or "No"!');
        return;
    }else{
      const num_ques1 = (ques1 === "Yes") ? 0 : (ques1 === "No") ? 1 : null;
      const num_ques2 = (ques2 === "Yes") ? 0 : (ques2 === "No") ? 1 : null;
      const num_ques3 = (ques3 === "Yes") ? 1 : (ques3 === "No") ? 0 : null;
      const num_ques4 = (ques4 === "Yes") ? 1 : (ques4 === "No") ? 0 : null;
      const num_ques5 = (ques5 === "Yes") ? 0 : (ques5 === "No") ? 1 : null;
      const num_ques6 = (ques6 === "Yes") ? 1 : (ques6 === "No") ? 0 : null;
      const num_ques7 = (ques7 === "Yes") ? 0 : (ques7 === "No") ? 1 : null;
      const num_ques8 = (ques8 === "Yes") ? 1 : (ques8 === "No") ? 0 : null;
      const num_ques9 = (ques9 === "Yes") ? 1 : (ques9 === "No") ? 0 : null;
      const num_ques10 = (ques10 === "Yes") ? 1 : (ques10 === "No") ? 0 : null;
      const num_ques11 = (ques11 === "Yes") ? 1 : (ques11 === "No") ? 0 : null;
      const num_ques12 = (ques12 === "Yes") ? 1 : (ques12 === "No") ? 0 : null;
      const num_ques13 = (ques13 === "Yes") ? 1 : (ques13 === "No") ? 0 : null;
      const num_ques14 = (ques14 === "Yes") ? 1 : (ques14 === "No") ? 0 : null;
      const sum_message = num_ques1 + num_ques2 + num_ques3 + num_ques4 + num_ques5 + num_ques6 + 
      num_ques7 + num_ques8 + num_ques9 + num_ques10 + num_ques11 + num_ques12 + num_ques13 + num_ques14
      
      sum_message == 0
        ? setExCompMessage('As per above declaration Export Compliance Approval is Not Required.')
        : sum_message >= 1
        ? setExCompMessage('As per above declaration Export Compliance Approval is Required.')
        : setExCompMessage('');
      setExCompRemark(true);
    }
    handleAutoSave()
    }

    const handleSelectChange = (crmNumber) => {
    const crm_num = crmNumber;
    setSearchTerm(crm_num);
    // setShowDropdown(false);
    const selectedCrm = crmData.find(item => item.crmNumber === crm_num);

    if (selectedCrm) {
      setcustomerName(selectedCrm.customerName);
      setsalesPersonName(selectedCrm.salesPersonName);
      setopportunityName(selectedCrm.opportunityName);
      setsalesPersonID(selectedCrm.salesPersonID);
      setpanNumber(selectedCrm.pan);
      setQues11(selectedCrm.dealBaseCheckApproval)
    }
    else {
      setcustomerName('');
      setsalesPersonName('');
      setopportunityName('');
      setsalesPersonID('');
      setpanNumber('');
    }
    };

    const handleToggleNote = () => {
      setIsNoteVisible(!isNoteVisible);
    };

    const handleCloseReopenModal = () => setShowReopen(false);
    const handleShowReopenModal = () => setShowReopen(true);
    const handleReopenPrelaoding = async (status) => {
      try {
        const JWTtoken = window.sessionStorage.getItem('token')
        const response = await apiService.clearENTCSApprovals(JWTtoken, series)
          .then(response => {
            toast.success(`${series} is reopened for Re-Approvals`)
            handleCloseReopenModal()
          })
          .catch(error => {
            setError(error);
          });
        console.log(':::::Clear Approvals API Response:', response.data);
      } catch (error) {
        console.error('Error in API call:', error);
      }
    };

    // ------------------------------------------------------------------------
  
    const handleSelectFile1 = async (e) => {
      e.preventDefault()
          const selectedFile = e.target.files[0];
          if (selectedFile) {
            setFile1(selectedFile);
            setFileName1(selectedFile.name);
            setfileSaveTrigger((prev)=>prev + 1)
            toast.success(`File Selected: ${selectedFile.name}`);
          }
    };
  
    const handleRemoveFile1 = () => {
      setFile1(null);
      setFileName1('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
      
    };
  
    const handleViewFile1 = async () => {
       const JWTtoken = window.sessionStorage.getItem('token')
          
          fileName1 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName1)
          .then((response) => {
            const url = window.URL.createObjectURL(new Blob([response.data]));
            const link = document.createElement('a');
            link.href = url;
            link.setAttribute('download', fileName1);
            document.body.appendChild(link);
            link.click();
            link.remove();
          })
          .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------
    const handleSelectFile2 = async (e) => {
       e.preventDefault()
          const selectedFile = e.target.files[0];
          if (selectedFile) {
            setFile2(selectedFile);
            setFileName2(selectedFile.name);
            setfileSaveTrigger((prev)=>prev + 1)
            toast.success(`File Selected: ${selectedFile.name}`);
          }
    };

    const handleRemoveFile2 = () => {
      setFile2(null);
      setFileName2('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile2 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName2 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName2)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName2);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------

    const handleSelectFile3 = async (e) => {
      e.preventDefault()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile3(selectedFile);
          setFileName3(selectedFile.name);
          setfileSaveTrigger((prev)=>prev + 1)
          toast.success(`File Selected: ${selectedFile.name}`);
        }
    };
  
    const handleRemoveFile3 = () => {
      setFile3(null);
      setFileName3('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile3 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName3 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName3)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName3);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------
    const handleSelectFile4 = async (e) => {
        e.preventDefault()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile4(selectedFile);
          setFileName4(selectedFile.name);
          setfileSaveTrigger((prev)=>prev + 1)
          toast.success(`File Selected: ${selectedFile.name}`);
        }
    };
  
    const handleRemoveFile4 = () => {
      setFile4(null);
      setFileName4('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile4 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName4 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName4)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName4);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------
    const handleSelectFile5 = async (e) => {
      e.preventDefault()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile5(selectedFile);
          setFileName5(selectedFile.name);
          setfileSaveTrigger((prev)=>prev + 1)
          toast.success(`File Selected: ${selectedFile.name}`);
        }
    };
  
    const handleRemoveFile5 = () => {
      setFile5(null);
      setFileName5('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile5 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName5 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName5)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName5);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------
    const handleSelectFile6 = async (e) => {
        e.preventDefault()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile6(selectedFile);
          setFileName6(selectedFile.name);
          setfileSaveTrigger((prev)=>prev + 1)
          toast.success(`File Selected: ${selectedFile.name}`);
        }
    };
  
    const handleRemoveFile6 = () => {
      setFile6(null);
      setFileName6('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile6 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName6 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName6)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName6);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------
    const handleSelectFile7 = async (e) => {
        e.preventDefault()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile7(selectedFile);
          setFileName7(selectedFile.name);
          setfileSaveTrigger((prev)=>prev + 1)
          toast.success(`File Selected: ${selectedFile.name}`);
        }
    };
  
    const handleRemoveFile7 = () => {
      setFile7(null);
      setFileName7('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile7 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName7 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName7)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName7);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------
    const handleSelectFile8 = async (e) => {
        e.preventDefault()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile8(selectedFile);
          setFileName8(selectedFile.name);
          setfileSaveTrigger((prev)=>prev + 1)
          toast.success(`File Selected: ${selectedFile.name}`);
        }
    };
  
    const handleRemoveFile8 = () => {
      setFile8(null);
      setFileName8('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile8 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName8 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName8)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName8);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------
    const handleSelectFile9 = async (e) => {
        e.preventDefault()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile9(selectedFile);
          setFileName9(selectedFile.name);
          setfileSaveTrigger((prev)=>prev + 1)
          toast.success(`File Selected: ${selectedFile.name}`);
        }
    };
  
    const handleRemoveFile9 = () => {
      setFile9(null);
      setFileName9('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile9 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName9 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName9)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName9);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

    // ------------------------------------------------------------------------
    const handleSelectFile10 = async (e) => {
        e.preventDefault()
        const selectedFile = e.target.files[0];
        if (selectedFile) {
          setFile10(selectedFile);
          setFileName10(selectedFile.name);
          setfileSaveTrigger((prev)=>prev + 1)
          toast.success(`File Selected: ${selectedFile.name}`);
        }
    };
  
    const handleRemoveFile10 = () => {
      setFile10(null);
      setFileName10('No File Selected');
      setfileSaveTrigger(0);
      toast.error('File Removed');
    };
  
    const handleViewFile10 = async () => {
      const JWTtoken = window.sessionStorage.getItem('token')
        
        fileName10 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName10)
        .then((response) => {
          const url = window.URL.createObjectURL(new Blob([response.data]));
          const link = document.createElement('a');
          link.href = url;
          link.setAttribute('download', fileName10);
          document.body.appendChild(link);
          link.click();
          link.remove();
        })
        .catch(console.error) : toast.error('No File Selected');
    };

//===========================================================================================================================================================
  
  const [currencyRates, setCurrencyRates] = useState({});
  const [totalValues, setTotalValues] = useState(Array(9).fill(0));

  const makeValues = (len) => Array(len).fill(null).map(() => ({ amount: 0, currency: "INR" }));

  const columnNames = [
    "Selling Value",
    "Transfer Prices",
    "Finance Fee",
    "Contingency Fee",
    "Penalty",
    "Insurance Fee",
    "Forex Fee",
    "MARGIN",
    "MARGIN %",
  ];

// transactionCurrency
  const initialRows = [
    { id: 1, name: "Year 1", currency: "INR", values: makeValues(9) },
    { id: 2, name: "Year 2", currency: "INR", values: makeValues(9) },
    { id: 3, name: "Year 3", currency: "INR", values: makeValues(9) },
  ];

  const extraRowNames = [
    "Year 4", "Year 5", "Year 6", "Year 7", "Year 8", "Year 9", "Year 10",
    "Year1 TP in USD", "Hitachi Implement", "Hitachi Manage Services", "Hitachi FMS",
    "OEM Implement", "OEM Support", "OEM Service", "Hitachi Support Services",
    "AWS Cloud", "AWS Manage Service", "MS Cloud", "Microsoft Manage Service",
    "Oracle Cloud", "Oracle Manage Service", "APM", "NOC", "SOC", "PCVisor", 
    "DIGI Box Cloud", "Finance Income", "Rebate", "Finance Cost"
  ];

  const enrichRow = (row) => {
    if (row.name === "Total") return row;
    const updatedValues = row.values.map((v) => typeof v === "object" ? v : { amount: v, currency: "INR"});
    const amounts = updatedValues.map((v) => v.amount);
    const { margin, marginPercent } = computeRowMargin(amounts);
    updatedValues[7] = { ...updatedValues[7], amount: margin };
    updatedValues[8] = { ...updatedValues[8], amount: marginPercent };
    return { ...row, values: updatedValues };
  };

  const computeRowMargin = (values) => {
    const [selling, transfer, finance, contingency, penalty, insurance, forex] = values;
    const margin = selling - transfer - finance - contingency - penalty - insurance - forex;
    const marginPercent = selling ? (margin / selling) * 100 : 0;
    return {
      margin: Number(margin.toFixed(2)),
      marginPercent: Number(marginPercent.toFixed(2)),
    };
  };

  const [rows, setRows] = useState([
    ...initialRows.map(enrichRow),
    { id: 999, name: "Total", values: makeValues(9) },
  ]);

  // ✅ Track which rows the user has manually changed via the currency dropdown,
  // so the auto-sync below never overwrites a deliberate user choice.
  const manuallyChangedRowsRef = useRef(new Set());

  // ✅ Keep Year 1-3 currency mirrored to transactionCurrency ONLY in single-currency
  // mode (transactionCurrency === secondaryTransactionCurrency). In multi-currency
  // mode (the two differ), the user is expected to pick currency per row (e.g. INR
  // for Year 2 while primary is USD) — so we must NOT force-overwrite rows here,
  // otherwise a DOM refresh / remount (which resets manuallyChangedRowsRef) would
  // wipe out that manual per-row choice back to transactionCurrency.
  useEffect(() => {
    if (!transactionCurrency) return;
    if (transactionCurrency !== secondaryTransactionCurrency) return; // multi-currency mode: skip auto-sync
    setRows((prev) =>
      prev.map((row) =>
        ["Year 1", "Year 2", "Year 3"].includes(row.name) && !manuallyChangedRowsRef.current.has(row.id)
          ? { ...row, currency: transactionCurrency }
          : row
      )
    );
  }, [transactionCurrency, secondaryTransactionCurrency]);

  const paymentTermsNonTotalRows = rows.filter((r) => r.name !== "Total");

  // const getRate = async (currency) => {
  //   if (currency === "INR") return 1;
  //   // console.log('currency',currency)
  //   if (currencyRates[currency]) return currencyRates[currency];
  //   const JWTtoken = window.sessionStorage.getItem("token");
  //   const rate = await apiService.getForexRecord(JWTtoken, currency);
  //   setCurrencyRates((prev) => ({ ...prev, [currency]: rate.data }));
  //   return rate.data;
  // };
  const getRate = async (currency, forceRefresh = false) => {
    // ✅ Guard against undefined, null, "", "INR", or any non-string
    if (!currency || typeof currency !== "string" || currency.trim() === "" || currency === "INR") {
      return 1;
    }

    // ✅ Cache hit — unless forceRefresh is explicitly requested (e.g. Send for Approval)
    if (!forceRefresh && currencyRates[currency]) return currencyRates[currency];

    try {
      const JWTtoken = window.sessionStorage.getItem("token");
      const res = await apiService.getForexRecord(JWTtoken, currency.trim());
      const rate = res.data;
      setCurrencyRates((prev) => ({ ...prev, [currency]: rate })); // overwrites stale cached value too
      return rate;
    } catch (err) {
      console.warn(`⚠️ Rate fetch failed for "${currency}", defaulting to 1`, err);
      return 1; // ✅ never crash calculateTotal
    }
  };
  const handleRowCurrencyChange = async (rowId, currency) => {
    await getRate(currency);

    manuallyChangedRowsRef.current.add(rowId); // ✅ user override — stop auto-syncing this row

    setRows((prev) => prev.map((row) => row.id === rowId ? { ...row, currency } : row ));
  };

  const handleValueChange = (rowId, colIndex, newValue) => {
    setDirtyFCTable(true);
    setRows((prev) =>
      prev.map((row) => {
        if (row.id !== rowId || row.name === "Total") return row;
        const cleanedValue = newValue.replace(/^0+(?=\d)/, "");
        const numericValue = cleanedValue === "" ? 0 : parseFloat(cleanedValue);
        const updatedValues = row.values.map((val, i) =>
          i === colIndex ? { ...val, amount: numericValue } : val
        );
        // Recompute margin (cols 0-6 are amounts)
        const amounts = updatedValues.map((v) => v.amount);
        const { margin, marginPercent } = computeRowMargin(amounts);
        updatedValues[7] = { ...updatedValues[7], amount: margin };
        updatedValues[8] = { ...updatedValues[8], amount: marginPercent };
        return { ...row, values: updatedValues };
      })
    );
  };

  const addRow = (name) => {
    setRows((prev) => {
      if (prev.some((row) => row.name === name)) return prev;
      const newRow = enrichRow({ id: Date.now(), name, currency: transactionCurrency , values: makeValues(9) });
      const totalRow = prev.find((r) => r.name === "Total");
      const others = prev.filter((r) => r.name !== "Total");
      return [...others, newRow, totalRow];
    });
  };

  const removeRow = (id) => {
          setRows((prev) => prev.filter((row) => row.id !== id));
  };

  const calculateTotal = async () => {
    const numCols = 9;
    const totals = Array(numCols).fill(0);
    const nonTotalRows = rows.filter((r) => r.name !== "Total");
    // console.log('nonTotalRows>>>>>>>>>>>>>>>>>>>>>>>>>>>>',nonTotalRows)

    const yearMultiplier = {
      "Year 1": 1,        
      "Year 2": 1.05,
      "Year 3": 1.05 ** 2,
      "Year 4": 1.05 ** 3,
      "Year 5": 1.05 ** 4,
      "Year 6": 1.05 ** 5,
      "Year 7": 1.05 ** 6,
    };

    for (const row of nonTotalRows) {
      // ✅ Sanitize currency
      const rawCurrency = row.currency ?? transactionCurrency ?? "INR";
      const currency = (typeof rawCurrency === "string" && rawCurrency.trim() !== "")
        ? rawCurrency.trim()
        : "INR";

      // ✅ If currency is not INR: non-Year rows convert by conversionRate as-is;
      // Year 1..Year 7 rows convert by conversionRate * that year's multiplier.
      const baseRate = currency === "INR" ? 1 : (Number(conversionRate) || 0);
      const multiplier = currency !== "INR" ? (yearMultiplier[row.name] ?? 1) : 1;
      const effectiveRate = Number((baseRate * multiplier).toFixed(2));

       // ✅ Subtract if name is "Rebate", otherwise add
      const isRebate = row.name?.trim() === "Rebate";

      for (let i = 0; i < 7; i++) {
        const amount = row.values[i]?.amount || 0;
        const convertedAmount = (parseFloat(amount) || 0) * effectiveRate;
        totals[i] += isRebate ? -convertedAmount : convertedAmount;
      }

      // for (let i = 0; i < 7; i++) {
      //   const amount = row.values[i]?.amount || 0;
      //   totals[i] += (parseFloat(amount) || 0) * effectiveRate;
      // }
    }

    const { margin, marginPercent } = computeRowMargin(totals);
    totals[7] = Number(margin.toFixed(2));
    totals[8] = Number(marginPercent.toFixed(2));

    return totals.map((t) => Number(parseFloat(t).toFixed(2)));
  };

  useEffect(() => {
    const recalc = async () => {
      const result = await calculateTotal();
      setTotalValues(result);
      setRows((prev) =>
        prev.map((row) =>
          row.name === "Total"
            ? { ...row, values: row.values.map((v, i) => ({ ...v, amount: result[i] })) }
            : row
        )
      );
    };
    recalc();
  }, [
    JSON.stringify(
      rows.filter((r) => r.name !== "Total").map((r) => ({
          currency: r.currency || transactionCurrency,  // ✅ include currency in dep
          values: r.values.map((v) => v.amount),
        }))
    ),
    conversionRate, // ✅ recompute when the manually-entered/fetched primary rate changes
  ]);

  // ✅ Explicit "refresh trigger" — used ONLY at the two points the user wants a
  // fresh rate: (1) transactionCurrency being saved (handleCurrencyChange), and
  // (2) the Send for Approval buttons. Force-refreshes every currency actually
  // in use across the rows (bypassing the cache), updates the primary
  // conversionRate, recomputes the Total row, and RETURNS the fresh totals
  // directly — because setRows()/setconversionRate() are async, a caller that
  // needs the fresh Total values immediately (e.g. to build rowsToSave before
  // saving) cannot rely on reading `rows` right after calling this; it must use
  // the returned value instead.
  const refreshRatesAndGetFreshTotals = async () => {
    const currenciesInUse = Array.from(
      new Set(
        rows
          .filter((r) => r.name !== "Total")
          .map((r) => r.currency || transactionCurrency)
          .filter((c) => c && c !== "INR")
      )
    );

    // Force-refresh every distinct non-INR currency actually used by a row
    await Promise.all(currenciesInUse.map((c) => getRate(c, true)));

    // ✅ Trigger point #2: Send for Approval. Only fetch/overwrite the primary
    // conversionRate when it is blank — otherwise keep the manually entered
    // (or already-resolved) value as the source of truth for conversion.
    const isConversionRateBlank =
      conversionRate === undefined || conversionRate === null || conversionRate === "";

    if (transactionCurrency === "INR") {
      setconversionRate(1);
    } else if (isConversionRateBlank) {
      const freshPrimaryRate = await getRate(transactionCurrency, true);
      setconversionRate(freshPrimaryRate);
    }
    // else: conversionRate already has a value — leave it untouched.

    // Recompute Total using the now-freshly-cached rates
    const result = await calculateTotal();
    setTotalValues(result);
    setRows((prev) =>
      prev.map((row) =>
        row.name === "Total"
          ? { ...row, values: row.values.map((v, i) => ({ ...v, amount: result[i] })) }
          : row
      )
    );

    return result; // ✅ caller uses this directly instead of waiting on stale `rows`
  };

    // ─── Save rows ───────────────────────────────────────────────────
    const handleSaveFinancialTable = () => {
      const JWTtoken = window.sessionStorage.getItem('token');
      setDirtyFCTable(false)

      // currency: row.currency || "INR",
      // currency: row.currency,
      const rowsToSave = rows.map((row) => ({
        id: row.id,
        name: row.name,
        currency: row.name === "Total" ? row.currency ?? "INR" : row.currency,
        values: row.values.map((v) => ({
          amount: v.amount,
          currency: v.currency,
        })),
      }));

      apiService.saveFinancialTable(JWTtoken, series, rowsToSave)
        .then((response) => {
          if (response.data.message === "Financial table saved successfully") {
            setTimeout(() => toast.success("Financial Table Saved"), 1000);
          }
        })
        .catch((error) => {
          setError(error);
          console.error("Failed to save financial table:", error);
        });

      console.log('vendorPaymentTerms',vendorPaymentTerms)
      // if(vendorPaymentTerms !== ""){
      //   recalculateAllVendorPaymentTermValues();
      // }
      console.log('customerPaymentTerms',customerPaymentTerms)
      // if(customerPaymentTerms !== ""){
      //   recalculateAllCustomerPaymentTermValues();
      // }
    };
     
      const totalRow = rows.find((row) => row.name === "Total");
      const marginPercent      = totalRow?.values?.[8]?.amount ?? 0;
      const totalTransferPrice = totalRow?.values?.[1]?.amount ?? 0;
      const totalSellingValue  = totalRow?.values?.[0]?.amount ?? 0;
      const showMarginRemarksRow = marginPercent < 6;
  //------------------------------------------------------------------------------------------VENDOR PAYMENTS TERMS DETAILS

  const [vendorPaymentTermsDetails, setVendorPaymentTermsDetails] = useState([{formSeries: `${series}`, vendorpayemntTermsParticular:"", vendorpaymentTermsDays: "", vendorpaymentTermsPercentage: "", vendorpaymentTermsValue:"" }]);


  const handleVendorPaymentTermChange = (index, field, value) => {
    const updated = [...vendorPaymentTermsDetails];
    updated[index][field] = value;
    setVendorPaymentTermsDetails(updated);
    // console.log('paymentTermsNonTotalRows',paymentTermsNonTotalRows)
  };

  const addVendorPaymentTermRow = () => {
    setVendorPaymentTermsDetails([...vendorPaymentTermsDetails, {formSeries: `${series}`, vendorpayemntTermsParticular:"", vendorpaymentTermsDays: "", vendorpaymentTermsPercentage: "", vendorpaymentTermsValue:""}]);
  };

  const closeVendorPaymentTermModal = () => {
    setIsVendorPaymentTermModalOpen(false);
  };

  const handlesSaveVendorPaymentTerms = (vpt_btn = false, overrideRows = null) => {
    // ✅ Guard against the load race: refuse to save while the financial
    // table's real transfer price hasn't loaded yet — otherwise the derived
    // expectedDtVendorPayment computation divides by 0 (Infinity/NaN days →
    // Invalid Date) and gets persisted, and this function's own save call
    // below would also persist any 0-corrupted Value cells.
    if (!financialTableLoaded || !totalTransferPrice) {
      toast.error("Financial table is still loading. Please wait a moment and try again.");
      return;
    }

    const JWTtoken = window.sessionStorage.getItem('token');
    const loginRole = window.sessionStorage.getItem('role');

    // ✅ Use overrideRows if provided, else fall back to state
    const rowsToSave = overrideRows ?? vendorPaymentTermsDetails;

    apiService.saveVendorPaymentTerms(JWTtoken, loginRole, JSON.stringify(rowsToSave))
      .then(response => {
        if (response.data.message === "Vendor payment terms saved successfully") {
          setTimeout(() => {
            toast.success("Vendor Payment Terms Saved");
          }, 1000);
        }
        closeVendorPaymentTermModal();
      })
      .catch(error => {
        setError(error);
        closeVendorPaymentTermModal();
      });

    if (!rowsToSave?.length) return;  // ✅ was vendorPaymentTermsDetails

    const decimalString = rowsToSave  // ✅ was vendorPaymentTermsDetails
      .map(item => `${item.vendorpaymentTermsPercentage / 100} ${item.vendorpaymentTermsDays}D`)
      .join(" ; ");

    setvendorPaymentTerms(decimalString);

    console.log('rowsToSave', rowsToSave)

    const vptweightedSum = rowsToSave.reduce((vptsum, item) => {  // ✅ was vendorPaymentTermsDetails
      const vptdays = Number(item.vendorpaymentTermsDays);
      const vptvalue = Number(item.vendorpaymentTermsValue);
      return vptsum + vptdays * vptvalue;
    }, 0);
    
    console.log('VPT Sum Value::::>>',vptweightedSum)
    console.log('Total Selling Value::::>>',Number(totalTransferPrice)) 
    const vpttotalDays = Math.round(vptweightedSum / Number(totalTransferPrice));
    console.log('VPT Total Days::::>>',vpttotalDays)
    console.log('Material Delivery Date::::>>',materialDeliveryDate)
    const vptupdatedDate = addDays(materialDeliveryDate, vpttotalDays);
    console.log('VPT Updated Date::::>>',vptupdatedDate)
    setexpectedDtVendorPayment(moment(vptupdatedDate).format("YYYY-MM-DD"));
    handleAutoSave({ fromButton: false });
  };

  const deleteVendorPaymentTermRow = (index) => {
    const sequence = index + 1
    // console.log("SERIES",series)
    // console.log("Sequence",sequence)
    const JWTtoken = window.sessionStorage.getItem('token')
    const loginRole = window.sessionStorage.getItem('role')
    apiService.deleteVendorPaymentTerm(JWTtoken, loginRole, series, sequence)
      .then(response => {
         if (response.data.message === "Vendor payment term deleted and sequence reordered") {
              setTimeout(() => {toast.success("Vendor Payment Term Deleted")}, 1000);
              setVendorPaymentTermsDetails((prev) => prev.filter((_, i) => i !== index));
              }
      })
      .catch(error => {
        if(error.status === 404) {
         toast.success("Vendor Payment Term Deleted")
         setVendorPaymentTermsDetails((prev) => prev.filter((_, i) => i !== index));
        }else{
          setError(error);
          console.log('ENTCS_ERROR - deleteVendorPaymentTermRow',error)
          toast.error(`Error: ${error}`)
      }
      });
  };

  
  const totalVendorPaymentTermsValue = vendorPaymentTermsDetails.reduce((sum, row) => {
  const value = parseFloat(row.vendorpaymentTermsValue);
  return isNaN(value) ? sum : sum + value;
  }, 0);

  const nonTotalFCTRows = rows.filter((r) => r.name !== "Total");
  
  const totalTransferPriceWithoutTotal =  Math.trunc(totalTransferPrice)

  const totalVendorPaymentTermsPercentage = ((totalVendorPaymentTermsValue / totalTransferPriceWithoutTotal) * 100).toFixed(2)
  
  const vendorPercentageShortfall = (totalVendorPaymentTermsPercentage - 100.00).toFixed(2);

  const addDays = (date, days) => {
  const result = new Date(date);
  result.setDate(result.getDate() + days);
  return result;
  };
  
  //-------------------------------------------------------------------------------------------------------------------------Customer Payments Terms Details

  const [customerPaymentTermsDetails, setCustomerPaymentTermsDetails] = useState([{formSeries: `${series}`,customerpaymentTermsParticular: "", customerpaymentTermsDays: "", customerpaymentTermsPercentage: "", customerpaymentTermsValue:"" }]);

  const handleCustomerPaymentTermChange = (index, field, value) => {
    const updated = [...customerPaymentTermsDetails];
    updated[index][field] = value;
    setCustomerPaymentTermsDetails(updated);
  };

  const addCustomerPaymentTermRow = () => {
    setCustomerPaymentTermsDetails([...customerPaymentTermsDetails, {formSeries: `${series}`, customerpaymentTermsParticular: "", customerpaymentTermsDays: "", customerpaymentTermsPercentage: "", customerpaymentTermsValue:""}]);
  };

  const closeCustomerPaymentTermModal = () => {
    setIsCustomerPaymentTermModalOpen(false);
  };

  const handlesSaveCustomerPaymentTerms = (cpt_btn = false) =>{
    // ✅ Same load-race guard as handlesSaveVendorPaymentTerms — refuse to save
    // while the financial table's real selling value hasn't loaded yet.
    if (!financialTableLoaded || !totalSellingValue) {
      toast.error("Financial table is still loading. Please wait a moment and try again.");
      return;
    }

    const JWTtoken = window.sessionStorage.getItem('token')
    const loginRole = window.sessionStorage.getItem('role')
    // console.log('CUSTOMBERRRR>>>>', JSON.stringify(customerPaymentTermsDetails))
    apiService.saveCustomerPaymentTerms(JWTtoken, loginRole,  JSON.stringify(customerPaymentTermsDetails))
      .then(response => {
        // console.log("CCCCCCCCCC",response);
         if (response.data.message === "Customer payment terms saved successfully") {
              setTimeout(() => {
                toast.success("customer Payment Terms Saved");
              }, 1000);
              }
              // console.log(':::::Form submitted successfully:', response.data);
        closeCustomerPaymentTermModal()
      })
      .catch(error => {
        setError(error);
        closeCustomerPaymentTermModal()
      });

      if (!customerPaymentTermsDetails?.length) return;
      const decimalString = customerPaymentTermsDetails.map(item => `${item.customerpaymentTermsPercentage / 100} ${item.customerpaymentTermsDays}D`).join(" ; ");
      setcustomerPaymentTerms(decimalString);

      const cptweightedSum = customerPaymentTermsDetails.reduce((cptsum, item) => {
        const cptdays = Number(item.customerpaymentTermsDays);
        // console.log('cptdays::   ',cptdays)
        const cptvalue = Number(item.customerpaymentTermsValue);
        // console.log('cptvalue::   ',cptvalue)
        return cptsum + cptdays * cptvalue;
      }, 0);
      console.log('CPT Sum Value::::>>',cptweightedSum)
      console.log('Total Selling Value::::>>',Number(totalSellingValue))
      const cpttotalDays = Math.round(cptweightedSum / Number(totalSellingValue));
      console.log('CPT Total Days::::>>',cpttotalDays)
      console.log('Material Delivery Date::::>>',materialDeliveryDate)  
      const cptupdatedDate = addDays(materialDeliveryDate, cpttotalDays);
      console.log('CPT Updated Date::::>>',cptupdatedDate)
      setexpectedDtCustomerRecipt(moment(cptupdatedDate).format("YYYY-MM-DD"));
      handleAutoSave({ fromButton: false });
  }

  // const handlesSaveCustomerPaymentTerms = (cpt_btn = false, overrideRows = null) => {
  //   const JWTtoken = window.sessionStorage.getItem('token');
  //   const loginRole = window.sessionStorage.getItem('role');

  //   const rowsToSave = overrideRows ?? customerPaymentTermsDetails; // ✅ key change

  //   console.log('CUSTOMBERRRR>>>>', JSON.stringify(rowsToSave));

  //   apiService.saveCustomerPaymentTerms(JWTtoken, loginRole, JSON.stringify(rowsToSave))
  //     .then(response => {
  //       if (response.data.message === "Customer payment terms saved successfully") {
  //         setTimeout(() => {
  //           toast.success("customer Payment Terms Saved");
  //         }, 1000);
  //       }
  //       closeCustomerPaymentTermModal();
  //     })
  //     .catch(error => {
  //       setError(error);
  //       closeCustomerPaymentTermModal();
  //     });

  //   if (!rowsToSave?.length) return;

  //   const decimalString = rowsToSave
  //     .map(item => `${item.customerpaymentTermsPercentage / 100} ${item.customerpaymentTermsDays}D`)
  //     .join(" ; ");
  //   setcustomerPaymentTerms(decimalString);   // ✅ setcustomerPaymentTerms (your actual setter)

  //   const cptweightedSum = rowsToSave.reduce((cptsum, item) => {
  //     const cptdays = Number(item.customerpaymentTermsDays);
  //     const cptvalue = Number(item.customerpaymentTermsValue);
  //     return cptsum + cptdays * cptvalue;
  //   }, 0);

  //   const cpttotalDays = Math.round(cptweightedSum / Number(totalSellingValue)); // ✅ totalSellingValue (not totalSellingPrice)
  //   const cptupdatedDate = addDays(materialDeliveryDate, cpttotalDays);
  //   console.log('CPTupdatedDate::   ', cptupdatedDate);
  //   setexpectedDtCustomerRecipt(moment(cptupdatedDate).format("YYYY-MM-DD")); // ✅ setexpectedDtCustomerRecipt (your actual setter)

  //   handleAutoSave({ fromButton: false });
  // };

  const deleteCustomerPaymentTermRow = (index) => {
    const sequence = index + 1
    const JWTtoken = window.sessionStorage.getItem('token')
    const loginRole = window.sessionStorage.getItem('role')
    apiService.deleteCustomerPaymentTerm(JWTtoken, loginRole, series, sequence)
      .then(response => {
         if (response.data.message === "Customer payment term deleted and sequence reordered") {
              setTimeout(() => {toast.success("Customer Payment Term Deleted")}, 1000);
              setCustomerPaymentTermsDetails((prev) => prev.filter((_, i) => i !== index));
            }
      })
      .catch(error => {
         if(error.status === 404) {
         toast.success("Customer Payment Term Deleted")
         setCustomerPaymentTermsDetails((prev) => prev.filter((_, i) => i !== index));
        }else{
          setError(error);
          console.log('ENTCS_ERROR - deleteVendorPaymentTermRow',error)
          toast.error(`Error: ${error}`)
      }
      });
  };

  const totalCustomerPaymentTermsValue = customerPaymentTermsDetails.reduce((sum, row) => {
  const value = parseFloat(row.customerpaymentTermsValue);
  return isNaN(value) ? sum : sum + value;
  }, 0);

  // const totalSellingValueWithoutTotal = nonTotalFCTRows.reduce((sum, row) => {
  // const val = Number(row.values?.[0]?.amount) || 0;
  // return sum + val;
  // }, 0);

  const totalSellingValueWithoutTotal = Math.trunc(totalSellingValue)

  const totalCustomerPaymentTermsPercentage = ((totalCustomerPaymentTermsValue / totalSellingValueWithoutTotal) * 100).toFixed(2)

  const customerPercentageShortfall =  (totalCustomerPaymentTermsPercentage - 100.00).toFixed(2);

  useEffect(() => { 
  if (!expectedDtVendorPayment || !expectedDtCustomerRecipt ) return;

    const vendorDate = moment(expectedDtVendorPayment, "YYYY-MM-DD", true);
    const customerDate = moment(expectedDtCustomerRecipt, "YYYY-MM-DD", true);

    if (vendorDate.isValid() && customerDate.isValid()) {
      const daysDiff = vendorDate.diff(customerDate, "days");
      if (daysDiff <= 0) {
        setcashFlowExpertAdvice("It's become FC Impacted deal");
      } else if (daysDiff > 0) {
        setcashFlowExpertAdvice("It's favourable to Hitachi");
      }else{
        setcashFlowExpertAdvice("");
      }
    }

  }, [expectedDtVendorPayment, expectedDtCustomerRecipt]);

  //-------------------------------------------------------------------------------------------------------------------------

   const host = window.location.hostname; 
    const handleAutoSave = async ({ event = null, fromButton = false, multioemvalues } = {}) => {
      if (event) event.preventDefault();

      const role = window.sessionStorage.getItem("role")?.trim();
      if (role === "BUSINESS FINANCE" && totalSellingValue > 5000000) {
        if (!dealType || dealType.trim() === "" || dealType.trim().toLowerCase() === "null") {
          event.preventDefault();
          toast.error("Form Not Saved, Please Select Deal Type !!");
          return;
        }
      }

       let authUser = window.sessionStorage.getItem('role') === 'SALES'
            || window.sessionStorage.getItem('role') === 'OPERATIONS'
            || window.sessionStorage.getItem('role') === 'ADMIN'
            || window.sessionStorage.getItem('role') === 'BUSINESS FINANCE'
            || window.sessionStorage.getItem('role') === 'TEAM LEADER'
            || window.sessionStorage.getItem('role') === 'EXPORT COMPLIANCE'
          if (authUser) {

            const oemToSave = multioemvalues ?? selectedOem.map(opt => opt.value);
           
            const entcostsheetData = new FormData();
            entcostsheetData.append("userName", userName);
            entcostsheetData.append("userId", userId);
            entcostsheetData.append("userRole", userRole);
            entcostsheetData.append("formSeries", series);
      
            entcostsheetData.append("file1", file1);
            entcostsheetData.append("fileName1", fileName1);
            entcostsheetData.append("file2", file2);
            entcostsheetData.append("fileName2", fileName2);
            entcostsheetData.append("file3", file3);
            entcostsheetData.append("fileName3", fileName3);
            entcostsheetData.append("file4", file4);
            entcostsheetData.append("fileName4", fileName4);
            entcostsheetData.append("file5", file5);
            entcostsheetData.append("fileName5", fileName5);
            entcostsheetData.append("file6", file6);
            entcostsheetData.append("fileName6", fileName6);
            entcostsheetData.append("file7", file7);
            entcostsheetData.append("fileName7", fileName7);
            entcostsheetData.append("file8", file8);
            entcostsheetData.append("fileName8", fileName8);
            entcostsheetData.append("file9", file9);
            entcostsheetData.append("fileName9", fileName9);
            entcostsheetData.append("file10", file10);
            entcostsheetData.append("fileName10", fileName10);

      
            entcostsheetData.append("crmNumber", searchTerm);
            entcostsheetData.append("customerName", customerName);
            entcostsheetData.append("salesPersonName", salesPersonName);
            entcostsheetData.append("salesPersonID", salesPersonID);
            entcostsheetData.append("pan", panNumber);
            entcostsheetData.append("multioemvalues", oemToSave);
            entcostsheetData.append("approvalRequestDate", status === "Open" ? approvalRequestDate : sendForAppvReqDate );
            entcostsheetData.append("opportunityName", opportunityName);
            entcostsheetData.append("vendorBillingCycle", vendorBillingCycle);
            entcostsheetData.append("transactionCurrency", transactionCurrency);
            entcostsheetData.append("secondaryTransactionCurrency", secondaryTransactionCurrency);
            entcostsheetData.append("secondaryOptions", secondaryOptions);
            entcostsheetData.append("vendorPaymentTerms", vendorPaymentTerms);
            entcostsheetData.append("customerPaymentTerms", customerPaymentTerms);
            entcostsheetData.append("dealType", dealType);
            entcostsheetData.append("hitachiRoleinthisDeal", hitachiRoleinthisDeal);
            entcostsheetData.append("materialDeliveryDate", materialDeliveryDate);
            entcostsheetData.append("lowMarginReason", lowMarginReason);
            entcostsheetData.append("confirmRebate", confirmRebate);
            entcostsheetData.append("conversionRate", conversionRate);
            entcostsheetData.append("remarksIfAny", remarksIfAny);
            entcostsheetData.append("expectedDtCustomerRecipt", expectedDtCustomerRecipt);
            entcostsheetData.append("expectedDtVendorPayment", expectedDtVendorPayment);
            entcostsheetData.append("cashFlowExpertAdvice", cashFlowExpertAdvice);
            entcostsheetData.append("marginExpertAdvice", marginExpertAdvice);
            
            entcostsheetData.append("ExCompQues1", ques1);
            entcostsheetData.append("ExCompQues2", ques2);
            entcostsheetData.append("ExCompQues3", ques3);
            entcostsheetData.append("ExCompQues4", ques4);
            entcostsheetData.append("ExCompQues5", ques5);
            entcostsheetData.append("ExCompQues6", ques6);
            entcostsheetData.append("ExCompQues7", ques7);
            entcostsheetData.append("ExCompQues8", ques8);
            entcostsheetData.append("ExCompQues9", ques9);
            entcostsheetData.append("ExCompQues10", ques10);
            entcostsheetData.append("ExCompQues11", ques11);
            entcostsheetData.append("ExCompQues12", ques12);
            entcostsheetData.append("ExCompQues13", ques13);
            entcostsheetData.append("ExCompQues14", ques14);
            entcostsheetData.append("functionalHead1ID", functionalHead1ID);
            entcostsheetData.append("functionalHead1Name", functionalHead1Name);
            entcostsheetData.append("functionalHead2ID", functionalHead2ID);
            entcostsheetData.append("functionalHead2Name", functionalHead2Name);
            entcostsheetData.append("functionalHead3ID", functionalHead3ID);
            entcostsheetData.append("functionalHead3Name", functionalHead3Name);
            entcostsheetData.append("functionalHead4ID", functionalHead4ID);
            entcostsheetData.append("functionalHead4Name", functionalHead4Name);
            entcostsheetData.append("functionalHead5ID", functionalHead5ID);
            entcostsheetData.append("functionalHead5Name", functionalHead5Name);
            entcostsheetData.append("functionalHead6ID", functionalHead6ID);
            entcostsheetData.append("functionalHead6Name", functionalHead6Name);
      
      
            try {
      
              const JWTtoken = window.sessionStorage.getItem('token')
              const response = await axios.post(`https://${host}:9001/api/saveEntCostSheetLogData`, entcostsheetData,
                {
                  headers: {
                    'Content-Type': 'multipart/form-data',
                    'authorization': JWTtoken,
                  },
                }
              )
      
              if (fromButton) {
                toast.success("Form Saved");
              }
              // console.log(':::::Form submitted successfully:', response.data);
            } catch (error) {
              // console.error('Error submitting form:', error);
              toast.error("Save failed");
            }
          }

      // toast.success("Form Saved");
      // setIsReadOnly(true);
    }

    const handleApproval = async () => {
  
      try {
        const JWTtoken = window.sessionStorage.getItem('token')
        const approvalSenderEmail = window.sessionStorage.getItem('emailID');
        const approvalSenderEmpId = window.sessionStorage.getItem('userId');
        const approverSenderName = window.sessionStorage.getItem('userName');
        setIsReadOnly(true)
        const confirmation = "Required"
  
        await apiService.requestENTCSApproval(JWTtoken, series, confirmation,  approvalSenderEmail, approverSenderName, approvalSenderEmpId)
          .then(response => {
            console.log('Yahi se aaya', response.data)
            response.data.map(async (approver) => {
              let approvalRole = approver.role;
              let approvalId = approver.userId;
              // console.log(':::::Approval Role::::>', approvalRole)
              if (approvalRole === 'TEAM LEADER') {
                setAppvTeamLeaderReq('YES')
              } else if (approvalRole === 'BRANCH HEAD') {
                setAppvBranchHeadReq('YES')
              } else if (approvalRole === 'REGION BUSINESS HEAD') {
                setAppvRegionBusinessHeadReq('YES')
              } else if (approvalRole === 'BUSINESS FINANCE') {
                setAppvBusinessFinanceReq('YES')
              } else if (approvalRole === 'EXPORT COMPLIANCE') {
                setAppvExportComplianceReq('YES')
              } else if (approvalRole === 'CREDIT INSURANCE') {
                setAppvCreditInsuranceReq('YES')
              } else if (approvalRole === 'CEO') {
                setAppvCEOReq('YES')
              } else if (approvalRole === 'COO') {
                setAppvCOOReq('YES')
              } else if (approvalRole === 'CFO') {
                setAppvCFOReq('YES')
              } else if (approvalRole === 'SVP-DIRECTOR') {
                setAppvSVPDirectorReq('YES')
              } else if (approvalRole === 'FUNCTIONAL HEAD') {
                if (approvalId === functionalHead1ID){
                  setAppvFunctionalHeadReq('YES')
                }
                if (approvalId === functionalHead2ID){
                  setAppvFunctionalHead2Req('YES')
                }
                if (approvalId === functionalHead3ID){
                  setAppvFunctionalHead3Req('YES')
                }
                if (approvalId === functionalHead4ID){
                  setAppvFunctionalHead4Req('YES')
                }
                if (approvalId === functionalHead5ID){
                  setAppvFunctionalHead5Req('YES')
                }
                if (approvalId === functionalHead6ID){
                  setAppvFunctionalHead6Req('YES')
                }
                
              } else if (approvalRole === 'LEGAL HEAD') {
                setAppvlegalHeadReq('YES')
              } else if (approvalRole === 'DYT-CFO') {
                setAppvDytCFOReq('YES')
              }
            });
  
            if (response.status == 200) {
              console.log("ENTCOSTSHEET - Handle Approval ::::>>",response)
              setTimeout(() => { window.location.reload() }, 2000);
              toast.success("All Approval Mails Sent", {
                autoClose: 2000,
              });
            }
            setModalSentForAppv(false);
          })
          .catch(error => {
            setError(error);
          });

          const formFlag = 'ENTCS';
          if(panNumber !== null && panNumber !== "NA" && panNumber !== ""){
            const approvalAmount = totalSellingValue;
            await apiService.creditApprovalByPan(JWTtoken, panNumber, searchTerm, approvalAmount, series, formFlag)
                            .then(response => { 
                              console.log(response.data.message)
                            })
          }
  
        // await apiService.postAppNotifyRequestApproval(JWTtoken, series)

        setModalSentForAppv(false); // Temporary
        // toast.success("All Approvals Mail Sent !!");
  
      } catch (error) {
        // console.log(':::::Error while sending preloading for approval', error)
        toast.error(`Error while sending preloading for approval: ${error}`)
      }
    }

    const handleApprove = (e) => {

      const role = window.sessionStorage.getItem("role")?.trim();
      if (role === "BUSINESS FINANCE" && totalSellingValue > 5000000) {
        if (!dealType || dealType.trim() === "" || dealType.trim().toLowerCase() === "null") {
          e.preventDefault();
          toast.error("Form Not Saved, Please Select Deal Type !!");
          return;
        }
      }

      if (approvalMessage === "") {
        e.preventDefault();
        let approvalStatus = "Approved";
        let approvalMessage = "Deal Approved";
        let approvalRole = window.sessionStorage.getItem('role');
        let approvalid = window.sessionStorage.getItem('userId');

        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      } else {
        e.preventDefault();
        let approvalStatus = "Approved";
        let approvalRole = window.sessionStorage.getItem('role');
        let approvalid = window.sessionStorage.getItem('userId');
        
        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleReject = (e) => {
      if (rejectionMessage === "") {
        toast.error("Please provide a valid rejection reason ");
      } else {
        e.preventDefault();
        let approvalStatus = "Rejected";
        let approvalRole = window.sessionStorage.getItem('role');
        let approvalid = window.sessionStorage.getItem('userId');

        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Rejected:::::", response.data);
            setResponse("Thank you for your response!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleCreditInsuranceApproval = (e) => {

        if (appvCIMessage === "") {
        e.preventDefault();
        let approvalStatus = "Management Approval";
        let appvCIMessage = "Credit Insurance Not Available Hence Submit For Approval";
        let approvalRole = window.sessionStorage.getItem('role');
        let approvalid = window.sessionStorage.getItem('userId');

        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      } else {
        e.preventDefault();
        let approvalStatus = "Management Approval";
        let approvalRole = window.sessionStorage.getItem('role');
        let approvalid = window.sessionStorage.getItem('userId');
        
        apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setResponse("Thank you for your approval!");
            setShowThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleManagementApproval = (e) => {

      if (mgmtApprovalMessage === "") {
        e.preventDefault();
        let approvalStatus = "Approved";
        let approvalRole = window.sessionStorage.getItem('role');
        if (
          approvalRole === 'TEAM LEADER' ||
          approvalRole === 'BRANCH HEAD'
        ) {
          approvalRole = 'REGION BUSINESS HEAD';
        }
        let approvalid = window.sessionStorage.getItem('userId');
        let mgmtApprovalMessage = "Deal Approved";

        apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setMgmtResponse("Thank you for your approval!");
            setShowMGMTThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      } else {
        e.preventDefault();
        let approvalRole = window.sessionStorage.getItem('role');
        if (
          approvalRole === 'TEAM LEADER' ||
          approvalRole === 'BRANCH HEAD'
        ) {
          approvalRole = 'REGION BUSINESS HEAD';
        }
        let approvalid = window.sessionStorage.getItem('userId');
        let approvalStatus = "Approved";
        
        apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Approved:::::", response.data);
            setMgmtResponse("Thank you for your approval!");
            setShowMGMTThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };

    const handleManagementReject = (e) => {
      if (mgmtRejectionMessage === "") {
        toast.error("Please provide a valid rejection reason for Management Approval");
      } else {
        e.preventDefault();
        let approvalStatus = "Rejected";
        let approvalRole = window.sessionStorage.getItem('role');
        if (
          approvalRole === 'TEAM LEADER' ||
          approvalRole === 'BRANCH HEAD'
        ) {
          approvalRole = 'REGION BUSINESS HEAD';
        }
        let approvalid = window.sessionStorage.getItem('userId');
        apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
          .then((response) => {
            console.log(":::::Aprroval Rejected:::::", response.data);
            setMgmtResponse("Thank you for your response!");
            setShowMGMTThankYou(true);
          })
          .catch((error) => {
            setError(error);
          });
      }
    };
  
  useEffect(() => {
    if (!marginPercent) return;
    if (!selectedOem || selectedOem.length === 0) {
      setmarginExpertAdvice("");
      return;
    }
    const hasMicrosoft = selectedOem.some(item => item.value?.toUpperCase() === "MICROSOFT");
    const threshold = hasMicrosoft && selectedOem.length === 1 ? 2.0 : 6.0;
    setmarginExpertAdvice(marginPercent > threshold ? "Margin Above the Threshold" : "Margin Below the Threshold");
  }, [marginPercent]);

  const CustomInput = (props) => {
    const { fieldName } = props.selectProps;

    return (
      <components.Input
        {...props}
        onPaste={(e) => {
          e.preventDefault();
          toast.error(`Pasting is not allowed in ${fieldName}. Please type and select from the dropdown.`)
        }}
      />
    );
  };

  const handlePaste = (event, fieldName) => { 
    event.preventDefault();

    if (fieldName === 'Hitachi Role in this Deal') {
      toast.error(`Pasting is not allowed while entering Hitachi Role in this Deal. Please type manually.`);
    }
    if (fieldName === 'LowMarginReasonFilled ') {
      toast.error(`Pasting is not allowed while entering Reason if its Margin goes less than 6%. Please type manually.`);
    }
    if (fieldName === 'Remarks ') {
      toast.error(`Pasting is not allowed while entering Remarks. Please type manually.`);
    }
    
    
  };

  const handleRebateChange = (e) => {
    const value = e.target.value
    setConfirmRebate(value);
    if (value === "YES"){
      toast.success('Please Upload Supporting Document for Rebate')
    }
  };

  const getSecondaryOptions = (primary) => {
    if (!primary) return [];

    if (primary === "INR") return ["INR"];

    // For USD, AED, and all others → same + INR
    // return [primary, "INR"];
    return [primary, "INR"];
  };

  const confirmToast = (onConfirm) => {
    toast(({ closeToast }) => (
      <div>
        <p>Are you sure?</p>

        <button
          onClick={async () => {
            await onConfirm();   // 👉 API call
            closeToast();
          }}
        >
          OK
        </button>

        <button onClick={closeToast}>Cancel</button>
      </div>
    ), { autoClose: false });
  };

  const handleCurrencyChange = async (e) => {
    const selectedCurrency = e.target.value;
    settransactionCurrency(selectedCurrency);

    const options = getSecondaryOptions(selectedCurrency);
    setSecondaryOptions(options);

    // Reset or auto-select
    setsecondaryTransactionCurrency(options[0] || "");

    if (!selectedCurrency) return;

    // ✅ Trigger point #1: transactionCurrency selected. Only fetch/overwrite the
    // conversionRate when it is blank — if the user already has a manually
    // entered (or previously fetched) value sitting in the field, leave it alone.
    try {
      const isConversionRateBlank =
        conversionRate === undefined || conversionRate === null || conversionRate === "";

      if (selectedCurrency === "INR") {
        setconversionRate(1);
      } else if (isConversionRateBlank) {
        const rate = await getRate(selectedCurrency);
        setconversionRate(rate);
      }
      // else: conversionRate already has a value — keep it as-is.
    } catch (error) {
      setError(error);
      setLoading(false);
    }

    const JWTtoken = window.sessionStorage.getItem('token');

    const result = await Swal.fire({
    title: `Selected Currency: ${e.target.value} `,
    text: 'Are you sure, save this as primary transaction currency!',
    icon: 'info',
    showCancelButton: true,
    confirmButtonText: 'Yes, Save it!',
  });

  if (result.isConfirmed) {
    try {
      const CurrTrans = e.target.value;
      await apiService.SaveYearlyCurrency(JWTtoken, series, CurrTrans, conversionRateyear1,conversionRateyear2,conversionRateyear3,
        conversionRateyear4,conversionRateyear5,conversionRateyear6,conversionRateyear7).then((response) => {
        if(response.data.message === "Data Updated"){
          Swal.fire('Saved..!', '', 'success');
        }
      }).catch((error) => {
        setError(error);
      });
    } catch (err) {
      Swal.fire('Error!', 'Something went wrong', 'error');
    }
  }
      
  };

  const handleSecondaryChange = (e) => {
  setsecondaryTransactionCurrency(e.target.value);
  };

  const allowedCurrencies = ['USD', 'AED', 'SGD', 'HKD', 'JPY', 'EUR', 'GBP'];

  const renderCurrencyOptions = () => {
    // Case 1: Both INR
    if (transactionCurrency === 'INR' && secondaryTransactionCurrency === 'INR') {
      return <option value="INR">INR</option>;
    }

    // Case 2: Foreign → INR
    if (
      allowedCurrencies.includes(transactionCurrency) &&
      secondaryTransactionCurrency === 'INR'
    ) {
      return secondaryOptions.map((curr) => (
        <option key={curr} value={curr}>
          {curr}
        </option>
      ));
    }

    // Case 3: Same currency
    if (transactionCurrency === secondaryTransactionCurrency) {
      return (
        <option value={transactionCurrency}>
          {transactionCurrency}
        </option>
      );
    }

    // Default fallback (optional)
    return null;
  };

  // const recalculateAllVendorPaymentTermValues = () => {
  //   const updatedRows = vendorPaymentTermsDetails.map((row) => {
  //     // Skip rows with no particular selected
  //     if (!row.vendorpayemntTermsParticular || row.vendorpayemntTermsParticular.trim() === "") {
  //       return row;
  //     }
  //     // Match the selected particular to get updated transfer price
  //     const matchedFTRows = paymentTermsNonTotalRows.filter(
  //       (selectedRow) => selectedRow.name === row.vendorpayemntTermsParticular
  //     );
  //     if (!matchedFTRows.length) return row; // No match found, skip
  //     const selectedTransferPrice = matchedFTRows[0].values[1].amount;
  //     const numericPercentage = Number(row.vendorpaymentTermsPercentage);
  //     // Skip if percentage is empty or invalid
  //     if (!row.vendorpaymentTermsPercentage || isNaN(numericPercentage)) {
  //       return row;
  //     }
  //     // Recalculate value using same rounding logic as inline handler
  //     const rawValue = (numericPercentage * Number(selectedTransferPrice)) / 100;
  //     const decimal = rawValue - Math.floor(rawValue);
  //     const calculatedValue = decimal <= 0.5 ? Math.floor(rawValue) : Math.ceil(rawValue);

  //     return {
  //       ...row, vendorpaymentTermsValue: calculatedValue,
  //     };
  //   });

  //   // Bulk update state once (instead of calling handleVendorPaymentTermChange per field)
  //   setVendorPaymentTermsDetails(updatedRows);
  //   handlesSaveVendorPaymentTerms(true, updatedRows);
  // };

  // const recalculateAllCustomerPaymentTermValues = () => {
  //   const updatedRows = customerPaymentTermsDetails.map((row) => {
  //     // Skip rows with no particular selected
  //     if (!row.customerpaymentTermsParticular || row.customerpaymentTermsParticular.trim() === "") {
  //       return row;
  //     }

  //     // Match the selected particular to get updated selling price
  //     const matchedFTRows = paymentTermsNonTotalRows.filter(
  //       (selectedRow) => selectedRow.name === row.customerpaymentTermsParticular
  //     );

  //     if (!matchedFTRows.length) return row;

  //     const selectedRowSellingValue = matchedFTRows[0].values[0].amount; // ✅ index 0 for selling price

  //     const numericPercentage = Number(row.customerpaymentTermsPercentage);

  //     if (!row.customerpaymentTermsPercentage || isNaN(numericPercentage)) {
  //       return row;
  //     }

  //     // Same rounding logic as inline handler
  //     const rawValue = (numericPercentage * Number(selectedRowSellingValue)) / 100;
  //     const decimal = rawValue - Math.floor(rawValue);
  //     const calculatedValue = decimal <= 0.5 ? Math.floor(rawValue) : Math.ceil(rawValue);

  //     return { ...row, customerpaymentTermsValue: calculatedValue };
  //   });

  //   setCustomerPaymentTermsDetails(updatedRows);
  //   handlesSaveCustomerPaymentTerms(true, updatedRows);
  // };


  // const crmOptions = crmData.map((item) => ({ label: item.crmNumber, value: item.crmNumber}));

  return (
    <>
      <Navbar />
      <Row className="mb-4 justify-content-between" data-row-name="logo & crmbutton">
            <Col md="auto"></Col>
            <Col md="auto"> <h1>Costsheet Enterprise Form</h1> </Col>
            <Col md="auto"></Col>
      </Row>
      <div style={{ display: "flex", width: "100%" }}>
        <Container className="pt-3" style={{ width: "75%", marginLeft: "25px" }}>
            <Form className="">
              {/* <Approval Form> */}
              <section style={{ position: 'relative', paddingLeft: '15px', paddingRight: '15px', marginBottom: '25px' }}>

                {(sessionStorage.getItem('role') === 'SALES' || sessionStorage.getItem('role') === 'OPERATIONS') && sendForAppv == false && (
                    <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
                      <Col md="auto">
                        <Button variant="primary" onClick={handleEdit}>
                          Edit
                        </Button>
                      </Col>
                      <Col md="auto">
                        <Button variant="primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>
                          Save
                        </Button>
                      </Col>
                      <Col md="auto">
                        <Button variant="primary" onClick={handleAppvUserValidation}>
                          Send for Approval
                        </Button>
                      </Col>
                    </Row>
                )}
                {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId == sessionStorage.getItem('userId') && sendForAppv === true)&& (
                  <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
                      <Col>
                        {(appvTeamLeaderStatus === 'Rejected' ||
                        appvBranchHeadStatus === 'Rejected' ||
                        appvRegionBusinessHeadStatus === 'Rejected' ||
                        appvBusinessFinanceStatus === 'Rejected' ||
                        appvExportComplianceStatus === 'Rejected' ||
                        appvCreditInsuranceStatus === 'Rejected' ||
                        appvCEOStatus === 'Rejected' ||
                        appvCFOStatus === 'Rejected' ||
                        appvCOOStatus === 'Rejected' ||
                        appvSVPDirectorStatus === 'Rejected' ||
                        appvLegalHeadStatus === 'Rejected' ||
                        appvDytCFOStatus === 'Rejected' ||
                        mgmtappvRegionBusinessHeadStatus === 'Rejected' ||
                        mgmtappvBusinessFinanceStatus === 'Rejected' ||
                        mgmtappvCEOStatus === 'Rejected' ||
                        mgmtappvCFOStatus === 'Rejected' ||
                        mgmtappvCOOStatus === 'Rejected' ||
                        appvFunctionalHeadStatus === 'Rejected' ||
                        appvFunctionalHead2Status === 'Rejected' ||
                        appvFunctionalHead3Status === 'Rejected' ||
                        appvFunctionalHead4Status === 'Rejected' ||
                        appvFunctionalHead5Status === 'Rejected' ||
                        appvFunctionalHead6Status === 'Rejected') && (
                          <Button variant="outline-danger" onClick={handleShowReopenModal}>
                            Reopen CostSheet
                          </Button>
                        )}

                        {formReopenCount > 0 && (<p style={{ padding: "2px" }}><b>Form Reopen Count: {formReopenCount}</b></p>)}

                      </Col>
                      <Col md="auto">
                        <Button variant="outline-primary" onClick={handleEdit}>
                          Edit
                        </Button>
                      </Col>
                      <Col md="auto">
                        <Button variant="outline-primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>
                          Save
                        </Button>
                      </Col>
                      <Col md="auto">
                        <Button variant="outline-primary" onClick={handleAdminAppvVal}>
                          Send for Approval
                        </Button>
                      </Col>
                    </Row>
                )}
                { (sessionStorage.getItem('role') === 'TEAM LEADER' && (salesPersonID == '' || salesPersonID == null || salesPersonID == sessionStorage.getItem('userId')) && sendForAppv === false) && (
                        <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
                        <Col md="auto">
                            <Button variant="primary" onClick={handleEdit}>Edit</Button>
                        </Col>
                        <Col md="auto">
                            <Button variant="primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>Save</Button>
                        </Col>
                        <Col md="auto">
                            <Button variant="primary" onClick={handleAppvUserValidation}>Send for Approval</Button>
                        </Col>
                        </Row>
                )}
                {/* { (sessionStorage.getItem('role') === 'TEAM LEADER' && (salesPersonID !== sessionStorage.getItem('userId')) && sendForAppv === true) && (
                        !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                { (sessionStorage.getItem('role') === 'BRANCH HEAD' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                { (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )} */}
                {(sessionStorage.getItem('role') === 'TEAM LEADER' || sessionStorage.getItem('role') === 'BRANCH HEAD' || sessionStorage.getItem('role') === 'REGION BUSINESS HEAD') && (salesPersonID !== sessionStorage.getItem('userId') && sendForAppv === true) && (
                    <>
                    {/* ((sessionStorage.getItem('userId') === appvTeamLeaderId && appvTeamLeaderReq === "YES" && appvTeamLeaderStatus === "Pending") || 
                        (sessionStorage.getItem('userId') === appvBranchHeadId && appvBranchHeadReq === "YES" && appvBranchHeadStatus === "Pending") ||
                        (sessionStorage.getItem('userId') === appvRegionBusinessHeadId && appvRegionBusinessHeadReq === "YES" && appvRegionBusinessHeadStatus === "Pending")) */}
                      
                      {((sessionStorage.getItem('userId') === appvTeamLeaderId && appvTeamLeaderReq === "YES") || 
                        (sessionStorage.getItem('userId') === appvBranchHeadId && appvBranchHeadReq === "YES") ||
                        (sessionStorage.getItem('userId') === appvRegionBusinessHeadId && appvRegionBusinessHeadReq === "YES")) && (
                        !showThankYou ? (
                          <>
                            <Col className="d-flex justify-content-center pt-3">
                              <h3>Please provide feedback for Enterprise CostSheet</h3>
                            </Col>

                            <Row className="pt-4 justify-content-center">
                              <InputGroup>
                                <Form.Control type="text" placeholder="Approval message" value={approvalMessage} onChange={(e) => setApprovalMessage(e.target.value)}/>
                                <Button variant="success" onClick={handleApprove} >Approve</Button>
                              </InputGroup>
                            </Row>

                            <Row className="pt-4 pb-4 justify-content-center">
                              <InputGroup>
                                <Form.Control type="text" placeholder="Rejection message" value={rejectionMessage} onChange={(e) => setRejectionMessage(e.target.value)}/>
                                <Button variant="danger" onClick={handleReject}>Reject</Button>
                              </InputGroup>
                            </Row>
                          </>
                        ) : (
                          <div className="pt-5 pb-2">
                            <Col className="d-flex justify-content-center pb-5">
                              <h1 style={{ color: 'Green' }}>
                                {response}
                              </h1>
                            </Col>
                          </div>
                        )
                      )}
                    </>
                )}
                { (sessionStorage.getItem('role') === 'EXPORT COMPLIANCE' && appvExportComplianceReq === 'YES' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                {(sessionStorage.getItem('role') === 'CREDIT INSURANCE' && appvCreditInsuranceReq === 'YES' && sendForAppv === true) && (
                    <>
                      {!showThankYou ? (
                        <>
                          <Col className='d-flex justify-content-center pt-3'>
                            <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                            <InputGroup>
                              <Form.Control type="text" placeholder="Approval message" value={approvalMessage} onChange={(e) => setApprovalMessage(e.target.value)}/>
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                            </InputGroup>
                          </Row>
                          <Row className="pt-4 justify-content-center">
                            <InputGroup>
                              <Form.Control type="text" placeholder="Rejection message" value={rejectionMessage} onChange={(e) => setRejectionMessage(e.target.value)}/>
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                            </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                            <InputGroup>
                              <Form.Control type="text" placeholder="Management Approval Message" value={appvCIMessage} onChange={(e) => setAppvCIMessage(e.target.value)} />
                              <Button variant="warning" onClick={handleCreditInsuranceApproval}>Management Approval Required</Button>
                            </InputGroup>
                          </Row>
                        </>
                      ) : (
                        <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                            <h1 style={{ color: 'Green' }} >{response}</h1>
                          </Col>
                        </div>
                      )}
                    </>
                )}
                { (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceReq === 'YES' && sendForAppv === true) && (
                    !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                { (sessionStorage.getItem('role') === 'CFO' && appvCFOReq === 'YES' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                { (sessionStorage.getItem('role') === 'CEO' && appvCEOReq === 'YES' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                { (sessionStorage.getItem('role') === 'COO' && appvCOOReq === 'YES' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                { (sessionStorage.getItem('role') === 'SVP-DIRECTOR' && appvSVPDirectorReq === 'YES' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                { (sessionStorage.getItem('role') === 'LEGAL HEAD' && appvlegalHeadReq === 'YES' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                { (sessionStorage.getItem('role') === 'DYT-CFO' && appvDytCFOReq === 'YES' && sendForAppv === true) && (
                      !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead1ID == sessionStorage.getItem('userId') && appvFunctionalHeadReq === 'YES'  && sendForAppv === true) && (
                  !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead2ID == sessionStorage.getItem('userId') && appvFunctionalHead2Req === 'YES'  && sendForAppv === true) && (
                  !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead3ID == sessionStorage.getItem('userId') && appvFunctionalHead3Req === 'YES'  && sendForAppv === true) && (
                  !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead4ID == sessionStorage.getItem('userId') && appvFunctionalHead4Req === 'YES'  && sendForAppv === true) && (
                  !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead5ID == sessionStorage.getItem('userId') && appvFunctionalHead5Req === 'YES'  && sendForAppv === true) && (
                  !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}
                {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead6ID == sessionStorage.getItem('userId') && appvFunctionalHead6Req === 'YES'  && sendForAppv === true) && (
                  !showThankYou ? (
                      <>
                          <Col className='d-flex justify-content-center pt-3'>
                          <h3>Please provide feedback for Enterprise CostSheet</h3>
                          </Col>
                          <Row className="pt-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Approval message"
                              value={approvalMessage}
                              onChange={(e) => setApprovalMessage(e.target.value)}
                              />
                              <Button variant="success" onClick={handleApprove}>Approve</Button>
                          </InputGroup>
                          </Row>
                          <Row className="pt-4 pb-4 justify-content-center">
                          <InputGroup>
                              <Form.Control
                              type="text"
                              placeholder="Rejection message"
                              value={rejectionMessage}
                              onChange={(e) => setRejectionMessage(e.target.value)}
                              />
                              <Button variant="danger" onClick={handleReject}>Reject</Button>
                          </InputGroup>
                          </Row>
                      </>
                      ) : (
                      <div className='pt-5 pb-2'>
                          <Col className='d-flex justify-content-center pb-5'>
                          <h1 style={{ color: 'Green' }}>{response}</h1>
                          </Col>
                      </div>
                      )
                )}

                {/* {showMGMTThankYou ? console.log('showMGMTThankYoushowMGMTThankYou',showMGMTThankYou) :console.log('showMGMTThankYoushowMGMTThankYou',showMGMTThankYou)}
                
                {showThankYou ? console.log('showThankYoushowThankYou',showThankYou) :console.log('showThankYoushowThankYou',showThankYou)} */}
                
                {!showMGMTThankYou ? (
                    <>
                      {((sessionStorage.getItem('role') === 'TEAM LEADER' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'BRANCH HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && mgmtappvBusinessFinanceReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'CEO' && appvCEOId === sessionStorage.getItem('userId') && mgmtappvCEOReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'CFO' && appvCFOId === sessionStorage.getItem('userId') && mgmtappvCFOReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'COO' && appvCOOId === sessionStorage.getItem('userId') && mgmtappvCOOReq === 'YES'))&& (mgmtApprovalRequire === 'YES') && (<Col className="d-flex flex-column align-items-center pt-4 mt-4">
                        <h3>Please provide management feedback for Credit Insurance Risk</h3>
                        <h6>(For Credit Insurance Check) Reason: <span style={{ fontWeight: 400, background: "lightcoral" }}>{ciMgmtReason}</span></h6>
                      </Col>)}

                      {((sessionStorage.getItem('role') === 'TEAM LEADER' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'BRANCH HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && mgmtappvBusinessFinanceReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'CEO' && appvCEOId === sessionStorage.getItem('userId') && mgmtappvCEOReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'CFO' && appvCFOId === sessionStorage.getItem('userId') && mgmtappvCFOReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'COO' && appvCOOId === sessionStorage.getItem('userId') && mgmtappvCOOReq === 'YES')) && (mgmtApprovalRequire === 'YES') && (<Row className="pt-4 justify-content-center">
                          <InputGroup>
                            <Form.Control type="text" placeholder="Management approval message" value={mgmtApprovalMessage} onChange={(e) => setMgmtApprovalMessage(e.target.value)} />
                            <Button variant="success" onClick={handleManagementApproval}>Approve</Button>
                          </InputGroup>
                      </Row>)}
                      
                      {((sessionStorage.getItem('role') === 'TEAM LEADER' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'BRANCH HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && mgmtappvBusinessFinanceReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'CEO' && appvCEOId === sessionStorage.getItem('userId') && mgmtappvCEOReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'CFO' && appvCFOId === sessionStorage.getItem('userId') && mgmtappvCFOReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'COO' && appvCOOId === sessionStorage.getItem('userId') && mgmtappvCOOReq === 'YES')) && (mgmtApprovalRequire === 'YES') && (<Row className="pt-4 mb-4 pb-4 justify-content-center">
                        <InputGroup>
                          <Form.Control type="text" placeholder="Management rejection message" value={mgmtRejectionMessage} onChange={(e) => setMgmtRejectionMessage(e.target.value)} />
                          <Button variant="danger" onClick={handleManagementReject}>Reject</Button>
                        </InputGroup>
                      </Row>)}
                    </>
                  ) : (<>
                    {((sessionStorage.getItem('role') === 'TEAM LEADER' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && appvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'BRANCH HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && appvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && appvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && appvRegionBusinessHeadReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'CEO' && appvCEOId === sessionStorage.getItem('userId') && appvCEOReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'CFO' && appvCFOId === sessionStorage.getItem('userId') && appvCFOReq === 'YES') || 
                    (sessionStorage.getItem('role') === 'COO' && appvCOOId === sessionStorage.getItem('userId') && appvCOOReq === 'YES')) && (mgmtApprovalRequire === 'YES') && (<div className="pt-5 mb-4 mt-5">
                      <Col className="d-flex justify-content-center pb-5">
                        <h1 style={{ color: "Green" }}>{mgmtResponse}</h1>
                      </Col>
                    </div>)}
                    </>
                )}
      
              </section>
              
              {/* <Approval Table and Modals> */}
              <section style={{ position: 'relative', paddingLeft: '15px', paddingRight: '15px', marginBottom: '25px' }}>

                {appvCreditInsuranceReq === 'YES' && <>
                  <Row className="mt-4 mb-1" data-row-name="Approvers-head">
                      <Col md="" style={{ fontWeight: 'bold' }}>
                        Approval Required:
                      </Col>
                  </Row>

                  <Row className="mb-1" data-row-name="Approvers-common">
                    {appvTeamLeaderReq === 'YES' && (
                      <>
                        <Col
                          id="teamLeader"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvTeamLeaderStatus === 'Approved'
                              ? 'green'
                              : appvTeamLeaderStatus === 'Rejected'
                                ? 'red'
                                : 'inherit',
                            backgroundColor: appvTeamLeaderStatus === 'Approved'
                              ? 'lightgreen'
                              : appvTeamLeaderStatus === 'Rejected'
                                ? 'lightcoral'
                                : 'inherit',
                          }}
                        >
                          TEAM LEADER
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={teamLeaderTooltip}
                          target="teamLeader"
                          toggle={() => setTeamLeaderTooltip(!teamLeaderTooltip)}
                          autohide={false}
                        >
                          {appvTeamLeaderMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvBranchHeadReq === 'YES' && (
                      <>
                        <Col
                          id="branchHead"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvBranchHeadStatus === 'Approved'
                              ? 'green'
                              : appvBranchHeadStatus === 'Rejected'
                                ? 'red'
                                : 'inherit',
                            backgroundColor: appvBranchHeadStatus === 'Approved'
                              ? 'lightgreen'
                              : appvBranchHeadStatus === 'Rejected'
                                ? 'lightcoral'
                                : 'inherit',
                          }}
                        >
                          BRANCH HEAD
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={branchHeadTooltip}
                          target="branchHead"
                          toggle={() => setBranchHeadTooltip(!branchHeadTooltip)}
                          autohide={false}
                        >
                          {appvBranchHeadMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvRegionBusinessHeadReq === 'YES' && (
                      <>
                        <Col
                          id="regionBusinessHead"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvRegionBusinessHeadStatus === 'Approved'
                              ? 'green'
                              : appvRegionBusinessHeadStatus === 'Rejected'
                                ? 'red'
                                : 'inherit',
                            backgroundColor: appvRegionBusinessHeadStatus === 'Approved'
                              ? 'lightgreen'
                              : appvRegionBusinessHeadStatus === 'Rejected'
                                ? 'lightcoral'
                                : 'inherit',
                          }}
                        >
                          REGION BUSINESS HEAD
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={regionBusinessHeadTooltip}
                          target="regionBusinessHead"
                          toggle={() => setRegionBusinessHeadTooltip(!regionBusinessHeadTooltip)}
                          autohide={false}
                        >
                          {appvRegionBusinessHeadMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvBusinessFinanceReq === 'YES' && (
                      <>
                        <Col
                          id="businessFinance"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvBusinessFinanceStatus === 'Approved'
                              ? 'green'
                              : appvBusinessFinanceStatus === 'Rejected'
                                ? 'red'
                                : 'inherit',
                            backgroundColor: appvBusinessFinanceStatus === 'Approved'
                              ? 'lightgreen'
                              : appvBusinessFinanceStatus === 'Rejected'
                                ? 'lightcoral'
                                : 'inherit',
                          }}
                        >
                          BUSINESS FINANCE
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={businessFinanceTooltip}
                          target="businessFinance"
                          toggle={() => setBusinessFinanceTooltip(!businessFinanceTooltip)}
                          autohide={false}
                        >
                          {appvBusinessFinanceMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvCreditInsuranceReq === 'YES' && (
                      <>
                        <Col
                          id="creditInsurance"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color:
                              appvCreditInsuranceStatus === 'Approved'
                                ? 'green'
                                : appvCreditInsuranceStatus === 'Rejected'
                                  ? 'red'
                                  : appvCreditInsuranceStatus === 'Management Approval'
                                    ? 'orange'
                                    : 'inherit',
                            backgroundColor:
                              appvCreditInsuranceStatus === 'Approved'
                                ? 'lightgreen'
                                : appvCreditInsuranceStatus === 'Rejected'
                                  ? 'lightcoral'
                                  : appvCreditInsuranceStatus === 'Management Approval'
                                    ? 'olivedrab'
                                    : 'inherit',
                          }}
                        >
                          CREDIT INSURANCE
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={creditInsuranceTooltip}
                          target="creditInsurance"
                          toggle={() => setCreditInsuranceTooltip(!creditInsuranceTooltip)}
                          autohide={false}
                        >
                          {appvCreditInsuranceMessage}
                        </Tooltip>
                      </>
                    )}
                  </Row>
                  <Row className="mb-1" data-row-name="Approvers-condition">
                    {appvExportComplianceReq === 'YES' && (
                      <>
                        <Col
                          id="exportCompliance"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvExportComplianceStatus === 'Approved' ? 'green' :
                                  appvExportComplianceStatus === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvExportComplianceStatus === 'Approved' ? 'lightgreen' :
                                            appvExportComplianceStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          EXPORT COMPLIANCE
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={exportComplianceTooltip}
                          target="exportCompliance"
                          toggle={() => setExportComplianceTooltip(!exportComplianceTooltip)}
                          autohide={false}
                        >
                          {appvExportComplianceMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvCFOReq === 'YES' && (
                      <>
                        <Col
                          id="cfo"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvCFOStatus === 'Approved' ? 'green' :
                                  appvCFOStatus === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvCFOStatus === 'Approved' ? 'lightgreen' :
                                            appvCFOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          CFO
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={cfoTooltip}
                          target="cfo"
                          toggle={() => setCfoTooltip(!cfoTooltip)}
                          autohide={false}
                        >
                          {appvCFOMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvCEOReq === 'YES' && (
                      <>
                        <Col
                          id="ceo"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvCEOStatus === 'Approved' ? 'green' :
                                  appvCEOStatus === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvCEOStatus === 'Approved' ? 'lightgreen' :
                                            appvCEOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          CEO
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={ceoTooltip}
                          target="ceo"
                          toggle={() => setCeoTooltip(!ceoTooltip)}
                          autohide={false}
                        >
                          {appvCEOMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvCOOReq === 'YES' && (
                      <>
                        <Col
                          id="coo"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvCOOStatus === 'Approved' ? 'green' :
                                  appvCOOStatus === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvCOOStatus === 'Approved' ? 'lightgreen' :
                                            appvCOOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          COO
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={cooTooltip}
                          target="coo"
                          toggle={() => setCooTooltip(!cooTooltip)}
                          autohide={false}
                        >
                          {appvCOOMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvSVPDirectorReq === 'YES' && (
                      <>
                        <Col
                          id="svpDirector"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvSVPDirectorStatus === 'Approved' ? 'green' :
                                  appvSVPDirectorStatus === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvSVPDirectorStatus === 'Approved' ? 'lightgreen' :
                                            appvSVPDirectorStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          SVP-DIRECTOR
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={svpDirectorTooltip}
                          target="svpDirector"
                          toggle={() => setSvpDirectorTooltip(!svpDirectorTooltip)}
                          autohide={false}
                        >
                          {appvSVPDirectorMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvlegalHeadReq === 'YES' && (
                      <>
                        <Col
                          id="legalHead"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvLegalHeadStatus === 'Approved' ? 'green' :
                                  appvLegalHeadStatus === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvLegalHeadStatus === 'Approved' ? 'lightgreen' :
                                            appvLegalHeadStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          LEGAL HEAD
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={legalHeadTooltip}
                          target="legalHead"
                          toggle={() => setLegalHeadTooltip(!legalHeadTooltip)}
                          autohide={false}
                        >
                          {appvLegalHeadMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvDytCFOReq === 'YES' && (
                      <>
                        <Col
                          id="dytCfo"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvDytCFOStatus === 'Approved' ? 'green' :
                                  appvDytCFOStatus === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvDytCFOStatus === 'Approved' ? 'lightgreen' :
                                            appvDytCFOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          DYT-CFO
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={dytCfoTooltip}
                          target="dytCfo"
                          toggle={() => setDytCfoTooltip(!dytCfoTooltip)}
                          autohide={false}
                        >
                          {appvDytCFOMessage}
                        </Tooltip>
                      </>
                    )}
                  </Row>
                  <Row className="mb-1" data-row-name="Approvers-condition">
                    {appvFunctionalHeadReq === 'YES' && (
                      <>
                        <Col
                          id="functionalHead1"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvFunctionalHeadStatus === 'Approved' ? 'green' :
                                  appvFunctionalHeadStatus === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvFunctionalHeadStatus === 'Approved' ? 'lightgreen' :
                                            appvFunctionalHeadStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          FUNCTIONAL HEAD - 1
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={functionalHead1Tooltip}
                          target="functionalHead1"
                          toggle={() => setFunctionalHead1Tooltip(!functionalHead1Tooltip)}
                          autohide={false}
                        >
                          {appvFunctionalHeadMessage}
                        </Tooltip>
                      </>
                    )}
                    {appvFunctionalHead2Req === 'YES' && (
                      <>
                        <Col
                          id="functionalHead2"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvFunctionalHead2Status === 'Approved' ? 'green' :
                                  appvFunctionalHead2Status === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvFunctionalHead2Status === 'Approved' ? 'lightgreen' :
                                            appvFunctionalHead2Status === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          FUNCTIONAL HEAD - 2
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={functionalHead2Tooltip}
                          target="functionalHead2"
                          toggle={() => setFunctionalHead2Tooltip(!functionalHead2Tooltip)}
                          autohide={false}
                        >
                          {appvFunctionalHead2Message}
                        </Tooltip>
                      </>
                    )}
                    {appvFunctionalHead3Req === 'YES' && (
                      <>
                        <Col
                          id="functionalHead3"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvFunctionalHead3Status === 'Approved' ? 'green' :
                                  appvFunctionalHead3Status === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvFunctionalHead3Status === 'Approved' ? 'lightgreen' :
                                            appvFunctionalHead3Status === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          FUNCTIONAL HEAD - 3
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={functionalHead3Tooltip}
                          target="functionalHead3"
                          toggle={() => setFunctionalHead3Tooltip(!functionalHead3Tooltip)}
                          autohide={false}
                        >
                          {appvFunctionalHead3Message}
                        </Tooltip>
                      </>
                    )}
                    {appvFunctionalHead4Req === 'YES' && (
                      <>
                        <Col
                          id="functionalHead4"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvFunctionalHead4Status === 'Approved' ? 'green' :
                                  appvFunctionalHead4Status === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvFunctionalHead4Status === 'Approved' ? 'lightgreen' :
                                            appvFunctionalHead4Status === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          FUNCTIONAL HEAD - 4
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={functionalHead4Tooltip}
                          target="functionalHead4"
                          toggle={() => setFunctionalHead4Tooltip(!functionalHead4Tooltip)}
                          autohide={false}
                        >
                          {appvFunctionalHead4Message}
                        </Tooltip>
                      </>
                    )}
                    {appvFunctionalHead5Req === 'YES' && (
                      <>
                        <Col
                          id="functionalHead5"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvFunctionalHead5Status === 'Approved' ? 'green' :
                                  appvFunctionalHead5Status === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvFunctionalHead5Status === 'Approved' ? 'lightgreen' :
                                            appvFunctionalHead5Status === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          FUNCTIONAL HEAD - 5
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={functionalHead5Tooltip}
                          target="functionalHead5"
                          toggle={() => setFunctionalHead5Tooltip(!functionalHead5Tooltip)}
                          autohide={false}
                        >
                          {appvFunctionalHead5Message}
                        </Tooltip>
                      </>
                    )}
                    {appvFunctionalHead6Req === 'YES' && (
                      <>
                        <Col
                          id="functionalHead6"
                          md=""
                          style={{
                            fontWeight: 'bold',
                            border: '1px solid black',
                            textAlign: 'center',
                            cursor: 'pointer',
                            color: appvFunctionalHead6Status === 'Approved' ? 'green' :
                                  appvFunctionalHead6Status === 'Rejected' ? 'red' : 'inherit',
                            backgroundColor: appvFunctionalHead6Status === 'Approved' ? 'lightgreen' :
                                            appvFunctionalHead6Status === 'Rejected' ? 'lightcoral' : 'inherit',
                          }}
                        >
                          FUNCTIONAL HEAD - 6
                        </Col>

                        <Tooltip
                          placement="top"
                          isOpen={functionalHead6Tooltip}
                          target="functionalHead6"
                          toggle={() => setFunctionalHead6Tooltip(!functionalHead6Tooltip)}
                          autohide={false}
                        >
                          {appvFunctionalHead6Message}
                        </Tooltip>
                      </>
                    )}
                  </Row>
                </>
                }

                {appvCreditInsuranceStatus === 'Management Approval' && <>
                  <Row className="mb-1" data-row-name="Management Approvers-head">
                    <Col md="" style={{ fontWeight: 'bold' }}>
                      Management Approval Required:
                    </Col>
                  </Row>
                  {/* <Row className="mb-1" data-row-name="Management Approvals">
                    <Col md="" style={{
                      fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                      color: mgmtappvRegionBusinessHeadStatus === 'Approved' ? 'green' : mgmtappvRegionBusinessHeadStatus === 'Rejected' ? 'red' : 'inherit',
                      backgroundColor: mgmtappvRegionBusinessHeadStatus === 'Approved' ? 'lightgreen' : mgmtappvRegionBusinessHeadStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                    }}>
                      REGION BUSINESS HEAD
                    </Col>
                    <Col md="" style={{
                      fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                      color: mgmtappvBusinessFinanceStatus === 'Approved' ? 'green' : mgmtappvBusinessFinanceStatus === 'Rejected' ? 'red' : 'inherit',
                      backgroundColor: mgmtappvBusinessFinanceStatus === 'Approved' ? 'lightgreen' : mgmtappvBusinessFinanceStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                    }}>
                      BUSINESS FINANCE
                    </Col>
                    <Col md="" style={{
                      fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                      color: mgmtappvCEOStatus === 'Approved' ? 'green' : mgmtappvCEOStatus === 'Rejected' ? 'red' : 'inherit',
                      backgroundColor: mgmtappvCEOStatus === 'Approved' ? 'lightgreen' : mgmtappvCEOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                    }}>
                      CEO
                    </Col>
                    <Col md="" style={{
                      fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                      color: mgmtappvCOOStatus === 'Approved' ? 'green' : mgmtappvCOOStatus === 'Rejected' ? 'red' : 'inherit',
                      backgroundColor: mgmtappvCOOStatus === 'Approved' ? 'lightgreen' : mgmtappvCOOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                    }}>
                      COO
                    </Col>
                    <Col md="" style={{
                      fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
                      color: mgmtappvCFOStatus === 'Approved' ? 'green' : mgmtappvCFOStatus === 'Rejected' ? 'red' : 'inherit',
                      backgroundColor: mgmtappvCFOStatus === 'Approved' ? 'lightgreen' : mgmtappvCFOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
                    }}>
                      CFO
                    </Col>
                  </Row> */}
                  <Row className="mb-1" data-row-name="Management Approvals">
                    <>
                      <Col
                        id="mgmtRegionBusinessHead"
                        md=""
                        style={{
                          fontWeight: 'bold',
                          border: '1px solid black',
                          textAlign: 'center',
                          cursor: 'pointer',
                          color: mgmtappvRegionBusinessHeadStatus === 'Approved'
                            ? 'green'
                            : mgmtappvRegionBusinessHeadStatus === 'Rejected'
                              ? 'red'
                              : 'inherit',
                          backgroundColor: mgmtappvRegionBusinessHeadStatus === 'Approved'
                            ? 'lightgreen'
                            : mgmtappvRegionBusinessHeadStatus === 'Rejected'
                              ? 'lightcoral'
                              : 'inherit',
                        }}
                      >
                        REGION BUSINESS HEAD
                      </Col>

                      <Tooltip
                        placement="top"
                        isOpen={mgmtRegionBusinessHeadTooltip}
                        target="mgmtRegionBusinessHead"
                        toggle={() => setMgmtRegionBusinessHeadTooltip(!mgmtRegionBusinessHeadTooltip)}
                        autohide={false}
                      >
                        {mgmtappvRegionBusinessHeadMessage}
                      </Tooltip>
                    </>
                    <>
                      <Col
                        id="mgmtBusinessFinance"
                        md=""
                        style={{
                          fontWeight: 'bold',
                          border: '1px solid black',
                          textAlign: 'center',
                          cursor: 'pointer',
                          color: mgmtappvBusinessFinanceStatus === 'Approved'
                            ? 'green'
                            : mgmtappvBusinessFinanceStatus === 'Rejected'
                              ? 'red'
                              : 'inherit',
                          backgroundColor: mgmtappvBusinessFinanceStatus === 'Approved'
                            ? 'lightgreen'
                            : mgmtappvBusinessFinanceStatus === 'Rejected'
                              ? 'lightcoral'
                              : 'inherit',
                        }}
                      >
                        BUSINESS FINANCE
                      </Col>

                      <Tooltip
                        placement="top"
                        isOpen={mgmtBusinessFinanceTooltip}
                        target="mgmtBusinessFinance"
                        toggle={() => setMgmtBusinessFinanceTooltip(!mgmtBusinessFinanceTooltip)}
                        autohide={false}
                      >
                        {mgmtappvBusinessFinanceMessage}
                      </Tooltip>
                    </>
                    <>
                      <Col
                        id="mgmtCEO"
                        md=""
                        style={{
                          fontWeight: 'bold',
                          border: '1px solid black',
                          textAlign: 'center',
                          cursor: 'pointer',
                          color: mgmtappvCEOStatus === 'Approved'
                            ? 'green'
                            : mgmtappvCEOStatus === 'Rejected'
                              ? 'red'
                              : 'inherit',
                          backgroundColor: mgmtappvCEOStatus === 'Approved'
                            ? 'lightgreen'
                            : mgmtappvCEOStatus === 'Rejected'
                              ? 'lightcoral'
                              : 'inherit',
                        }}
                      >
                        CEO
                      </Col>

                      <Tooltip
                        placement="top"
                        isOpen={mgmtCeoTooltip}
                        target="mgmtCEO"
                        toggle={() => setMgmtCeoTooltip(!mgmtCeoTooltip)}
                        autohide={false}
                      >
                        {mgmtappvCEOMessage}
                      </Tooltip>
                    </>
                    <>
                      <Col
                        id="mgmtCOO"
                        md=""
                        style={{
                          fontWeight: 'bold',
                          border: '1px solid black',
                          textAlign: 'center',
                          cursor: 'pointer',
                          color: mgmtappvCOOStatus === 'Approved'
                            ? 'green'
                            : mgmtappvCOOStatus === 'Rejected'
                              ? 'red'
                              : 'inherit',
                          backgroundColor: mgmtappvCOOStatus === 'Approved'
                            ? 'lightgreen'
                            : mgmtappvCOOStatus === 'Rejected'
                              ? 'lightcoral'
                              : 'inherit',
                        }}
                      >
                        COO
                      </Col>

                      <Tooltip
                        placement="top"
                        isOpen={mgmtCooTooltip}
                        target="mgmtCOO"
                        toggle={() => setMgmtCooTooltip(!mgmtCooTooltip)}
                        autohide={false}
                      >
                        {mgmtappvCOOMessage}
                      </Tooltip>
                    </>
                    <>
                      <Col
                        id="mgmtCFO"
                        md=""
                        style={{
                          fontWeight: 'bold',
                          border: '1px solid black',
                          textAlign: 'center',
                          cursor: 'pointer',
                          color: mgmtappvCFOStatus === 'Approved'
                            ? 'green'
                            : mgmtappvCFOStatus === 'Rejected'
                              ? 'red'
                              : 'inherit',
                          backgroundColor: mgmtappvCFOStatus === 'Approved'
                            ? 'lightgreen'
                            : mgmtappvCFOStatus === 'Rejected'
                              ? 'lightcoral'
                              : 'inherit',
                        }}
                      >
                        CFO
                      </Col>

                      <Tooltip
                        placement="top"
                        isOpen={mgmtCfoTooltip}
                        target="mgmtCFO"
                        toggle={() => setMgmtCfoTooltip(!mgmtCfoTooltip)}
                        autohide={false}
                      >
                        {mgmtappvCFOMessage}
                      </Tooltip>
                    </>
                  </Row>
                </>
                }

                  {/* VENDOR PAYMENT TERM MODAL */}
                <Modal show={isVendorPaymentTermModalOpen} onHide={closeVendorPaymentTermModal} size="lg" centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Vendor Payment Terms</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    {!financialTableLoaded && (
                      <div style={{ color: "#856404", backgroundColor: "#fff3cd", border: "1px solid #ffeeba", borderRadius: "4px", padding: "8px 12px", marginBottom: "12px", fontWeight: 600 }}>
                        ⏳ Financial table data is still loading — percentage entry and Save are disabled until it finishes.
                      </div>
                    )}
                    <Table bordered width="100%">
                      <thead>
                        <tr>
                          <th>Particuars</th>
                          <th>Days</th>
                          <th>Percentage</th>
                          <th>Value</th>
                          <th> </th>
                          {/* <th width="80">Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                        {vendorPaymentTermsDetails.map((row, i) => (
                          <tr key={i}>
                            <td>
                              <Form.Select 
                              value={row.vendorpayemntTermsParticular}
                              disabled={isReadOnly}  
                              onChange={(e) => {
                                const value = e.target.value;
                                handleVendorPaymentTermChange(i, "vendorpayemntTermsParticular", value);
                                }}
                              aria-label="vendorpayemntTermsParticular">
                                <option value="" disabled>Select Any One</option>
                              {paymentTermsNonTotalRows.map((row, index) => (
                                  <option key={index} value={row.name}>{row.name}</option>
                                ))}
                              </Form.Select>
                            </td>
                            <td>
                            <Form.Control type="text" disabled={isReadOnly} inputMode="numeric" value={row.vendorpaymentTermsDays}
                                onChange={(e) => {const value = e.target.value;

                                  // Allow empty OR digits only
                                  if (/^\d*$/.test(value)) { handleVendorPaymentTermChange(i, "vendorpaymentTermsDays", value);}
                                }}
                              />
                            </td>
                            <td>
                              <Form.Control type="text" disabled={isReadOnly || !financialTableLoaded}  inputMode="decimal" value={row.vendorpaymentTermsPercentage}
                                onChange={async(e) => {
                                  const value = e.target.value;
                                  // ✅ Guard against the load race: block the calculation entirely until
                                  // the financial table's real row amounts have loaded — otherwise the
                                  // matched row's transfer price reads as its placeholder "0" and the
                                  // percentage-derived Value gets computed (and can be saved) as 0.
                                  if (!financialTableLoaded) {
                                    toast.error("Financial table is still loading. Please wait a moment and try again.");
                                    return;
                                  }
                                  if (!row.vendorpayemntTermsParticular || row.vendorpayemntTermsParticular.trim() === "") {
                                    toast.error("Please select particulars in vendor payment terms");
                                    return;
                                  }
                                  // console.log('row.vendorpayemntTermsParticular', row.vendorpayemntTermsParticular);
                                  const matchedFTRows = paymentTermsNonTotalRows.filter((selctedRow) => selctedRow.name === row.vendorpayemntTermsParticular);
                                  // console.log('selctedRowmatchedFTRowsmatchedFTRows', matchedFTRows);
                                  // console.log('selectedTransferPrice:::::::::::::::::::::::::', matchedFTRows[0].values[1].amount);
                                  // console.log('selectedCurrency:::::::::::::::::::::::::', matchedFTRows[0].currency);
                                  // console.log('selectedParticular:::::::::::::::::::::::::', matchedFTRows[0].name);

                                  const selectedTransferPrice = matchedFTRows[0].values[1].amount;
                                  const selectedCurrency = matchedFTRows[0].currency;
                                  const selectedParticular = matchedFTRows[0].name;

                                  const baseRate = await getRate(selectedCurrency);
                                  const yearMultiplier = {
                                    "Year 1": 1,        
                                    "Year 2": 1.05,
                                    "Year 3": 1.05 ** 2,
                                    "Year 4": 1.05 ** 3,
                                    "Year 5": 1.05 ** 4,
                                    "Year 6": 1.05 ** 5,
                                    "Year 7": 1.05 ** 6,
                                  };
                                  const multiplier = selectedCurrency !== "INR" ? (yearMultiplier[selectedParticular] ?? 1) : 1;
                                  const effectiveRate = Number((baseRate * multiplier).toFixed(2));
                                  // console.log('effectiveRate:::::::::::::::::::::::::', effectiveRate);
                                  const effectivePrice = Math.trunc(selectedTransferPrice * effectiveRate)
                                  // console.log('effectivePrice:::::::::::::::::::::::::', effectivePrice);

                                  if (!/^\d+(\.\d{0,2})?$|^$/.test(value)) return;

                                  const numericValue = value === "" ? 0 : Number(value);

                                  const otherTotal = vendorPaymentTermsDetails.reduce((sum, r, index) => {
                                    if (index === i) return sum;
                                    const v = Number(r.vendorpaymentTermsPercentage);
                                    return isNaN(v) ? sum : sum + v;
                                  }, 0);

                                  // if (otherTotal + numericValue > 100) {
                                  //   return;
                                  // }

                                  const calculatedValue = value === ""
                                    ? ""
                                    : (() => {
                                        // const rawValue = (numericValue * Number(selectedTransferPrice)) / 100;
                                        const rawValue = (numericValue * Number(effectivePrice)) / 100;
                                        const decimal = rawValue - Math.floor(rawValue);
                                        return decimal <= 0.5 ? Math.floor(rawValue) : Math.ceil(rawValue);
                                      })();

                                  handleVendorPaymentTermChange(i, "vendorpaymentTermsPercentage", value);
                                  handleVendorPaymentTermChange(i, "vendorpaymentTermsValue", calculatedValue);
                                }}
                              />
                            </td>
                            <td>
                              <Form.Control value={row.vendorpaymentTermsValue} disabled={isReadOnly} readOnly={true} 
                              onChange={(e) => 
                              handleVendorPaymentTermChange(i, "vendorpaymentTermsValue", e.target.value)
                              } />
                            </td>
                            <td className="text-center">
                              {i > 0 && (
                                <Button variant="danger" disabled={isReadOnly}  size="sm" onClick={() => deleteVendorPaymentTermRow(i)}>
                                  <i class="fa-solid fa-trash"></i>
                                </Button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                      </Table>
                    <Row className="mt-2 align-items-center">
                      <Col className="d-flex justify-content-between align-items-center">
                        {totalVendorPaymentTermsValue < totalTransferPriceWithoutTotal && (<Button variant="secondary" disabled={isReadOnly} onClick={addVendorPaymentTermRow}>Add Row</Button>)}

                        {totalVendorPaymentTermsValue > 0 && (
                          <span style={{ fontWeight: "600", color: vendorPercentageShortfall == 0 ? "green" : vendorPercentageShortfall > 0 ? "orange" : "red",}}>
                            Total Percentage: {totalVendorPaymentTermsPercentage}%

                            {vendorPercentageShortfall < 0 && (
                              <> (Shortfall: {Math.abs(vendorPercentageShortfall)}%)</>
                            )}

                            {vendorPercentageShortfall > 0 && (
                              <> (Exceeds by {vendorPercentageShortfall}%)</>
                            )}
                          </span>
                        )}
                      </Col>
                    </Row>
                  </Modal.Body>

                  <Modal.Footer>
                    {/* ✅ Cancel is always available, even while loading. Save is always
                        rendered too, but disabled until financialTableLoaded AND the
                        percentage-total check both pass — no more vanishing buttons. */}
                    <Button variant="primary" disabled={isReadOnly || !financialTableLoaded || 
                    Number(((totalVendorPaymentTermsValue / totalTransferPriceWithoutTotal) * 100).toFixed(2)) !== 100}
                      onClick={(e) => {
                        handlesSaveVendorPaymentTerms(true);
                        handleAutoSave({ event: e, fromButton: false });
                    }}>Save</Button>
                    <Button variant="outline-secondary" disabled={isReadOnly} onClick={closeVendorPaymentTermModal}>Cancel</Button>
                  </Modal.Footer>
                </Modal>
              
                {/* CUSTOMER PAYMENT TERM MODAL */}
                <Modal show={isCustomerPaymentTermModalOpen} onHide={closeCustomerPaymentTermModal} size="lg" centered>
                  <Modal.Header closeButton>
                    <Modal.Title>Customer Payment Terms</Modal.Title>
                  </Modal.Header>

                  <Modal.Body>
                    {!financialTableLoaded && (
                      <div style={{ color: "#856404", backgroundColor: "#fff3cd", border: "1px solid #ffeeba", borderRadius: "4px", padding: "8px 12px", marginBottom: "12px", fontWeight: 600 }}>
                        ⏳ Financial table data is still loading — percentage entry and Save are disabled until it finishes.
                      </div>
                    )}
                    <Table bordered width="100%">
                      <thead>
                        <tr>
                          <th>Particuars</th>
                          <th>Days</th>
                          <th>Percentage</th>
                          <th>Value</th>
                          <th> </th>
                          {/* <th width="80">Action</th> */}
                        </tr>
                      </thead>
                      <tbody>
                      {customerPaymentTermsDetails.map((row, i) => (
                        <tr key={i}>
                          <td>
                            <Form.Select value={row.customerpaymentTermsParticular} 
                            disabled={isReadOnly}
                            onChange={(e) => {
                              const value = e.target.value;
                              handleCustomerPaymentTermChange(i, "customerpaymentTermsParticular", value);
                              }}
                            aria-label="customerpaymentTermsParticular">
                              <option value="" disabled>Select Any One</option>
                            {paymentTermsNonTotalRows.map((row, index) => (
                                <option key={index} value={row.name}>{row.name}</option>
                              ))}
                            </Form.Select>
                          </td>
                          <td>
                            <Form.Control type="text" disabled={isReadOnly} inputMode="numeric" value={row.customerpaymentTermsDays}
                              onChange={(e) => {
                                const value = e.target.value;
                                // Allow empty OR digits only
                                if (/^\d*$/.test(value)) {handleCustomerPaymentTermChange(i, "customerpaymentTermsDays", value);}
                              }}
                            />
                          </td>
                          <td>
                            <Form.Control type="text" disabled={isReadOnly || !financialTableLoaded} inputMode="decimal" value={row.customerpaymentTermsPercentage}
                              onChange={async(e) => {
                                const value = e.target.value;
                                // ✅ Same load-race guard as the vendor payment terms handler above.
                                if (!financialTableLoaded) {
                                  toast.error("Financial table is still loading. Please wait a moment and try again.");
                                  return;
                                }
                                if (!row.customerpaymentTermsParticular || row.customerpaymentTermsParticular.trim() === "") {
                                  toast.error("Please select particulars in customer payment terms");
                                  return;
                                }

                                const matchedFTRows = paymentTermsNonTotalRows.filter((selctedRow) => selctedRow.name === row.customerpaymentTermsParticular);
                                // console.log('selctedRowmatchedFTRowsmatchedFTRows', matchedFTRows);
                                //  console.log('selectedSellingValue:::::::::::::::::::::::::', matchedFTRows[0].values[0].amount);
                                //  console.log('selectedCurrency:::::::::::::::::::::::::', matchedFTRows[0].currency);
                                //  console.log('selectedParticular:::::::::::::::::::::::::', matchedFTRows[0].name);
                                
                                const selectedSellingValue = matchedFTRows[0].values[0].amount;
                                const selectedCurrency = matchedFTRows[0].currency;
                                const selectedParticular = matchedFTRows[0].name;

                                const baseRate = await getRate(selectedCurrency);
                                const yearMultiplier = {
                                "Year 1": 1,        
                                "Year 2": 1.05,
                                "Year 3": 1.05 ** 2,
                                "Year 4": 1.05 ** 3,
                                "Year 5": 1.05 ** 4,
                                "Year 6": 1.05 ** 5,
                                "Year 7": 1.05 ** 6,
                                };

                                const multiplier = selectedCurrency !== "INR" ? (yearMultiplier[selectedParticular] ?? 1) : 1;
                                const effectiveRate = Number((baseRate * multiplier).toFixed(2));
                                // console.log('effectiveRate:::::::::::::::::::::::::', effectiveRate);
                                const effectivePrice = Math.trunc(selectedSellingValue * effectiveRate)
                                // console.log('effectivePrice:::::::::::::::::::::::::', effectivePrice);

                                if (!/^\d+(\.\d{0,2})?$|^$/.test(value)) return; // Allow only digits(also upto 2 decimal) or empty
                                
                                const numericValue = value === "" ? 0 : Number(value);
                                
                                // Calculate total excluding current row
                                const otherTotal = customerPaymentTermsDetails.reduce((sum, r, index) => {
                                    if (index === i) return sum;
                                    const v = Number(r.customerpaymentTermsPercentage);
                                    return isNaN(v) ? sum : sum + v;
                                  },0);

                                // Block update if total exceeds 100
                                // if (otherTotal + numericValue > 100) {
                                //   return;
                                // }


                                const calculatedValue = value === "" 
                                  ? "" 
                                  : (() => {
                                      // const rawValue = (numericValue * Number(selectedRowSellingValue)) / 100;
                                      const rawValue = (numericValue * Number(effectivePrice)) / 100;
                                      const decimal = rawValue - Math.floor(rawValue);
                                      return decimal <= 0.5 ? Math.floor(rawValue) : Math.ceil(rawValue);
                                    })();


                                // Update percentage
                                handleCustomerPaymentTermChange( i, "customerpaymentTermsPercentage", value );

                                // Update calculated value in state
                                handleCustomerPaymentTermChange( i, "customerpaymentTermsValue", calculatedValue );
                              }}
                            />
                          </td>
                          <td>
                            <Form.Control disabled={isReadOnly} value={row.customerpaymentTermsValue} readOnly={true} />
                          </td>
                          <td className="text-center">
                            {i > 0 && (
                              <Button
                                variant="danger"
                                size="sm"
                                disabled={isReadOnly}
                                onClick={() => deleteCustomerPaymentTermRow(i)}
                              >
                                <i className="fa-solid fa-trash"></i>
                              </Button>
                            )}
                          </td>
                        </tr>
                      ))}
                    </tbody>
                    </Table>
                  
                    <Row className="mt-2 align-items-center">
                      <Col className="d-flex justify-content-between align-items-center">
                        {totalCustomerPaymentTermsValue < totalSellingValueWithoutTotal && (
                          <Button variant="secondary" disabled={isReadOnly} onClick={addCustomerPaymentTermRow}>
                            Add Row
                          </Button>
                        )}
                        {totalCustomerPaymentTermsValue > 0 && (
                          <span style={{ fontWeight: "600", color: customerPercentageShortfall == 0 ? "green" : customerPercentageShortfall > 0 ? "orange" : "red" }}>
                            Total Percentage: {totalCustomerPaymentTermsPercentage}%
                            {customerPercentageShortfall < 0 && (<> (Shortfall: {Math.abs(customerPercentageShortfall)}%)</>)}
                            {customerPercentageShortfall > 0 && (<> (Exceeds by {customerPercentageShortfall}%)</>)}
                          </span>
                        )}
                      </Col>
                    </Row>
                  </Modal.Body>

                  <Modal.Footer>
                    {/* ✅ Same fix as the vendor modal: Cancel always available, Save
                        always rendered but disabled until ready — no vanishing buttons. */}
                    <Button variant="primary" disabled={isReadOnly || !financialTableLoaded || totalCustomerPaymentTermsValue > totalSellingValueWithoutTotal} onClick={(e) => {
                        handlesSaveCustomerPaymentTerms(true);
                        handleAutoSave({ event: e, fromButton: false });
                    }}>Save</Button>
                    <Button variant="outline-secondary" disabled={isReadOnly} onClick={closeCustomerPaymentTermModal}>Cancel</Button>
                  </Modal.Footer>
                </Modal>

                {/* Export Compliance Approval Component */}
                <Modal show={modalSentForAppv} onHide={handleCloseModal} size="xl" centered backdrop="static" keyboard={false}>
                  <Modal.Header closeButton>
                    <Modal.Title>
                      {step === 1 ? 'Requirement of Export Compliance Approval' : 'Approval Mail Confirmation'}
                    </Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    {step === 1 ? (
                      <Form>
                      <Table bordered responsive>
                        <thead>
                          <tr>
                            <th>Sr. No.</th>
                            <th>Particulars</th>
                            <th>YES/NO</th>
                          </tr>
                        </thead>
                        <tbody>
                          {[
                            ["End User & Billing Customer Name is Same", ques1, setQues1],
                            ["Customer Billing Location is Domestic", ques2, setQues2],
                            ["Customer Billing Location is International, (if any)", ques3, setQues3],
                            ["Customer PO Issuance from International Location", ques4, setQues4],
                            ["End User Location is Domestic", ques5, setQues5],
                            ["End User Location is International, (if any)", ques6, setQues6],
                            ["PO Issued in INR", ques7, setQues7],
                            [`We Are Selling Following Product/Service :- (AI-Tool/CCTV Camera/ Drone / Surveillance Camera/Nvidia Graphic Card)`, ques8, setQues8],
                            [`We Are Selling Following OEM's Product :- (Hikvision, Dhaua, Huawei, Kaspersky Or Any Chinese Camera Manufacturer)`, ques9, setQues9],
                            ["Customer is Related To WMD (Weapons of Mass Destruction)/ Military/Defence/Nuclear/Aerospace", ques10, setQues10],
                            [`Customer/End Customer is Fall Under Category:- State Govt./Central Govt./PSU`, ques12, setQues12],
                            [`This deal is related to Tender`, ques13, setQues13],
                            [`Is customer having Global (Out of India) Presence`, ques14, setQues14],
                          ].map(([label, value, setter], index) => renderEXCompQuestions(index, label, value, setter, false, setExCompMessage, setExCompRemark) )}
                        </tbody>
                      </Table>
                      <span style={{color: 'grey', fontSize:'16px'}}>
                      <i className="fa-solid fa-star-of-life" style={{ color: '#e91717', fontSize: '10px', marginLeft: '1px' }} />
                      Declaration: I hereby declare that the information I have provided regarding export control matters is true, 
                      complete, and accurate to the best of my knowledge based on available documentation and customer confirmation
                      </span>
                      <span style={ExCompMessage ? {display: 'block',textAlign: 'center',fontWeight: 'bold',color: 'black',backgroundColor: 'yellow',borderRadius: '5px',
                          padding: '8px',margin: '10px auto',width: 'fit-content'} : {}}>{ExCompMessage}</span>
      
                      </Form>
                    ) : (
                      <>
                        <p>Are you sure you want to proceed, After this point mail will be triggered! To Following Approvers:</p>
                  
                        <Row>
                          <Col xs={3}>
                            <span data-row-name="Approvers-common">
                              {appvTeamLeaderReq === 'YES' ? 'Team Leader' : ''} <br />
                              {appvCreditInsuranceReq === 'YES' ? 'Credit Insurance' : ''} <br />
                              {appvRegionBusinessHeadReq === 'YES' ? 'Region Business Head ' : ''} <br />
                              {appvFunctionalHead4Req === 'YES' ? 'Functional Head - 4' : ''} <br />
                              {appvlegalHeadReq === 'YES' ? 'Legal Head' : ''}
                            </span>
                          </Col>
                          <Col xs={3}>
                            <span data-row-name="Approvers-common">
                              {appvBranchHeadReq === 'YES' ? 'Branch Head' : ''} <br />
                              {appvFunctionalHeadReq === 'YES' ? 'Functional Head - 1' : ''} <br />
                              {appvCFOReq === 'YES' ? 'CFO' : ''} <br />
                              {appvFunctionalHead5Req === 'YES' ? 'Functional Head - 5' : ''} <br />
                              {appvCEOReq === 'YES' ? 'CEO' : ''}
                            </span>
                          </Col>
                          <Col xs={3}>
                            <span data-row-name="Approvers-condition">
                              {appvBusinessFinanceReq === 'YES' ? 'Business Finance' : ''}  <br />
                              {appvFunctionalHead2Req === 'YES' ? 'Functional Head - 2' : ''} <br />
                              {appvFunctionalHead6Req === 'YES' ? 'Functional Head - 6' : ''} <br />
                              {appvCOOReq === 'YES' ? 'COO' : ''}

                              
                            </span>
                          </Col>
                          <Col xs={3}>
                            <span data-row-name="Approvers-condition">
                              {appvExportComplianceReq === 'YES' ? 'Export Compliance' : ''}  <br />
                              {appvFunctionalHead3Req === 'YES' ? 'Functional Head - 3' : ''} <br />
                              {appvSVPDirectorReq === 'YES' ? 'SVP-Director' : ''}
                            </span>
                          </Col>
                        </Row>
                      </>
                    )}
                  </Modal.Body>
                  <Modal.Footer>
                    {step === 1 ? (
                      <>
                      {!showExCompRemark? (
                        <Button variant="info" 
                        onClick={handleExCompAppvRemark}>Check</Button>
                      ) : (
                        <Button variant="secondary" onClick={handleQuesNext}>Next</Button>
                      )}
                    </>
                    ) : (
                      <>
                        <Button variant="primary" onClick={() => setStep(1)}>Back</Button>
                        <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
                        <Button variant="success" onClick={handleApproval}>Confirm</Button>
                      </>
                    )}
                  </Modal.Footer>
                </Modal>
      
                {/* Form Reopen Component */}
                <Modal show={showReopen} onHide={handleCloseReopenModal}>
                  <Modal.Header closeButton>
                    <Modal.Title>Reopen Preloading</Modal.Title>
                  </Modal.Header>
                  <Modal.Body>
                    Are you sure you want to Re-Open this Preloading?
                  </Modal.Body>
                  <Modal.Footer>
                    <Button variant="outline-secondary" onClick={handleCloseReopenModal}>
                      Close
                    </Button>
                    <Button variant="outline-success" onClick={handleReopenPrelaoding}>
                      Yes REOPEN !
                    </Button>
                  </Modal.Footer>
                </Modal>

              </section>
              
              {/* <Basic Form Details> */}
              <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }}>
                {(status === 'Approved'|| status === 'PO Received') && (
                  <div style={{
                    position: 'absolute',
                    top: '50%',
                    left: '50%',
                    transform: 'translate(-50%, -50%) rotate(-10deg) scale(0.1)',
                    zIndex: 100,
                    // pointerEvents: 'none' // optional: lets clicks pass through if needed
                  }}>
                    <img src={approvedStamp} alt="Centered" />
                  </div>
                )}
                <Row className="mb-1" data-row-name="Document ID">
                  <Col md="5" className="customformlabel"><Form.Label>Document ID</Form.Label></Col>
                  <Col md="7">
                    <Form.Control type="text" disabled readOnly value={series} />
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="CRM Number">
                  <Col md="5" className="customformlabel">
                    <Form.Label>CRM Number<i className="fa-solid fa-star-of-life" style={{ color: "red", fontSize: "10px", paddingLeft: "2px" }}/></Form.Label>
                  </Col>

                  <Col md="7">
                    {/* <Col md="7" className="searchable-select-container">
                        <input type="text" placeholder="Select CRM Number" value={searchTerm} onFocus={() => setShowDropdown(true)} onBlur={() => setShowDropdown(false)}
                        onChange={(e) => { if (!isReadOnly) { setSearchTerm(e.target.value); setShowDropdown(true); } }} readOnly={isReadOnly} className="searchable-select-input"
                        />
                        {showDropdown && !isReadOnly && (
                        <div className="searchable-select-dropdown">
                            {filteredCrmData.length > 0 ? (
                            filteredCrmData.map(item => (
                                <div key={item.crmNumber} value={item.crmNumber} onMouseDown={() => handleSelectChange(item.crmNumber)} className="searchable-select-item">
                                {item.crmNumber}
                                </div>
                            ))
                            ) : (
                            <div className="searchable-select-item disabled">No results found</div>
                            )}
                        </div>
                        )} */}
                    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
                      <div style={{ flex: 1 }}>
                        <Select components={{ Input: CustomInput }} fieldName="CRM Number"  options={crmData.map((item) => ({label: item.crmNumber, value: item.crmNumber }))} 
                          value={searchTerm ? { label: searchTerm, value: searchTerm } : null}
                          isDisabled={isReadOnly} isSearchable placeholder="Select CRM Number" noOptionsMessage={() => "No results found"}
                          filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                          onChange={(selected) => {setSearchTerm(selected?.value || ""); handleSelectChange(selected?.value || "");}}/>
                      </div>

                      <div style={{ position: "relative" }} onMouseEnter={() => setIsNoteVisible(true)} onMouseLeave={() => setIsNoteVisible(false)}>
                        <i className="fa fa-info-circle" style={{ fontSize: "20px", cursor: "pointer" }} />
                        {isNoteVisible && (
                          <div style={{ position: "absolute", top: "120%", right: "0", backgroundColor: "white", border: "1px solid #ccc", padding: "10px", zIndex: 10, minWidth: "250px", boxShadow: "0 2px 5px rgba(0,0,0,0.2)" }} >
                            CRM Number will be updated after every one hour.
                          </div>
                        )}
                      </div>

                    </div>
                  </Col>
                </Row>            
                <Row className="mb-1" data-row-name="Customer Name">
                  <Col md="5" className="customformlabel"><Form.Label>Customer Name</Form.Label></Col>
                  <Col md="7"><Form.Control type="text" value={customerName} disabled={isReadOnly} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="Sales Person Name">
                  <Col md="5" className="customformlabel"><Form.Label>Sales Person Name</Form.Label></Col>
                  <Col md="7"><Form.Control type="text" value={salesPersonName} disabled={isReadOnly} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="Approval Request Date">
                  <Col md="5" className="customformlabel"><Form.Label>Approval Request Date</Form.Label></Col>
                  <Col md="7">
                    <Form.Control 
                    // value={approvalRequestDate} 
                    value={status === "Open" ? moment(approvalRequestDate).format("dddd, DD MMMM, YYYY") : moment(sendForAppvReqDate).format("dddd, DD MMMM, YYYY")}
                    disabled={isReadOnly}  
                    type="text" readOnly />
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Opportunity Name">
                  <Col md="5" className="customformlabel"><Form.Label>Opportunity Name</Form.Label></Col>
                  <Col md="7"><Form.Control type="text" value={opportunityName} disabled={isReadOnly} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="OEM">
                  <Col md="5" className="customformlabel"><Form.Label>Opportunity Category(OEM)
                    <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                  </Form.Label></Col>
                  <Col md="7">
                    {/* <Form.Select value={oem} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => setOem(e.target.value)} aria-label="OEM">
                      <option value="" disabled>Select Opportunity Category(OEM)</option>
                      <option value="Microsoft">Microsoft</option>
                      <option value="Other than Microsoft">Other than Microsoft</option>
                    </Form.Select> */}

                    <Select components={{ Input: CustomInput }} fieldName="Opportunity Category(OEM)"  options={oemOptions} value={selectedOem} isDisabled={isReadOnly} isSearchable placeholder="Select Opportunity Category (OEM)"
                    filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
                    onChange={(selected) => {
                      setSelectedOem(selected);
                      handleAutoSave({ fromButton: false, multioemvalues: selected.map(opt => opt.value)})
                    }} 
                      isMulti={true}
                    />

                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Primary Transaction Currency">
                    <Col md="5" className="customformlabel"><Form.Label>Primary Transaction Currency
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label></Col>
                    <Col md="7">
                      <Form.Select value={transactionCurrency} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={handleCurrencyChange} aria-label="TransactionCurrency">
                        <option value="" disabled> Select Transaction Currency</option>
                        
                        <option value="USD">USD</option>
                        <option value="AED">AED</option>
                        <option value="SGD">SGD</option>
                        <option value="HKD">HKD</option>
                        <option value="JPY">JPY</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                        <option value="INR">INR</option>
                      </Form.Select>
                    </Col>
                </Row>
                <Row className="mb-1" data-row-name="Secondary Transaction Currency">
                    <Col md="5" className="customformlabel"><Form.Label>Secondary Transaction Currency
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label></Col>
                    <Col md="7">
                      {/* <Form.Select value={secondaryTransactionCurrency} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={} aria-label="SecondaryTransactionCurrency">
                        <option value="" disabled> Select Transaction Currency</option>
                        
                        <option value="USD">USD</option>
                        <option value="AED">AED</option>
                        <option value="SGD">SGD</option>
                        <option value="HKD">HKD</option>
                        <option value="JPY">JPY</option>
                        <option value="EUR">EUR</option>
                        <option value="GBP">GBP</option>
                        <option value="INR">INR</option>
                      </Form.Select> */}

                      <Form.Select
                        value={secondaryTransactionCurrency}
                        disabled={isReadOnly}
                        onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={handleSecondaryChange}
                      >
                        {secondaryOptions.map((curr) => (
                          <option key={curr} value={curr}>
                            {curr}
                          </option>
                        ))}
                      </Form.Select>
                    </Col>
                </Row>
                <Row className="mb-1" data-row-name="Expected date of Material Delivery">
                  <Col md="5" className="customformlabel">
                    <Form.Label>Expected date of Delivery
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label>
                  </Col>
                  <Col md="7">
                    {/* <Form.Control type="date" readOnly={isReadOnly} value={materialDeliveryDate} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                    onChange={(e) => setMaterialDeliveryDate(e.target.value)} aria-label="MaterialDeliveryDate" /> */}
                    <Form.Control type="date" min={moment().format("YYYY-MM-DD")} disabled={isReadOnly} readOnly={isReadOnly} value={materialDeliveryDate} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                      onChange={(e) => setMaterialDeliveryDate(moment(e.target.value).format("YYYY-MM-DD"))} aria-label="MaterialDeliveryDate" />

                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Vendor Billing Cycle">
                    <Col md="5" className="customformlabel"><Form.Label>Vendor Billing Cycle
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label></Col>
                    <Col md="7">
                      <Form.Select value={vendorBillingCycle} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => setvendorBillingCycle(e.target.value)} aria-label="Vendor Billing Cycle">
                        <option value='' disabled> Select Vendor Billing Cycle</option>
                        <option value="Same as Customer">Same as Customer</option>
                        <option value="UpFront">UpFront</option>
                        <option value="Deffered">Deffered</option>
                      </Form.Select>
                    </Col>
                </Row>
                <Row className="mb-1" data-row-name="Hitachi Role in this Deal">
                  <Col md="5" className="customformlabel">
                    <Form.Label> Hitachi Role in this Deal
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label>
                  </Col>
                  <Col md="7">
                    <Form.Control type="text" readOnly={isReadOnly} maxLength={300} value={hitachiRoleinthisDeal} disabled={isReadOnly} onPaste={(e) => handlePaste(e, 'Hitachi Role')} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                    onChange={(e) => sethitachiRoleinthisDeal(e.target.value)} aria-label="hitachiRoleinthisDeal" />
                    {/* <div className="text-end text-muted small">{hitachiRoleinthisDeal.length}/300</div> */}
                    <div className="text-end text-muted small">{hitachiRoleinthisDeal?.length != null ? `${hitachiRoleinthisDeal.length}/300` : '0/300'} </div>
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Rebate Amount if any">
                  <Col md="5" className="customformlabel" style={{ display: 'flex', justifyContent: 'space-between' }}>
                    <Form.Label> Rebate Amount if any</Form.Label>
                    <Form>
                      <div className="mb-3">
                        <Form.Check inline label="YES" name="yesNo" type="radio" id="yes-radio" value="YES" checked={confirmRebate === "YES"} onChange={handleRebateChange}/>
                        <Form.Check inline label="NO" name="yesNo" type="radio" id="no-radio" value="NO" checked={confirmRebate === "NO"} onChange={handleRebateChange}/>
                      </div>
                    </Form>
                  </Col>

                  <Col md="7">
                    <InputGroup>
                      <Form.Control type="text" value={fileName4} disabled={isReadOnly} aria-label="Upload Document-4" readOnly />
                      <Form.Control type="file" onChange={(e) => handleSelectFile4(e)} style={{ display: 'none' }} id="file-input-4"/>
                      <Button variant="outline-primary" id="file-del-4" onClick={() => document.getElementById('file-input-4').click()} disabled={isReadOnly || confirmRebate === "NO" || confirmRebate == null}><MDBIcon fas icon="file-upload" size="lg" /></Button>
                      <Button variant="outline-danger" onClick={handleRemoveFile4} disabled={!fileName4 || isReadOnly || confirmRebate === "NO" || confirmRebate == null}><MDBIcon fas icon="trash" /></Button>
                      <Button variant="outline-success" onClick={handleViewFile4}><MDBIcon fas icon="file-download" /></Button>
                    </InputGroup>
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Conversion Rate">
                  <Col md="5" className="customformlabel">
                    <Form.Label>Conversion Rate</Form.Label>
                  </Col>

                  <Col md="7">
                    {(transactionCurrency === "USD" || transactionCurrency === "AED" || transactionCurrency === "SGD" || 
                    transactionCurrency === "HKD" || transactionCurrency === "JPY" || transactionCurrency === "EUR" || transactionCurrency === "GBP") ? (

                      <div style={{ display: "flex", width: "100%" }}>
                        <div style={{ flex: 1, textAlign: "center" }}>
                          <Form.Label>Year 1</Form.Label><br />
                          <Form.Label>{conversionRateyear1}</Form.Label>
                        </div>
                        <div style={{ flex: 1, textAlign: "center" }}>
                          <Form.Label>Year 2</Form.Label><br />
                          <Form.Label>{conversionRateyear2}</Form.Label>
                        </div>
                        <div style={{ flex: 1, textAlign: "center" }}>
                          <Form.Label>Year 3</Form.Label><br />
                          <Form.Label>{conversionRateyear3}</Form.Label>
                        </div>
                        <div style={{ flex: 1, textAlign: "center" }}>
                          <Form.Label>Year 4</Form.Label><br />
                          <Form.Label>{conversionRateyear4}</Form.Label>
                        </div>
                        <div style={{ flex: 1, textAlign: "center" }}>
                          <Form.Label>Year 5</Form.Label><br />
                          <Form.Label>{conversionRateyear5}</Form.Label>
                        </div>
                        <div style={{ flex: 1, textAlign: "center" }}>
                          <Form.Label>Year 6</Form.Label><br />
                          <Form.Label>{conversionRateyear6}</Form.Label>
                        </div>
                        <div style={{ flex: 1, textAlign: "center" }}>
                          <Form.Label>Year 7</Form.Label><br />
                          <Form.Label>{conversionRateyear7}</Form.Label>
                        </div>
                      </div>

                    ) : (
                      <Form.Control
                        type="text" value={conversionRate} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
                        onChange={(e) => setconversionRate(e.target.value)} aria-label="conversionRate" />
                    )}
                  </Col>
                </Row>
              </section>
              
              {/* <Financial Table & Doc Upload> */}
              <section style={{ position: 'relative', border: '2px solid #ccc', paddingLeft: '15px', paddingRight: '15px'}}>
                  <div className="p-2">
                    {/* <div className="mt-1 mb-1 d-flex justify-content-end">
                      <Button variant="outline-success" className="m-1" onClick={handleSaveFinancialTable}><MDBIcon fas icon="floppy-disk" size='lg' /></Button>
                    </div> */}
                    <style>
                      {`
                        @keyframes blinkBorder {
                          0%   { box-shadow: 0 0 0 3px red; }
                          50%  { box-shadow: 0 0 0 3px transparent; }
                          100% { box-shadow: 0 0 0 3px red; }
                        }

                        .blink-border {
                          animation: blinkBorder 1s infinite;
                        }
                      `}
                    </style>
                      <Table bordered hover size="sm" className="text-center align-middle" style={{ fontSize: "0.85rem" }}>
                        <thead>
                          <tr>
                            <th>Currency</th>
                            <th>Particulars</th>
                            {columnNames.map((col, i) => (<th key={i}>{col}</th>))}
                            <th>Action</th>
                          </tr>
                        </thead>
                      
                        <tbody>
                          {rows.map((row) => (
                            <tr key={row.id}>
                              <td>
                                {row.name === "Total" ? (<strong style={{ fontSize: "0.9rem" }}>INR</strong>) : (
                                  <Form.Select value={row?.currency} disabled={isReadOnly} onChange={(e) => handleRowCurrencyChange(row.id, e.target.value)} 
                                  aria-label="Row Currency" style={{ fontSize: "0.8rem" }}>
                                    {renderCurrencyOptions()}
                                  </Form.Select>
                                )}
                              </td>

                              <td><strong>{row.name}</strong></td>

                              {row.name === "Total"
                                ? [
                                    ...totalValues.map((t, i) => (
                                      <td key={i}>
                                        <strong>
                                          {i === totalValues.length - 1
                                            ? `${t}%`
                                            : new Intl.NumberFormat('en-IN').format(t)}
                                        </strong>
                                      </td>
                                    )),
                                    <td className={dirtyFCTable ? "blink-border" : ""} style={{backgroundColor: dirtyFCTable ? "#ffcccc" : "transparent"}} key="action">
                                      <Button variant="success" disabled={isReadOnly} size="sm" onClick={() => handleSaveFinancialTable()}>
                                        Save
                                      </Button>
                                    </td>,
                                  ]
                                : row.values.map((val, i) => (
                                    <td key={i}>
                                      <input
                                        type="text"
                                        value={editingCell?.rowId === row.id && editingCell?.colIndex === i
                                            ? editingValue 
                                            : i === totalValues.length - 1
                                              ? `${val.amount} %`
                                              : new Intl.NumberFormat('en-IN').format(val.amount)
                                        }
                                        disabled={isReadOnly}
                                        onChange={(e) => {
                                          const value = e.target.value.replace(/,/g, "");
                                          if (/^\d*$/.test(value)) {
                                            setEditingValue(value);
                                          }
                                        }}
                                        onFocus={() => {
                                          setEditingCell({ rowId: row.id, colIndex: i });
                                          setEditingValue(String(val.amount));
                                        }}
                                        onBlur={() => {
                                          handleValueChange(row.id, i, editingValue);
                                          setEditingCell(null);
                                          setEditingValue("");
                                        }}
                                        style={{ width: "100%", fontSize: "0.8rem" }}
                                      />
                                    </td>
                                ))
                              }

                              {!["Year 1", "Year 2", "Year 3", "Total"].includes(row.name) && (
                                <td>
                                  <Button variant="danger" disabled={isReadOnly} size="sm" onClick={() => removeRow(row.id)}>
                                    Delete
                                  </Button>
                                </td>
                              )}

                            </tr>
                          ))}
                        </tbody>
                      </Table>

                      {/* Add Row Buttons */}
                      <div className="mt-3">
                        {extraRowNames.map((name, i) => (<Button key={i} size="sm" className="m-1" onClick={() => addRow(name)} disabled={isReadOnly || rows.some((row) => row.name === name)}> {name} </Button>))}
                      </div>
                      
                  </div>
                  {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && (
                  <Row className="mt-1 mb-1" data-row-name="Upload Document-5 [ Upload Business Finance Doc ]">
                        <Col md="5" className="customformlabel"><Form.Label>Upload Business Finance Doc
                          {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName5} disabled={isReadOnly} aria-label="Upload Document-5" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile5(e)} style={{ display: 'none' }} id="file-input-5" />
                            <Button variant="outline-primary" id="file-del-5" onClick={() => { document.getElementById('file-input-5').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile5} disabled={!fileName5 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile5}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                  </Row>
                  )}
                  {(sessionStorage.getItem('role') === 'EXPORT COMPLIANCE' || sessionStorage.getItem('role') === 'ADMIN') && (
                      <Row className="mb-1" data-row-name="Upload Document-6 [ Upload Ex-Comp Doc ]">
                        <Col md="5" className="customformlabel"><Form.Label> Upload Ex-Comp Doc
                          <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName6} disabled={isReadOnly} aria-label="Upload Document-4" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile6(e)} style={{ display: 'none' }} id="file-input-6" />
                            <Button variant="outline-primary" id="file-del-6" onClick={() => document.getElementById('file-input-6').click()}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile6} disabled={!fileName6}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile6}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      )}
              </section> 
              
              {/* <Payment Terms & Expected Dates> */}
              <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }}>
                <Row className="mb-1" data-row-name="Vendor Payment Terms">
                  <Col md="5" className="d-flex align-items-center justify-content-between customformlabel">
                    <Form.Label className="mb-0"> Vendor Payment Terms
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label>

                    <Button variant="primary" size="sm" type="button" onClick={() => {setIsVendorPaymentTermModalOpen(true)}}>
                      Payment Terms <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Button>
                  </Col>

                  <Col md="7" className="d-flex align-items-center justify-content-between">
                    <Form.Control type="text" disabled={isReadOnly} readOnly={true} value={vendorPaymentTerms} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                    onChange={(e) => setvendorPaymentTerms(e.target.value)} aria-label="vendorPaymentTerms" />

                    {/* <Button variant="warning" size="sm" className="mb-2" onClick={recalculateAllVendorPaymentTermValues}>
                      <i className="fa-solid fa-rotate"></i> Recal
                    </Button> */}
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Customer Payment Terms">
                  <Col md="5" className=" d-flex align-items-center justify-content-between customformlabel">
                    <Form.Label> Customer Payment Terms
                    <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label>
                    
                    <Button variant="primary" size="sm" type="button" onClick={() => setIsCustomerPaymentTermModalOpen(true)} >
                      Payment Terms <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Button>
                  </Col>
                  <Col md="7" className="d-flex align-items-center justify-content-between">
                    <Form.Control type="text" disabled={isReadOnly} readOnly={true} value={customerPaymentTerms} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                    onChange={(e) => setcustomerPaymentTerms(e.target.value)} aria-label="customerPaymentTerms" />

                    {/* <Button variant="warning" size="sm" className="mb-2" onClick={recalculateAllCustomerPaymentTermValues}>
                      <i className="fa-solid fa-rotate"></i> Recal
                    </Button> */}
                  </Col>
                </Row>
                {showMarginRemarksRow == true && (
                  <Row className="mb-1" data-row-name="Reason if its Margin goes less than 6%">
                    <Col md="5" className="customformlabel">
                      <Form.Label> Reason if its Margin goes less than 6%</Form.Label>
                    </Col>
                    <Col md="7">
                      <Form.Control type="text" disabled={isReadOnly} readOnly={isReadOnly} maxLength={300} value={lowMarginReason} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                      onChange={(e) => setLowMarginReason(e.target.value)} aria-label="LowMarginReason" />
                      <div className="text-end text-muted small">{lowMarginReason.length}/300</div>
                    </Col>
                </Row>
                )}
                  {/* totalSellingValue >= 300000000 */}
                {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && totalSellingValue > 5000000 && (
                  <Row className="mb-1" data-row-name="Deal Type">
                      <Col md="5" className="customformlabel"><Form.Label>Select Deal Type
                        <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                      <Col md="7">
                        <Form.Select value={dealType} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => setDealType(e.target.value)} aria-label="Deal Type">
                          <option value='' disabled> Select Deal type</option>
                          <option value="Gross">Gross</option>      
                          <option value="Net-off">Net-off</option>
                        </Form.Select>
                      </Col>
                  </Row>
                )}
                {sessionStorage.getItem('role') !== 'BUSINESS FINANCE' && totalSellingValue > 5000000 && (
                  <Row className="mb-1" data-row-name="Deal Type">
                      <Col md="5" className="customformlabel"><Form.Label>Deal Type
                        <span style={{ fontSize: "0.8em", fontWeight: "normal", color: "#6c757d" }}>
                            [ This will be duly filled by BUSINESS FINANCE ]
                        </span>
                        <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                      <Col md="7">
                        <Form.Control type="text" value={dealType} disabled readOnly/>
                      </Col>
                  </Row>
                )}
                <Row className="mb-1" data-row-name="Remarks if any">
                  <Col md="5" className="customformlabel">
                    <Form.Label> Remarks if any</Form.Label>
                  </Col>
                  <Col md="7">
                    <Form.Control type="text" disabled={isReadOnly} readOnly={isReadOnly} maxLength={300} value={remarksIfAny} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                    onChange={(e) => {setremarksIfAny(e.target.value);}}aria-label="remarksIfAny" />
                    <div className="text-end text-muted small">{remarksIfAny.length}/300</div>
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Expected date of Customer Recipt">
                  <Col md="5" className="customformlabel">
                    <Form.Label> Expected date of Customer Recipt</Form.Label>
                  </Col>
                  <Col md="7">
                    <Form.Control type="date" value={expectedDtCustomerRecipt} disabled={isReadOnly} readOnly={true} onFocus={(e) => e.target.blur()} onKeyDown={(e) => e.preventDefault()}
                      onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} aria-label="expectedDtCustomerRecipt"/>
                    {/* <Form.Control type="date" readOnly={isReadOnly} value={expectedDtCustomerRecipt} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                    onChange={(e) => setexpectedDtCustomerRecipt(e.target.value)} aria-label="expectedDtCustomerRecipt" /> */}
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Expected date of Vendor Payment">
                  <Col md="5" className="customformlabel">
                    <Form.Label> Expected date of Vendor Payment</Form.Label>
                  </Col>
                  <Col md="7">
                  <Form.Control type="date" disabled={isReadOnly} readOnly={true} value={expectedDtVendorPayment} onFocus={(e) => e.target.blur()} onKeyDown={(e) => e.preventDefault()} 
                    onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => {}} aria-label="expectedDtVendorPayment" />
                    {/* <Form.Control type="date" readOnly={isReadOnly} value={expectedDtVendorPayment} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
                    onChange={(e) => setexpectedDtVendorPayment(e.target.value)} aria-label="expectedDtVendorPayment" /> */}
                  </Col>
                </Row>
                
              </section>

              {/* <Expert Advices> */}
              <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }}>
                <Row className="mb-1" data-row-name="Expert advice from Company's Cashflow Prospective">
                  <Col md="5" className="customformlabel"><Form.Label>Expert advice from Company's Cashflow Prospective</Form.Label></Col>
                  <Col md="7">
                    <Form.Control as="textarea" type="text" row={2} disabled={isReadOnly} readOnly value={cashFlowExpertAdvice}
                      onChange={(e) => setcashFlowExpertAdvice(e.target.value)}
                      className={ cashFlowExpertAdvice === "It's favourable to Hitachi" ? 'cashFlowExpertAdvicefavourable'
                          : cashFlowExpertAdvice === "It's become FC Impacted deal" ? 'cashFlowExpertAdviceimpacted'
                            : cashFlowExpertAdvice === "" ? 'cashFlowExpertAdvicedefault' : null
                      }/>
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="Expert advice from Company's Margin Prospective">
                  <Col md="5" className="customformlabel"><Form.Label>Expert advice from Company's Margin Prospective</Form.Label></Col>
                  <Col md="7">
                    <Form.Control as="textarea" type="text" rows={2} disabled={isReadOnly} readOnly value={marginExpertAdvice} 
                      onChange={(e) => setmarginExpertAdvice(e.target.value)}
                      className={ marginExpertAdvice === "Margin Above the Threshold" ? 'cashFlowExpertAdvicefavourable'
                          : marginExpertAdvice === "Margin Below the Threshold" ? 'cashFlowExpertAdviceimpacted'
                            : marginExpertAdvice === "" ? 'cashFlowExpertAdvicedefault' : null
                      } />
                  </Col>
                </Row>
              </section>

              {/* <Select Functional Heads> */}
              <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }}>
                <Row className="mb-1" data-row-name="FunctionalHead-1">
                  <Col md="5" className="customformlabel">
                    <Form.Label>Functional Head - 1</Form.Label>
                  </Col>

                  <Col md="7">
                    <Select components={{ Input: CustomInput }} fieldName="Functional Head -1" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
                      options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
                      value={functionalHead1ID ? { label: functionalHead1Name, value: functionalHead1ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -1" noOptionsMessage={() => "No results found"}
                      filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
                      onChange={(selected) => {setFunctionalHead1ID(selected?.value || ""); setFunctionalHead1Name(selected?.empName || "");}}/>
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="FunctionalHead-2">
                  <Col md="5" className="customformlabel">
                    <Form.Label>Functional Head - 2</Form.Label>
                  </Col>
                  <Col md="7">
                    <Select components={{ Input: CustomInput }} fieldName="Functional Head -2" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
                      options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
                      value={functionalHead2ID ? { label: functionalHead2Name, value: functionalHead2ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -2" noOptionsMessage={() => "No results found"}
                      filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
                      onChange={(selected) => {setFunctionalHead2ID(selected?.value || ""); setFunctionalHead2Name(selected?.empName || "");}}/>
                  </Col>
                </Row>
                <Row className="mb-1" data-row-name="FunctionalHead-3">
                  <Col md="5" className="customformlabel">
                    <Form.Label>Functional Head - 3</Form.Label>
                  </Col>

                  <Col md="7">
                    <Select components={{ Input: CustomInput }} fieldName="Functional Head -3" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
                      options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
                      value={functionalHead3ID ? { label: functionalHead3Name, value: functionalHead3ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -3" noOptionsMessage={() => "No results found"}
                      filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
                      onChange={(selected) => {setFunctionalHead3ID(selected?.value || ""); setFunctionalHead3Name(selected?.empName || "");}}/>
                  </Col>
                </Row> 
                {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && (
                  <>
                    <Row className="mb-1" data-row-name="FunctionalHead-4">
                    <Col md="5" className="customformlabel">
                      <Form.Label>Functional Head - 4</Form.Label>
                    </Col>

                    <Col md="7">
                      <Select components={{ Input: CustomInput }} fieldName="Functional Head -4" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
                        options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
                        value={functionalHead4ID ? { label: functionalHead4Name, value: functionalHead4ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -4" noOptionsMessage={() => "No results found"}
                        filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
                        onChange={(selected) => {setFunctionalHead4ID(selected?.value || ""); setFunctionalHead4Name(selected?.empName || "");}}/>
                    </Col>
                    </Row>
                    <Row className="mb-1" data-row-name="FunctionalHead-5">
                      <Col md="5" className="customformlabel">
                        <Form.Label>Functional Head - 5</Form.Label>
                      </Col>

                      <Col md="7">
                        <Select components={{ Input: CustomInput }} fieldName="Functional Head -5" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
                          options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
                          value={functionalHead5ID ? { label: functionalHead5Name, value: functionalHead5ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -5" noOptionsMessage={() => "No results found"}
                          filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
                          onChange={(selected) => {setFunctionalHead5ID(selected?.value || ""); setFunctionalHead5Name(selected?.empName || "");}}/>
                      </Col>
                    </Row>
                    <Row className="mb-1" data-row-name="FunctionalHead-6">
                      <Col md="5" className="customformlabel">
                        <Form.Label>Functional Head - 6</Form.Label>
                      </Col>

                      <Col md="7">
                        <Select components={{ Input: CustomInput }} fieldName="Functional Head -6" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
                          options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
                          value={functionalHead6ID ? { label: functionalHead6Name, value: functionalHead6ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -6" noOptionsMessage={() => "No results found"}
                          filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
                          onChange={(selected) => {setFunctionalHead6ID(selected?.value || ""); setFunctionalHead6Name(selected?.empName || "");}}/>
                      </Col>
                    </Row>
                  </>
                )}
              </section>

              {/* <Attachments - File Management> */}
              <section style={{ position: 'relative', border: '2px solid #ccc', paddingLeft: '15px', paddingRight: '15px', marginBottom: '25px' }}>
                    
                      <Row className="mt-2 mb-1" data-row-name="Upload Document-1 [ Customer accepted proposal copy ]">
                        <Col md="5" className="customformlabel"><Form.Label> Customer Proposal
                          <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName1} disabled={isReadOnly} aria-label="Upload Document-1" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile1(e)} style={{ display: 'none' }} id="file-input-1" />
                            <Button variant="outline-primary" id="file-del-1" onClick={() => { document.getElementById('file-input-1').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile1} disabled={!fileName1 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile1}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="mb-1" data-row-name="Upload Document-2 [ Vendor TP Doc ]">
                        <Col md="5" className="customformlabel"><Form.Label> Vendor TP with their payment terms and delivery timeline of that product
                          <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName2} disabled={isReadOnly} aria-label="Upload Document-2" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile2(e)} style={{ display: 'none' }} id="file-input-2" />
                            <Button variant="outline-primary" id="file-del-2" onClick={() => document.getElementById('file-input-2').click()} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile2} disabled={!fileName2 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile2}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="mb-1" data-row-name="Upload Document-3 [ Purchase Order ]">
                        <Col md="5" className="customformlabel"><Form.Label> Purchase Order
                          {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName3} disabled={isReadOnly} aria-label="Upload Document-3" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile3(e)} style={{ display: 'none' }} id="file-input-3" />
                            <Button variant="outline-primary" id="file-del-3" onClick={() => document.getElementById('file-input-3').click()} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile3} disabled={!fileName3 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile3}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="mt-2 mb-1" data-row-name="Upload Document-7 [Additional Document-1 ] ">
                        <Col md="5" className="customformlabel"><Form.Label> Additional Document-1
                          {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName7} disabled={isReadOnly} aria-label="Upload Document-7" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile7(e)} style={{ display: 'none' }} id="file-input-7" />
                            <Button variant="outline-primary" id="file-del-7" onClick={() => { document.getElementById('file-input-7').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile7} disabled={!fileName7 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile7}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="mt-2 mb-1" data-row-name="Upload Document-8 [Additional Document-2 ] ">
                        <Col md="5" className="customformlabel"><Form.Label> Additional Document-2
                          {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName8} disabled={isReadOnly} aria-label="Upload Document-8" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile8(e)} style={{ display: 'none' }} id="file-input-8" />
                            <Button variant="outline-primary" id="file-del-7" onClick={() => { document.getElementById('file-input-8').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile8} disabled={!fileName8 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile8}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="mt-2 mb-1" data-row-name="Upload Document-9 [Additional Document-3 ] ">
                        <Col md="5" className="customformlabel"><Form.Label> Additional Document-3
                          {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName9} disabled={isReadOnly} aria-label="Upload Document-9" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile9(e)} style={{ display: 'none' }} id="file-input-9" />
                            <Button variant="outline-primary" id="file-del-9" onClick={() => { document.getElementById('file-input-9').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile9} disabled={!fileName9 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile9}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      <Row className="mt-2 mb-1" data-row-name="Upload Document-10 [Additional Document-4 ] ">
                        <Col md="5" className="customformlabel"><Form.Label> Additional Document-4
                          {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
                        </Form.Label></Col>
                        <Col md="7">
                          <InputGroup>
                            <Form.Control type="text" value={fileName10} disabled={isReadOnly} aria-label="Upload Document-10" readOnly />
                            <Form.Control type="file" onChange={(e) => handleSelectFile10(e)} style={{ display: 'none' }} id="file-input-10" />
                            <Button variant="outline-primary" id="file-del-10" onClick={() => { document.getElementById('file-input-10').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
                            <Button variant="outline-danger" onClick={handleRemoveFile10} disabled={!fileName10 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
                            <Button variant="outline-success" onClick={handleViewFile10}><MDBIcon fas icon="file-download" /></Button>
                          </InputGroup>
                        </Col>
                      </Row>
                      
              </section>

              {( sendForAppv == true && (
                <section style={{ border: '2px solid #ccc', padding: '15px', paddingRight: '4px', marginBottom: '20px' }}>
                <Row className="mb-1" data-row-name="ExCompQues1">
                    <Col md="5" className="customformlabel"><Form.Label>End User & Billing Customer Name is Same
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques1} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues2">
                    <Col md="5" className="customformlabel"><Form.Label>Customer Billing Location is Domestic
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques2} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues3">
                    <Col md="5" className="customformlabel"><Form.Label>Customer Billing Location is International,(if any)
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques3} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQue4s">
                    <Col md="5" className="customformlabel"><Form.Label>Customer PO Issuance from International Location
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques4} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues5">
                    <Col md="5" className="customformlabel"><Form.Label>End User Location is Domestic
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques5} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues6">
                    <Col md="5" className="customformlabel"><Form.Label>End User Location is International, (if any)
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques6} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues7">
                    <Col md="5" className="customformlabel"><Form.Label>PO Issued in INR
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques7} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues8">
                    <Col md="5" className="customformlabel"><Form.Label>We Are Selling Following Product/Service :- 
                      (AI-Tool/CCTV Camera/ Drone / Surveillance Camera/Nvidia Graphic Card)
                    <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques8} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues9">
                    <Col md="5" className="customformlabel"><Form.Label>We Are Selling Following OEM's Product :-
                      (Hikvision, Dhaua, Huawei, Kaspersky Or Any Chinese Camera Manufacturer)
                    <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                    </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques9} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues10">
                    <Col md="5" className="customformlabel"><Form.Label>Customer is Related To WMD (Weapons of Mass Destruction)/ Military/Defence/Nuclear/Aerospace
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques10} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues12">
                    <Col md="5" className="customformlabel"><Form.Label>Customer/End Customer is Fall Under Category:- State Govt./Central Govt./PSU
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques12} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues13">
                    <Col md="5" className="customformlabel"><Form.Label>This deal is related to Tender
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques13} readOnly /></Col>
                </Row>
                <Row className="mb-1" data-row-name="ExCompQues14">
                    <Col md="5" className="customformlabel"><Form.Label>Is customer having Global (Out of India) Presence
                      <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
                      </Form.Label></Col>
                    <Col md="7"><Form.Control type="text" value={ques14} readOnly /></Col>
                </Row>
                </section>
                ))}
        </Form>
        </Container>

        <div style={{width: "24%", position: "fixed", right: 0, top: 52, height: "84vh", zIndex: 100, display: "flex", 
          justifyContent: "center", alignItems: "center", textAlign: "center"}}>
          {/* backgroundColor: "#8be2ec" */}
          {/* <Row className="mb-4" data-row-name="logo & crmbutton" style={{ justifyContent: "center", 
            border: "1px solid black" ,alignItems: "center", width: "100%" }} >
            <Col md="auto"><h1>Costsheet</h1></Col>
            <Col md="auto"><h1>Enterprise</h1></Col>
            <Col md="auto"><h1>Form</h1></Col>
            <Col md="auto"><h1>Empty</h1></Col>
            <Col md="auto"><h1>Space</h1></Col>
            <Col md="auto"><h1>For</h1></Col>
            <Col md="auto"><h1>AI</h1></Col>
          </Row> */}
        </div>
      </div>
        </>
  );
};

export default CostSheetEntForm;














// import { useParams } from 'react-router-dom';
// import React, { useState, useEffect, useRef, useLayoutEffect } from 'react';
// import moment from 'moment';
// import axios from 'axios';
// import { Form, Row, Col, Table,FormControl, Container, InputGroup, Button, Modal } from 'react-bootstrap';
// import { Tooltip } from 'reactstrap';
// import { MDBIcon } from 'mdb-react-ui-kit';
// import { toast } from 'react-toastify';
// import apiService from '../../services/api.services';
// import approvedStamp from '../../images/approvedStamp.png';
// import '../../css/entcsform.css';
// import '../../index.css';
// import Navbar from '../common/Navbar';
// import Select, { components } from 'react-select';
// import Swal from 'sweetalert2';

// const CostSheetEntForm = () => {

//   const { series } = useParams();

//   const [formReopenCount, setformReopenCount] = useState();
//   const [userName, setuserName] = useState('');
//   const [userId, setuserId] = useState('');
//   const [userRole, setuserRole] = useState('');
//   const [status, setStatus] = useState('');
//   const [crmData, setcrmData] = useState([]);
//   const [allFunctionalHeadList, setAllFunctionalHeadList] = useState([]);
  
//   const [searchTerm, setSearchTerm] = useState('');
//   const [showDropdown, setShowDropdown] = useState(false);
//   const [customerName, setcustomerName] = useState('');
//   const [sendForAppv, setSendForAppv] = useState('')
//   const [salesPersonName, setsalesPersonName] = useState('');
//   const [salesPersonID, setsalesPersonID] = useState('');
//   // const [oem, setOem] = useState("");
//   const [approvalRequestDate, setapprovalRequestDate] = useState(moment().format('dddd, DD MMMM, YYYY'));
//   const [sendForAppvReqDate, setSendForAppvReqDate] = useState('');
//   const [opportunityName, setopportunityName] = useState('');
//   const [vendorBillingCycle, setvendorBillingCycle] = useState('');
//   const [transactionCurrency, settransactionCurrency] = useState('');
//   const [secondaryOptions, setSecondaryOptions] = useState([]);
//   const [secondaryTransactionCurrency, setsecondaryTransactionCurrency] = useState('');  
//   const [vendorPaymentTerms, setvendorPaymentTerms] = useState('');
//   const [customerPaymentTerms, setcustomerPaymentTerms] = useState('');
//   const [hitachiRoleinthisDeal, sethitachiRoleinthisDeal] = useState('');
//   const [materialDeliveryDate, setMaterialDeliveryDate] = useState('');
//   const [lowMarginReason, setLowMarginReason] = useState('');
//   const [rebateAmountIfAny, setrebateAmountIfAny] = useState('');
//   const [confirmRebate, setConfirmRebate] = useState('');
//   const [conversionRate, setconversionRate] = useState();
//   const [dealType, setDealType] = useState('');
//   const [dirtyFCTable, setDirtyFCTable] = useState(false);

//   const [remarksIfAny, setremarksIfAny] = useState('');
//   const [expectedDtCustomerRecipt, setexpectedDtCustomerRecipt] = useState(''); 
//   const [expectedDtVendorPayment, setexpectedDtVendorPayment] = useState('');  

//   const [cashFlowExpertAdvice, setcashFlowExpertAdvice] = useState('');
//   const [marginExpertAdvice, setmarginExpertAdvice] = useState('');

//   const [file1, setFile1] = useState(null);
//   const [fileName1, setFileName1] = useState('No File Selected');
//   const [file1url, setFile1url] = useState('')
//   const [file2, setFile2] = useState(null);
//   const [fileName2, setFileName2] = useState('No File Selected');
//   const [file2url, setFile2url] = useState('')
//   const [file3, setFile3] = useState(null);
//   const [fileName3, setFileName3] = useState('No File Selected');
//   const [file3url, setFile3url] = useState('')
//   const [file4, setFile4] = useState(null);
//   const [fileName4, setFileName4] = useState('No File Selected');
//   const [file4url, setFile4url] = useState('')
//   const [file5, setFile5] = useState(null);
//   const [fileName5, setFileName5] = useState('No File Selected');
//   const [file5url, setFile5url] = useState('')
//   const [file6, setFile6] = useState(null);
//   const [fileName6, setFileName6] = useState('No File Selected');
//   const [file6url, setFile6url] = useState('')
//   const [file7, setFile7] = useState(null);
//   const [fileName7, setFileName7] = useState('No File Selected');
//   const [file7url, setFile7url] = useState('')
//   const [file8, setFile8] = useState(null);
//   const [fileName8, setFileName8] = useState('No File Selected');
//   const [file8url, setFile8url] = useState('')
//   const [file9, setFile9] = useState(null);
//   const [fileName9, setFileName9] = useState('No File Selected');
//   const [file9url, setFile9url] = useState('')
//   const [file10, setFile10] = useState(null);
//   const [fileName10, setFileName10] = useState('No File Selected');
//   const [file10url, setFile10url] = useState('')

//   const [editingCell, setEditingCell] = useState(null); // tracks { rowId, colIndex }
//   const [editingValue, setEditingValue] = useState("");

//   const [answer, setAnswer] = useState(null);

//   const [appvTeamLeaderId, setAppvTeamLeaderId] = useState('');
//   const [appvBranchHeadId, setAppvBranchHeadId] = useState('');
//   const [appvRegionBusinessHeadId, setAppvRegionBusinessHeadId] = useState('');
//   const [appvBusinessFinanceId, setAppvBusinessFinanceId] = useState('');
//   const [appvExportComplianceId, setAppvExportComplianceId] = useState('');
//   const [appvCreditInsuranceId, setAppvCreditInsuranceId] = useState('');
//   const [appvCEOId, setAppvCEOId] = useState('');
//   const [appvCOOId, setAppvCOOId] = useState('');
//   const [appvCFOId, setAppvCFOId] = useState('');
//   const [appvSVPDirectorId, setAppvSVPDirectorId] = useState('');
//   const [appvFunctionalHeadId, setAppvFunctionalHeadId] = useState('');
//   const [appvLegalHeadId, setAppvLegalHeadId] = useState('');
//   const [appvDytCFOId, setAppvDytCFOId] = useState('');


//   const [functionalHead1ID, setFunctionalHead1ID] = useState("");
//   const [functionalHead1Name, setFunctionalHead1Name] = useState("");
//   const [functionalHead2ID, setFunctionalHead2ID] = useState("");
//   const [functionalHead2Name, setFunctionalHead2Name] = useState("");
//   const [functionalHead3ID, setFunctionalHead3ID] = useState("");
//   const [functionalHead3Name, setFunctionalHead3Name] = useState("");
//   const [functionalHead4ID, setFunctionalHead4ID] = useState("");
//   const [functionalHead4Name, setFunctionalHead4Name] = useState("");
//   const [functionalHead5ID, setFunctionalHead5ID] = useState("");
//   const [functionalHead5Name, setFunctionalHead5Name] = useState("");
//   const [functionalHead6ID, setFunctionalHead6ID] = useState("");
//   const [functionalHead6Name, setFunctionalHead6Name] = useState("");

//   const [mgmtappvRegionBusinessHeadID, setMgmtAppvRegionBusinessHeadID] = useState('');
//   const [mgmtappvBusinessFinanceID, setMgmtAppvBusinessFinanceID] = useState('');
//   const [mgmtappvCEOID, setMgmtAppvCEOID] = useState('');
//   const [mgmtappvCOOID, setMgmtAppvCOOID] = useState('');
//   const [mgmtappvCFOID, setMgmtAppvCFOID] = useState('');

//   const [hoveredRole, setHoveredRole] = useState(null);
//   const [response, setResponse] = useState('');
//   const [appvTeamLeaderReq, setAppvTeamLeaderReq] = useState('');
//   const [appvBranchHeadReq, setAppvBranchHeadReq] = useState('');
//   const [appvRegionBusinessHeadReq, setAppvRegionBusinessHeadReq] = useState('');
//   const [appvBusinessFinanceReq, setAppvBusinessFinanceReq] = useState('');
//   const [appvExportComplianceReq, setAppvExportComplianceReq] = useState('');
//   const [appvCreditInsuranceReq, setAppvCreditInsuranceReq] = useState('');
//   const [appvCEOReq, setAppvCEOReq] = useState('');
//   const [appvCOOReq, setAppvCOOReq] = useState('');
//   const [appvCFOReq, setAppvCFOReq] = useState('');
//   const [appvSVPDirectorReq, setAppvSVPDirectorReq] = useState('');  
//   const [appvlegalHeadReq, setAppvlegalHeadReq] = useState('');
//   const [appvDytCFOReq, setAppvDytCFOReq] = useState('');
//   const [appvFunctionalHeadReq, setAppvFunctionalHeadReq] = useState('');
//   const [appvFunctionalHead2Req, setAppvFunctionalHead2Req] = useState('');
//   const [appvFunctionalHead3Req, setAppvFunctionalHead3Req] = useState('');
//   const [appvFunctionalHead4Req, setAppvFunctionalHead4Req] = useState(''); 
//   const [appvFunctionalHead5Req, setAppvFunctionalHead5Req] = useState(''); 
//   const [appvFunctionalHead6Req, setAppvFunctionalHead6Req] = useState('');  
//   const [mgmtappvRegionBusinessHeadReq, setMgmtAppvRegionBusinessHeadReq] = useState('');
//   const [mgmtappvBusinessFinanceReq, setMgmtAppvBusinessFinanceReq] = useState('');
//   const [mgmtappvCEOReq, setMgmtAppvCEOReq] = useState('');
//   const [mgmtappvCOOReq, setMgmtAppvCOOReq] = useState('');
//   const [mgmtappvCFOReq, setMgmtAppvCFOReq] = useState('');

//   const [appvTeamLeaderStatus, setAppvTeamLeaderStatus] = useState('');
//   const [appvBranchHeadStatus, setAppvBranchHeadStatus] = useState('');
//   const [appvRegionBusinessHeadStatus, setAppvRegionBusinessHeadStatus] = useState('');
//   const [appvBusinessFinanceStatus, setAppvBusinessFinanceStatus] = useState('');
//   const [appvExportComplianceStatus, setAppvExportComplianceStatus] = useState('');
//   const [appvCreditInsuranceStatus, setAppvCreditInsuranceStatus] = useState('');
//   const [appvCEOStatus, setAppvCEOStatus] = useState('');
//   const [appvCOOStatus, setAppvCOOStatus] = useState('');
//   const [appvCFOStatus, setAppvCFOStatus] = useState('');
//   const [appvSVPDirectorStatus, setAppvSVPDirectorStatus] = useState('');  
//   const [appvLegalHeadStatus, setAppvLegalHeadStatus] = useState('');
//   const [appvDytCFOStatus, setAppvDytCFOStatus] = useState('');
//   const [appvFunctionalHeadStatus, setAppvFunctionalHeadStatus] = useState('');
//   const [appvFunctionalHead2Status, setAppvFunctionalHead2Status] = useState('');
//   const [appvFunctionalHead3Status, setAppvFunctionalHead3Status] = useState('');
//   const [appvFunctionalHead4Status, setAppvFunctionalHead4Status] = useState(''); 
//   const [appvFunctionalHead5Status, setAppvFunctionalHead5Status] = useState(''); 
//   const [appvFunctionalHead6Status, setAppvFunctionalHead6Status] = useState('');  
//   const [mgmtappvRegionBusinessHeadStatus, setMgmtAppvRegionBusinessHeadStatus] = useState('');
//   const [mgmtappvBusinessFinanceStatus, setMgmtAppvBusinessFinanceStatus] = useState('');
//   const [mgmtappvCEOStatus, setMgmtAppvCEOStatus] = useState('');
//   const [mgmtappvCOOStatus, setMgmtAppvCOOStatus] = useState('');
//   const [mgmtappvCFOStatus, setMgmtAppvCFOStatus] = useState('');

//   const [appvTeamLeaderMessage, setAppvTeamLeaderMessage] = useState('');
//   const [appvBranchHeadMessage, setAppvBranchHeadMessage] = useState('');
//   const [appvRegionBusinessHeadMessage, setAppvRegionBusinessHeadMessage] = useState('');
//   const [appvBusinessFinanceMessage, setAppvBusinessFinanceMessage] = useState('');
//   const [appvExportComplianceMessage, setAppvExportComplianceMessage] = useState('');
//   const [appvCreditInsuranceMessage, setAppvCreditInsuranceMessage] = useState('');
//   const [appvCEOMessage, setAppvCEOMessage] = useState('');
//   const [appvCOOMessage, setAppvCOOMessage] = useState('');
//   const [appvCFOMessage, setAppvCFOMessage] = useState('');
//   const [appvSVPDirectorMessage, setAppvSVPDirectorMessage] = useState('');  
//   const [appvFunctionalHeadMessage, setAppvFunctionalHeadMessage] = useState('');
//   const [appvFunctionalHead2Message, setAppvFunctionalHead2Message] = useState('');
//   const [appvFunctionalHead3Message, setAppvFunctionalHead3Message] = useState('');
//   const [appvFunctionalHead4Message, setAppvFunctionalHead4Message] = useState(''); 
//   const [appvFunctionalHead5Message, setAppvFunctionalHead5Message] = useState(''); 
//   const [appvFunctionalHead6Message, setAppvFunctionalHead6Message] = useState('');  
//   const [appvLegalHeadMessage, setAppvLegalHeadMessage] = useState('');
//   const [appvDytCFOMessage, setAppvDytCFOMessage] = useState('');
//   const [mgmtappvRegionBusinessHeadMessage, setMgmtAppvRegionBusinessHeadMessage] = useState('');
//   const [mgmtappvBusinessFinanceMessage, setMgmtAppvBusinessFinanceMessage] = useState('');
//   const [mgmtappvCEOMessage, setMgmtAppvCEOMessage] = useState('');
//   const [mgmtappvCOOMessage, setMgmtAppvCOOMessage] = useState('');
//   const [mgmtappvCFOMessage, setMgmtAppvCFOMessage] = useState('');
  
//   const [approvalMessage, setApprovalMessage] = useState('');
//   const [rejectionMessage, setRejectionMessage] = useState("");
//   const [appvCIMessage, setAppvCIMessage] = useState("");
//   const [ciMgmtReason, setCIMgmtReason] = useState("");
//   const [mgmtApprovalMessage, setMgmtApprovalMessage] = useState('');
//   const [mgmtRejectionMessage, setMgmtRejectionMessage] = useState("");
//   const [mgmtApprovalRequire, setMgmtApprovalRequire] = useState("");
//   const [showThankYou, setShowThankYou] = useState(false);
//   const [mgmtResponse, setMgmtResponse] = useState("");
//   const [showMGMTThankYou, setShowMGMTThankYou] = useState(false);

  
//   const [modalSentForAppv, setModalSentForAppv] = useState(false);
//   const [showReopen, setShowReopen] = useState(false);
//   const [step, setStep] = useState(1);
//   const [ques1, setQues1] = useState('');
//   const [ques2, setQues2] = useState('');
//   const [ques3, setQues3] = useState('');
//   const [ques4, setQues4] = useState('');
//   const [ques5, setQues5] = useState('');
//   const [ques6, setQues6] = useState('');
//   const [ques7, setQues7] = useState('');
//   const [ques8, setQues8] = useState('');
//   const [ques9, setQues9] = useState('');
//   const [ques10, setQues10] = useState('');
//   const [ques11, setQues11] = useState('');
//   const [ques12, setQues12] = useState('');
//   const [ques13, setQues13] = useState('');
//   const [ques14, setQues14] = useState('');
//   const [showExCompRemark, setExCompRemark] = useState(false);
//   const [ExCompMessage, setExCompMessage] = useState('');
//   const [isVendorPaymentTermModalOpen, setIsVendorPaymentTermModalOpen] = useState(false);
//   const [isCustomerPaymentTermModalOpen, setIsCustomerPaymentTermModalOpen] = useState(false);
//   const [fileSaveTrigger, setfileSaveTrigger] = useState(0);

//   const [isReadOnly, setIsReadOnly] = useState(true);
//   const [isNoteVisible, setIsNoteVisible] = useState(false);
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState('');


//   const [tooltipOpen, setTooltipOpen] = useState(false);
//   const [teamLeaderTooltip, setTeamLeaderTooltip] = useState(false);
//   const [branchHeadTooltip, setBranchHeadTooltip] = useState(false);
//   const [regionBusinessHeadTooltip, setRegionBusinessHeadTooltip] = useState(false);
//   const [businessFinanceTooltip, setBusinessFinanceTooltip] = useState(false);
//   const [creditInsuranceTooltip, setCreditInsuranceTooltip] = useState(false);
//   const [exportComplianceTooltip, setExportComplianceTooltip] = useState(false);
//   const [cfoTooltip, setCfoTooltip] = useState(false);
//   const [ceoTooltip, setCeoTooltip] = useState(false);
//   const [cooTooltip, setCooTooltip] = useState(false);
//   const [svpDirectorTooltip, setSvpDirectorTooltip] = useState(false);
//   const [legalHeadTooltip, setLegalHeadTooltip] = useState(false);
//   const [dytCfoTooltip, setDytCfoTooltip] = useState(false);
//   const [functionalHead1Tooltip, setFunctionalHead1Tooltip] = useState(false);
//   const [functionalHead2Tooltip, setFunctionalHead2Tooltip] = useState(false);
//   const [functionalHead3Tooltip, setFunctionalHead3Tooltip] = useState(false);
//   const [functionalHead4Tooltip, setFunctionalHead4Tooltip] = useState(false);
//   const [functionalHead5Tooltip, setFunctionalHead5Tooltip] = useState(false);
//   const [functionalHead6Tooltip, setFunctionalHead6Tooltip] = useState(false);
//   const [mgmtRegionBusinessHeadTooltip, setMgmtRegionBusinessHeadTooltip] = useState(false);
//   const [mgmtBusinessFinanceTooltip, setMgmtBusinessFinanceTooltip] = useState(false);
//   const [mgmtCeoTooltip, setMgmtCeoTooltip] = useState(false);
//   const [mgmtCooTooltip, setMgmtCooTooltip] = useState(false);
//   const [mgmtCfoTooltip, setMgmtCfoTooltip] = useState(false);
//   const toggle = () => setTooltipOpen(!tooltipOpen);

      
//   const oemOptions = [
//     { label: "1KOSMOS", value: "1KOSMOS" },
//     { label: "3C3", value: "3C3" },
//     { label: "3COM", value: "3COM" },
//     { label: "3M", value: "3M" },
//     { label: "42GEARS", value: "42GEARS" },
//     { label: "A10", value: "A10" },
//     { label: "ABAS", value: "ABAS" },
//     { label: "ACCOPS", value: "ACCOPS" },
//     { label: "ACCORD", value: "ACCORD" },
//     { label: "ACER", value: "ACER" },
//     { label: "ACRONIS", value: "ACRONIS" },
//     { label: "ADATA", value: "ADATA" },
//     { label: "ADOBE", value: "ADOBE" },
//     { label: "AFL", value: "AFL" },
//     { label: "AKAMAI", value: "AKAMAI" },
//     { label: "ALGOSEC", value: "ALGOSEC" },
//     { label: "AMD", value: "AMD" },
//     { label: "AMP", value: "AMP" },
//     { label: "ANKER", value: "ANKER" },
//     { label: "APC", value: "APC" },
//     { label: "APP", value: "APP" },
//     { label: "APPDYNAMIC", value: "APPDYNAMIC" },
//     { label: "APPKNOX", value: "APPKNOX" },
//     { label: "APPLE", value: "APPLE" },
//     { label: "APW", value: "APW" },
//     { label: "ARBOR", value: "ARBOR" },
//     { label: "ARCHER", value: "ARCHER" },
//     { label: "ARCON", value: "ARCON" },
//     { label: "ARCOS", value: "ARCOS" },
//     { label: "ARCSERVE", value: "ARCSERVE" },
//     { label: "ARCSIGHT", value: "ARCSIGHT" },
//     { label: "ARI", value: "ARI" },
//     { label: "ARRAY", value: "ARRAY" },
//     { label: "ARRCUS", value: "ARRCUS" },
//     { label: "ARUBA", value: "ARUBA" },
//     { label: "ASUS", value: "ASUS" },
//     { label: "ATEMPO", value: "ATEMPO" },
//     { label: "ATEN", value: "ATEN" },
//     { label: "AUTODESK", value: "AUTODESK" },
//     { label: "AVAYA", value: "AVAYA" },
//     { label: "AWIROS", value: "AWIROS" },
//     { label: "AMAZON", value: "AMAZON" },
//     { label: "AZURE", value: "AZURE" },
//     { label: "BARACUDA", value: "BARACUDA" },
//     { label: "BARCO", value: "BARCO" },
//     { label: "BARRACUDA", value: "BARRACUDA" },
//     { label: "BEHRINGER", value: "BEHRINGER" },
//     { label: "BELDEN", value: "BELDEN" },
//     { label: "BEYONDTRUS", value: "BEYONDTRUS" },
//     { label: "BITBUCKET", value: "BITBUCKET" },
//     { label: "BITTITAN", value: "BITTITAN" },
//     { label: "BLACKBERRY", value: "BLACKBERRY" },
//     { label: "BLUEBEAM", value: "BLUEBEAM" },
//     { label: "BLUECOAT", value: "BLUECOAT" },
//     { label: "BMC", value: "BMC" },
//     { label: "BOSCH", value: "BOSCH" },
//     { label: "BPE", value: "BPE" },
//     { label: "BROADCOM", value: "BROADCOM" },
//     { label: "BROCADE", value: "BROCADE" },
//     { label: "BROTHER", value: "BROTHER" },
//     { label: "BROWS", value: "BROWS" },
//     { label: "BURPSUITE", value: "BURPSUITE" },
//     { label: "C3C", value: "C3C" },
//     { label: "CA", value: "CA" },
//     { label: "CAMBIUM", value: "CAMBIUM" },
//     { label: "CANON", value: "CANON" },
//     { label: "CARBONITE", value: "CARBONITE" },
//     { label: "CASIO", value: "CASIO" },
//     { label: "CHECKMARX", value: "CHECKMARX" },
//     { label: "CHECKPOINT", value: "CHECKPOINT" },
//     { label: "CISCO", value: "CISCO" },
//     { label: "CIT", value: "CIT" },
//     { label: "CITRIX", value: "CITRIX" },
//     { label: "CLAROTY", value: "CLAROTY" },
//     { label: "CLOUDERA", value: "CLOUDERA" },
//     { label: "CLOUDFLARE", value: "CLOUDFLARE" },
//     { label: "CLOUDSEK", value: "CLOUDSEK" },
//     { label: "COLOUR TOK", value: "COLOUR TOK" },
//     { label: "COMMSCOPE", value: "COMMSCOPE" },
//     { label: "COMMVAULT", value: "COMMVAULT" },
//     { label: "COMODO", value: "COMODO" },
//     { label: "COMPTEK", value: "COMPTEK" },
//     { label: "COMRACK", value: "COMRACK" },
//     { label: "COMSCOPE", value: "COMSCOPE" },
//     { label: "CONFLUENCE", value: "CONFLUENCE" },
//     { label: "CORP", value: "CORP" },
//     { label: "COSOSYS", value: "COSOSYS" },
//     { label: "CROWDSTRIK", value: "CROWDSTRIK" },
//     { label: "CROWN", value: "CROWN" },
//     { label: "C-SYSTEM", value: "C-SYSTEM" },
//     { label: "CUSTOM", value: "CUSTOM" },
//     { label: "CYB", value: "CYB" },
//     { label: "CYBER", value: "CYBER" },
//     { label: "CYBLE", value: "CYBLE" },
//     { label: "CYWARE", value: "CYWARE" },
//     { label: "DATA SAFE", value: "DATA SAFE" },
//     { label: "DATADOG", value: "DATADOG" },
//     { label: "DATALOAD", value: "DATALOAD" },
//     { label: "DATALOGIC", value: "DATALOGIC" },
//     { label: "DATAMOTIVE", value: "DATAMOTIVE" },
//     { label: "DECLINK", value: "DECLINK" },
//     { label: "DELL", value: "DELL" },
//     { label: "DELPHI", value: "DELPHI" },
//     { label: "DELTA", value: "DELTA" },
//     { label: "DELTON", value: "DELTON" },
//     { label: "DENSO", value: "DENSO" },
//     { label: "DESKO", value: "DESKO" },
//     { label: "DEVICE XPL", value: "DEVICE XPL" },
//     { label: "DG", value: "DG" },
//     { label: "DIGIBOX", value: "DIGIBOX" },
//     { label: "DIGICERT", value: "DIGICERT" },
//     { label: "DIGISOL", value: "DIGISOL" },
//     { label: "D-LINK", value: "D-LINK" },
//     { label: "DNIF", value: "DNIF" },
//     { label: "DRUVA", value: "DRUVA" },
//     { label: "DYNATRACE", value: "DYNATRACE" },
//     { label: "EATON", value: "EATON" },
//     { label: "EDB", value: "EDB" },
//     { label: "EKAHAU", value: "EKAHAU" },
//     { label: "ELASTIC", value: "ELASTIC" },
//     { label: "EMC", value: "EMC" },
//     { label: "EPSON", value: "EPSON" },
//     { label: "ESDS", value: "ESDS" },
//     { label: "ESET", value: "ESET" },
//     { label: "EXAGRID", value: "EXAGRID" },
//     { label: "EXTREME NW", value: "EXTREME NW" },
//     { label: "F5", value: "F5" },
//     { label: "FATPIPE", value: "FATPIPE" },
//     { label: "FIREEYE", value: "FIREEYE" },
//     { label: "FORCEPOINT", value: "FORCEPOINT" },
//     { label: "FORESCOUT", value: "FORESCOUT" },
//     { label: "FORTIGATE", value: "FORTIGATE" },
//     { label: "FORTINET", value: "FORTINET" },
//     { label: "FORTRA", value: "FORTRA" },
//     { label: "FUJITSU", value: "FUJITSU" },
//     { label: "GEMALTO", value: "GEMALTO" },
//     { label: "GEOTRUST", value: "GEOTRUST" },
//     { label: "GGNOME", value: "GGNOME" },
//     { label: "GLOBALSCAP", value: "GLOBALSCAP" },
//     { label: "GURUCUL", value: "GURUCUL" },
//     { label: "HFCL", value: "HFCL" },
//     { label: "HSI", value: "HSI" },
//     { label: "HITACHI VANTARA", value: "HITACHI VANTARA" },
//     { label: "HONEYWELL", value: "HONEYWELL" },
//     { label: "HP", value: "HP" },
//     { label: "HPE", value: "HPE" },
//     { label: "H-REL", value: "H-REL" },
//     { label: "HULASI", value: "HULASI" },
//     { label: "HULFT8", value: "HULFT8" },
//     { label: "HYNIX", value: "HYNIX" },
//     { label: "IBALL", value: "IBALL" },
//     { label: "IBM", value: "IBM" },
//     { label: "IER", value: "IER" },
//     { label: "IMPERVA", value: "IMPERVA" },
//     { label: "INDYGEN", value: "INDYGEN" },
//     { label: "INFINEON", value: "INFINEON" },
//     { label: "INFOBLOX", value: "INFOBLOX" },
//     { label: "INFORMATIC", value: "INFORMATIC" },
//     { label: "INHOUSE", value: "INHOUSE" },
//     { label: "INNSPARKS", value: "INNSPARKS" },
//     { label: "INTEL", value: "INTEL" },
//     { label: "IRAJE", value: "IRAJE" },
//     { label: "ISI", value: "ISI" },
//     { label: "ITEXT", value: "ITEXT" },
//     { label: "IVANTI", value: "IVANTI" },
//     { label: "IXIA", value: "IXIA" },
//     { label: "JBL", value: "JBL" },
//     { label: "JIRA", value: "JIRA" },
//     { label: "JP1", value: "JP1" },
//     { label: "JREBEL", value: "JREBEL" },
//     { label: "JUNIPER", value: "JUNIPER" },
//     { label: "KEMP1", value: "KEMP1" },
//     { label: "KINGSTON", value: "KINGSTON" },
//     { label: "KISOK", value: "KISOK" },
//     { label: "KLASSIFY", value: "KLASSIFY" },
//     { label: "KONG", value: "KONG" },
//     { label: "KOSMOS", value: "KOSMOS" },
//     { label: "KRAMER", value: "KRAMER" },
//     { label: "KVMP", value: "KVMP" },
//     { label: "KYOCERA", value: "KYOCERA" },
//     { label: "LABELARY", value: "LABELARY" },
//     { label: "LENOVO", value: "LENOVO" },
//     { label: "LEPIDE", value: "LEPIDE" },
//     { label: "LEVIA", value: "LEVIA" },
//     { label: "LG", value: "LG" },
//     { label: "LIFESIZE", value: "LIFESIZE" },
//     { label: "LINK PROOF", value: "LINK PROOF" },
//     { label: "LIPI", value: "LIPI" },
//     { label: "LOADBALANC", value: "LOADBALANC" },
//     { label: "LOCAL", value: "LOCAL" },
//     { label: "LOGITECH", value: "LOGITECH" },
//     { label: "LOGRHYTHM", value: "LOGRHYTHM" },
//     { label: "LUMINOUS", value: "LUMINOUS" },
//     { label: "MAGE", value: "MAGE" },
//     { label: "MAN ENG", value: "MAN ENG" },
//     { label: "ManageEngine", value: "ManageEngine" },
//     { label: "MANDIANT", value: "MANDIANT" },
//     { label: "MAT", value: "MAT" },
//     { label: "MCAFEE", value: "MCAFEE" },
//     { label: "MCIPL", value: "MCIPL" },
//     { label: "MELLANOX", value: "MELLANOX" },
//     { label: "MERAKI", value: "MERAKI" },
//     { label: "MICROFOCUS", value: "MICROFOCUS" },
//     { label: "MICRON", value: "MICRON" },
//     { label: "MICROSOFT", value: "MICROSOFT" },
//     { label: "MILESTONE", value: "MILESTONE" },
//     { label: "MILLENIUM", value: "MILLENIUM" },
//     { label: "MIPRO", value: "MIPRO" },
//     { label: "MIZPAH", value: "MIZPAH" },
//     { label: "MOLEX", value: "MOLEX" },
//     { label: "MOTA", value: "MOTA" },
//     { label: "MOVEIT", value: "MOVEIT" },
//     { label: "MX", value: "MX" },
//     { label: "NEC", value: "NEC" },
//     { label: "NESSUS", value: "NESSUS" },
//     { label: "NET RACK", value: "NET RACK" },
//     { label: "NetApp", value: "NetApp" },
//     { label: "NETCORE", value: "NETCORE" },
//     { label: "NETGEAR", value: "NETGEAR" },
//     { label: "NETRACK", value: "NETRACK" },
//     { label: "NETSCOUT", value: "NETSCOUT" },
//     { label: "NETSKOPE", value: "NETSKOPE" },
//     { label: "NETWRIX", value: "NETWRIX" },
//     { label: "NOKIA", value: "NOKIA" },
//     { label: "NUTANIX", value: "NUTANIX" },
//     { label: "NVIDIA", value: "NVIDIA" },
//     { label: "OKTA", value: "OKTA" },
//     { label: "OMNISSA", value: "OMNISSA" },
//     { label: "OPENGEAR", value: "OPENGEAR" },
//     { label: "OPENTEXT", value: "OPENTEXT" },
//     { label: "OPSWAT", value: "OPSWAT" },
//     { label: "OPTIEMUS", value: "OPTIEMUS" },
//     { label: "ORACLE", value: "ORACLE" },
//     { label: "ORCA", value: "ORCA" },
//     { label: "PALOALTO", value: "PALOALTO" },
//     { label: "PANACHE", value: "PANACHE" },
//     { label: "PERPUITUIT", value: "PERPUITUIT" },
//     { label: "PERSISTENT", value: "PERSISTENT" },
//     { label: "PICUS", value: "PICUS" },
//     { label: "POLYCAB", value: "POLYCAB" },
//     { label: "POLYCOM", value: "POLYCOM" },
//     { label: "PRESIDENT", value: "PRESIDENT" },
//     { label: "PRODMARC", value: "PRODMARC" },
//     { label: "PROGIST", value: "PROGIST" },
//     { label: "PROGRESS S", value: "PROGRESS S" },
//     { label: "PROOFPOINT", value: "PROOFPOINT" },
//     { label: "PROTEK", value: "PROTEK" },
//     { label: "PULSE", value: "PULSE" },
//     { label: "PURE", value: "PURE" },
//     { label: "QUALYS", value: "QUALYS" },
//     { label: "QUANTUM", value: "QUANTUM" },
//     { label: "QUEST", value: "QUEST" },
//     { label: "QUICKHEAL", value: "QUICKHEAL" },
//     { label: "Quilr", value: "Quilr" },
//     { label: "R&M", value: "R&M" },
//     { label: "RACKWARE", value: "RACKWARE" },
//     { label: "RADWARE", value: "RADWARE" },
//     { label: "RAPID7", value: "RAPID7" },
//     { label: "RARITAN", value: "RARITAN" },
//     { label: "RASPBERRY", value: "RASPBERRY" },
//     { label: "REALVNC", value: "REALVNC" },
//     { label: "REDHAT", value: "REDHAT" },
//     { label: "RETROSPECT", value: "RETROSPECT" },
//     { label: "RISKPROFIL", value: "RISKPROFIL" },
//     { label: "RITAL", value: "RITAL" },
//     { label: "RITTAL", value: "RITTAL" },
//     { label: "RSA", value: "RSA" },
//     { label: "RUBRIK", value: "RUBRIK" },
//     { label: "RUCKUS", value: "RUCKUS" },
//     { label: "SAHI PRO", value: "SAHI PRO" },
//     { label: "SAMSUNG", value: "SAMSUNG" },
//     { label: "SANDISK", value: "SANDISK" },
//     { label: "SAPPHIRE", value: "SAPPHIRE" },
//     { label: "SCALE FUSI", value: "SCALE FUSI" },
//     { label: "SCHNEI", value: "SCHNEI" },
//     { label: "SCHNEIDER", value: "SCHNEIDER" },
//     { label: "SEAGATE", value: "SEAGATE" },
//     { label: "SECEON", value: "SECEON" },
//     { label: "SECLOGIC", value: "SECLOGIC" },
//     { label: "SECLORE", value: "SECLORE" },
//     { label: "SECONIZE", value: "SECONIZE" },
//     { label: "SECURBAY", value: "SECURBAY" },
//     { label: "SECUREYE", value: "SECUREYE" },
//     { label: "SECURITYSC", value: "SECURITYSC" },
//     { label: "SECURONIX", value: "SECURONIX" },
//     { label: "SENTINELONE", value: "SENTINELONE" },
//     { label: "SERTEL", value: "SERTEL" },
//     { label: "SERVICENOW", value: "SERVICENOW" },
//     { label: "SHAREPLEX", value: "SHAREPLEX" },
//     { label: "SHURE", value: "SHURE" },
//     { label: "SITA", value: "SITA" },
//     { label: "SKY BOX", value: "SKY BOX" },
//     { label: "SKY HIGH", value: "SKY HIGH" },
//     { label: "SLIDO", value: "SLIDO" },
//     { label: "SOLARWIND", value: "SOLARWIND" },
//     { label: "SONICWALL", value: "SONICWALL" },
//     { label: "SONY", value: "SONY" },
//     { label: "SOPHOS", value: "SOPHOS" },
//     { label: "SOTI MOBI", value: "SOTI MOBI" },
//     { label: "SOUNDCRAFT", value: "SOUNDCRAFT" },
//     { label: "SPARSH", value: "SPARSH" },
//     { label: "SPK", value: "SPK" },
//     { label: "STANDARD", value: "STANDARD" },
//     { label: "SUSE", value: "SUSE" },
//     { label: "SUVIRA/TRU", value: "SUVIRA/TRU" },
//     { label: "SYMANTEC", value: "SYMANTEC" },
//     { label: "SYMPHONY", value: "SYMPHONY" },
//     { label: "SYNOLOGY", value: "SYNOLOGY" },
//     { label: "SYROTECH", value: "SYROTECH" },
//     { label: "SYSTIMAX", value: "SYSTIMAX" },
//     { label: "SYSTOOLS", value: "SYSTOOLS" },
//     { label: "TABLEAU", value: "TABLEAU" },
//     { label: "TANDBERG", value: "TANDBERG" },
//     { label: "TARGUS", value: "TARGUS" },
//     { label: "TEAMVIEWER", value: "TEAMVIEWER" },
//     { label: "TENABLE", value: "TENABLE" },
//     { label: "TETHERFI", value: "TETHERFI" },
//     { label: "TH", value: "TH" },
//     { label: "THALES", value: "THALES" },
//     { label: "THREATCOP", value: "THREATCOP" },
//     { label: "TINTRI", value: "TINTRI" },
//     { label: "TITUS", value: "TITUS" },
//     { label: "TOSHIBA", value: "TOSHIBA" },
//     { label: "TPLINK", value: "TPLINK" },
//     { label: "TRELLIX", value: "TRELLIX" },
//     { label: "TRENDMICRO", value: "TRENDMICRO" },
//     { label: "TSC", value: "TSC" },
//     { label: "TUFIN", value: "TUFIN" },
//     { label: "TYCO", value: "TYCO" },
//     { label: "UBIQUITI", value: "UBIQUITI" },
//     { label: "UBUNTU", value: "UBUNTU" },
//     { label: "UIPATH", value: "UIPATH" },
//     { label: "UNB", value: "UNB" },
//     { label: "VAL", value: "VAL" },
//     { label: "VALRACK", value: "VALRACK" },
//     { label: "VANTAGEO", value: "VANTAGEO" },
//     { label: "VARONIS", value: "VARONIS" },
//     { label: "VEEAM", value: "VEEAM" },
//     { label: "VERGER3D", value: "VERGER3D" },
//     { label: "VERITAS", value: "VERITAS" },
//     { label: "VERTIV", value: "VERTIV" },
//     { label: "VIP", value: "VIP" },
//     { label: "VMWARE", value: "VMWARE" },
//     { label: "WATCHDOG", value: "WATCHDOG" },
//     { label: "WESTERN", value: "WESTERN" },
//     { label: "WHATSUP", value: "WHATSUP" },
//     { label: "WILDCARD", value: "WILDCARD" },
//     { label: "WIPRO", value: "WIPRO" },
//     { label: "WQ", value: "WQ" },
//     { label: "WS FTP", value: "WS FTP" },
//     { label: "XAAS", value: "XAAS" },
//     { label: "XEROX", value: "XEROX" },
//     { label: "YAMAHA", value: "YAMAHA" },
//     { label: "Yotta", value: "Yotta" },
//     { label: "YUBICO", value: "YUBICO" },
//     { label: "ZEBRA", value: "ZEBRA" },
//     { label: "ZEBRONICS", value: "ZEBRONICS" },
//     { label: "ZOHO", value: "ZOHO" },
//     { label: "ZOOM", value: "ZOOM" },
//     { label: "ZSCALER", value: "ZSCALER" },
//   ];

//   const [selectedOem, setSelectedOem] = useState([]);

//     const CurrencyyearMultiplier = {
//       "Year 1": 1,
//       "Year 2": 1.05,
//       "Year 3": 1.05 ** 2,
//       "Year 4": 1.05 ** 3,
//       "Year 5": 1.05 ** 4,
//       "Year 6": 1.05 ** 5,
//       "Year 7": 1.05 ** 6,
//     };

//     const conversionRateyear1 = (conversionRate * 1).toFixed(2);
//     const conversionRateyear2 = (conversionRate * CurrencyyearMultiplier["Year 2"]).toFixed(2);
//     const conversionRateyear3 = (conversionRate * CurrencyyearMultiplier["Year 3"]).toFixed(2);
//     const conversionRateyear4 = (conversionRate * CurrencyyearMultiplier["Year 4"]).toFixed(2);
//     const conversionRateyear5 = (conversionRate * CurrencyyearMultiplier["Year 5"]).toFixed(2);
//     const conversionRateyear6 = (conversionRate * CurrencyyearMultiplier["Year 6"]).toFixed(2);
//     const conversionRateyear7 = (conversionRate * CurrencyyearMultiplier["Year 7"]).toFixed(2);

//     // const conversionRateyear1 = (conversionRate * 1).toFixed(2);
//     // const conversionRateyear2 = (conversionRateyear1 * 1.05).toFixed(2);
//     // const conversionRateyear3 = (conversionRateyear2 * 1.05).toFixed(2);
//     // const conversionRateyear4 = (conversionRateyear3 * 1.05).toFixed(2);
//     // const conversionRateyear5 = (conversionRateyear4 * 1.05).toFixed(2);
//     // const conversionRateyear6 = (conversionRateyear5 * 1.05).toFixed(2);
//     // const conversionRateyear7 = (conversionRateyear6 * 1.05).toFixed(2);


//     useEffect(() => {
//       const JWTtoken = window.sessionStorage.getItem('token')
//       const loginID = window.sessionStorage.getItem('userId')
//       const loginRole = window.sessionStorage.getItem('role')
//       console.log('Hitted')
//       apiService.getNonTenderCrmDetails(JWTtoken, loginID, loginRole)
//         .then(response => {
//           console.log('Non Tender CRM Data>>>>>>>>>>>',response.data)
//           setcrmData(response.data);
//           setLoading(false);
//         })
//         .catch(error => {
//           setError(error);
//           setLoading(false);
//         });

//         getdataforcostsheet(JWTtoken)
        
//       apiService.getFunctionalHeadList(JWTtoken)
//         .then(response => {
//           // console.log("10101010101101010",response.data)
//           setAllFunctionalHeadList(response.data);
//         })
//         .catch(error => {
//           setError(error);
//         });

//       apiService.getFinancialTable(JWTtoken, series)
//         .then((res) => {
//           const fetchedRows = res.data.data;
//           if (!fetchedRows || fetchedRows.length === 0) return;

//           // Separate Total row from data rows
//           const dataRows = fetchedRows.filter((r) => r.name !== "Total");
          
//           const enrichedRows = dataRows.map((row) => {
//             const rowCurrency = row.currency || "INR"; // ✅ restore row-level currency

//             const normalizedValues = (row.values || []).map((v) => {
//               if (typeof v === "object" && v !== null) {
//                 return { amount: v.amount || 0, currency: v.currency || rowCurrency };
//               }
//               return { amount: Number(v) || 0, currency: rowCurrency };
//             });

//             return enrichRow({
//               ...row,
//               currency: rowCurrency,        // ✅ restore at row level
//               values: normalizedValues,
//             });
//           });

//           // ✅ Always append a fresh Total row — it will be recalculated by useEffect
//           setRows([
//             ...enrichedRows,
//             { id: 999, name: "Total", currency: "INR", values: makeValues(9) },
//           ]);
//         })
//         .catch((err) => console.error("Failed to fetch financial table:", err));
      
//       apiService.getENTCSAppvByFormseries(JWTtoken, series)
//         .then((response) => {
//           console.log('ENTCOSTSHEET - getENTCSAppvByFormseries ::::>>', response.data)
//           setAppvTeamLeaderId(response.data.appvTeamLeaderID)
//           setAppvBranchHeadId(response.data.appvBranchHeadID)
//           setAppvRegionBusinessHeadId(response.data.appvRegionBusinessHeadID)
//           setAppvBusinessFinanceId(response.data.appvBusinessFinanceID)
//           setAppvExportComplianceId(response.data.appvExportComplianceID)
//           setAppvCreditInsuranceId(response.data.appvCreditInsuranceID)
//           setAppvCEOId(response.data.appvCEOID)
//           setAppvCOOId(response.data.appvCOOID)
//           setAppvCFOId(response.data.appvCFOID)
//           setAppvSVPDirectorId(response.data.appvSVPDirectorID)
//           setAppvLegalHeadId(response.data.appvLegalHeadID)
//           setAppvDytCFOId(response.data.appvDytCFOID)
//           setMgmtAppvRegionBusinessHeadID(response.data.mgmtAppvRegionBusinessHeadID) 
//           setMgmtAppvBusinessFinanceID(response.data.mgmtAppvBusinessFinanceID)
//           setMgmtAppvCEOID(response.data.mgmtAppvCEOID)
//           setMgmtAppvCOOID(response.data.mgmtAppvCOOID)
//           setMgmtAppvCFOID(response.data.mgmtAppvCFOID)

//           setAppvTeamLeaderReq(response.data.appvTeamLeaderReq)
//           setAppvBranchHeadReq(response.data.appvBranchHeadReq)
//           setAppvRegionBusinessHeadReq(response.data.appvRegionBusinessHeadReq)
//           setAppvBusinessFinanceReq(response.data.appvBusinessFinanceReq)
//           setAppvExportComplianceReq(response.data.appvExportComplianceReq)
//           setAppvCreditInsuranceReq(response.data.appvCreditInsuranceReq)
//           setAppvCEOReq(response.data.appvCEOReq)
//           setAppvCOOReq(response.data.appvCOOReq)
//           setAppvCFOReq(response.data.appvCFOReq)
//           setAppvSVPDirectorReq(response.data.appvSVPDirectorReq)
//           setAppvFunctionalHeadReq(response.data.appvFunctionalHeadReq)
//           setAppvFunctionalHead2Req(response.data.appvFunctionalHead2Req)
//           setAppvFunctionalHead3Req(response.data.appvFunctionalHead3Req)
//           setAppvFunctionalHead4Req(response.data.appvFunctionalHead4Req)
//           setAppvFunctionalHead5Req(response.data.appvFunctionalHead5Req)
//           setAppvFunctionalHead6Req(response.data.appvFunctionalHead6Req)
//           setAppvlegalHeadReq(response.data.appvLegalHeadReq)
//           setAppvDytCFOReq(response.data.appvDytCFOReq)
//           setMgmtAppvRegionBusinessHeadReq(response.data.mgmtAppvRegionBusinessHeadReq) 
//           setMgmtAppvBusinessFinanceReq(response.data.mgmtAppvBusinessFinanceReq)
//           setMgmtAppvCEOReq(response.data.mgmtAppvCEOReq)
//           setMgmtAppvCOOReq(response.data.mgmtAppvCOOReq)
//           setMgmtAppvCFOReq(response.data.mgmtAppvCFOReq)

//           setAppvTeamLeaderStatus(response.data.appvTeamLeaderStatus)
//           setAppvBranchHeadStatus(response.data.appvBranchHeadStatus)
//           setAppvRegionBusinessHeadStatus(response.data.appvRegionBusinessHeadStatus)
//           setAppvBusinessFinanceStatus(response.data.appvBusinessFinanceStatus)
//           setAppvExportComplianceStatus(response.data.appvExportComplianceStatus)
//           setAppvCreditInsuranceStatus(response.data.appvCreditInsuranceStatus)
//           setAppvCEOStatus(response.data.appvCEOStatus)
//           setAppvCOOStatus(response.data.appvCOOStatus)
//           setAppvCFOStatus(response.data.appvCFOStatus)
//           setAppvSVPDirectorStatus(response.data.appvSVPDirectorStatus)
//           setAppvFunctionalHeadStatus(response.data.appvFunctionalHeadStatus)
//           setAppvFunctionalHead2Status(response.data.appvFunctionalHead2Status)
//           setAppvFunctionalHead3Status(response.data.appvFunctionalHead3Status)
//           setAppvFunctionalHead4Status(response.data.appvFunctionalHead4Status)
//           setAppvFunctionalHead5Status(response.data.appvFunctionalHead5Status)
//           setAppvFunctionalHead6Status(response.data.appvFunctionalHead6Status)
//           setAppvLegalHeadStatus(response.data.appvLegalHeadStatus)
//           setAppvDytCFOStatus(response.data.appvDytCFOStatus)
//           setMgmtAppvRegionBusinessHeadStatus(response.data.mgmtAppvRegionBusinessHeadStatus)
//           setMgmtAppvBusinessFinanceStatus(response.data.mgmtAppvBusinessFinanceStatus)
//           setMgmtAppvCEOStatus(response.data.mgmtAppvCEOStatus)
//           setMgmtAppvCOOStatus(response.data.mgmtAppvCOOStatus)
//           setMgmtAppvCFOStatus(response.data.mgmtAppvCFOStatus)
          
//         })
//         .catch((error) => {
//           console.error("Failed to ENTCSAPPV records by formseries:", error);
//         });

//       let user_name = window.sessionStorage.getItem('userName');
//       if (user_name) {
//         setuserName(user_name);
//       }

//       let user_id = window.sessionStorage.getItem('userId');
//       if (user_id) {
//         setuserId(user_id);
//       }

//       let user_role = window.sessionStorage.getItem('role');
//       if (user_role) {
//         setuserRole(user_role);
//       }

//     }, [series]);

//     const getdataforcostsheet = async(JWTtoken)=> {
//       await apiService.getDataAgainstEntCostSheet(JWTtoken, series)
//       .then(response => {
//           setSendForAppv(response.data.entCostSheetLogs.sentForAppv)
//           setformReopenCount(response.data.entCostSheetLogs.formReopenCount)
//           const rawOEM = response.data.entCostSheetLogs?.OEM;
//           const oemArray = rawOEM ? rawOEM.split(',').map(item => item.trim()) : [];
//           const formattedOem = oemArray.map(item => ({ label: item, value: item }));
//           const secondaryOptionsArray = response.data.entCostSheetLogs?.secondaryOptions?.split(",") || [];
//           // console.log('response.data.entCostSheetLogs?.secondaryOptions>>>', response.data.entCostSheetLogs?.secondaryOptions);
//           setStatus(response.data.entCostSheetLogs.status)
//           setSearchTerm(response.data.entCostSheetLogs.crmNumber)
//           setcustomerName(response.data.entCostSheetLogs.customerName)
//           setsalesPersonName(response.data.entCostSheetLogs.salesPersonName)
//           setsalesPersonID(response.data.entCostSheetLogs.salesPersonID)
//           setLowMarginReason(response.data.entCostSheetLogs.ReasonForMarginLessThanSixPercent)
//           setSendForAppvReqDate(response.data.entCostSheetLogs.approvalRequestDate)
//           setopportunityName(response.data.entCostSheetLogs.opportunityName)
//           // setOem(response.data.entCostSheetLogs.OEM)
//           setSelectedOem(formattedOem)
//           // setSelectedOem(response.data.entCostSheetLogs.OEM)
//           settransactionCurrency(response.data.entCostSheetLogs.transactionCurrency)
//           setsecondaryTransactionCurrency(response.data.entCostSheetLogs.secondaryTransactionCurrency)
//           setSecondaryOptions(secondaryOptionsArray)
//           setvendorBillingCycle(response.data.entCostSheetLogs.vendorBillingCycle)
//           setcashFlowExpertAdvice(response.data.entCostSheetLogs.expertAdviceCashflow)
//           setmarginExpertAdvice(response.data.entCostSheetLogs.expertAdviceMargin)
//           setvendorPaymentTerms(response.data.entCostSheetLogs.vendorPaymentTerms)
//           setcustomerPaymentTerms(response.data.entCostSheetLogs.customerPaymentTerms)
//           setDealType(response.data.entCostSheetLogs.dealType)
//           sethitachiRoleinthisDeal(response.data.entCostSheetLogs.HitachiRoleInThisDeal)
//           // setMaterialDeliveryDate(new Date (response.data.entCostSheetLogs.materialDeliveryDate))
//           setMaterialDeliveryDate(response.data.entCostSheetLogs.materialDeliveryDate)
//           setConfirmRebate(response.data.entCostSheetLogs.RebateAmountDetails)
//           setconversionRate(response.data.entCostSheetLogs.ConversionRate)
//           setremarksIfAny(response.data.entCostSheetLogs.remarks)
//           setexpectedDtCustomerRecipt(response.data.entCostSheetLogs.ExpectedDateCustomerRecipt)
//           setexpectedDtVendorPayment(response.data.entCostSheetLogs.ExpectedDateVendorPayment)
//           setcashFlowExpertAdvice(response.data.entCostSheetLogs.expertAdviceCashFlow)
//           setmarginExpertAdvice(response.data.entCostSheetLogs.expertAdviceMargin)

//           setFile1url(response.data.entCostSheetLogs.file1url)
//           setFile2url(response.data.entCostSheetLogs.file2url)
//           setFile3url(response.data.entCostSheetLogs.file3url)
//           setFile4url(response.data.entCostSheetLogs.file4url)
//           setFile5url(response.data.entCostSheetLogs.file5url)
//           setFile6url(response.data.entCostSheetLogs.file6url)
//           setFile7url(response.data.entCostSheetLogs.file7url)
//           setFile8url(response.data.entCostSheetLogs.file8url)
//           setFile9url(response.data.entCostSheetLogs.file9url)
//           setFile10url(response.data.entCostSheetLogs.file10url)
//           setFileName1(response.data.entCostSheetLogs.fileName1)
//           setFileName2(response.data.entCostSheetLogs.fileName2)
//           setFileName3(response.data.entCostSheetLogs.fileName3)
//           setFileName4(response.data.entCostSheetLogs.fileName4)
//           setFileName5(response.data.entCostSheetLogs.fileName5)
//           setFileName6(response.data.entCostSheetLogs.fileName6)
//           setFileName7(response.data.entCostSheetLogs.fileName7)
//           setFileName8(response.data.entCostSheetLogs.fileName8)
//           setFileName9(response.data.entCostSheetLogs.fileName9)
//           setFileName10(response.data.entCostSheetLogs.fileName10)
//           setQues1(response.data.entCostSheetLogs.ExCompQues1)
//           setQues2(response.data.entCostSheetLogs.ExCompQues2)
//           setQues3(response.data.entCostSheetLogs.ExCompQues3)
//           setQues4(response.data.entCostSheetLogs.ExCompQues4)
//           setQues5(response.data.entCostSheetLogs.ExCompQues5)
//           setQues6(response.data.entCostSheetLogs.ExCompQues6)
//           setQues7(response.data.entCostSheetLogs.ExCompQues7)
//           setQues8(response.data.entCostSheetLogs.ExCompQues8)
//           setQues9(response.data.entCostSheetLogs.ExCompQues9)
//           setQues10(response.data.entCostSheetLogs.ExCompQues10)
//           setQues11(response.data.entCostSheetLogs.ExCompQues11)
//           setQues12(response.data.entCostSheetLogs.ExCompQues12)
//           setQues13(response.data.entCostSheetLogs.ExCompQues13)
//           setQues14(response.data.entCostSheetLogs.ExCompQues14)
//           setFunctionalHead1ID(response.data.entCostSheetLogs.functionalHead1ID)
//           setFunctionalHead1Name(response.data.entCostSheetLogs.functionalHead1Name)
//           setFunctionalHead2ID(response.data.entCostSheetLogs.functionalHead2ID)
//           setFunctionalHead2Name(response.data.entCostSheetLogs.functionalHead2Name)
//           setFunctionalHead3ID(response.data.entCostSheetLogs.functionalHead3ID)
//           setFunctionalHead3Name(response.data.entCostSheetLogs.functionalHead3Name)
//           setFunctionalHead4ID(response.data.entCostSheetLogs.functionalHead4ID)
//           setFunctionalHead4Name(response.data.entCostSheetLogs.functionalHead4Name)
//           setFunctionalHead5ID(response.data.entCostSheetLogs.functionalHead5ID)
//           setFunctionalHead5Name(response.data.entCostSheetLogs.functionalHead5Name)
//           setFunctionalHead6ID(response.data.entCostSheetLogs.functionalHead6ID)
//           setFunctionalHead6Name(response.data.entCostSheetLogs.functionalHead6Name)
//           // console.log('VPTDetails>>>>',response.data.vendorPaymentTerms)
//           if (response.data.vendorPaymentTerms && response.data.vendorPaymentTerms.length > 0) {
//               const mappedData = response.data.vendorPaymentTerms.map(item => ({
//               formSeries: item.formSeries || series,
//               vendorpayemntTermsParticular: item.particulars || "",
//               vendorpaymentTermsDays: item.days || "",
//               vendorpaymentTermsPercentage: item.percentage || "",
//               vendorpaymentTermsValue: item.value || ""
//             }));

//             setVendorPaymentTermsDetails(mappedData);
//           }
//           // console.log('CCCCCCCCPTDetails>>>>',response.data.customerPaymentTerms)
//           if (response.data.customerPaymentTerms && response.data.customerPaymentTerms.length > 0) {
//               const mappedCPTData = response.data.customerPaymentTerms.map(item => ({
//               formSeries: item.formSeries || series,
//               customerpaymentTermsParticular: item.particulars || "",
//               customerpaymentTermsDays: item.days || "",
//               customerpaymentTermsPercentage: item.percentage || "",
//               customerpaymentTermsValue: item.value || ""
//             }));
//             setCustomerPaymentTermsDetails(mappedCPTData);

            
//           }
//         })
//         .catch(error => {
//           setError(error);
//         });
//     }

//     useEffect(() => {
//       let approvalRole = window.sessionStorage.getItem('role');
//       let approvalid = window.sessionStorage.getItem('userId');
//       apiService.confirmedENTCSAppv(series).then((response) => {

//       const status = response.data.appvStatus;
//       if(status.appvCreditInsuranceStatus === "Management Approval"){
//         setMgmtApprovalRequire("YES")
//         setCIMgmtReason(status.appvCreditInsuranceMessage)
//       }

//       setAppvTeamLeaderMessage(status.appvTeamLeaderMessage);
//       setAppvBranchHeadMessage(status.appvBranchHeadMessage);
//       setAppvRegionBusinessHeadMessage(status.appvRegionBusinessHeadMessage);
//       setAppvBusinessFinanceMessage(status.appvBusinessFinanceMessage);
//       setAppvExportComplianceMessage(status.appvExportComplianceMessage);
//       setAppvCreditInsuranceMessage(status.appvCreditInsuranceMessage);
//       setAppvCEOMessage(status.appvCEOMessage);
//       setAppvCOOMessage(status.appvCOOMessage);
//       setAppvCFOMessage(status.appvCFOMessage);
//       setAppvSVPDirectorMessage(status.appvSVPDirectorMessage);  
//       setAppvFunctionalHeadMessage(status.appvFunctionalHeadMessage);
//       setAppvFunctionalHead2Message(status.appvFunctionalHead2Message);
//       setAppvFunctionalHead3Message(status.appvFunctionalHead3Message);
//       setAppvFunctionalHead4Message(status.appvFunctionalHead4Message); 
//       setAppvFunctionalHead5Message(status.appvFunctionalHead5Message); 
//       setAppvFunctionalHead6Message(status.appvFunctionalHead6Message);  
//       setAppvLegalHeadMessage(status.appvlegalHeadMessage);
//       setAppvDytCFOMessage(status.appvDytCFOMessage);
//       setMgmtAppvRegionBusinessHeadMessage(status.mgmtAppvRegionBusinessHeadMessage);
//       setMgmtAppvBusinessFinanceMessage(status.mgmtAppvBusinessFinanceMessage);
//       setMgmtAppvCEOMessage(status.mgmtAppvCEOMessage);
//       setMgmtAppvCOOMessage(status.mgmtAppvCOOMessage);
//       setMgmtAppvCFOMessage(status.mgmtAppvCFOMessage);

//       console.log(`
//           approvalid ${approvalid}
//           appvTeamLeaderId ${status.appvTeamLeaderID}
//           status.appvTeamLeaderStatus ${status.appvTeamLeaderStatus}
//           appvBranchHeadId ${status.appvBranchHeadID}
//           status.appvBranchHeadStatus ${status.appvBranchHeadStatus}
//           appvRegionBusinessHeadId ${status.appvRegionBusinessHeadID}
//           status.appvRegionBusinessHeadStatus ${status.appvRegionBusinessHeadStatus}
//           `)

//       if (approvalRole === "TEAM LEADER") {

//         // const tlDone = approvalid === status.appvTeamLeaderID && (status.appvTeamLeaderStatus === "Approved" || status.appvTeamLeaderStatus === "Rejected");
//         // const bhDone = approvalid === status.appvBranchHeadID && (status.appvBranchHeadStatus === "Approved" || status.appvBranchHeadStatus === "Rejected");
//         // const rbhDone = approvalid === status.appvRegionBusinessHeadID && (status.appvRegionBusinessHeadStatus === "Approved" || status.appvRegionBusinessHeadStatus === "Rejected");
//         const tlDone = approvalid === status.appvTeamLeaderID && (status.appvTeamLeaderStatus !== "Pending");
//         const bhDone = approvalid === status.appvBranchHeadID && (status.appvBranchHeadStatus !== "Pending");
//         const rbhDone = approvalid === status.appvRegionBusinessHeadID && (status.appvRegionBusinessHeadStatus !== "Pending");

//         // Block only when ALL roles assigned to this person are already completed
//         const allAssignedRolesDone =
//           (!status.appvTeamLeaderID || status.appvTeamLeaderID !== approvalid || tlDone) &&
//           (!status.appvBranchHeadID || status.appvBranchHeadID !== approvalid || bhDone) &&
//           (!status.appvRegionBusinessHeadID || status.appvRegionBusinessHeadID !== approvalid || rbhDone);

//         if (allAssignedRolesDone) {
//           setResponse("Your approval is already recorded for this Deal!");
//           setShowThankYou(true);
//         }

//         if((status.mgmtAppvRegionBusinessHeadStatus === "Approved" || status.mgmtAppvRegionBusinessHeadStatus === "Rejected")){
//                 setMgmtResponse("Your Management Approval is already recorded for this Deal!");
//                 setShowMGMTThankYou(true);
//         }
//       } else if ( approvalRole === "BRANCH HEAD" && approvalid === status.appvBranchHeadID && (status.appvBranchHeadStatus === "Approved" ||status.appvBranchHeadStatus === "Rejected")) {
//         setResponse("Your approval is already recorded for this Deal!");
//         setShowThankYou(true);
//       } else if (approvalRole === "REGION BUSINESS HEAD" && approvalid === status.appvRegionBusinessHeadID) {
//         if (status.appvRegionBusinessHeadStatus === "Approved" || status.appvRegionBusinessHeadStatus === "Rejected") {
//           setResponse("Your approval is already recorded for this Deal!");
//           setShowThankYou(true);
//         }
//         if (status.mgmtAppvRegionBusinessHeadStatus === "Approved" || status.mgmtAppvRegionBusinessHeadStatus === "Rejected") {
//           setMgmtResponse("Your Management Approval is already recorded for this Deal!");
//           setShowMGMTThankYou(true);
//         }
//       } else if (approvalRole === "BUSINESS FINANCE") {
//         if (status.appvBusinessFinanceStatus === "Approved" || status.appvBusinessFinanceStatus === "Rejected") {
//           setResponse("Your approval is already recorded for this Deal!");
//           setShowThankYou(true);
//         }
//         if (status.mgmtAppvBusinessFinanceStatus === "Approved" || status.mgmtAppvBusinessFinanceStatus === "Rejected") {
//           setMgmtResponse("Your Management Approval is already recorded for this Deal!");
//           setShowMGMTThankYou(true);
//         }
//       } else if ( approvalRole === "EXPORT COMPLIANCE" && (status.appvExportComplianceStatus === "Approved" || status.appvExportComplianceStatus === "Rejected")) {
//         setResponse("Your approval is already recorded for this Deal!");
//         setShowThankYou(true);
//       } else if ( approvalRole === "CREDIT INSURANCE" && (status.appvCreditInsuranceStatus === "Approved" || status.appvCreditInsuranceStatus === "Rejected" || status.appvCreditInsuranceStatus === "Management Approval")) {
//         setResponse("Your approval is already recorded for this Deal!");
//         setShowThankYou(true);
//       } else if (approvalRole === "CEO") {
//         if (status.appvCEOStatus === "Approved" || status.appvCEOStatus === "Rejected") {
//           setResponse("Your approval is already recorded for this Deal!");
//           setShowThankYou(true);
//         }
//         if (status.mgmtAppvCEOStatus === "Approved" || status.mgmtAppvCEOStatus === "Rejected") {
//           setMgmtResponse("Your Management Approval is already recorded for this Deal!");
//           setShowMGMTThankYou(true);
//         }
//       } else if (approvalRole === "CFO") {
//         if (status.appvCFOStatus === "Approved" || status.appvCFOStatus === "Rejected") {
//           setResponse("Your approval is already recorded for this Deal!");
//           setShowThankYou(true);
//         }
//         if (status.mgmtAppvCFOStatus === "Approved" || status.mgmtAppvCFOStatus === "Rejected") {
//           setMgmtResponse("Your Management Approval is already recorded for this Deal!");
//           setShowMGMTThankYou(true);
//         }
//       } else if (approvalRole === "COO") {
//         if (status.appvCOOStatus === "Approved" || status.appvCOOStatus === "Rejected") {
//           setResponse("Your approval is already recorded for this Deal!");
//           setShowThankYou(true);
//         }
//         if (status.mgmtAppvCOOStatus === "Approved" || status.mgmtAppvCOOStatus === "Rejected") {
//           setMgmtResponse("Your Management Approval is already recorded for this Deal!");
//           setShowMGMTThankYou(true);
//         }
//       } else if ( approvalRole === "SVP-director" && (status.appvSVPDirectorStatus === "Approved" || status.appvSVPDirectorStatus === "Rejected") ) {
//         setResponse("Your approval is already recorded for this Deal!");
//         setShowThankYou(true);
//       } else if ( approvalRole === "FUNCTIONAL HEAD") {

//           let approverStatus = "";

//           if (approvalid === status.appvFunctionalHeadID) {
//                   approverStatus = status.appvFunctionalHeadStatus;
//               }else if (approvalid === status.appvFunctionalHead2ID) {
//                   approverStatus = status.appvFunctionalHead2Status;
//               }else if (approvalid === status.appvFunctionalHead3ID) {
//                   approverStatus = status.appvFunctionalHead3Status;
//               }else if (approvalid === status.appvFunctionalHead4ID) {
//                   approverStatus = status.appvFunctionalHead4Status;
//               }else if (approvalid === status.appvFunctionalHead5ID) {
//                   approverStatus = status.appvFunctionalHead5Status;
//               }else if (approvalid === status.appvFunctionalHead6ID) {
//                   approverStatus = status.appvFunctionalHead6Status;
//               }

//           if ( approverStatus === "Approved" || approverStatus === "Rejected") {
//               setResponse("Your approval is already recorded for this Deal!");
//               setShowThankYou(true);
//           }
//       } else if ( approvalRole === "LEGAL HEAD" && (status.appvLegalHeadStatus === "Approved" || status.appvlegalHeadStatus === "Rejected") ) {
//         setResponse("Your approval is already recorded for this Deal!");
//         setShowThankYou(true);
//       } else if ( approvalRole === "DYT-CFO" && (status.appvDytCFOStatus === "Approved" || status.appvDytCFOStatus === "Rejected") ) {
//         setResponse("Your approval is already recorded for this Deal!");
//         setShowThankYou(true);
//       }
//     })
//     .catch((error) => {
//       setError(error);
//     });
  
//     }, []);
    
  
//     // const filteredCrmData = crmData.filter(item =>
//     //   item.crmNumber.toLowerCase().includes(searchTerm.toLowerCase())
//     // );

//     useEffect(() => {
//       if (searchTerm === '') {
//         setcustomerName('');
//         setsalesPersonName('');
//         setopportunityName('');
//         setsalesPersonID('');
//       }
//     }, [searchTerm]);

//     useEffect(() => {
//         if(fileSaveTrigger === 0) return;
//         const timer = setTimeout(() => {
//           handleAutoSave();
//         }, 1000);
//         return () => clearTimeout(timer);
//       }, [file1,fileName1,file2,fileName2,file3,fileName3,file4,fileName4,file5,fileName5,file6,fileName6,file7,fileName7 ,file8,fileName8 ,file9,fileName9,file10,fileName10]);
    
//     const handleEdit = () => {
//       toast.success("EDIT Form");
//       setIsReadOnly(false);
//     };

//     const host = window.location.hostname; 
//     const handleAutoSave = async ({ event = null, fromButton = false, multioemvalues } = {}) => {
//       if (event) event.preventDefault();
//        let authUser = window.sessionStorage.getItem('role') === 'SALES'
//             || window.sessionStorage.getItem('role') === 'OPERATIONS'
//             || window.sessionStorage.getItem('role') === 'ADMIN'
//             || window.sessionStorage.getItem('role') === 'BUSINESS FINANCE'
//             || window.sessionStorage.getItem('role') === 'TEAM LEADER'
//             || window.sessionStorage.getItem('role') === 'EXPORT COMPLIANCE'
//           if (authUser) {

//             const oemToSave = multioemvalues ?? selectedOem.map(opt => opt.value);
           
//             const entcostsheetData = new FormData();
//             entcostsheetData.append("userName", userName);
//             entcostsheetData.append("userId", userId);
//             entcostsheetData.append("userRole", userRole);
//             entcostsheetData.append("formSeries", series);
      
//             entcostsheetData.append("file1", file1);
//             entcostsheetData.append("fileName1", fileName1);
//             entcostsheetData.append("file2", file2);
//             entcostsheetData.append("fileName2", fileName2);
//             entcostsheetData.append("file3", file3);
//             entcostsheetData.append("fileName3", fileName3);
//             entcostsheetData.append("file4", file4);
//             entcostsheetData.append("fileName4", fileName4);
//             entcostsheetData.append("file5", file5);
//             entcostsheetData.append("fileName5", fileName5);
//             entcostsheetData.append("file6", file6);
//             entcostsheetData.append("fileName6", fileName6);
//             entcostsheetData.append("file7", file7);
//             entcostsheetData.append("fileName7", fileName7);
//             entcostsheetData.append("file8", file8);
//             entcostsheetData.append("fileName8", fileName8);
//             entcostsheetData.append("file9", file9);
//             entcostsheetData.append("fileName9", fileName9);
//             entcostsheetData.append("file10", file10);
//             entcostsheetData.append("fileName10", fileName10);

      
//             entcostsheetData.append("crmNumber", searchTerm);
//             entcostsheetData.append("customerName", customerName);
//             entcostsheetData.append("salesPersonName", salesPersonName);
//             entcostsheetData.append("salesPersonID", salesPersonID);
//             entcostsheetData.append("multioemvalues", oemToSave);
//             entcostsheetData.append("approvalRequestDate", status === "Open" ? approvalRequestDate : sendForAppvReqDate );
//             entcostsheetData.append("opportunityName", opportunityName);
//             entcostsheetData.append("vendorBillingCycle", vendorBillingCycle);
//             entcostsheetData.append("transactionCurrency", transactionCurrency);
//             entcostsheetData.append("secondaryTransactionCurrency", secondaryTransactionCurrency);
//             entcostsheetData.append("secondaryOptions", secondaryOptions);
//             entcostsheetData.append("vendorPaymentTerms", vendorPaymentTerms);
//             entcostsheetData.append("customerPaymentTerms", customerPaymentTerms);
//             entcostsheetData.append("dealType", dealType);
//             entcostsheetData.append("hitachiRoleinthisDeal", hitachiRoleinthisDeal);
//             entcostsheetData.append("materialDeliveryDate", materialDeliveryDate);
//             entcostsheetData.append("lowMarginReason", lowMarginReason);
//             entcostsheetData.append("confirmRebate", confirmRebate);
//             entcostsheetData.append("conversionRate", conversionRate);
//             entcostsheetData.append("remarksIfAny", remarksIfAny);
//             entcostsheetData.append("expectedDtCustomerRecipt", expectedDtCustomerRecipt);
//             entcostsheetData.append("expectedDtVendorPayment", expectedDtVendorPayment);
//             entcostsheetData.append("cashFlowExpertAdvice", cashFlowExpertAdvice);
//             entcostsheetData.append("marginExpertAdvice", marginExpertAdvice);
            
//             entcostsheetData.append("ExCompQues1", ques1);
//             entcostsheetData.append("ExCompQues2", ques2);
//             entcostsheetData.append("ExCompQues3", ques3);
//             entcostsheetData.append("ExCompQues4", ques4);
//             entcostsheetData.append("ExCompQues5", ques5);
//             entcostsheetData.append("ExCompQues6", ques6);
//             entcostsheetData.append("ExCompQues7", ques7);
//             entcostsheetData.append("ExCompQues8", ques8);
//             entcostsheetData.append("ExCompQues9", ques9);
//             entcostsheetData.append("ExCompQues10", ques10);
//             entcostsheetData.append("ExCompQues11", ques11);
//             entcostsheetData.append("ExCompQues12", ques12);
//             entcostsheetData.append("ExCompQues13", ques13);
//             entcostsheetData.append("ExCompQues14", ques14);
//             entcostsheetData.append("functionalHead1ID", functionalHead1ID);
//             entcostsheetData.append("functionalHead1Name", functionalHead1Name);
//             entcostsheetData.append("functionalHead2ID", functionalHead2ID);
//             entcostsheetData.append("functionalHead2Name", functionalHead2Name);
//             entcostsheetData.append("functionalHead3ID", functionalHead3ID);
//             entcostsheetData.append("functionalHead3Name", functionalHead3Name);
//             entcostsheetData.append("functionalHead4ID", functionalHead4ID);
//             entcostsheetData.append("functionalHead4Name", functionalHead4Name);
//             entcostsheetData.append("functionalHead5ID", functionalHead5ID);
//             entcostsheetData.append("functionalHead5Name", functionalHead5Name);
//             entcostsheetData.append("functionalHead6ID", functionalHead6ID);
//             entcostsheetData.append("functionalHead6Name", functionalHead6Name);
      
      
//             try {
      
//               const JWTtoken = window.sessionStorage.getItem('token')
//               const response = await axios.post(`https://${host}:9001/api/saveEntCostSheetLogData`, entcostsheetData,
//                 {
//                   headers: {
//                     'Content-Type': 'multipart/form-data',
//                     'authorization': JWTtoken,
//                   },
//                 }
//               )
      
//               if (fromButton) {
//                 toast.success("Form Saved");
//               }
//               // console.log(':::::Form submitted successfully:', response.data);
//             } catch (error) {
//               // console.error('Error submitting form:', error);
//               toast.error("Save failed");
//             }
//           }

//       // toast.success("Form Saved");
//       // setIsReadOnly(true);
//     }

//     const handleAppvUserValidation = async () => {
//       setIsReadOnly(true);
//        try {
//             const JWTtoken = window.sessionStorage.getItem('token');
//             const loginRole = window.sessionStorage.getItem('role');
      
//             const response = await apiService.getDataAgainstEntCostSheet(JWTtoken, series);
//             // console.log('response:::::::::::::', response)
      
//             if (loginRole === 'SALES') {
//               // currency: row.currency || "INR"
//             if (response.data.entCostSheetLogs.userId === response.data.entCostSheetLogs.salesPersonID) {
//                   const rowsToSave = rows.map((row) => ({
//                       id: row.id,
//                       name: row.name,
//                       currency: row.name === "Total" ? row.currency ?? "INR" : row.currency,   // ✅ row-level currency
//                       values: row.values.map((v) => ({
//                         amount: v.amount,
//                         currency: v.currency, // ✅ also store in each cell for safety
//                       })),
//                     }));
//                 await apiService.saveFinancialTable(JWTtoken, series, rowsToSave)
//                   .then((response) => {
//                     if (response.data.message === "Financial table saved successfully") {
//                       setTimeout(() => toast.success("Financial Table Saved"), 1000);
//                     }
//                   })
//                   .catch((error) => {
//                     setError(error);
//                     console.error("Failed to save financial table:", error);
//                   });
//                 await handleOpenModal();
//                 await handleAutoSave();
//                 await setStep(1);
//             } else {
//                 toast.error("Please proceed with your own opportunity");
//             }
//             } else {
//               // currency: row.currency || "INR",
//                   const rowsToSave = rows.map((row) => ({
//                     id: row.id,
//                     name: row.name,
//                     currency: row.name === "Total" ? row.currency ?? "INR" : row.currency,   // ✅ row-level currency
//                     values: row.values.map((v) => ({
//                       amount: v.amount,
//                       currency: v.currency, // ✅ also store in each cell for safety
//                     })),
//                   }));
//               await apiService.saveFinancialTable(JWTtoken, series, rowsToSave)
//                 .then((response) => {
//                   if (response.data.message === "Financial table saved successfully") {
//                     setTimeout(() => toast.success("Financial Table Saved"), 1000);
//                   }
//                 })
//                 .catch((error) => {
//                   setError(error);
//                   console.error("Failed to save financial table:", error);
//                 });
//             await handleOpenModal();
//             await handleAutoSave();
//             await setStep(1);
//             }
//         } catch (error) {
//             // console.log(':::::Error while verifying sales user before approval:', error);
//             toast.error(`Error while verifying sales user before approval: ${error}`);
//         }
//     }

//     const handleOpenModal = async () => {
//         try {
//           const JWTtoken = window.sessionStorage.getItem('token')
    
//           await apiService.checkOpenOppType(JWTtoken, searchTerm)
//             .then(response => {
    
//               if (response.data.opportunityType === 'Open') {
//               let hasError = false;
  
//               const errorCheck = (condition, message) => {
//                   if (condition) {
//                   toast.error(message);
//                   hasError = true;
//                   }
//               };
  
//               errorCheck(!searchTerm || searchTerm.trim() === '', 'Please Select CRM Number');
//               // errorCheck(!oem || oem.trim() === '', 'Please select Opportunity Category(OEM)');
//               errorCheck(!transactionCurrency || transactionCurrency.trim() === '', 'Please select Transaction Currency');
//               errorCheck(!materialDeliveryDate || materialDeliveryDate.trim() === '', 'Please select Expected date of Delivery');
//               errorCheck(!vendorBillingCycle || vendorBillingCycle.trim() === '', 'Please select Vendor Billing Cycle');
//               errorCheck(!hitachiRoleinthisDeal || hitachiRoleinthisDeal.trim() === '', 'Please fill Hitachi Role in this Deal');
//               errorCheck(!vendorPaymentTerms || vendorPaymentTerms.trim() === '', 'Please fill Vendor Payment Terms');
//               errorCheck(!customerPaymentTerms || customerPaymentTerms.trim() === '', 'Please fill Customer Payment Terms');
              
//               if (totalSellingValue >= 300000000) {
//                 errorCheck(!searchTerm || searchTerm.trim() === '', 'Please Select Deal Type');
//               }

//               if (confirmRebate === 'YES'){
//                 errorCheck(!fileName4 || fileName4.trim() === '' || fileName4 === 'No File Selected', 'Please Upload Supporting Document for Rebate');  
//               }
//               errorCheck(!fileName1 || fileName1.trim() === '' || fileName1 === 'No File Selected', 'Please Upload Customer accepted PO');
//               errorCheck(!fileName2 || fileName2.trim() === '' || fileName2 === 'No File Selected', 'Please Upload Vendor TP with their payment terms and delivery timeline of that product');

//               // ✅ Final check: only proceed if no errors
//               if (!hasError) {
//                   console.log('All checks passed. Setting modal.');
//                   setModalSentForAppv(true);
//               }
  
//               } else if (response.data.opportunityType === 'Won') {
//               toast.error('This opportunity is already WON');
//               } else if (response.data.opportunityType === 'Lost') {
//               toast.error('This opportunity is already LOST');
//               }

//             })
//           //  setModalSentForAppv(true);
//         } catch (error) {
//           // console.log(':::::Error while sending preloading for approval', error)
//           toast.error(`Error while sending preloading for approval: ${error}`)
//         }
//       };
//     // const handleSelectChange = async () => {}
//     const handleCloseModal = () => setModalSentForAppv(false);

//     const handleQuesNext = async (e) => {
//       e.preventDefault();
//       const JWTtoken = window.sessionStorage.getItem('token')
//       const confirmation = 'Required';
//       await handleAutoSave({ event: e, fromButton: false });
//       await apiService.checkENTCSApprovalTable(JWTtoken, series, confirmation ).then((response) => {
//         const approverRoles = response.data.map((a) => a.role); 
  
//         const roleSetters = {
//           "TEAM LEADER": setAppvTeamLeaderReq,
//           "BRANCH HEAD": setAppvBranchHeadReq,
//           "REGION BUSINESS HEAD": setAppvRegionBusinessHeadReq,
//           "BUSINESS FINANCE": setAppvBusinessFinanceReq,
//           "EXPORT COMPLIANCE": setAppvExportComplianceReq,
//           "CREDIT INSURANCE": setAppvCreditInsuranceReq,
//           "CEO": setAppvCEOReq,
//           "COO": setAppvCOOReq,
//           "CFO": setAppvCFOReq,
//           "SVP-Director": setAppvSVPDirectorReq,
//           "FUNCTIONAL HEAD - 1": setAppvFunctionalHeadReq,
//           "FUNCTIONAL HEAD - 2": setAppvFunctionalHead2Req,
//           "FUNCTIONAL HEAD - 3": setAppvFunctionalHead3Req,
//           "FUNCTIONAL HEAD - 4": setAppvFunctionalHead4Req,
//           "FUNCTIONAL HEAD - 5": setAppvFunctionalHead5Req,
//           "FUNCTIONAL HEAD - 6": setAppvFunctionalHead6Req,
//           "Legal Head": setAppvlegalHeadReq, 
//           "DYT-CFO": setAppvDytCFOReq
//         };
  
//         Object.entries(roleSetters).forEach(([role, setter]) => {
//           if (approverRoles.includes(role)) {
//             setter("YES");
//           } else {
//             setter("NA");
//           }
//         });
//       });
  
//       setStep(2);
//     };

//     const renderEXCompQuestions = (index, label, value, onChange, readonly = false) => (
//         <tr key={index}>
//           <td>{index + 1}</td>
//           <td><i className="fa-solid fa-star-of-life" style={{ color: '#e91717', fontSize: '10px', marginLeft: '1px' }} /> {label}</td>
//           <td>
//             <Form.Check inline label="Yes" name={label} type="radio" value="Yes" checked={value === 'Yes'} onChange={() => {onChange('Yes'); setExCompMessage(''); setExCompRemark(false); }}  disabled={readonly} />
//             <Form.Check inline label="No" name={label} type="radio" value="No" checked={value === 'No'} onChange={() => {onChange('No'); setExCompMessage('');  setExCompRemark(false); }} disabled={readonly} />
//           </td>
//         </tr>
//     );
    
//     const handleExCompAppvRemark = async () => {
//     const questions = [ques1, ques2, ques3, ques4, ques5, ques6, ques7, ques8, ques9, ques10, ques11, ques12, ques13, ques14 ];

//       //  console.log("hellloo..",ques14);
       

//     const isValid = questions.every(q => q === 'Yes' || q === 'No');

//     if (!isValid) {
//         alert('All questions are mandatory and must be either "Yes" or "No"!');
//         return;
//     }else{
//       const num_ques1 = (ques1 === "Yes") ? 0 : (ques1 === "No") ? 1 : null;
//       const num_ques2 = (ques2 === "Yes") ? 0 : (ques2 === "No") ? 1 : null;
//       const num_ques3 = (ques3 === "Yes") ? 1 : (ques3 === "No") ? 0 : null;
//       const num_ques4 = (ques4 === "Yes") ? 1 : (ques4 === "No") ? 0 : null;
//       const num_ques5 = (ques5 === "Yes") ? 0 : (ques5 === "No") ? 1 : null;
//       const num_ques6 = (ques6 === "Yes") ? 1 : (ques6 === "No") ? 0 : null;
//       const num_ques7 = (ques7 === "Yes") ? 0 : (ques7 === "No") ? 1 : null;
//       const num_ques8 = (ques8 === "Yes") ? 1 : (ques8 === "No") ? 0 : null;
//       const num_ques9 = (ques9 === "Yes") ? 1 : (ques9 === "No") ? 0 : null;
//       const num_ques10 = (ques10 === "Yes") ? 1 : (ques10 === "No") ? 0 : null;
//       const num_ques11 = (ques11 === "Yes") ? 1 : (ques11 === "No") ? 0 : null;
//       const num_ques12 = (ques12 === "Yes") ? 1 : (ques12 === "No") ? 0 : null;
//       const num_ques13 = (ques13 === "Yes") ? 1 : (ques13 === "No") ? 0 : null;
//       const num_ques14 = (ques14 === "Yes") ? 1 : (ques14 === "No") ? 0 : null;
//       const sum_message = num_ques1 + num_ques2 + num_ques3 + num_ques4 + num_ques5 + num_ques6 + 
//       num_ques7 + num_ques8 + num_ques9 + num_ques10 + num_ques11 + num_ques12 + num_ques13 + num_ques14
      
//       sum_message == 0
//         ? setExCompMessage('As per above declaration Export Compliance Approval is Not Required.')
//         : sum_message >= 1
//         ? setExCompMessage('As per above declaration Export Compliance Approval is Required.')
//         : setExCompMessage('');
//       setExCompRemark(true);
//     }
//     handleAutoSave()
//     }

//     const handleSelectChange = (crmNumber) => {
//     const crm_num = crmNumber;
//     setSearchTerm(crm_num);
//     // setShowDropdown(false);
//     const selectedCrm = crmData.find(item => item.crmNumber === crm_num);

//     if (selectedCrm) {
//       setcustomerName(selectedCrm.customerName);
//       setsalesPersonName(selectedCrm.salesPersonName);
//       setopportunityName(selectedCrm.opportunityName);
//       setsalesPersonID(selectedCrm.salesPersonID);
//       setQues11(selectedCrm.dealBaseCheckApproval)
//     }
//     else {
//       setcustomerName('');
//       setsalesPersonName('');
//       setopportunityName('');
//       setsalesPersonID('');
//     }
//     };

//     const handleApproval = async () => {
  
//       try {
//         const JWTtoken = window.sessionStorage.getItem('token')
//         const approvalSenderEmail = window.sessionStorage.getItem('emailID');
//         const approvalSenderEmpId = window.sessionStorage.getItem('userId');
//         const approverSenderName = window.sessionStorage.getItem('userName');
//         setIsReadOnly(true)
//         const confirmation = "Required"
  
//         await apiService.requestENTCSApproval(JWTtoken, series, confirmation,  approvalSenderEmail, approverSenderName, approvalSenderEmpId)
//           .then(response => {
//             console.log('Yahi se aaya', response.data)
//             response.data.map(async (approver) => {
//               let approvalRole = approver.role;
//               let approvalId = approver.userId;
//               // console.log(':::::Approval Role::::>', approvalRole)
//               if (approvalRole === 'TEAM LEADER') {
//                 setAppvTeamLeaderReq('YES')
//               } else if (approvalRole === 'BRANCH HEAD') {
//                 setAppvBranchHeadReq('YES')
//               } else if (approvalRole === 'REGION BUSINESS HEAD') {
//                 setAppvRegionBusinessHeadReq('YES')
//               } else if (approvalRole === 'BUSINESS FINANCE') {
//                 setAppvBusinessFinanceReq('YES')
//               } else if (approvalRole === 'EXPORT COMPLIANCE') {
//                 setAppvExportComplianceReq('YES')
//               } else if (approvalRole === 'CREDIT INSURANCE') {
//                 setAppvCreditInsuranceReq('YES')
//               } else if (approvalRole === 'CEO') {
//                 setAppvCEOReq('YES')
//               } else if (approvalRole === 'COO') {
//                 setAppvCOOReq('YES')
//               } else if (approvalRole === 'CFO') {
//                 setAppvCFOReq('YES')
//               } else if (approvalRole === 'SVP-DIRECTOR') {
//                 setAppvSVPDirectorReq('YES')
//               } else if (approvalRole === 'FUNCTIONAL HEAD') {
//                 if (approvalId === functionalHead1ID){
//                   setAppvFunctionalHeadReq('YES')
//                 }
//                 if (approvalId === functionalHead2ID){
//                   setAppvFunctionalHead2Req('YES')
//                 }
//                 if (approvalId === functionalHead3ID){
//                   setAppvFunctionalHead3Req('YES')
//                 }
//                 if (approvalId === functionalHead4ID){
//                   setAppvFunctionalHead4Req('YES')
//                 }
//                 if (approvalId === functionalHead5ID){
//                   setAppvFunctionalHead5Req('YES')
//                 }
//                 if (approvalId === functionalHead6ID){
//                   setAppvFunctionalHead6Req('YES')
//                 }
                
//               } else if (approvalRole === 'LEGAL HEAD') {
//                 setAppvlegalHeadReq('YES')
//               } else if (approvalRole === 'DYT-CFO') {
//                 setAppvDytCFOReq('YES')
//               }
//             });
  
//             if (response.status == 200) {
//               console.log("ENTCOSTSHEET - Handle Approval ::::>>",response)
//               setTimeout(() => { window.location.reload() }, 2000);
//               toast.success("All Approval Mails Sent", {
//                 autoClose: 2000,
//               });
//             }
//             setModalSentForAppv(false);
//           })
//           .catch(error => {
//             setError(error);
//           });
  
//         // await apiService.postAppNotifyRequestApproval(JWTtoken, series)

//         setModalSentForAppv(false); // Temporary
//         // toast.success("All Approvals Mail Sent !!");
  
//       } catch (error) {
//         // console.log(':::::Error while sending preloading for approval', error)
//         toast.error(`Error while sending preloading for approval: ${error}`)
//       }
//     }

//     const handleApprove = (e) => {

//       if (approvalMessage === "") {
//         e.preventDefault();
//         let approvalStatus = "Approved";
//         let approvalMessage = "Deal Approved";
//         let approvalRole = window.sessionStorage.getItem('role');
//         let approvalid = window.sessionStorage.getItem('userId');

//         apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
//           .then((response) => {
//             console.log(":::::Aprroval Approved:::::", response.data);
//             setResponse("Thank you for your approval!");
//             setShowThankYou(true);
//           })
//           .catch((error) => {
//             setError(error);
//           });
//       } else {
//         e.preventDefault();
//         let approvalStatus = "Approved";
//         let approvalRole = window.sessionStorage.getItem('role');
//         let approvalid = window.sessionStorage.getItem('userId');
        
//         apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
//           .then((response) => {
//             console.log(":::::Aprroval Approved:::::", response.data);
//             setResponse("Thank you for your approval!");
//             setShowThankYou(true);
//           })
//           .catch((error) => {
//             setError(error);
//           });
//       }
//     };

//     const handleReject = (e) => {
//       if (rejectionMessage === "") {
//         toast.error("Please provide a valid rejection reason ");
//       } else {
//         e.preventDefault();
//         let approvalStatus = "Rejected";
//         let approvalRole = window.sessionStorage.getItem('role');
//         let approvalid = window.sessionStorage.getItem('userId');

//         apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
//           .then((response) => {
//             console.log(":::::Aprroval Rejected:::::", response.data);
//             setResponse("Thank you for your response!");
//             setShowThankYou(true);
//           })
//           .catch((error) => {
//             setError(error);
//           });
//       }
//     };

//     const handleCreditInsuranceApproval = (e) => {

//         if (appvCIMessage === "") {
//         e.preventDefault();
//         let approvalStatus = "Management Approval";
//         let appvCIMessage = "Credit Insurance Not Available Hence Submit For Approval";
//         let approvalRole = window.sessionStorage.getItem('role');
//         let approvalid = window.sessionStorage.getItem('userId');

//         apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
//           .then((response) => {
//             console.log(":::::Aprroval Approved:::::", response.data);
//             setResponse("Thank you for your approval!");
//             setShowThankYou(true);
//           })
//           .catch((error) => {
//             setError(error);
//           });
//       } else {
//         e.preventDefault();
//         let approvalStatus = "Management Approval";
//         let approvalRole = window.sessionStorage.getItem('role');
//         let approvalid = window.sessionStorage.getItem('userId');
        
//         apiService.finalEntCSApproval(series,approvalStatus,approvalMessage,rejectionMessage,appvCIMessage,approvalRole,approvalid)
//           .then((response) => {
//             console.log(":::::Aprroval Approved:::::", response.data);
//             setResponse("Thank you for your approval!");
//             setShowThankYou(true);
//           })
//           .catch((error) => {
//             setError(error);
//           });
//       }
//     };

//     const handleManagementApproval = (e) => {

//       if (mgmtApprovalMessage === "") {
//         e.preventDefault();
//         let approvalStatus = "Approved";
//         let approvalRole = window.sessionStorage.getItem('role');
//         if (
//           approvalRole === 'TEAM LEADER' ||
//           approvalRole === 'BRANCH HEAD'
//         ) {
//           approvalRole = 'REGION BUSINESS HEAD';
//         }
//         let approvalid = window.sessionStorage.getItem('userId');
//         let mgmtApprovalMessage = "Deal Approved";

//         apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
//           .then((response) => {
//             console.log(":::::Aprroval Approved:::::", response.data);
//             setMgmtResponse("Thank you for your approval!");
//             setShowMGMTThankYou(true);
//           })
//           .catch((error) => {
//             setError(error);
//           });
//       } else {
//         e.preventDefault();
//         let approvalRole = window.sessionStorage.getItem('role');
//         if (
//           approvalRole === 'TEAM LEADER' ||
//           approvalRole === 'BRANCH HEAD'
//         ) {
//           approvalRole = 'REGION BUSINESS HEAD';
//         }
//         let approvalid = window.sessionStorage.getItem('userId');
//         let approvalStatus = "Approved";
        
//         apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
//           .then((response) => {
//             console.log(":::::Aprroval Approved:::::", response.data);
//             setMgmtResponse("Thank you for your approval!");
//             setShowMGMTThankYou(true);
//           })
//           .catch((error) => {
//             setError(error);
//           });
//       }
//     };

//     const handleManagementReject = (e) => {
//       if (mgmtRejectionMessage === "") {
//         toast.error("Please provide a valid rejection reason for Management Approval");
//       } else {
//         e.preventDefault();
//         let approvalStatus = "Rejected";
//         let approvalRole = window.sessionStorage.getItem('role');
//         if (
//           approvalRole === 'TEAM LEADER' ||
//           approvalRole === 'BRANCH HEAD'
//         ) {
//           approvalRole = 'REGION BUSINESS HEAD';
//         }
//         let approvalid = window.sessionStorage.getItem('userId');
//         apiService.finalMGMTAppv(series,approvalStatus,mgmtApprovalMessage,mgmtRejectionMessage,approvalRole,approvalid)
//           .then((response) => {
//             console.log(":::::Aprroval Rejected:::::", response.data);
//             setMgmtResponse("Thank you for your response!");
//             setShowMGMTThankYou(true);
//           })
//           .catch((error) => {
//             setError(error);
//           });
//       }
//     };

//     const handleToggleNote = () => {
//       setIsNoteVisible(!isNoteVisible);
//     };

//     const handleCloseReopenModal = () => setShowReopen(false);
//     const handleShowReopenModal = () => setShowReopen(true);
//     const handleReopenPrelaoding = async (status) => {
//       try {
//         const JWTtoken = window.sessionStorage.getItem('token')
//         const response = await apiService.clearENTCSApprovals(JWTtoken, series)
//           .then(response => {
//             toast.success(`${series} is reopened for Re-Approvals`)
//             handleCloseReopenModal()
//           })
//           .catch(error => {
//             setError(error);
//           });
//         console.log(':::::Clear Approvals API Response:', response.data);
//       } catch (error) {
//         console.error('Error in API call:', error);
//       }
//     };

//     // ------------------------------------------------------------------------
  
//     const handleAdminAppvVal = async () => {
//       try {
//         const JWTtoken = window.sessionStorage.getItem('token')
//         const approvalSenderEmail = window.sessionStorage.getItem('emailID');
//         const approvalSenderEmpId = window.sessionStorage.getItem('userId');
//         const approverSenderName = window.sessionStorage.getItem('userName');
        
//           //   handleAutoSave()
//         await apiService.requestENTCSApproval(JWTtoken, series, approvalSenderEmail, approverSenderName, approvalSenderEmpId)
//         .then(response => {
//           response.data.map(async (approver) => {
//             let approvalRole = approver.role;
//             let approvalId = approver.userId;
//             console.log(':::::Approval Role::::>', approvalRole)
//             if (approvalRole === 'TEAM LEADER') {
//               setAppvTeamLeaderReq('YES')
//             } else if (approvalRole === 'BRANCH HEAD') {
//               setAppvBranchHeadReq('YES')
//             } else if (approvalRole === 'REGION BUSINESS HEAD') {
//               setAppvRegionBusinessHeadReq('YES')
//             } else if (approvalRole === 'BUSINESS FINANCE') {
//               setAppvBusinessFinanceReq('YES')
//             } else if (approvalRole === 'EXPORT COMPLIANCE') {
//               setAppvExportComplianceReq('YES')
//             } else if (approvalRole === 'CREDIT INSURANCE') {
//               setAppvCreditInsuranceReq('YES')
//             } else if (approvalRole === 'CEO') {
//               setAppvCEOReq('YES')
//             } else if (approvalRole === 'COO') {
//               setAppvCOOReq('YES')
//             } else if (approvalRole === 'CFO') {
//               setAppvCFOReq('YES')
//             } else if (approvalRole === 'SVP-DIRECTOR') {
//               setAppvSVPDirectorReq('YES')
//             } else if (approvalRole === 'FUNCTIONAL HEAD') {
//              if (approvalId === functionalHead1ID){
//                   setAppvFunctionalHeadReq('YES')
//                 }
//                 if (approvalId === functionalHead2ID){
//                   setAppvFunctionalHead2Req('YES')
//                 }
//                 if (approvalId === functionalHead3ID){
//                   setAppvFunctionalHead3Req('YES')
//                 }
//                 if (approvalId === functionalHead4ID){
//                   setAppvFunctionalHead4Req('YES')
//                 }
//                 if (approvalId === functionalHead5ID){
//                   setAppvFunctionalHead5Req('YES')
//                 }
//                 if (approvalId === functionalHead6ID){
//                   setAppvFunctionalHead6Req('YES')
//                 }
//             } else if (approvalRole === 'LEGAL HEAD') {
//               setAppvlegalHeadReq('YES')
//             } else if (approvalRole === 'DYT-CFO') {
//               setAppvDytCFOReq('YES')
//             }
//           });

//           if (response.status == 200) {
//             console.log("ENTCOSTSHEET - Handle Admin Appv ::::>>", response)
//             setTimeout(() => { window.location.reload() }, 2000);
//             toast.success("All Approval Mails Sent", {
//               autoClose: 2000,
//             });
//           }
//         })

//         // await apiService.postAppNotifyRequestApproval(JWTtoken, series)

//       } catch (error) {
//         console.log(':::::Error while verifying sales user before approval:', error)
//         toast.error(`Error while verifying sales user before approval:${error}`)
//       }
//     }

//     const handleSelectFile1 = async (e) => {
//       e.preventDefault()
//           const selectedFile = e.target.files[0];
//           if (selectedFile) {
//             setFile1(selectedFile);
//             setFileName1(selectedFile.name);
//             setfileSaveTrigger((prev)=>prev + 1)
//             toast.success(`File Selected: ${selectedFile.name}`);
//           }
//     };
  
//     const handleRemoveFile1 = () => {
//       setFile1(null);
//       setFileName1('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
      
//     };
  
//     const handleViewFile1 = async () => {
//        const JWTtoken = window.sessionStorage.getItem('token')
          
//           fileName1 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName1)
//           .then((response) => {
//             const url = window.URL.createObjectURL(new Blob([response.data]));
//             const link = document.createElement('a');
//             link.href = url;
//             link.setAttribute('download', fileName1);
//             document.body.appendChild(link);
//             link.click();
//             link.remove();
//           })
//           .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------
//     const handleSelectFile2 = async (e) => {
//        e.preventDefault()
//           const selectedFile = e.target.files[0];
//           if (selectedFile) {
//             setFile2(selectedFile);
//             setFileName2(selectedFile.name);
//             setfileSaveTrigger((prev)=>prev + 1)
//             toast.success(`File Selected: ${selectedFile.name}`);
//           }
//     };

//     const handleRemoveFile2 = () => {
//       setFile2(null);
//       setFileName2('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile2 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName2 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName2)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName2);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------

//     const handleSelectFile3 = async (e) => {
//       e.preventDefault()
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//           setFile3(selectedFile);
//           setFileName3(selectedFile.name);
//           setfileSaveTrigger((prev)=>prev + 1)
//           toast.success(`File Selected: ${selectedFile.name}`);
//         }
//     };
  
//     const handleRemoveFile3 = () => {
//       setFile3(null);
//       setFileName3('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile3 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName3 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName3)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName3);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------
//     const handleSelectFile4 = async (e) => {
//         e.preventDefault()
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//           setFile4(selectedFile);
//           setFileName4(selectedFile.name);
//           setfileSaveTrigger((prev)=>prev + 1)
//           toast.success(`File Selected: ${selectedFile.name}`);
//         }
//     };
  
//     const handleRemoveFile4 = () => {
//       setFile4(null);
//       setFileName4('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile4 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName4 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName4)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName4);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------
//     const handleSelectFile5 = async (e) => {
//       e.preventDefault()
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//           setFile5(selectedFile);
//           setFileName5(selectedFile.name);
//           setfileSaveTrigger((prev)=>prev + 1)
//           toast.success(`File Selected: ${selectedFile.name}`);
//         }
//     };
  
//     const handleRemoveFile5 = () => {
//       setFile5(null);
//       setFileName5('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile5 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName5 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName5)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName5);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------
//     const handleSelectFile6 = async (e) => {
//         e.preventDefault()
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//           setFile6(selectedFile);
//           setFileName6(selectedFile.name);
//           setfileSaveTrigger((prev)=>prev + 1)
//           toast.success(`File Selected: ${selectedFile.name}`);
//         }
//     };
  
//     const handleRemoveFile6 = () => {
//       setFile6(null);
//       setFileName6('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile6 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName6 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName6)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName6);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------
//     const handleSelectFile7 = async (e) => {
//         e.preventDefault()
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//           setFile7(selectedFile);
//           setFileName7(selectedFile.name);
//           setfileSaveTrigger((prev)=>prev + 1)
//           toast.success(`File Selected: ${selectedFile.name}`);
//         }
//     };
  
//     const handleRemoveFile7 = () => {
//       setFile7(null);
//       setFileName7('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile7 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName7 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName7)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName7);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------
//     const handleSelectFile8 = async (e) => {
//         e.preventDefault()
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//           setFile8(selectedFile);
//           setFileName8(selectedFile.name);
//           setfileSaveTrigger((prev)=>prev + 1)
//           toast.success(`File Selected: ${selectedFile.name}`);
//         }
//     };
  
//     const handleRemoveFile8 = () => {
//       setFile8(null);
//       setFileName8('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile8 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName8 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName8)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName8);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------
//     const handleSelectFile9 = async (e) => {
//         e.preventDefault()
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//           setFile9(selectedFile);
//           setFileName9(selectedFile.name);
//           setfileSaveTrigger((prev)=>prev + 1)
//           toast.success(`File Selected: ${selectedFile.name}`);
//         }
//     };
  
//     const handleRemoveFile9 = () => {
//       setFile9(null);
//       setFileName9('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile9 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName9 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName9)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName9);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

//     // ------------------------------------------------------------------------
//     const handleSelectFile10 = async (e) => {
//         e.preventDefault()
//         const selectedFile = e.target.files[0];
//         if (selectedFile) {
//           setFile10(selectedFile);
//           setFileName10(selectedFile.name);
//           setfileSaveTrigger((prev)=>prev + 1)
//           toast.success(`File Selected: ${selectedFile.name}`);
//         }
//     };
  
//     const handleRemoveFile10 = () => {
//       setFile10(null);
//       setFileName10('No File Selected');
//       setfileSaveTrigger(0);
//       toast.error('File Removed');
//     };
  
//     const handleViewFile10 = async () => {
//       const JWTtoken = window.sessionStorage.getItem('token')
        
//         fileName10 ? apiService.exportEntCostSheetViewFiles(JWTtoken, series, fileName10)
//         .then((response) => {
//           const url = window.URL.createObjectURL(new Blob([response.data]));
//           const link = document.createElement('a');
//           link.href = url;
//           link.setAttribute('download', fileName10);
//           document.body.appendChild(link);
//           link.click();
//           link.remove();
//         })
//         .catch(console.error) : toast.error('No File Selected');
//     };

// //===========================================================================================================================================================
  
//   const [currencyRates, setCurrencyRates] = useState({});
//   const [totalValues, setTotalValues] = useState(Array(9).fill(0));

//   const makeValues = (len) => Array(len).fill(null).map(() => ({ amount: 0, currency: "INR" }));

//   const columnNames = [
//     "Selling Value",
//     "Transfer Prices",
//     "Finance Fee",
//     "Contingency Fee",
//     "Penalty",
//     "Insurance Fee",
//     "Forex Fee",
//     "MARGIN",
//     "MARGIN %",
//   ];
// // transactionCurrency
//   const initialRows = [
//     { id: 1, name: "Year 1", currency: "INR", values: makeValues(9) },
//     { id: 2, name: "Year 2", currency: "INR", values: makeValues(9) },
//     { id: 3, name: "Year 3", currency: "INR", values: makeValues(9) },
//   ];

//   const extraRowNames = [
//     "Year 4", "Year 5", "Year 6", "Year 7", "Year 8", "Year 9", "Year 10",
//     "Year1 TP in USD", "Hitachi Implement", "Hitachi Manage Services", "Hitachi FMS",
//     "OEM Implement", "OEM Support", "OEM Service", "Hitachi Support Services",
//     "AWS Cloud", "AWS Manage Service", "MS Cloud", "Microsoft Manage Service",
//     "Oracle Cloud", "Oracle Manage Service", "APM", "NOC", "SOC", "PCVisor", 
//     "DIGI Box Cloud", "Finance Income", "Rebate", "Finance Cost"
//   ];

//   const enrichRow = (row) => {
//     if (row.name === "Total") return row;
//     const updatedValues = row.values.map((v) => typeof v === "object" ? v : { amount: v, currency: "INR"});
//     const amounts = updatedValues.map((v) => v.amount);
//     const { margin, marginPercent } = computeRowMargin(amounts);
//     updatedValues[7] = { ...updatedValues[7], amount: margin };
//     updatedValues[8] = { ...updatedValues[8], amount: marginPercent };
//     return { ...row, values: updatedValues };
//   };

//   const computeRowMargin = (values) => {
//     const [selling, transfer, finance, contingency, penalty, insurance, forex] = values;
//     const margin = selling - transfer - finance - contingency - penalty - insurance - forex;
//     const marginPercent = selling ? (margin / selling) * 100 : 0;
//     return {
//       margin: Number(margin.toFixed(2)),
//       marginPercent: Number(marginPercent.toFixed(2)),
//     };
//   };

//   const [rows, setRows] = useState([
//     ...initialRows.map(enrichRow),
//     { id: 999, name: "Total", values: makeValues(9) },
//   ]);

//   // ✅ Track which rows the user has manually changed via the currency dropdown,
//   // so the auto-sync below never overwrites a deliberate user choice.
//   const manuallyChangedRowsRef = useRef(new Set());

//   // ✅ Keep Year 1-3 currency mirrored to transactionCurrency on every change
//   // (initial load AND later updates), unless the user manually overrode that row.
//  useEffect(() => {
//     if (!transactionCurrency) return;
//     if (transactionCurrency !== secondaryTransactionCurrency) return; // multi-currency mode: skip auto-sync
//     setRows((prev) =>
//       prev.map((row) =>
//         ["Year 1", "Year 2", "Year 3"].includes(row.name) && !manuallyChangedRowsRef.current.has(row.id)
//           ? { ...row, currency: transactionCurrency }
//           : row
//       )
//     );
//   }, [transactionCurrency, secondaryTransactionCurrency]);
  

//   const paymentTermsNonTotalRows = rows.filter((r) => r.name !== "Total");

//   // const getRate = async (currency) => {
//   //   if (currency === "INR") return 1;
//   //   // console.log('currency',currency)
//   //   if (currencyRates[currency]) return currencyRates[currency];
//   //   const JWTtoken = window.sessionStorage.getItem("token");
//   //   const rate = await apiService.getForexRecord(JWTtoken, currency);
//   //   setCurrencyRates((prev) => ({ ...prev, [currency]: rate.data }));
//   //   return rate.data;
//   // };
//   const getRate = async (currency) => {
//     // ✅ Guard against undefined, null, "", "INR", or any non-string
//     if (!currency || typeof currency !== "string" || currency.trim() === "" || currency === "INR") {
//       return 1;
//     }

//     if (currencyRates[currency]) return currencyRates[currency];

//     try {
//       const JWTtoken = window.sessionStorage.getItem("token");
//       const res = await apiService.getForexRecord(JWTtoken, currency.trim());
//       const rate = res.data;
//       setCurrencyRates((prev) => ({ ...prev, [currency]: rate }));
//       return rate;
//     } catch (err) {
//       console.warn(`⚠️ Rate fetch failed for "${currency}", defaulting to 1`, err);
//       return 1; // ✅ never crash calculateTotal
//     }
//   };
//   const handleRowCurrencyChange = async (rowId, currency) => {
//     await getRate(currency);

//     manuallyChangedRowsRef.current.add(rowId); // ✅ user override — stop auto-syncing this row

//     setRows((prev) => prev.map((row) => row.id === rowId ? { ...row, currency } : row ));
//   };

//   const handleValueChange = (rowId, colIndex, newValue) => {
//     setDirtyFCTable(true);
//     setRows((prev) =>
//       prev.map((row) => {
//         if (row.id !== rowId || row.name === "Total") return row;
//         const cleanedValue = newValue.replace(/^0+(?=\d)/, "");
//         const numericValue = cleanedValue === "" ? 0 : parseFloat(cleanedValue);
//         const updatedValues = row.values.map((val, i) =>
//           i === colIndex ? { ...val, amount: numericValue } : val
//         );
//         // Recompute margin (cols 0-6 are amounts)
//         const amounts = updatedValues.map((v) => v.amount);
//         const { margin, marginPercent } = computeRowMargin(amounts);
//         updatedValues[7] = { ...updatedValues[7], amount: margin };
//         updatedValues[8] = { ...updatedValues[8], amount: marginPercent };
//         return { ...row, values: updatedValues };
//       })
//     );
//   };

//   const addRow = (name) => {
//     setRows((prev) => {
//       if (prev.some((row) => row.name === name)) return prev;
//       const newRow = enrichRow({ id: Date.now(), name, currency: transactionCurrency , values: makeValues(9) });
//       const totalRow = prev.find((r) => r.name === "Total");
//       const others = prev.filter((r) => r.name !== "Total");
//       return [...others, newRow, totalRow];
//     });
//   };

//   const removeRow = (id) => {
//           setRows((prev) => prev.filter((row) => row.id !== id));
//   };

//   // const calculateTotal = async () => {
//   //     const numCols = 9;
//   //     const totals = Array(numCols).fill(0);
//   //     const nonTotalRows = rows.filter((r) => r.name !== "Total");

//   //     // Rows whose values should be subtracted from the total
//   //     const subtractRows = ["Finance Income", "Rebate"];

//   //     const yearMultiplier = {
//   //       "Year 1": 1,
//   //       "Year 2": 1.05,
//   //       "Year 3": 1.05 ** 2,
//   //       "Year 4": 1.05 ** 3,
//   //       "Year 5": 1.05 ** 4,
//   //       "Year 6": 1.05 ** 5,
//   //       "Year 7": 1.05 ** 6,
//   //     };

//   //     for (const row of nonTotalRows) {
//   //       // const currency = row.currency ?? "INR";
//   //       const currency = row.currency ?? transactionCurrency;
//   //       console.log('CCCCCCCCCCCCCCCCurrency',currency)
//   //       const baseRate = await getRate(currency);

//   //       const multiplier = currency !== "INR" ? (yearMultiplier[row.name] ?? 1) : 1;
//   //       const effectiveRate = Number((baseRate * multiplier).toFixed(2));

//   //       // ✅ Subtract for specific rows, add for all others
//   //       const sign = subtractRows.includes(row.name) ? -1 : 1;

//   //       // console.log(`Row: ${row.name} | Currency: ${currency} | Base Rate: ${baseRate} | Multiplier: ${multiplier} | Effective Rate: ${effectiveRate} | Sign: ${sign}`);

//   //       for (let i = 0; i < 7; i++) {
//   //         const amount = row.values[i]?.amount || 0;
//   //         totals[i] += sign * (parseFloat(amount) || 0) * effectiveRate;
//   //       }
//   //     }

//   //     const { margin, marginPercent } = computeRowMargin(totals);
//   //     totals[7] = Number(margin.toFixed(2));
//   //     totals[8] = Number(marginPercent.toFixed(2));

//   //     return totals.map((t) => Number(parseFloat(t).toFixed(2)));
//   // };
//   const calculateTotal = async () => {
//     const numCols = 9;
//     const totals = Array(numCols).fill(0);
//     const nonTotalRows = rows.filter((r) => r.name !== "Total");
//     // console.log('nonTotalRows>>>>>>>>>>>>>>>>>>>>>>>>>>>>',nonTotalRows)

//     const yearMultiplier = {
//       "Year 1": 1,        
//       "Year 2": 1.05,
//       "Year 3": 1.05 ** 2,
//       "Year 4": 1.05 ** 3,
//       "Year 5": 1.05 ** 4,
//       "Year 6": 1.05 ** 5,
//       "Year 7": 1.05 ** 6,
//     };

//     for (const row of nonTotalRows) {
//       // ✅ Sanitize currency before passing to getRate
//       const rawCurrency = row.currency ?? transactionCurrency ?? "INR";
//       const currency = (typeof rawCurrency === "string" && rawCurrency.trim() !== "")
//         ? rawCurrency.trim()
//         : "INR";

//       const baseRate = await getRate(currency);
//       const multiplier = currency !== "INR" ? (yearMultiplier[row.name] ?? 1) : 1;
//       const effectiveRate = Number((baseRate * multiplier).toFixed(2));

//        // ✅ Subtract if name is "Rebate", otherwise add
//       const isRebate = row.name?.trim() === "Rebate";

//       for (let i = 0; i < 7; i++) {
//         const amount = row.values[i]?.amount || 0;
//         const convertedAmount = (parseFloat(amount) || 0) * effectiveRate;
//         totals[i] += isRebate ? -convertedAmount : convertedAmount;
//       }

//       // for (let i = 0; i < 7; i++) {
//       //   const amount = row.values[i]?.amount || 0;
//       //   totals[i] += (parseFloat(amount) || 0) * effectiveRate;
//       // }
//     }

//     const { margin, marginPercent } = computeRowMargin(totals);
//     totals[7] = Number(margin.toFixed(2));
//     totals[8] = Number(marginPercent.toFixed(2));

//     return totals.map((t) => Number(parseFloat(t).toFixed(2)));
//   };

//   useEffect(() => {
//     const recalc = async () => {
//       const result = await calculateTotal();
//       setTotalValues(result);
//       setRows((prev) =>
//         prev.map((row) =>
//           row.name === "Total"
//             ? { ...row, values: row.values.map((v, i) => ({ ...v, amount: result[i] })) }
//             : row
//         )
//       );
//     };
//     recalc();
//   }, [
//     JSON.stringify(
//       rows.filter((r) => r.name !== "Total").map((r) => ({
//           currency: r.currency || transactionCurrency,  // ✅ include currency in dep
//           values: r.values.map((v) => v.amount),
//         }))
//     ),
//   ]);

//     // ─── Save rows ───────────────────────────────────────────────────
//     const handleSaveFinancialTable = () => {
//       const JWTtoken = window.sessionStorage.getItem('token');
//       setDirtyFCTable(false)

//       // currency: row.currency || "INR",
//       // currency: row.currency,
//       const rowsToSave = rows.map((row) => ({
//         id: row.id,
//         name: row.name,
//         currency: row.name === "Total" ? row.currency ?? "INR" : row.currency,
//         values: row.values.map((v) => ({
//           amount: v.amount,
//           currency: v.currency,
//         })),
//       }));

//       apiService.saveFinancialTable(JWTtoken, series, rowsToSave)
//         .then((response) => {
//           if (response.data.message === "Financial table saved successfully") {
//             setTimeout(() => toast.success("Financial Table Saved"), 1000);
//           }
//         })
//         .catch((error) => {
//           setError(error);
//           console.error("Failed to save financial table:", error);
//         });

//       console.log('vendorPaymentTerms',vendorPaymentTerms)
//       // if(vendorPaymentTerms !== ""){
//       //   recalculateAllVendorPaymentTermValues();
//       // }
//       console.log('customerPaymentTerms',customerPaymentTerms)
//       // if(customerPaymentTerms !== ""){
//       //   recalculateAllCustomerPaymentTermValues();
//       // }
//     };
     
//       const totalRow = rows.find((row) => row.name === "Total");
//       const marginPercent      = totalRow?.values?.[8]?.amount ?? 0;
//       const totalTransferPrice = totalRow?.values?.[1]?.amount ?? 0;
//       const totalSellingValue  = totalRow?.values?.[0]?.amount ?? 0;
//       const showMarginRemarksRow = marginPercent < 6;
      
//       // let showMarginRemarksRow = false
//       // if(marginPercent > 6){
//       //     showMarginRemarksRow = true
//       // }
//       // const showMarginRemarksRow = marginPercent < 6;
//       // console.log("totalRow", totalRow)
//       // console.log("marginPercent", marginPercent)      
//       // console.log("showMarginRemarksRow", showMarginRemarksRow)
//       // console.log("totalTransferPrice", totalTransferPrice)
//       // console.log("ENTCOSTSHEET - totalSellingValue ::::>>", totalSellingValue)
      

//   //------------------------------------------------------------------------------------------VENDOR PAYMENTS TERMS DETAILS

//   const [vendorPaymentTermsDetails, setVendorPaymentTermsDetails] = useState([{formSeries: `${series}`, vendorpayemntTermsParticular:"", vendorpaymentTermsDays: "", vendorpaymentTermsPercentage: "", vendorpaymentTermsValue:"" }]);


//   const handleVendorPaymentTermChange = (index, field, value) => {
//     const updated = [...vendorPaymentTermsDetails];
//     updated[index][field] = value;
//     setVendorPaymentTermsDetails(updated);
//     // console.log('paymentTermsNonTotalRows',paymentTermsNonTotalRows)
//   };

//   const addVendorPaymentTermRow = () => {
//     setVendorPaymentTermsDetails([...vendorPaymentTermsDetails, {formSeries: `${series}`, vendorpayemntTermsParticular:"", vendorpaymentTermsDays: "", vendorpaymentTermsPercentage: "", vendorpaymentTermsValue:""}]);
//   };

//   const closeVendorPaymentTermModal = () => {
//     setIsVendorPaymentTermModalOpen(false);
//   };

//   // const handlesSaveVendorPaymentTerms = (vpt_btn = false) =>{
//   //   const JWTtoken = window.sessionStorage.getItem('token')
//   //   const loginRole = window.sessionStorage.getItem('role')
//   //   apiService.saveVendorPaymentTerms(JWTtoken, loginRole, JSON.stringify(vendorPaymentTermsDetails))
//   //     .then(response => {
//   //       // console.log("AAAAAAAA",response);
//   //        if (response.data.message === "Vendor payment terms saved successfully") {
//   //             setTimeout(() => {
//   //               toast.success("Vendor Payment Terms Saved");
//   //             }, 1000);
//   //             }
//   //             // console.log(':::::Form submitted successfully:', response.data);
//   //       closeVendorPaymentTermModal()
//   //     })
//   //     .catch(error => {
//   //       setError(error);
//   //       closeVendorPaymentTermModal()
//   //     });

//   //     if (!vendorPaymentTermsDetails?.length) return;

//   //       const decimalString = vendorPaymentTermsDetails.map(item => `${item.vendorpaymentTermsPercentage / 100} ${item.vendorpaymentTermsDays}D`).join(" ; ");

//   //       setvendorPaymentTerms(decimalString);

//   //       const vptweightedSum = vendorPaymentTermsDetails.reduce((vptsum, item) => {
//   //       const vptdays = Number(item.vendorpaymentTermsDays);
//   //       // console.log('vptdays::   ',vptdays)
//   //       const vptvalue = Number(item.vendorpaymentTermsValue);
//   //       // console.log('vptvalue::   ',vptvalue)
//   //       return vptsum + vptdays * vptvalue;
//   //       }, 0);
//   //         // console.log('vptweightedSum::   ', vptweightedSum)
//   //         const vpttotalDays = Math.round(vptweightedSum / Number(totalTransferPrice));
//   //         // console.log('vpttotalDays::   ',vpttotalDays)
//   //         const vptupdatedDate = addDays(materialDeliveryDate, vpttotalDays);
//   //         // console.log('vptupdatedDate::   ',vptupdatedDate)
//   //         setexpectedDtVendorPayment(moment(vptupdatedDate).format("YYYY-MM-DD"));

//   //         handleAutoSave({ fromButton: false });
//   // }

//   const handlesSaveVendorPaymentTerms = (vpt_btn = false, overrideRows = null) => {
//     const JWTtoken = window.sessionStorage.getItem('token');
//     const loginRole = window.sessionStorage.getItem('role');

//     // ✅ Use overrideRows if provided, else fall back to state
//     const rowsToSave = overrideRows ?? vendorPaymentTermsDetails;

//     apiService.saveVendorPaymentTerms(JWTtoken, loginRole, JSON.stringify(rowsToSave))
//       .then(response => {
//         if (response.data.message === "Vendor payment terms saved successfully") {
//           setTimeout(() => {
//             toast.success("Vendor Payment Terms Saved");
//           }, 1000);
//         }
//         closeVendorPaymentTermModal();
//       })
//       .catch(error => {
//         setError(error);
//         closeVendorPaymentTermModal();
//       });

//     if (!rowsToSave?.length) return;  // ✅ was vendorPaymentTermsDetails

//     const decimalString = rowsToSave  // ✅ was vendorPaymentTermsDetails
//       .map(item => `${item.vendorpaymentTermsPercentage / 100} ${item.vendorpaymentTermsDays}D`)
//       .join(" ; ");

//     setvendorPaymentTerms(decimalString);

//     console.log('rowsToSave', rowsToSave)

//     const vptweightedSum = rowsToSave.reduce((vptsum, item) => {  // ✅ was vendorPaymentTermsDetails
//       const vptdays = Number(item.vendorpaymentTermsDays);
//       const vptvalue = Number(item.vendorpaymentTermsValue);
//       return vptsum + vptdays * vptvalue;
//     }, 0);
    
//     console.log('VPT Sum Value::::>>',vptweightedSum)
//     console.log('Total Selling Value::::>>',Number(totalTransferPrice)) 
//     const vpttotalDays = Math.round(vptweightedSum / Number(totalTransferPrice));
//     console.log('VPT Total Days::::>>',vpttotalDays)
//     console.log('Material Delivery Date::::>>',materialDeliveryDate)
//     const vptupdatedDate = addDays(materialDeliveryDate, vpttotalDays);
//     console.log('VPT Updated Date::::>>',vptupdatedDate)
//     setexpectedDtVendorPayment(moment(vptupdatedDate).format("YYYY-MM-DD"));
//     handleAutoSave({ fromButton: false });
//   };

//   const deleteVendorPaymentTermRow = (index) => {
//     const sequence = index + 1
//     // console.log("SERIES",series)
//     // console.log("Sequence",sequence)
//     const JWTtoken = window.sessionStorage.getItem('token')
//     const loginRole = window.sessionStorage.getItem('role')
//     apiService.deleteVendorPaymentTerm(JWTtoken, loginRole, series, sequence)
//       .then(response => {
//          if (response.data.message === "Vendor payment term deleted and sequence reordered") {
//               setTimeout(() => {toast.success("Vendor Payment Term Deleted")}, 1000);
//               setVendorPaymentTermsDetails((prev) => prev.filter((_, i) => i !== index));
//               }
//       })
//       .catch(error => {
//         if(error.status === 404) {
//          toast.success("Vendor Payment Term Deleted")
//          setVendorPaymentTermsDetails((prev) => prev.filter((_, i) => i !== index));
//         }else{
//           setError(error);
//           console.log('ENTCS_ERROR - deleteVendorPaymentTermRow',error)
//           toast.error(`Error: ${error}`)
//       }
//       });
//   };

  
//   const totalVendorPaymentTermsValue = vendorPaymentTermsDetails.reduce((sum, row) => {
//   const value = parseFloat(row.vendorpaymentTermsValue);
//   return isNaN(value) ? sum : sum + value;
//   }, 0);

//   const nonTotalFCTRows = rows.filter((r) => r.name !== "Total");
  
//   // const totalTransferPriceWithoutTotal = nonTotalFCTRows.reduce((sum, row) => {
//   // const val = Number(row.values?.[1]?.amount) || 0;
//   // return sum + val;
//   // }, 0);
//   const totalTransferPriceWithoutTotal =  Math.trunc(totalTransferPrice)

//   const totalVendorPaymentTermsPercentage = ((totalVendorPaymentTermsValue / totalTransferPriceWithoutTotal) * 100).toFixed(2)
  
//   const vendorPercentageShortfall = (totalVendorPaymentTermsPercentage - 100.00).toFixed(2);

//   // console.log(`[
//   // totalVendorPaymentTermsValue: ${totalVendorPaymentTermsValue}
//   // totalTransferPriceWithoutTotal: ${totalTransferPriceWithoutTotal}
//   // totalVendorPaymentTermsPercentage: ${totalVendorPaymentTermsPercentage}
//   // vendorPercentageShortfall : ${vendorPercentageShortfall}
//   // ]`)

//   const addDays = (date, days) => {
//   const result = new Date(date);
//   result.setDate(result.getDate() + days);
//   return result;
//   };
  
//   //-------------------------------------------------------------------------------------------------------------------------Customer Payments Terms Details

//     const [customerPaymentTermsDetails, setCustomerPaymentTermsDetails] = useState([{formSeries: `${series}`,customerpaymentTermsParticular: "", customerpaymentTermsDays: "", customerpaymentTermsPercentage: "", customerpaymentTermsValue:"" }]);

//   const handleCustomerPaymentTermChange = (index, field, value) => {
//     const updated = [...customerPaymentTermsDetails];
//     updated[index][field] = value;
//     setCustomerPaymentTermsDetails(updated);
//   };

//   const addCustomerPaymentTermRow = () => {
//     setCustomerPaymentTermsDetails([...customerPaymentTermsDetails, {formSeries: `${series}`, customerpaymentTermsParticular: "", customerpaymentTermsDays: "", customerpaymentTermsPercentage: "", customerpaymentTermsValue:""}]);
//   };

//   const closeCustomerPaymentTermModal = () => {
//     setIsCustomerPaymentTermModalOpen(false);
//   };

//   const handlesSaveCustomerPaymentTerms = (cpt_btn = false) =>{
//     const JWTtoken = window.sessionStorage.getItem('token')
//     const loginRole = window.sessionStorage.getItem('role')
//     // console.log('CUSTOMBERRRR>>>>', JSON.stringify(customerPaymentTermsDetails))
//     apiService.saveCustomerPaymentTerms(JWTtoken, loginRole,  JSON.stringify(customerPaymentTermsDetails))
//       .then(response => {
//         // console.log("CCCCCCCCCC",response);
//          if (response.data.message === "Customer payment terms saved successfully") {
//               setTimeout(() => {
//                 toast.success("customer Payment Terms Saved");
//               }, 1000);
//               }
//               // console.log(':::::Form submitted successfully:', response.data);
//         closeCustomerPaymentTermModal()
//       })
//       .catch(error => {
//         setError(error);
//         closeCustomerPaymentTermModal()
//       });

//       if (!customerPaymentTermsDetails?.length) return;
//       const decimalString = customerPaymentTermsDetails.map(item => `${item.customerpaymentTermsPercentage / 100} ${item.customerpaymentTermsDays}D`).join(" ; ");
//       setcustomerPaymentTerms(decimalString);

//       const cptweightedSum = customerPaymentTermsDetails.reduce((cptsum, item) => {
//         const cptdays = Number(item.customerpaymentTermsDays);
//         // console.log('cptdays::   ',cptdays)
//         const cptvalue = Number(item.customerpaymentTermsValue);
//         // console.log('cptvalue::   ',cptvalue)
//         return cptsum + cptdays * cptvalue;
//       }, 0);
//       console.log('CPT Sum Value::::>>',cptweightedSum)
//       console.log('Total Selling Value::::>>',Number(totalSellingValue))
//       const cpttotalDays = Math.round(cptweightedSum / Number(totalSellingValue));
//       console.log('CPT Total Days::::>>',cpttotalDays)
//       console.log('Material Delivery Date::::>>',materialDeliveryDate)  
//       const cptupdatedDate = addDays(materialDeliveryDate, cpttotalDays);
//       console.log('CPT Updated Date::::>>',cptupdatedDate)
//       setexpectedDtCustomerRecipt(moment(cptupdatedDate).format("YYYY-MM-DD"));
//       handleAutoSave({ fromButton: false });
//   }

//   // const handlesSaveCustomerPaymentTerms = (cpt_btn = false, overrideRows = null) => {
//   //   const JWTtoken = window.sessionStorage.getItem('token');
//   //   const loginRole = window.sessionStorage.getItem('role');

//   //   const rowsToSave = overrideRows ?? customerPaymentTermsDetails; // ✅ key change

//   //   console.log('CUSTOMBERRRR>>>>', JSON.stringify(rowsToSave));

//   //   apiService.saveCustomerPaymentTerms(JWTtoken, loginRole, JSON.stringify(rowsToSave))
//   //     .then(response => {
//   //       if (response.data.message === "Customer payment terms saved successfully") {
//   //         setTimeout(() => {
//   //           toast.success("customer Payment Terms Saved");
//   //         }, 1000);
//   //       }
//   //       closeCustomerPaymentTermModal();
//   //     })
//   //     .catch(error => {
//   //       setError(error);
//   //       closeCustomerPaymentTermModal();
//   //     });

//   //   if (!rowsToSave?.length) return;

//   //   const decimalString = rowsToSave
//   //     .map(item => `${item.customerpaymentTermsPercentage / 100} ${item.customerpaymentTermsDays}D`)
//   //     .join(" ; ");
//   //   setcustomerPaymentTerms(decimalString);   // ✅ setcustomerPaymentTerms (your actual setter)

//   //   const cptweightedSum = rowsToSave.reduce((cptsum, item) => {
//   //     const cptdays = Number(item.customerpaymentTermsDays);
//   //     const cptvalue = Number(item.customerpaymentTermsValue);
//   //     return cptsum + cptdays * cptvalue;
//   //   }, 0);

//   //   const cpttotalDays = Math.round(cptweightedSum / Number(totalSellingValue)); // ✅ totalSellingValue (not totalSellingPrice)
//   //   const cptupdatedDate = addDays(materialDeliveryDate, cpttotalDays);
//   //   console.log('CPTupdatedDate::   ', cptupdatedDate);
//   //   setexpectedDtCustomerRecipt(moment(cptupdatedDate).format("YYYY-MM-DD")); // ✅ setexpectedDtCustomerRecipt (your actual setter)

//   //   handleAutoSave({ fromButton: false });
//   // };

//   const deleteCustomerPaymentTermRow = (index) => {
//     const sequence = index + 1
//     const JWTtoken = window.sessionStorage.getItem('token')
//     const loginRole = window.sessionStorage.getItem('role')
//     apiService.deleteCustomerPaymentTerm(JWTtoken, loginRole, series, sequence)
//       .then(response => {
//          if (response.data.message === "Customer payment term deleted and sequence reordered") {
//               setTimeout(() => {toast.success("Customer Payment Term Deleted")}, 1000);
//               setCustomerPaymentTermsDetails((prev) => prev.filter((_, i) => i !== index));
//             }
//       })
//       .catch(error => {
//          if(error.status === 404) {
//          toast.success("Customer Payment Term Deleted")
//          setCustomerPaymentTermsDetails((prev) => prev.filter((_, i) => i !== index));
//         }else{
//           setError(error);
//           console.log('ENTCS_ERROR - deleteVendorPaymentTermRow',error)
//           toast.error(`Error: ${error}`)
//       }
//       });
//   };

//   const totalCustomerPaymentTermsValue = customerPaymentTermsDetails.reduce((sum, row) => {
//   const value = parseFloat(row.customerpaymentTermsValue);
//   return isNaN(value) ? sum : sum + value;
//   }, 0);

//   // const totalSellingValueWithoutTotal = nonTotalFCTRows.reduce((sum, row) => {
//   // const val = Number(row.values?.[0]?.amount) || 0;
//   // return sum + val;
//   // }, 0);

//   const totalSellingValueWithoutTotal = Math.trunc(totalSellingValue)

//   const totalCustomerPaymentTermsPercentage = ((totalCustomerPaymentTermsValue / totalSellingValueWithoutTotal) * 100).toFixed(2)

//   const customerPercentageShortfall =  (totalCustomerPaymentTermsPercentage - 100.00).toFixed(2);

//   useEffect(() => { 
//   if (!expectedDtVendorPayment || !expectedDtCustomerRecipt ) return;

//     const vendorDate = moment(expectedDtVendorPayment, "YYYY-MM-DD", true);
//     const customerDate = moment(expectedDtCustomerRecipt, "YYYY-MM-DD", true);

//     if (vendorDate.isValid() && customerDate.isValid()) {
//       const daysDiff = vendorDate.diff(customerDate, "days");
//       if (daysDiff <= 0) {
//         setcashFlowExpertAdvice("It's become FC Impacted deal");
//       } else if (daysDiff > 0) {
//         setcashFlowExpertAdvice("It's favourable to Hitachi");
//       }else{
//         setcashFlowExpertAdvice("");
//       }
//     }

//   }, [expectedDtVendorPayment, expectedDtCustomerRecipt]);

//   //-------------------------------------------------------------------------------------------------------------------------
//   // useEffect(() => {
//   // if (!marginPercent) return;
//   // if (!selectedOem || selectedOem.length === 0) {
//   //   setmarginExpertAdvice("");
//   // } else {
//   //   const hasMicrosoft = selectedOem.some(item => item.value.toUpperCase() === "MICROSOFT");
//   //   const threshold = hasMicrosoft ? 2.00 : 6.00;
//   //   console.log('threshold>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>>',threshold)

//   //   setmarginExpertAdvice(
//   //     marginPercent >= threshold
//   //       ? "Margin Above the Threshold"
//   //       : "Margin Below the Threshold"
//   //   );
//   // }

//   // }, [marginPercent]);

//   useEffect(() => {
//     if (!marginPercent) return;
//     if (!selectedOem || selectedOem.length === 0) {
//       setmarginExpertAdvice("");
//       return;
//     }
//     const hasMicrosoft = selectedOem.some(item => item.value?.toUpperCase() === "MICROSOFT");
//     const threshold = hasMicrosoft && selectedOem.length === 1 ? 2.0 : 6.0;
//     setmarginExpertAdvice(marginPercent > threshold ? "Margin Above the Threshold" : "Margin Below the Threshold");
//   }, [marginPercent]);

//   const CustomInput = (props) => {
//     const { fieldName } = props.selectProps;

//     return (
//       <components.Input
//         {...props}
//         onPaste={(e) => {
//           e.preventDefault();
//           toast.error(`Pasting is not allowed in ${fieldName}. Please type and select from the dropdown.`)
//         }}
//       />
//     );
//   };

//   const handlePaste = (event, fieldName) => { 
//     event.preventDefault();

//     if (fieldName === 'Hitachi Role in this Deal') {
//       toast.error(`Pasting is not allowed while entering Hitachi Role in this Deal. Please type manually.`);
//     }
//     if (fieldName === 'LowMarginReasonFilled ') {
//       toast.error(`Pasting is not allowed while entering Reason if its Margin goes less than 6%. Please type manually.`);
//     }
//     if (fieldName === 'Remarks ') {
//       toast.error(`Pasting is not allowed while entering Remarks. Please type manually.`);
//     }
    
    
//   };

//   const handleRebateChange = (e) => {
//     const value = e.target.value
//     setConfirmRebate(value);
//     if (value === "YES"){
//       toast.success('Please Upload Supporting Document for Rebate')
//     }
//   };

//   const getSecondaryOptions = (primary) => {
//     if (!primary) return [];

//     if (primary === "INR") return ["INR"];

//     // For USD, AED, and all others → same + INR
//     // return [primary, "INR"];
//     return [primary, "INR"];
//   };

//   const confirmToast = (onConfirm) => {
//     toast(({ closeToast }) => (
//       <div>
//         <p>Are you sure?</p>

//         <button
//           onClick={async () => {
//             await onConfirm();   // 👉 API call
//             closeToast();
//           }}
//         >
//           OK
//         </button>

//         <button onClick={closeToast}>Cancel</button>
//       </div>
//     ), { autoClose: false });
//   };

//   const handleCurrencyChange = async (e) => {
//     const selectedCurrency = e.target.value;
//     settransactionCurrency(selectedCurrency);

//     const options = getSecondaryOptions(selectedCurrency);
//     setSecondaryOptions(options);

//     // Reset or auto-select
//     setsecondaryTransactionCurrency(options[0] || "");

//     if (selectedCurrency === 'INR') {
//       setconversionRate(1.0);
//       // return;
//     }

//     if (!selectedCurrency) return;

//     const JWTtoken = window.sessionStorage.getItem('token');

//     apiService.getForexRecord(JWTtoken, selectedCurrency)
//       .then((response) => {
//         // console.log('CurrencyResponse',response.data)
//         setconversionRate(response.data);
//       })
//       .catch((error) => {
//         setError(error);
//         setLoading(false);
//       });

//     const result = await Swal.fire({
//     title: `Selected Currency: ${e.target.value} `,
//     text: 'Are you sure, save this as primary transaction currency!',
//     icon: 'info',
//     showCancelButton: true,
//     confirmButtonText: 'Yes, Save it!',
//   });

//   if (result.isConfirmed) {
//     try {
//       const CurrTrans = e.target.value;
//       await apiService.SaveYearlyCurrency(JWTtoken, series, CurrTrans, conversionRateyear1,conversionRateyear2,conversionRateyear3,
//         conversionRateyear4,conversionRateyear5,conversionRateyear6,conversionRateyear7).then((response) => {
//         if(response.data.message === "Data Updated"){
//           Swal.fire('Saved..!', '', 'success');
//         }
//       }).catch((error) => {
//         setError(error);
//       });
//     } catch (err) {
//       Swal.fire('Error!', 'Something went wrong', 'error');
//     }
//   }
      
//   };

//   const handleSecondaryChange = (e) => {
//   setsecondaryTransactionCurrency(e.target.value);
//   };

//   const allowedCurrencies = ['USD', 'AED', 'SGD', 'HKD', 'JPY', 'EUR', 'GBP'];

//   const renderCurrencyOptions = () => {
//     // Case 1: Both INR
//     if (transactionCurrency === 'INR' && secondaryTransactionCurrency === 'INR') {
//       return <option value="INR">INR</option>;
//     }

//     // Case 2: Foreign → INR
//     if (
//       allowedCurrencies.includes(transactionCurrency) &&
//       secondaryTransactionCurrency === 'INR'
//     ) {
//       return secondaryOptions.map((curr) => (
//         <option key={curr} value={curr}>
//           {curr}
//         </option>
//       ));
//     }

//     // Case 3: Same currency
//     if (transactionCurrency === secondaryTransactionCurrency) {
//       return (
//         <option value={transactionCurrency}>
//           {transactionCurrency}
//         </option>
//       );
//     }

//     // Default fallback (optional)
//     return null;
//   };

//   // const recalculateAllVendorPaymentTermValues = () => {
//   //   const updatedRows = vendorPaymentTermsDetails.map((row) => {
//   //     // Skip rows with no particular selected
//   //     if (!row.vendorpayemntTermsParticular || row.vendorpayemntTermsParticular.trim() === "") {
//   //       return row;
//   //     }
//   //     // Match the selected particular to get updated transfer price
//   //     const matchedFTRows = paymentTermsNonTotalRows.filter(
//   //       (selectedRow) => selectedRow.name === row.vendorpayemntTermsParticular
//   //     );
//   //     if (!matchedFTRows.length) return row; // No match found, skip
//   //     const selectedTransferPrice = matchedFTRows[0].values[1].amount;
//   //     const numericPercentage = Number(row.vendorpaymentTermsPercentage);
//   //     // Skip if percentage is empty or invalid
//   //     if (!row.vendorpaymentTermsPercentage || isNaN(numericPercentage)) {
//   //       return row;
//   //     }
//   //     // Recalculate value using same rounding logic as inline handler
//   //     const rawValue = (numericPercentage * Number(selectedTransferPrice)) / 100;
//   //     const decimal = rawValue - Math.floor(rawValue);
//   //     const calculatedValue = decimal <= 0.5 ? Math.floor(rawValue) : Math.ceil(rawValue);

//   //     return {
//   //       ...row, vendorpaymentTermsValue: calculatedValue,
//   //     };
//   //   });

//   //   // Bulk update state once (instead of calling handleVendorPaymentTermChange per field)
//   //   setVendorPaymentTermsDetails(updatedRows);
//   //   handlesSaveVendorPaymentTerms(true, updatedRows);
//   // };

//   // const recalculateAllCustomerPaymentTermValues = () => {
//   //   const updatedRows = customerPaymentTermsDetails.map((row) => {
//   //     // Skip rows with no particular selected
//   //     if (!row.customerpaymentTermsParticular || row.customerpaymentTermsParticular.trim() === "") {
//   //       return row;
//   //     }

//   //     // Match the selected particular to get updated selling price
//   //     const matchedFTRows = paymentTermsNonTotalRows.filter(
//   //       (selectedRow) => selectedRow.name === row.customerpaymentTermsParticular
//   //     );

//   //     if (!matchedFTRows.length) return row;

//   //     const selectedRowSellingValue = matchedFTRows[0].values[0].amount; // ✅ index 0 for selling price

//   //     const numericPercentage = Number(row.customerpaymentTermsPercentage);

//   //     if (!row.customerpaymentTermsPercentage || isNaN(numericPercentage)) {
//   //       return row;
//   //     }

//   //     // Same rounding logic as inline handler
//   //     const rawValue = (numericPercentage * Number(selectedRowSellingValue)) / 100;
//   //     const decimal = rawValue - Math.floor(rawValue);
//   //     const calculatedValue = decimal <= 0.5 ? Math.floor(rawValue) : Math.ceil(rawValue);

//   //     return { ...row, customerpaymentTermsValue: calculatedValue };
//   //   });

//   //   setCustomerPaymentTermsDetails(updatedRows);
//   //   handlesSaveCustomerPaymentTerms(true, updatedRows);
//   // };


//   // const crmOptions = crmData.map((item) => ({ label: item.crmNumber, value: item.crmNumber}));

//   return (
//     <>
//       <Navbar />
//       <Row className="mb-4 justify-content-between" data-row-name="logo & crmbutton">
//             <Col md="auto"></Col>
//             <Col md="auto"> <h1>Costsheet Enterprise Form</h1> </Col>
//             <Col md="auto"></Col>
//       </Row>
//       <div style={{ display: "flex", width: "100%" }}>
//         <Container className="pt-3" style={{ width: "75%", marginLeft: "25px" }}>
//             <Form className="">
//               {/* <Approval Form> */}
//               <section style={{ position: 'relative', paddingLeft: '15px', paddingRight: '15px', marginBottom: '25px' }}>

//                 {(sessionStorage.getItem('role') === 'SALES' || sessionStorage.getItem('role') === 'OPERATIONS') && sendForAppv === false && (
//                     <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
//                       <Col md="auto">
//                         <Button variant="primary" onClick={handleEdit}>
//                           Edit
//                         </Button>
//                       </Col>
//                       <Col md="auto">
//                         <Button variant="primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>
//                           Save
//                         </Button>
//                       </Col>
//                       <Col md="auto">
//                         <Button variant="primary" onClick={handleAppvUserValidation}>
//                           Send for Approval
//                         </Button>
//                       </Col>
//                     </Row>
//                 )}
//                 {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && sendForAppv === true)&& (
//                   <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
//                       <Col>
//                         {(appvTeamLeaderStatus === 'Rejected' ||
//                         appvBranchHeadStatus === 'Rejected' ||
//                         appvRegionBusinessHeadStatus === 'Rejected' ||
//                         appvBusinessFinanceStatus === 'Rejected' ||
//                         appvExportComplianceStatus === 'Rejected' ||
//                         appvCreditInsuranceStatus === 'Rejected' ||
//                         appvCEOStatus === 'Rejected' ||
//                         appvCFOStatus === 'Rejected' ||
//                         appvCOOStatus === 'Rejected' ||
//                         appvSVPDirectorStatus === 'Rejected' ||
//                         appvLegalHeadStatus === 'Rejected' ||
//                         appvDytCFOStatus === 'Rejected' ||
//                         mgmtappvRegionBusinessHeadStatus === 'Rejected' ||
//                         mgmtappvBusinessFinanceStatus === 'Rejected' ||
//                         mgmtappvCEOStatus === 'Rejected' ||
//                         mgmtappvCFOStatus === 'Rejected' ||
//                         mgmtappvCOOStatus === 'Rejected' ||
//                         appvFunctionalHeadStatus === 'Rejected' ||
//                         appvFunctionalHead2Status === 'Rejected' ||
//                         appvFunctionalHead3Status === 'Rejected' ||
//                         appvFunctionalHead4Status === 'Rejected' ||
//                         appvFunctionalHead5Status === 'Rejected' ||
//                         appvFunctionalHead6Status === 'Rejected') && (
//                           <Button variant="outline-danger" onClick={handleShowReopenModal}>
//                             Reopen CostSheet
//                           </Button>
//                         )}

//                         {formReopenCount > 0 && (<p style={{ padding: "2px" }}><b>Form Reopen Count: {formReopenCount}</b></p>)}

//                       </Col>
//                       <Col md="auto">
//                         <Button variant="outline-primary" onClick={handleEdit}>
//                           Edit
//                         </Button>
//                       </Col>
//                       <Col md="auto">
//                         <Button variant="outline-primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>
//                           Save
//                         </Button>
//                       </Col>
//                       <Col md="auto">
//                         <Button variant="outline-primary" onClick={handleAdminAppvVal}>
//                           Send for Approval
//                         </Button>
//                       </Col>
//                     </Row>
//                 )}
//                 { (sessionStorage.getItem('role') === 'TEAM LEADER' && (salesPersonID === '' || salesPersonID == null || salesPersonID === sessionStorage.getItem('userId')) && sendForAppv === false) && (
//                         <Row className="mt-4 mb-4 justify-content-between" data-row-name="save, edit and submit button">
//                         <Col md="auto">
//                             <Button variant="primary" onClick={handleEdit}>Edit</Button>
//                         </Col>
//                         <Col md="auto">
//                             <Button variant="primary" onClick={(e) => handleAutoSave({ event: e, fromButton: true })}>Save</Button>
//                         </Col>
//                         <Col md="auto">
//                             <Button variant="primary" onClick={handleAppvUserValidation}>Send for Approval</Button>
//                         </Col>
//                         </Row>
//                 )}
//                 {/* { (sessionStorage.getItem('role') === 'TEAM LEADER' && (salesPersonID !== sessionStorage.getItem('userId')) && sendForAppv === true) && (
//                         !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 { (sessionStorage.getItem('role') === 'BRANCH HEAD' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 { (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )} */}
//                 {(sessionStorage.getItem('role') === 'TEAM LEADER' || sessionStorage.getItem('role') === 'BRANCH HEAD' || sessionStorage.getItem('role') === 'REGION BUSINESS HEAD') && (salesPersonID !== sessionStorage.getItem('userId') && sendForAppv === true) && (
//                     <>
//                     {/* ((sessionStorage.getItem('userId') === appvTeamLeaderId && appvTeamLeaderReq === "YES" && appvTeamLeaderStatus === "Pending") || 
//                         (sessionStorage.getItem('userId') === appvBranchHeadId && appvBranchHeadReq === "YES" && appvBranchHeadStatus === "Pending") ||
//                         (sessionStorage.getItem('userId') === appvRegionBusinessHeadId && appvRegionBusinessHeadReq === "YES" && appvRegionBusinessHeadStatus === "Pending")) */}
                      
//                       {((sessionStorage.getItem('userId') === appvTeamLeaderId && appvTeamLeaderReq === "YES") || 
//                         (sessionStorage.getItem('userId') === appvBranchHeadId && appvBranchHeadReq === "YES") ||
//                         (sessionStorage.getItem('userId') === appvRegionBusinessHeadId && appvRegionBusinessHeadReq === "YES")) && (
//                         !showThankYou ? (
//                           <>
//                             <Col className="d-flex justify-content-center pt-3">
//                               <h3>Please provide feedback for Enterprise CostSheet</h3>
//                             </Col>

//                             <Row className="pt-4 justify-content-center">
//                               <InputGroup>
//                                 <Form.Control type="text" placeholder="Approval message" value={approvalMessage} onChange={(e) => setApprovalMessage(e.target.value)}/>
//                                 <Button variant="success" onClick={handleApprove} >Approve</Button>
//                               </InputGroup>
//                             </Row>

//                             <Row className="pt-4 pb-4 justify-content-center">
//                               <InputGroup>
//                                 <Form.Control type="text" placeholder="Rejection message" value={rejectionMessage} onChange={(e) => setRejectionMessage(e.target.value)}/>
//                                 <Button variant="danger" onClick={handleReject}>Reject</Button>
//                               </InputGroup>
//                             </Row>
//                           </>
//                         ) : (
//                           <div className="pt-5 pb-2">
//                             <Col className="d-flex justify-content-center pb-5">
//                               <h1 style={{ color: 'Green' }}>
//                                 {response}
//                               </h1>
//                             </Col>
//                           </div>
//                         )
//                       )}
//                     </>
//                 )}
//                 { (sessionStorage.getItem('role') === 'EXPORT COMPLIANCE' && appvExportComplianceReq === 'YES' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 {(sessionStorage.getItem('role') === 'CREDIT INSURANCE' && appvCreditInsuranceReq === 'YES' && sendForAppv === true) && (
//                     <>
//                       {!showThankYou ? (
//                         <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                             <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                             <InputGroup>
//                               <Form.Control type="text" placeholder="Approval message" value={approvalMessage} onChange={(e) => setApprovalMessage(e.target.value)}/>
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                             </InputGroup>
//                           </Row>
//                           <Row className="pt-4 justify-content-center">
//                             <InputGroup>
//                               <Form.Control type="text" placeholder="Rejection message" value={rejectionMessage} onChange={(e) => setRejectionMessage(e.target.value)}/>
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                             </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                             <InputGroup>
//                               <Form.Control type="text" placeholder="Management Approval Message" value={appvCIMessage} onChange={(e) => setAppvCIMessage(e.target.value)} />
//                               <Button variant="warning" onClick={handleCreditInsuranceApproval}>Management Approval Required</Button>
//                             </InputGroup>
//                           </Row>
//                         </>
//                       ) : (
//                         <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                             <h1 style={{ color: 'Green' }} >{response}</h1>
//                           </Col>
//                         </div>
//                       )}
//                     </>
//                 )}
//                 { (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceReq === 'YES' && sendForAppv === true) && (
//                     !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 { (sessionStorage.getItem('role') === 'CFO' && appvCFOReq === 'YES' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 { (sessionStorage.getItem('role') === 'CEO' && appvCEOReq === 'YES' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 { (sessionStorage.getItem('role') === 'COO' && appvCOOReq === 'YES' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 { (sessionStorage.getItem('role') === 'SVP-DIRECTOR' && appvSVPDirectorReq === 'YES' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 { (sessionStorage.getItem('role') === 'LEGAL HEAD' && appvlegalHeadReq === 'YES' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 { (sessionStorage.getItem('role') === 'DYT-CFO' && appvDytCFOReq === 'YES' && sendForAppv === true) && (
//                       !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead1ID === sessionStorage.getItem('userId') && appvFunctionalHeadReq === 'YES'  && sendForAppv === true) && (
//                   !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead2ID === sessionStorage.getItem('userId') && appvFunctionalHead2Req === 'YES'  && sendForAppv === true) && (
//                   !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead3ID === sessionStorage.getItem('userId') && appvFunctionalHead3Req === 'YES'  && sendForAppv === true) && (
//                   !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead4ID === sessionStorage.getItem('userId') && appvFunctionalHead4Req === 'YES'  && sendForAppv === true) && (
//                   !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead5ID === sessionStorage.getItem('userId') && appvFunctionalHead5Req === 'YES'  && sendForAppv === true) && (
//                   !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}
//                 {(sessionStorage.getItem('role') === 'FUNCTIONAL HEAD' && functionalHead6ID === sessionStorage.getItem('userId') && appvFunctionalHead6Req === 'YES'  && sendForAppv === true) && (
//                   !showThankYou ? (
//                       <>
//                           <Col className='d-flex justify-content-center pt-3'>
//                           <h3>Please provide feedback for Enterprise CostSheet</h3>
//                           </Col>
//                           <Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Approval message"
//                               value={approvalMessage}
//                               onChange={(e) => setApprovalMessage(e.target.value)}
//                               />
//                               <Button variant="success" onClick={handleApprove}>Approve</Button>
//                           </InputGroup>
//                           </Row>
//                           <Row className="pt-4 pb-4 justify-content-center">
//                           <InputGroup>
//                               <Form.Control
//                               type="text"
//                               placeholder="Rejection message"
//                               value={rejectionMessage}
//                               onChange={(e) => setRejectionMessage(e.target.value)}
//                               />
//                               <Button variant="danger" onClick={handleReject}>Reject</Button>
//                           </InputGroup>
//                           </Row>
//                       </>
//                       ) : (
//                       <div className='pt-5 pb-2'>
//                           <Col className='d-flex justify-content-center pb-5'>
//                           <h1 style={{ color: 'Green' }}>{response}</h1>
//                           </Col>
//                       </div>
//                       )
//                 )}

//                 {!showMGMTThankYou ? (
//                     <>
//                       {((sessionStorage.getItem('role') === 'TEAM LEADER' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'BRANCH HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && mgmtappvBusinessFinanceReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'CEO' && appvCEOId === sessionStorage.getItem('userId') && mgmtappvCEOReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'CFO' && appvCFOId === sessionStorage.getItem('userId') && mgmtappvCFOReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'COO' && appvCOOId === sessionStorage.getItem('userId') && mgmtappvCOOReq === 'YES'))&& (mgmtApprovalRequire === 'YES') && (<Col className="d-flex flex-column align-items-center pt-4 mt-4">
//                         <h3>Please provide management feedback for Credit Insurance Risk</h3>
//                         <h6>(For Credit Insurance Check) Reason: <span style={{ fontWeight: 400, background: "lightcoral" }}>{ciMgmtReason}</span></h6>
//                       </Col>)}

//                       {((sessionStorage.getItem('role') === 'TEAM LEADER' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'BRANCH HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && mgmtappvBusinessFinanceReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'CEO' && appvCEOId === sessionStorage.getItem('userId') && mgmtappvCEOReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'CFO' && appvCFOId === sessionStorage.getItem('userId') && mgmtappvCFOReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'COO' && appvCOOId === sessionStorage.getItem('userId') && mgmtappvCOOReq === 'YES')) && (mgmtApprovalRequire === 'YES') && (<Row className="pt-4 justify-content-center">
//                           <InputGroup>
//                             <Form.Control type="text" placeholder="Management approval message" value={mgmtApprovalMessage} onChange={(e) => setMgmtApprovalMessage(e.target.value)} />
//                             <Button variant="success" onClick={handleManagementApproval}>Approve</Button>
//                           </InputGroup>
//                       </Row>)}
                      
//                       {((sessionStorage.getItem('role') === 'TEAM LEADER' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'BRANCH HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && mgmtappvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && mgmtappvBusinessFinanceReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'CEO' && appvCEOId === sessionStorage.getItem('userId') && mgmtappvCEOReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'CFO' && appvCFOId === sessionStorage.getItem('userId') && mgmtappvCFOReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'COO' && appvCOOId === sessionStorage.getItem('userId') && mgmtappvCOOReq === 'YES')) && (mgmtApprovalRequire === 'YES') && (<Row className="pt-4 mb-4 pb-4 justify-content-center">
//                         <InputGroup>
//                           <Form.Control type="text" placeholder="Management rejection message" value={mgmtRejectionMessage} onChange={(e) => setMgmtRejectionMessage(e.target.value)} />
//                           <Button variant="danger" onClick={handleManagementReject}>Reject</Button>
//                         </InputGroup>
//                       </Row>)}
//                     </>
//                   ) : (<>
//                     {((sessionStorage.getItem('role') === 'TEAM LEADER' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && appvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'BRANCH HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && appvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'REGION BUSINESS HEAD' && appvRegionBusinessHeadId === sessionStorage.getItem('userId') && appvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'BUSINESS FINANCE' && appvBusinessFinanceId === sessionStorage.getItem('userId') && appvRegionBusinessHeadReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'CEO' && appvCEOId === sessionStorage.getItem('userId') && appvCEOReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'CFO' && appvCFOId === sessionStorage.getItem('userId') && appvCFOReq === 'YES') || 
//                     (sessionStorage.getItem('role') === 'COO' && appvCOOId === sessionStorage.getItem('userId') && appvCOOReq === 'YES')) && (mgmtApprovalRequire === 'YES') && (<div className="pt-5 mb-4 mt-5">
//                       <Col className="d-flex justify-content-center pb-5">
//                         <h1 style={{ color: "Green" }}>{mgmtResponse}</h1>
//                       </Col>
//                     </div>)}
//                     </>
//                 )}
      
//               </section>
              
//               {/* <Approval Table and Modals> */}
//               <section style={{ position: 'relative', paddingLeft: '15px', paddingRight: '15px', marginBottom: '25px' }}>

//                 {appvCreditInsuranceReq === 'YES' && <>
//                   <Row className="mt-4 mb-1" data-row-name="Approvers-head">
//                       <Col md="" style={{ fontWeight: 'bold' }}>
//                         Approval Required:
//                       </Col>
//                   </Row>

//                   <Row className="mb-1" data-row-name="Approvers-common">
//                     {appvTeamLeaderReq === 'YES' && (
//                       <>
//                         <Col
//                           id="teamLeader"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvTeamLeaderStatus === 'Approved'
//                               ? 'green'
//                               : appvTeamLeaderStatus === 'Rejected'
//                                 ? 'red'
//                                 : 'inherit',
//                             backgroundColor: appvTeamLeaderStatus === 'Approved'
//                               ? 'lightgreen'
//                               : appvTeamLeaderStatus === 'Rejected'
//                                 ? 'lightcoral'
//                                 : 'inherit',
//                           }}
//                         >
//                           TEAM LEADER
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={teamLeaderTooltip}
//                           target="teamLeader"
//                           toggle={() => setTeamLeaderTooltip(!teamLeaderTooltip)}
//                           autohide={false}
//                         >
//                           {appvTeamLeaderMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvBranchHeadReq === 'YES' && (
//                       <>
//                         <Col
//                           id="branchHead"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvBranchHeadStatus === 'Approved'
//                               ? 'green'
//                               : appvBranchHeadStatus === 'Rejected'
//                                 ? 'red'
//                                 : 'inherit',
//                             backgroundColor: appvBranchHeadStatus === 'Approved'
//                               ? 'lightgreen'
//                               : appvBranchHeadStatus === 'Rejected'
//                                 ? 'lightcoral'
//                                 : 'inherit',
//                           }}
//                         >
//                           BRANCH HEAD
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={branchHeadTooltip}
//                           target="branchHead"
//                           toggle={() => setBranchHeadTooltip(!branchHeadTooltip)}
//                           autohide={false}
//                         >
//                           {appvBranchHeadMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvRegionBusinessHeadReq === 'YES' && (
//                       <>
//                         <Col
//                           id="regionBusinessHead"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvRegionBusinessHeadStatus === 'Approved'
//                               ? 'green'
//                               : appvRegionBusinessHeadStatus === 'Rejected'
//                                 ? 'red'
//                                 : 'inherit',
//                             backgroundColor: appvRegionBusinessHeadStatus === 'Approved'
//                               ? 'lightgreen'
//                               : appvRegionBusinessHeadStatus === 'Rejected'
//                                 ? 'lightcoral'
//                                 : 'inherit',
//                           }}
//                         >
//                           REGION BUSINESS HEAD
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={regionBusinessHeadTooltip}
//                           target="regionBusinessHead"
//                           toggle={() => setRegionBusinessHeadTooltip(!regionBusinessHeadTooltip)}
//                           autohide={false}
//                         >
//                           {appvRegionBusinessHeadMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvBusinessFinanceReq === 'YES' && (
//                       <>
//                         <Col
//                           id="businessFinance"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvBusinessFinanceStatus === 'Approved'
//                               ? 'green'
//                               : appvBusinessFinanceStatus === 'Rejected'
//                                 ? 'red'
//                                 : 'inherit',
//                             backgroundColor: appvBusinessFinanceStatus === 'Approved'
//                               ? 'lightgreen'
//                               : appvBusinessFinanceStatus === 'Rejected'
//                                 ? 'lightcoral'
//                                 : 'inherit',
//                           }}
//                         >
//                           BUSINESS FINANCE
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={businessFinanceTooltip}
//                           target="businessFinance"
//                           toggle={() => setBusinessFinanceTooltip(!businessFinanceTooltip)}
//                           autohide={false}
//                         >
//                           {appvBusinessFinanceMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvCreditInsuranceReq === 'YES' && (
//                       <>
//                         <Col
//                           id="creditInsurance"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color:
//                               appvCreditInsuranceStatus === 'Approved'
//                                 ? 'green'
//                                 : appvCreditInsuranceStatus === 'Rejected'
//                                   ? 'red'
//                                   : appvCreditInsuranceStatus === 'Management Approval'
//                                     ? 'orange'
//                                     : 'inherit',
//                             backgroundColor:
//                               appvCreditInsuranceStatus === 'Approved'
//                                 ? 'lightgreen'
//                                 : appvCreditInsuranceStatus === 'Rejected'
//                                   ? 'lightcoral'
//                                   : appvCreditInsuranceStatus === 'Management Approval'
//                                     ? 'olivedrab'
//                                     : 'inherit',
//                           }}
//                         >
//                           CREDIT INSURANCE
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={creditInsuranceTooltip}
//                           target="creditInsurance"
//                           toggle={() => setCreditInsuranceTooltip(!creditInsuranceTooltip)}
//                           autohide={false}
//                         >
//                           {appvCreditInsuranceMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                   </Row>
//                   <Row className="mb-1" data-row-name="Approvers-condition">
//                     {appvExportComplianceReq === 'YES' && (
//                       <>
//                         <Col
//                           id="exportCompliance"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvExportComplianceStatus === 'Approved' ? 'green' :
//                                   appvExportComplianceStatus === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvExportComplianceStatus === 'Approved' ? 'lightgreen' :
//                                             appvExportComplianceStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           EXPORT COMPLIANCE
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={exportComplianceTooltip}
//                           target="exportCompliance"
//                           toggle={() => setExportComplianceTooltip(!exportComplianceTooltip)}
//                           autohide={false}
//                         >
//                           {appvExportComplianceMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvCFOReq === 'YES' && (
//                       <>
//                         <Col
//                           id="cfo"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvCFOStatus === 'Approved' ? 'green' :
//                                   appvCFOStatus === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvCFOStatus === 'Approved' ? 'lightgreen' :
//                                             appvCFOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           CFO
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={cfoTooltip}
//                           target="cfo"
//                           toggle={() => setCfoTooltip(!cfoTooltip)}
//                           autohide={false}
//                         >
//                           {appvCFOMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvCEOReq === 'YES' && (
//                       <>
//                         <Col
//                           id="ceo"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvCEOStatus === 'Approved' ? 'green' :
//                                   appvCEOStatus === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvCEOStatus === 'Approved' ? 'lightgreen' :
//                                             appvCEOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           CEO
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={ceoTooltip}
//                           target="ceo"
//                           toggle={() => setCeoTooltip(!ceoTooltip)}
//                           autohide={false}
//                         >
//                           {appvCEOMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvCOOReq === 'YES' && (
//                       <>
//                         <Col
//                           id="coo"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvCOOStatus === 'Approved' ? 'green' :
//                                   appvCOOStatus === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvCOOStatus === 'Approved' ? 'lightgreen' :
//                                             appvCOOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           COO
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={cooTooltip}
//                           target="coo"
//                           toggle={() => setCooTooltip(!cooTooltip)}
//                           autohide={false}
//                         >
//                           {appvCOOMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvSVPDirectorReq === 'YES' && (
//                       <>
//                         <Col
//                           id="svpDirector"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvSVPDirectorStatus === 'Approved' ? 'green' :
//                                   appvSVPDirectorStatus === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvSVPDirectorStatus === 'Approved' ? 'lightgreen' :
//                                             appvSVPDirectorStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           SVP-DIRECTOR
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={svpDirectorTooltip}
//                           target="svpDirector"
//                           toggle={() => setSvpDirectorTooltip(!svpDirectorTooltip)}
//                           autohide={false}
//                         >
//                           {appvSVPDirectorMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvlegalHeadReq === 'YES' && (
//                       <>
//                         <Col
//                           id="legalHead"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvLegalHeadStatus === 'Approved' ? 'green' :
//                                   appvLegalHeadStatus === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvLegalHeadStatus === 'Approved' ? 'lightgreen' :
//                                             appvLegalHeadStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           LEGAL HEAD
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={legalHeadTooltip}
//                           target="legalHead"
//                           toggle={() => setLegalHeadTooltip(!legalHeadTooltip)}
//                           autohide={false}
//                         >
//                           {appvLegalHeadMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvDytCFOReq === 'YES' && (
//                       <>
//                         <Col
//                           id="dytCfo"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvDytCFOStatus === 'Approved' ? 'green' :
//                                   appvDytCFOStatus === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvDytCFOStatus === 'Approved' ? 'lightgreen' :
//                                             appvDytCFOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           DYT-CFO
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={dytCfoTooltip}
//                           target="dytCfo"
//                           toggle={() => setDytCfoTooltip(!dytCfoTooltip)}
//                           autohide={false}
//                         >
//                           {appvDytCFOMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                   </Row>
//                   <Row className="mb-1" data-row-name="Approvers-condition">
//                     {appvFunctionalHeadReq === 'YES' && (
//                       <>
//                         <Col
//                           id="functionalHead1"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvFunctionalHeadStatus === 'Approved' ? 'green' :
//                                   appvFunctionalHeadStatus === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvFunctionalHeadStatus === 'Approved' ? 'lightgreen' :
//                                             appvFunctionalHeadStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           FUNCTIONAL HEAD - 1
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={functionalHead1Tooltip}
//                           target="functionalHead1"
//                           toggle={() => setFunctionalHead1Tooltip(!functionalHead1Tooltip)}
//                           autohide={false}
//                         >
//                           {appvFunctionalHeadMessage}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvFunctionalHead2Req === 'YES' && (
//                       <>
//                         <Col
//                           id="functionalHead2"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvFunctionalHead2Status === 'Approved' ? 'green' :
//                                   appvFunctionalHead2Status === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvFunctionalHead2Status === 'Approved' ? 'lightgreen' :
//                                             appvFunctionalHead2Status === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           FUNCTIONAL HEAD - 2
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={functionalHead2Tooltip}
//                           target="functionalHead2"
//                           toggle={() => setFunctionalHead2Tooltip(!functionalHead2Tooltip)}
//                           autohide={false}
//                         >
//                           {appvFunctionalHead2Message}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvFunctionalHead3Req === 'YES' && (
//                       <>
//                         <Col
//                           id="functionalHead3"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvFunctionalHead3Status === 'Approved' ? 'green' :
//                                   appvFunctionalHead3Status === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvFunctionalHead3Status === 'Approved' ? 'lightgreen' :
//                                             appvFunctionalHead3Status === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           FUNCTIONAL HEAD - 3
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={functionalHead3Tooltip}
//                           target="functionalHead3"
//                           toggle={() => setFunctionalHead3Tooltip(!functionalHead3Tooltip)}
//                           autohide={false}
//                         >
//                           {appvFunctionalHead3Message}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvFunctionalHead4Req === 'YES' && (
//                       <>
//                         <Col
//                           id="functionalHead4"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvFunctionalHead4Status === 'Approved' ? 'green' :
//                                   appvFunctionalHead4Status === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvFunctionalHead4Status === 'Approved' ? 'lightgreen' :
//                                             appvFunctionalHead4Status === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           FUNCTIONAL HEAD - 4
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={functionalHead4Tooltip}
//                           target="functionalHead4"
//                           toggle={() => setFunctionalHead4Tooltip(!functionalHead4Tooltip)}
//                           autohide={false}
//                         >
//                           {appvFunctionalHead4Message}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvFunctionalHead5Req === 'YES' && (
//                       <>
//                         <Col
//                           id="functionalHead5"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvFunctionalHead5Status === 'Approved' ? 'green' :
//                                   appvFunctionalHead5Status === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvFunctionalHead5Status === 'Approved' ? 'lightgreen' :
//                                             appvFunctionalHead5Status === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           FUNCTIONAL HEAD - 5
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={functionalHead5Tooltip}
//                           target="functionalHead5"
//                           toggle={() => setFunctionalHead5Tooltip(!functionalHead5Tooltip)}
//                           autohide={false}
//                         >
//                           {appvFunctionalHead5Message}
//                         </Tooltip>
//                       </>
//                     )}
//                     {appvFunctionalHead6Req === 'YES' && (
//                       <>
//                         <Col
//                           id="functionalHead6"
//                           md=""
//                           style={{
//                             fontWeight: 'bold',
//                             border: '1px solid black',
//                             textAlign: 'center',
//                             cursor: 'pointer',
//                             color: appvFunctionalHead6Status === 'Approved' ? 'green' :
//                                   appvFunctionalHead6Status === 'Rejected' ? 'red' : 'inherit',
//                             backgroundColor: appvFunctionalHead6Status === 'Approved' ? 'lightgreen' :
//                                             appvFunctionalHead6Status === 'Rejected' ? 'lightcoral' : 'inherit',
//                           }}
//                         >
//                           FUNCTIONAL HEAD - 6
//                         </Col>

//                         <Tooltip
//                           placement="top"
//                           isOpen={functionalHead6Tooltip}
//                           target="functionalHead6"
//                           toggle={() => setFunctionalHead6Tooltip(!functionalHead6Tooltip)}
//                           autohide={false}
//                         >
//                           {appvFunctionalHead6Message}
//                         </Tooltip>
//                       </>
//                     )}
//                   </Row>
//                 </>
//                 }

//                 {appvCreditInsuranceStatus === 'Management Approval' && <>
//                   <Row className="mb-1" data-row-name="Management Approvers-head">
//                     <Col md="" style={{ fontWeight: 'bold' }}>
//                       Management Approval Required:
//                     </Col>
//                   </Row>
//                   {/* <Row className="mb-1" data-row-name="Management Approvals">
//                     <Col md="" style={{
//                       fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
//                       color: mgmtappvRegionBusinessHeadStatus === 'Approved' ? 'green' : mgmtappvRegionBusinessHeadStatus === 'Rejected' ? 'red' : 'inherit',
//                       backgroundColor: mgmtappvRegionBusinessHeadStatus === 'Approved' ? 'lightgreen' : mgmtappvRegionBusinessHeadStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                     }}>
//                       REGION BUSINESS HEAD
//                     </Col>
//                     <Col md="" style={{
//                       fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
//                       color: mgmtappvBusinessFinanceStatus === 'Approved' ? 'green' : mgmtappvBusinessFinanceStatus === 'Rejected' ? 'red' : 'inherit',
//                       backgroundColor: mgmtappvBusinessFinanceStatus === 'Approved' ? 'lightgreen' : mgmtappvBusinessFinanceStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                     }}>
//                       BUSINESS FINANCE
//                     </Col>
//                     <Col md="" style={{
//                       fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
//                       color: mgmtappvCEOStatus === 'Approved' ? 'green' : mgmtappvCEOStatus === 'Rejected' ? 'red' : 'inherit',
//                       backgroundColor: mgmtappvCEOStatus === 'Approved' ? 'lightgreen' : mgmtappvCEOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                     }}>
//                       CEO
//                     </Col>
//                     <Col md="" style={{
//                       fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
//                       color: mgmtappvCOOStatus === 'Approved' ? 'green' : mgmtappvCOOStatus === 'Rejected' ? 'red' : 'inherit',
//                       backgroundColor: mgmtappvCOOStatus === 'Approved' ? 'lightgreen' : mgmtappvCOOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                     }}>
//                       COO
//                     </Col>
//                     <Col md="" style={{
//                       fontWeight: 'bold', border: '1px solid black', textAlign: 'center',
//                       color: mgmtappvCFOStatus === 'Approved' ? 'green' : mgmtappvCFOStatus === 'Rejected' ? 'red' : 'inherit',
//                       backgroundColor: mgmtappvCFOStatus === 'Approved' ? 'lightgreen' : mgmtappvCFOStatus === 'Rejected' ? 'lightcoral' : 'inherit',
//                     }}>
//                       CFO
//                     </Col>
//                   </Row> */}
//                   <Row className="mb-1" data-row-name="Management Approvals">
//                     <>
//                       <Col
//                         id="mgmtRegionBusinessHead"
//                         md=""
//                         style={{
//                           fontWeight: 'bold',
//                           border: '1px solid black',
//                           textAlign: 'center',
//                           cursor: 'pointer',
//                           color: mgmtappvRegionBusinessHeadStatus === 'Approved'
//                             ? 'green'
//                             : mgmtappvRegionBusinessHeadStatus === 'Rejected'
//                               ? 'red'
//                               : 'inherit',
//                           backgroundColor: mgmtappvRegionBusinessHeadStatus === 'Approved'
//                             ? 'lightgreen'
//                             : mgmtappvRegionBusinessHeadStatus === 'Rejected'
//                               ? 'lightcoral'
//                               : 'inherit',
//                         }}
//                       >
//                         REGION BUSINESS HEAD
//                       </Col>

//                       <Tooltip
//                         placement="top"
//                         isOpen={mgmtRegionBusinessHeadTooltip}
//                         target="mgmtRegionBusinessHead"
//                         toggle={() => setMgmtRegionBusinessHeadTooltip(!mgmtRegionBusinessHeadTooltip)}
//                         autohide={false}
//                       >
//                         {mgmtappvRegionBusinessHeadMessage}
//                       </Tooltip>
//                     </>
//                     <>
//                       <Col
//                         id="mgmtBusinessFinance"
//                         md=""
//                         style={{
//                           fontWeight: 'bold',
//                           border: '1px solid black',
//                           textAlign: 'center',
//                           cursor: 'pointer',
//                           color: mgmtappvBusinessFinanceStatus === 'Approved'
//                             ? 'green'
//                             : mgmtappvBusinessFinanceStatus === 'Rejected'
//                               ? 'red'
//                               : 'inherit',
//                           backgroundColor: mgmtappvBusinessFinanceStatus === 'Approved'
//                             ? 'lightgreen'
//                             : mgmtappvBusinessFinanceStatus === 'Rejected'
//                               ? 'lightcoral'
//                               : 'inherit',
//                         }}
//                       >
//                         BUSINESS FINANCE
//                       </Col>

//                       <Tooltip
//                         placement="top"
//                         isOpen={mgmtBusinessFinanceTooltip}
//                         target="mgmtBusinessFinance"
//                         toggle={() => setMgmtBusinessFinanceTooltip(!mgmtBusinessFinanceTooltip)}
//                         autohide={false}
//                       >
//                         {mgmtappvBusinessFinanceMessage}
//                       </Tooltip>
//                     </>
//                     <>
//                       <Col
//                         id="mgmtCEO"
//                         md=""
//                         style={{
//                           fontWeight: 'bold',
//                           border: '1px solid black',
//                           textAlign: 'center',
//                           cursor: 'pointer',
//                           color: mgmtappvCEOStatus === 'Approved'
//                             ? 'green'
//                             : mgmtappvCEOStatus === 'Rejected'
//                               ? 'red'
//                               : 'inherit',
//                           backgroundColor: mgmtappvCEOStatus === 'Approved'
//                             ? 'lightgreen'
//                             : mgmtappvCEOStatus === 'Rejected'
//                               ? 'lightcoral'
//                               : 'inherit',
//                         }}
//                       >
//                         CEO
//                       </Col>

//                       <Tooltip
//                         placement="top"
//                         isOpen={mgmtCeoTooltip}
//                         target="mgmtCEO"
//                         toggle={() => setMgmtCeoTooltip(!mgmtCeoTooltip)}
//                         autohide={false}
//                       >
//                         {mgmtappvCEOMessage}
//                       </Tooltip>
//                     </>
//                     <>
//                       <Col
//                         id="mgmtCOO"
//                         md=""
//                         style={{
//                           fontWeight: 'bold',
//                           border: '1px solid black',
//                           textAlign: 'center',
//                           cursor: 'pointer',
//                           color: mgmtappvCOOStatus === 'Approved'
//                             ? 'green'
//                             : mgmtappvCOOStatus === 'Rejected'
//                               ? 'red'
//                               : 'inherit',
//                           backgroundColor: mgmtappvCOOStatus === 'Approved'
//                             ? 'lightgreen'
//                             : mgmtappvCOOStatus === 'Rejected'
//                               ? 'lightcoral'
//                               : 'inherit',
//                         }}
//                       >
//                         COO
//                       </Col>

//                       <Tooltip
//                         placement="top"
//                         isOpen={mgmtCooTooltip}
//                         target="mgmtCOO"
//                         toggle={() => setMgmtCooTooltip(!mgmtCooTooltip)}
//                         autohide={false}
//                       >
//                         {mgmtappvCOOMessage}
//                       </Tooltip>
//                     </>
//                     <>
//                       <Col
//                         id="mgmtCFO"
//                         md=""
//                         style={{
//                           fontWeight: 'bold',
//                           border: '1px solid black',
//                           textAlign: 'center',
//                           cursor: 'pointer',
//                           color: mgmtappvCFOStatus === 'Approved'
//                             ? 'green'
//                             : mgmtappvCFOStatus === 'Rejected'
//                               ? 'red'
//                               : 'inherit',
//                           backgroundColor: mgmtappvCFOStatus === 'Approved'
//                             ? 'lightgreen'
//                             : mgmtappvCFOStatus === 'Rejected'
//                               ? 'lightcoral'
//                               : 'inherit',
//                         }}
//                       >
//                         CFO
//                       </Col>

//                       <Tooltip
//                         placement="top"
//                         isOpen={mgmtCfoTooltip}
//                         target="mgmtCFO"
//                         toggle={() => setMgmtCfoTooltip(!mgmtCfoTooltip)}
//                         autohide={false}
//                       >
//                         {mgmtappvCFOMessage}
//                       </Tooltip>
//                     </>
//                   </Row>
//                 </>
//                 }

//                 {/* VENDOR PAYMENT TERM MODAL */}
//                 <Modal show={isVendorPaymentTermModalOpen} onHide={closeVendorPaymentTermModal} size="lg" centered>
//                   <Modal.Header closeButton>
//                     <Modal.Title>Vendor Payment Terms</Modal.Title>
//                   </Modal.Header>

//                   <Modal.Body>
//                     <Table bordered width="100%">
//                       <thead>
//                         <tr>
//                           <th>Particuars</th>
//                           <th>Days</th>
//                           <th>Percentage</th>
//                           <th>Value</th>
//                           <th> </th>
//                           {/* <th width="80">Action</th> */}
//                         </tr>
//                       </thead>
//                       <tbody>
//                         {vendorPaymentTermsDetails.map((row, i) => (
//                           <tr key={i}>
//                             <td>
//                               <Form.Select 
//                               value={row.vendorpayemntTermsParticular}
//                               disabled={isReadOnly}  
//                               onChange={(e) => {
//                                 const value = e.target.value;
//                                 handleVendorPaymentTermChange(i, "vendorpayemntTermsParticular", value);
//                                 }}
//                               aria-label="vendorpayemntTermsParticular">
//                                 <option value="" disabled>Select Any One</option>
//                               {paymentTermsNonTotalRows.map((row, index) => (
//                                   <option key={index} value={row.name}>{row.name}</option>
//                                 ))}
//                               </Form.Select>
//                             </td>
//                             <td>
//                             <Form.Control type="text" disabled={isReadOnly} inputMode="numeric" value={row.vendorpaymentTermsDays}
//                                 onChange={(e) => {const value = e.target.value;

//                                   // Allow empty OR digits only
//                                   if (/^\d*$/.test(value)) { handleVendorPaymentTermChange(i, "vendorpaymentTermsDays", value);}
//                                 }}
//                               />
//                             </td>
//                             <td>
//                               <Form.Control type="text" disabled={isReadOnly}  inputMode="decimal" value={row.vendorpaymentTermsPercentage}
//                                 onChange={async(e) => {
//                                   const value = e.target.value;
//                                   if (!row.vendorpayemntTermsParticular || row.vendorpayemntTermsParticular.trim() === "") {
//                                     toast.error("Please select particulars in vendor payment terms");
//                                     return;
//                                   }
//                                   // console.log('row.vendorpayemntTermsParticular', row.vendorpayemntTermsParticular);
//                                   const matchedFTRows = paymentTermsNonTotalRows.filter((selctedRow) => selctedRow.name === row.vendorpayemntTermsParticular);
//                                   // console.log('selctedRowmatchedFTRowsmatchedFTRows', matchedFTRows);
//                                   // console.log('selectedTransferPrice:::::::::::::::::::::::::', matchedFTRows[0].values[1].amount);
//                                   // console.log('selectedCurrency:::::::::::::::::::::::::', matchedFTRows[0].currency);
//                                   // console.log('selectedParticular:::::::::::::::::::::::::', matchedFTRows[0].name);

//                                   const selectedTransferPrice = matchedFTRows[0].values[1].amount;
//                                   const selectedCurrency = matchedFTRows[0].currency;
//                                   const selectedParticular = matchedFTRows[0].name;

//                                   const baseRate = await getRate(selectedCurrency);
//                                   const yearMultiplier = {
//                                     "Year 1": 1,        
//                                     "Year 2": 1.05,
//                                     "Year 3": 1.05 ** 2,
//                                     "Year 4": 1.05 ** 3,
//                                     "Year 5": 1.05 ** 4,
//                                     "Year 6": 1.05 ** 5,
//                                     "Year 7": 1.05 ** 6,
//                                   };
//                                   const multiplier = selectedCurrency !== "INR" ? (yearMultiplier[selectedParticular] ?? 1) : 1;
//                                   const effectiveRate = Number((baseRate * multiplier).toFixed(2));
//                                   // console.log('effectiveRate:::::::::::::::::::::::::', effectiveRate);
//                                   const effectivePrice = Math.trunc(selectedTransferPrice * effectiveRate)
//                                   // console.log('effectivePrice:::::::::::::::::::::::::', effectivePrice);

//                                   if (!/^\d+(\.\d{0,2})?$|^$/.test(value)) return;

//                                   const numericValue = value === "" ? 0 : Number(value);

//                                   const otherTotal = vendorPaymentTermsDetails.reduce((sum, r, index) => {
//                                     if (index === i) return sum;
//                                     const v = Number(r.vendorpaymentTermsPercentage);
//                                     return isNaN(v) ? sum : sum + v;
//                                   }, 0);

//                                   // if (otherTotal + numericValue > 100) {
//                                   //   return;
//                                   // }

//                                   const calculatedValue = value === ""
//                                     ? ""
//                                     : (() => {
//                                         // const rawValue = (numericValue * Number(selectedTransferPrice)) / 100;
//                                         const rawValue = (numericValue * Number(effectivePrice)) / 100;
//                                         const decimal = rawValue - Math.floor(rawValue);
//                                         return decimal <= 0.5 ? Math.floor(rawValue) : Math.ceil(rawValue);
//                                       })();

//                                   handleVendorPaymentTermChange(i, "vendorpaymentTermsPercentage", value);
//                                   handleVendorPaymentTermChange(i, "vendorpaymentTermsValue", calculatedValue);
//                                 }}
//                               />
//                             </td>
//                             <td>
//                               <Form.Control value={row.vendorpaymentTermsValue} disabled={isReadOnly} readOnly={true} 
//                               onChange={(e) => 
//                               handleVendorPaymentTermChange(i, "vendorpaymentTermsValue", e.target.value)
//                               } />
//                             </td>
//                             <td className="text-center">
//                               {i > 0 && (
//                                 <Button variant="danger" disabled={isReadOnly}  size="sm" onClick={() => deleteVendorPaymentTermRow(i)}>
//                                   <i class="fa-solid fa-trash"></i>
//                                 </Button>
//                               )}
//                             </td>
//                           </tr>
//                         ))}
//                       </tbody>
//                       </Table>
//                     <Row className="mt-2 align-items-center">
//                       <Col className="d-flex justify-content-between align-items-center">
//                         {totalVendorPaymentTermsValue < totalTransferPriceWithoutTotal && (<Button variant="secondary" disabled={isReadOnly} onClick={addVendorPaymentTermRow}>Add Row</Button>)}

//                         {totalVendorPaymentTermsValue > 0 && (
//                           <span style={{ fontWeight: "600", color: vendorPercentageShortfall == 0 ? "green" : vendorPercentageShortfall > 0 ? "orange" : "red",}}>
//                             Total Percentage: {totalVendorPaymentTermsPercentage}%

//                             {vendorPercentageShortfall < 0 && (
//                               <> (Shortfall: {Math.abs(vendorPercentageShortfall)}%)</>
//                             )}

//                             {vendorPercentageShortfall > 0 && (
//                               <> (Exceeds by {vendorPercentageShortfall}%)</>
//                             )}
//                           </span>
//                         )}
//                       </Col>
//                     </Row>
//                   </Modal.Body>

//                   <Modal.Footer>
//                     {totalVendorPaymentTermsValue <= totalTransferPriceWithoutTotal && (
//                       <>
//                         <Button variant="primary" disabled={isReadOnly} 
//                           onClick={(e) => {
//                             handlesSaveVendorPaymentTerms(true);
//                             handleAutoSave({ event: e, fromButton: false });
//                         }}>Save</Button>
//                       <Button variant="outline-secondary" disabled={isReadOnly} onClick={closeVendorPaymentTermModal}>Cancel</Button>
//                       </>
//                     )}
//                   </Modal.Footer>
//                 </Modal>
              
//                 {/* CUSTOMER PAYMENT TERM MODAL */}
//                 <Modal show={isCustomerPaymentTermModalOpen} onHide={closeCustomerPaymentTermModal} size="lg" centered>
//                   <Modal.Header closeButton>
//                     <Modal.Title>Customer Payment Terms</Modal.Title>
//                   </Modal.Header>

//                   <Modal.Body>
//                     <Table bordered width="100%">
//                       <thead>
//                         <tr>
//                           <th>Particuars</th>
//                           <th>Days</th>
//                           <th>Percentage</th>
//                           <th>Value</th>
//                           <th> </th>
//                           {/* <th width="80">Action</th> */}
//                         </tr>
//                       </thead>
//                       <tbody>
//                       {customerPaymentTermsDetails.map((row, i) => (
//                         <tr key={i}>
//                           <td>
//                             <Form.Select value={row.customerpaymentTermsParticular} 
//                             disabled={isReadOnly}
//                             onChange={(e) => {
//                               const value = e.target.value;
//                               handleCustomerPaymentTermChange(i, "customerpaymentTermsParticular", value);
//                               }}
//                             aria-label="customerpaymentTermsParticular">
//                               <option value="" disabled>Select Any One</option>
//                             {paymentTermsNonTotalRows.map((row, index) => (
//                                 <option key={index} value={row.name}>{row.name}</option>
//                               ))}
//                             </Form.Select>
//                           </td>
//                           <td>
//                             <Form.Control type="text" disabled={isReadOnly} inputMode="numeric" value={row.customerpaymentTermsDays}
//                               onChange={(e) => {
//                                 const value = e.target.value;
//                                 // Allow empty OR digits only
//                                 if (/^\d*$/.test(value)) {handleCustomerPaymentTermChange(i, "customerpaymentTermsDays", value);}
//                               }}
//                             />
//                           </td>
//                           <td>
//                             <Form.Control type="text" disabled={isReadOnly} inputMode="decimal" value={row.customerpaymentTermsPercentage}
//                               onChange={async(e) => {
//                                 const value = e.target.value;
//                                 if (!row.customerpaymentTermsParticular || row.customerpaymentTermsParticular.trim() === "") {
//                                   toast.error("Please select particulars in customer payment terms");
//                                   return;
//                                 }

//                                 const matchedFTRows = paymentTermsNonTotalRows.filter((selctedRow) => selctedRow.name === row.customerpaymentTermsParticular);
//                                 // console.log('selctedRowmatchedFTRowsmatchedFTRows', matchedFTRows);
//                                 //  console.log('selectedSellingValue:::::::::::::::::::::::::', matchedFTRows[0].values[0].amount);
//                                 //  console.log('selectedCurrency:::::::::::::::::::::::::', matchedFTRows[0].currency);
//                                 //  console.log('selectedParticular:::::::::::::::::::::::::', matchedFTRows[0].name);
                                
//                                 const selectedSellingValue = matchedFTRows[0].values[0].amount;
//                                 const selectedCurrency = matchedFTRows[0].currency;
//                                 const selectedParticular = matchedFTRows[0].name;

//                                 const baseRate = await getRate(selectedCurrency);
//                                 const yearMultiplier = {
//                                 "Year 1": 1,        
//                                 "Year 2": 1.05,
//                                 "Year 3": 1.05 ** 2,
//                                 "Year 4": 1.05 ** 3,
//                                 "Year 5": 1.05 ** 4,
//                                 "Year 6": 1.05 ** 5,
//                                 "Year 7": 1.05 ** 6,
//                                 };

//                                 const multiplier = selectedCurrency !== "INR" ? (yearMultiplier[selectedParticular] ?? 1) : 1;
//                                 const effectiveRate = Number((baseRate * multiplier).toFixed(2));
//                                 // console.log('effectiveRate:::::::::::::::::::::::::', effectiveRate);
//                                 const effectivePrice = Math.trunc(selectedSellingValue * effectiveRate)
//                                 // console.log('effectivePrice:::::::::::::::::::::::::', effectivePrice);

//                                 if (!/^\d+(\.\d{0,2})?$|^$/.test(value)) return; // Allow only digits(also upto 2 decimal) or empty
                                
//                                 const numericValue = value === "" ? 0 : Number(value);
                                
//                                 // Calculate total excluding current row
//                                 const otherTotal = customerPaymentTermsDetails.reduce((sum, r, index) => {
//                                     if (index === i) return sum;
//                                     const v = Number(r.customerpaymentTermsPercentage);
//                                     return isNaN(v) ? sum : sum + v;
//                                   },0);

//                                 // Block update if total exceeds 100
//                                 // if (otherTotal + numericValue > 100) {
//                                 //   return;
//                                 // }


//                                 const calculatedValue = value === "" 
//                                   ? "" 
//                                   : (() => {
//                                       // const rawValue = (numericValue * Number(selectedRowSellingValue)) / 100;
//                                       const rawValue = (numericValue * Number(effectivePrice)) / 100;
//                                       const decimal = rawValue - Math.floor(rawValue);
//                                       return decimal <= 0.5 ? Math.floor(rawValue) : Math.ceil(rawValue);
//                                     })();


//                                 // Update percentage
//                                 handleCustomerPaymentTermChange( i, "customerpaymentTermsPercentage", value );

//                                 // Update calculated value in state
//                                 handleCustomerPaymentTermChange( i, "customerpaymentTermsValue", calculatedValue );
//                               }}
//                             />
//                           </td>
//                           <td>
//                             <Form.Control disabled={isReadOnly} value={row.customerpaymentTermsValue} readOnly={true} />
//                           </td>
//                           <td className="text-center">
//                             {i > 0 && (
//                               <Button
//                                 variant="danger"
//                                 size="sm"
//                                 disabled={isReadOnly}
//                                 onClick={() => deleteCustomerPaymentTermRow(i)}
//                               >
//                                 <i className="fa-solid fa-trash"></i>
//                               </Button>
//                             )}
//                           </td>
//                         </tr>
//                       ))}
//                     </tbody>
//                     </Table>
                  
//                     <Row className="mt-2 align-items-center">
//                       <Col className="d-flex justify-content-between align-items-center">
//                         {totalCustomerPaymentTermsValue < totalSellingValueWithoutTotal && (
//                           <Button variant="secondary" disabled={isReadOnly} onClick={addCustomerPaymentTermRow}>
//                             Add Row
//                           </Button>
//                         )}
//                         {totalCustomerPaymentTermsValue > 0 && (
//                           <span style={{ fontWeight: "600", color: customerPercentageShortfall == 0 ? "green" : customerPercentageShortfall > 0 ? "orange" : "red" }}>
//                             Total Percentage: {totalCustomerPaymentTermsPercentage}%
//                             {customerPercentageShortfall < 0 && (<> (Shortfall: {Math.abs(customerPercentageShortfall)}%)</>)}
//                             {customerPercentageShortfall > 0 && (<> (Exceeds by {customerPercentageShortfall}%)</>)}
//                           </span>
//                         )}
//                       </Col>
//                     </Row>
//                   </Modal.Body>

//                   <Modal.Footer>
//                     {totalCustomerPaymentTermsValue <= totalSellingValueWithoutTotal && (
//                     <>
//                       <Button variant="primary" disabled={isReadOnly} onClick={(e) => {
//                           handlesSaveCustomerPaymentTerms(true);
//                           handleAutoSave({ event: e, fromButton: false });
//                       }}>Save</Button>
//                       <Button variant="outline-secondary" disabled={isReadOnly} onClick={closeCustomerPaymentTermModal}>Cancel</Button>
//                     </>
//                     )}
//                   </Modal.Footer>
//                 </Modal>

//                 {/* Export Compliance Approval Component */}
//                 <Modal show={modalSentForAppv} onHide={handleCloseModal} size="xl" centered backdrop="static" keyboard={false}>
//                   <Modal.Header closeButton>
//                     <Modal.Title>
//                       {step === 1 ? 'Requirement of Export Compliance Approval' : 'Approval Mail Confirmation'}
//                     </Modal.Title>
//                   </Modal.Header>
//                   <Modal.Body>
//                     {step === 1 ? (
//                       <Form>
//                       <Table bordered responsive>
//                         <thead>
//                           <tr>
//                             <th>Sr. No.</th>
//                             <th>Particulars</th>
//                             <th>YES/NO</th>
//                           </tr>
//                         </thead>
//                         <tbody>
//                           {[
//                             ["End User & Billing Customer Name is Same", ques1, setQues1],
//                             ["Customer Billing Location is Domestic", ques2, setQues2],
//                             ["Customer Billing Location is International, (if any)", ques3, setQues3],
//                             ["Customer PO Issuance from International Location", ques4, setQues4],
//                             ["End User Location is Domestic", ques5, setQues5],
//                             ["End User Location is International, (if any)", ques6, setQues6],
//                             ["PO Issued in INR", ques7, setQues7],
//                             [`We Are Selling Following Product/Service :- (AI-Tool/CCTV Camera/ Drone / Surveillance Camera/Nvidia Graphic Card)`, ques8, setQues8],
//                             [`We Are Selling Following OEM's Product :- (Hikvision, Dhaua, Huawei, Kaspersky Or Any Chinese Camera Manufacturer)`, ques9, setQues9],
//                             ["Customer is Related To WMD (Weapons of Mass Destruction)/ Military/Defence/Nuclear/Aerospace", ques10, setQues10],
//                             [`Customer/End Customer is Fall Under Category:- State Govt./Central Govt./PSU`, ques12, setQues12],
//                             [`This deal is related to Tender`, ques13, setQues13],
//                             [`Is customer having Global (Out of India) Presence`, ques14, setQues14],
//                           ].map(([label, value, setter], index) => renderEXCompQuestions(index, label, value, setter, false, setExCompMessage, setExCompRemark) )}
//                         </tbody>
//                       </Table>
//                       <span style={{color: 'grey', fontSize:'16px'}}>
//                       <i className="fa-solid fa-star-of-life" style={{ color: '#e91717', fontSize: '10px', marginLeft: '1px' }} />
//                       Declaration: I hereby declare that the information I have provided regarding export control matters is true, 
//                       complete, and accurate to the best of my knowledge based on available documentation and customer confirmation
//                       </span>
//                       <span style={ExCompMessage ? {display: 'block',textAlign: 'center',fontWeight: 'bold',color: 'black',backgroundColor: 'yellow',borderRadius: '5px',
//                           padding: '8px',margin: '10px auto',width: 'fit-content'} : {}}>{ExCompMessage}</span>
      
//                       </Form>
//                     ) : (
//                       <>
//                         <p>Are you sure you want to proceed, After this point mail will be triggered! To Following Approvers:</p>
                  
//                         <Row>
//                           <Col xs={3}>
//                             <span data-row-name="Approvers-common">
//                               {appvTeamLeaderReq === 'YES' ? 'Team Leader' : ''} <br />
//                               {appvCreditInsuranceReq === 'YES' ? 'Credit Insurance' : ''} <br />
//                               {appvRegionBusinessHeadReq === 'YES' ? 'Region Business Head ' : ''} <br />
//                               {appvFunctionalHead4Req === 'YES' ? 'Functional Head - 4' : ''} <br />
//                               {appvlegalHeadReq === 'YES' ? 'Legal Head' : ''}
//                             </span>
//                           </Col>
//                           <Col xs={3}>
//                             <span data-row-name="Approvers-common">
//                               {appvBranchHeadReq === 'YES' ? 'Branch Head' : ''} <br />
//                               {appvFunctionalHeadReq === 'YES' ? 'Functional Head - 1' : ''} <br />
//                               {appvCFOReq === 'YES' ? 'CFO' : ''} <br />
//                               {appvFunctionalHead5Req === 'YES' ? 'Functional Head - 5' : ''} <br />
//                               {appvCEOReq === 'YES' ? 'CEO' : ''}
//                             </span>
//                           </Col>
//                           <Col xs={3}>
//                             <span data-row-name="Approvers-condition">
//                               {appvBusinessFinanceReq === 'YES' ? 'Business Finance' : ''}  <br />
//                               {appvFunctionalHead2Req === 'YES' ? 'Functional Head - 2' : ''} <br />
//                               {appvFunctionalHead6Req === 'YES' ? 'Functional Head - 6' : ''} <br />
//                               {appvCOOReq === 'YES' ? 'COO' : ''}

                              
//                             </span>
//                           </Col>
//                           <Col xs={3}>
//                             <span data-row-name="Approvers-condition">
//                               {appvExportComplianceReq === 'YES' ? 'Export Compliance' : ''}  <br />
//                               {appvFunctionalHead3Req === 'YES' ? 'Functional Head - 3' : ''} <br />
//                               {appvSVPDirectorReq === 'YES' ? 'SVP-Director' : ''}
//                             </span>
//                           </Col>
//                         </Row>
//                       </>
//                     )}
//                   </Modal.Body>
//                   <Modal.Footer>
//                     {step === 1 ? (
//                       <>
//                       {!showExCompRemark? (
//                         <Button variant="info" 
//                         onClick={handleExCompAppvRemark}>Check</Button>
//                       ) : (
//                         <Button variant="secondary" onClick={handleQuesNext}>Next</Button>
//                       )}
//                     </>
//                     ) : (
//                       <>
//                         <Button variant="primary" onClick={() => setStep(1)}>Back</Button>
//                         <Button variant="secondary" onClick={handleCloseModal}>Close</Button>
//                         <Button variant="success" onClick={handleApproval}>Confirm</Button>
//                       </>
//                     )}
//                   </Modal.Footer>
//                 </Modal>
      
//                 {/* Form Reopen Component */}
//                 <Modal show={showReopen} onHide={handleCloseReopenModal}>
//                   <Modal.Header closeButton>
//                     <Modal.Title>Reopen Preloading</Modal.Title>
//                   </Modal.Header>
//                   <Modal.Body>
//                     Are you sure you want to Re-Open this Preloading?
//                   </Modal.Body>
//                   <Modal.Footer>
//                     <Button variant="outline-secondary" onClick={handleCloseReopenModal}>
//                       Close
//                     </Button>
//                     <Button variant="outline-success" onClick={handleReopenPrelaoding}>
//                       Yes REOPEN !
//                     </Button>
//                   </Modal.Footer>
//                 </Modal>

//               </section>
              
//               {/* <Basic Form Details> */}
//               <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }}>
//                 {(status === 'Approved'|| status === 'PO Received') && (
//                   <div style={{
//                     position: 'absolute',
//                     top: '50%',
//                     left: '50%',
//                     transform: 'translate(-50%, -50%) rotate(-10deg) scale(0.1)',
//                     zIndex: 100,
//                     // pointerEvents: 'none' // optional: lets clicks pass through if needed
//                   }}>
//                     <img src={approvedStamp} alt="Centered" />
//                   </div>
//                 )}
//                 <Row className="mb-1" data-row-name="Document ID">
//                   <Col md="5" className="customformlabel"><Form.Label>Document ID</Form.Label></Col>
//                   <Col md="7">
//                     <Form.Control type="text" disabled readOnly value={series} />
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="CRM Number">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label>CRM Number<i className="fa-solid fa-star-of-life" style={{ color: "red", fontSize: "10px", paddingLeft: "2px" }}/></Form.Label>
//                   </Col>

//                   <Col md="7">
//                     {/* <Col md="7" className="searchable-select-container">
//                         <input type="text" placeholder="Select CRM Number" value={searchTerm} onFocus={() => setShowDropdown(true)} onBlur={() => setShowDropdown(false)}
//                         onChange={(e) => { if (!isReadOnly) { setSearchTerm(e.target.value); setShowDropdown(true); } }} readOnly={isReadOnly} className="searchable-select-input"
//                         />
//                         {showDropdown && !isReadOnly && (
//                         <div className="searchable-select-dropdown">
//                             {filteredCrmData.length > 0 ? (
//                             filteredCrmData.map(item => (
//                                 <div key={item.crmNumber} value={item.crmNumber} onMouseDown={() => handleSelectChange(item.crmNumber)} className="searchable-select-item">
//                                 {item.crmNumber}
//                                 </div>
//                             ))
//                             ) : (
//                             <div className="searchable-select-item disabled">No results found</div>
//                             )}
//                         </div>
//                         )} */}
//                     <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
//                       <div style={{ flex: 1 }}>
//                         <Select components={{ Input: CustomInput }} fieldName="CRM Number"  options={crmData.map((item) => ({label: item.crmNumber, value: item.crmNumber }))} 
//                           value={searchTerm ? { label: searchTerm, value: searchTerm } : null}
//                           isDisabled={isReadOnly} isSearchable placeholder="Select CRM Number" noOptionsMessage={() => "No results found"}
//                           filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
//                           onChange={(selected) => {setSearchTerm(selected?.value || ""); handleSelectChange(selected?.value || "");}}/>
//                       </div>

//                       <div style={{ position: "relative" }} onMouseEnter={() => setIsNoteVisible(true)} onMouseLeave={() => setIsNoteVisible(false)}>
//                         <i className="fa fa-info-circle" style={{ fontSize: "20px", cursor: "pointer" }} />
//                         {isNoteVisible && (
//                           <div style={{ position: "absolute", top: "120%", right: "0", backgroundColor: "white", border: "1px solid #ccc", padding: "10px", zIndex: 10, minWidth: "250px", boxShadow: "0 2px 5px rgba(0,0,0,0.2)" }} >
//                             CRM Number will be updated after every one hour.
//                           </div>
//                         )}
//                       </div>

//                     </div>
//                   </Col>
//                 </Row>            
//                 <Row className="mb-1" data-row-name="Customer Name">
//                   <Col md="5" className="customformlabel"><Form.Label>Customer Name</Form.Label></Col>
//                   <Col md="7"><Form.Control type="text" value={customerName} disabled={isReadOnly} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Sales Person Name">
//                   <Col md="5" className="customformlabel"><Form.Label>Sales Person Name</Form.Label></Col>
//                   <Col md="7"><Form.Control type="text" value={salesPersonName} disabled={isReadOnly} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Approval Request Date">
//                   <Col md="5" className="customformlabel"><Form.Label>Approval Request Date</Form.Label></Col>
//                   <Col md="7">
//                     <Form.Control value={approvalRequestDate} disabled={isReadOnly}  type="text" readOnly />
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Opportunity Name">
//                   <Col md="5" className="customformlabel"><Form.Label>Opportunity Name</Form.Label></Col>
//                   <Col md="7"><Form.Control type="text" value={opportunityName} disabled={isReadOnly} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="OEM">
//                   <Col md="5" className="customformlabel"><Form.Label>Opportunity Category(OEM)
//                     <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                   </Form.Label></Col>
//                   <Col md="7">
//                     {/* <Form.Select value={oem} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => setOem(e.target.value)} aria-label="OEM">
//                       <option value="" disabled>Select Opportunity Category(OEM)</option>
//                       <option value="Microsoft">Microsoft</option>
//                       <option value="Other than Microsoft">Other than Microsoft</option>
//                     </Form.Select> */}

//                     <Select components={{ Input: CustomInput }} fieldName="Opportunity Category(OEM)"  options={oemOptions} value={selectedOem} isDisabled={isReadOnly} isSearchable placeholder="Select Opportunity Category (OEM)"
//                     filterOption={(option, inputValue) => option.label.toLowerCase().includes(inputValue.toLowerCase())}
//                     onChange={(selected) => {
//                       setSelectedOem(selected);
//                       handleAutoSave({ fromButton: false, multioemvalues: selected.map(opt => opt.value)})
//                     }} 
//                       isMulti={true}
//                     />

//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Primary Transaction Currency">
//                     <Col md="5" className="customformlabel"><Form.Label>Primary Transaction Currency
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label></Col>
//                     <Col md="7">
//                       <Form.Select value={transactionCurrency} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={handleCurrencyChange} aria-label="TransactionCurrency">
//                         <option value="" disabled> Select Transaction Currency</option>
                        
//                         <option value="USD">USD</option>
//                         <option value="AED">AED</option>
//                         <option value="SGD">SGD</option>
//                         <option value="HKD">HKD</option>
//                         <option value="JPY">JPY</option>
//                         <option value="EUR">EUR</option>
//                         <option value="GBP">GBP</option>
//                         <option value="INR">INR</option>
//                       </Form.Select>
//                     </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Secondary Transaction Currency">
//                     <Col md="5" className="customformlabel"><Form.Label>Secondary Transaction Currency
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label></Col>
//                     <Col md="7">
//                       {/* <Form.Select value={secondaryTransactionCurrency} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={} aria-label="SecondaryTransactionCurrency">
//                         <option value="" disabled> Select Transaction Currency</option>
                        
//                         <option value="USD">USD</option>
//                         <option value="AED">AED</option>
//                         <option value="SGD">SGD</option>
//                         <option value="HKD">HKD</option>
//                         <option value="JPY">JPY</option>
//                         <option value="EUR">EUR</option>
//                         <option value="GBP">GBP</option>
//                         <option value="INR">INR</option>
//                       </Form.Select> */}

//                       <Form.Select
//                         value={secondaryTransactionCurrency}
//                         disabled={isReadOnly}
//                         onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
//                         onChange={handleSecondaryChange}
//                       >
//                         {secondaryOptions.map((curr) => (
//                           <option key={curr} value={curr}>
//                             {curr}
//                           </option>
//                         ))}
//                       </Form.Select>
//                     </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Expected date of Material Delivery">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label>Expected date of Delivery
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label>
//                   </Col>
//                   <Col md="7">
//                     {/* <Form.Control type="date" readOnly={isReadOnly} value={materialDeliveryDate} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
//                     onChange={(e) => setMaterialDeliveryDate(e.target.value)} aria-label="MaterialDeliveryDate" /> */}
//                     <Form.Control type="date" min={moment().format("YYYY-MM-DD")} disabled={isReadOnly} readOnly={isReadOnly} value={materialDeliveryDate} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
//                       onChange={(e) => setMaterialDeliveryDate(moment(e.target.value).format("YYYY-MM-DD"))} aria-label="MaterialDeliveryDate" />

//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Vendor Billing Cycle">
//                     <Col md="5" className="customformlabel"><Form.Label>Vendor Billing Cycle
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label></Col>
//                     <Col md="7">
//                       <Form.Select value={vendorBillingCycle} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => setvendorBillingCycle(e.target.value)} aria-label="Vendor Billing Cycle">
//                         <option value='' disabled> Select Vendor Billing Cycle</option>
//                         <option value="Same as Customer">Same as Customer</option>
//                         <option value="UpFront">UpFront</option>
//                         <option value="Deffered">Deffered</option>
//                       </Form.Select>
//                     </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Hitachi Role in this Deal">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label> Hitachi Role in this Deal
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label>
//                   </Col>
//                   <Col md="7">
//                     <Form.Control type="text" readOnly={isReadOnly} maxLength={300} value={hitachiRoleinthisDeal} disabled={isReadOnly} onPaste={(e) => handlePaste(e, 'Hitachi Role')} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
//                     onChange={(e) => sethitachiRoleinthisDeal(e.target.value)} aria-label="hitachiRoleinthisDeal" />
//                     {/* <div className="text-end text-muted small">{hitachiRoleinthisDeal.length}/300</div> */}
//                     <div className="text-end text-muted small">{hitachiRoleinthisDeal?.length != null ? `${hitachiRoleinthisDeal.length}/300` : '0/300'} </div>
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Rebate Amount if any">
//                   <Col md="5" className="customformlabel" style={{ display: 'flex', justifyContent: 'space-between' }}>
//                     <Form.Label> Rebate Amount if any</Form.Label>
//                     <Form>
//                       <div className="mb-3">
//                         <Form.Check inline label="YES" name="yesNo" type="radio" id="yes-radio" value="YES" checked={confirmRebate === "YES"} onChange={handleRebateChange}/>
//                         <Form.Check inline label="NO" name="yesNo" type="radio" id="no-radio" value="NO" checked={confirmRebate === "NO"} onChange={handleRebateChange}/>
//                       </div>
//                     </Form>
//                   </Col>

//                   <Col md="7">
//                     <InputGroup>
//                       <Form.Control type="text" value={fileName4} disabled={isReadOnly} aria-label="Upload Document-4" readOnly />
//                       <Form.Control type="file" onChange={(e) => handleSelectFile4(e)} style={{ display: 'none' }} id="file-input-4"/>
//                       <Button variant="outline-primary" id="file-del-4" onClick={() => document.getElementById('file-input-4').click()} disabled={isReadOnly || confirmRebate === "NO" || confirmRebate == null}><MDBIcon fas icon="file-upload" size="lg" /></Button>
//                       <Button variant="outline-danger" onClick={handleRemoveFile4} disabled={!fileName4 || isReadOnly || confirmRebate === "NO" || confirmRebate == null}><MDBIcon fas icon="trash" /></Button>
//                       <Button variant="outline-success" onClick={handleViewFile4}><MDBIcon fas icon="file-download" /></Button>
//                     </InputGroup>
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Conversion Rate">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label>Conversion Rate</Form.Label>
//                   </Col>

//                   <Col md="7">
//                     {(transactionCurrency === "USD" || transactionCurrency === "AED" || transactionCurrency === "SGD" || 
//                     transactionCurrency === "HKD" || transactionCurrency === "JPY" || transactionCurrency === "EUR" || transactionCurrency === "GBP") ? (

//                       <div style={{ display: "flex", width: "100%" }}>
//                         <div style={{ flex: 1, textAlign: "center" }}>
//                           <Form.Label>Year 1</Form.Label><br />
//                           <Form.Label>{conversionRateyear1}</Form.Label>
//                         </div>
//                         <div style={{ flex: 1, textAlign: "center" }}>
//                           <Form.Label>Year 2</Form.Label><br />
//                           <Form.Label>{conversionRateyear2}</Form.Label>
//                         </div>
//                         <div style={{ flex: 1, textAlign: "center" }}>
//                           <Form.Label>Year 3</Form.Label><br />
//                           <Form.Label>{conversionRateyear3}</Form.Label>
//                         </div>
//                         <div style={{ flex: 1, textAlign: "center" }}>
//                           <Form.Label>Year 4</Form.Label><br />
//                           <Form.Label>{conversionRateyear4}</Form.Label>
//                         </div>
//                         <div style={{ flex: 1, textAlign: "center" }}>
//                           <Form.Label>Year 5</Form.Label><br />
//                           <Form.Label>{conversionRateyear5}</Form.Label>
//                         </div>
//                         <div style={{ flex: 1, textAlign: "center" }}>
//                           <Form.Label>Year 6</Form.Label><br />
//                           <Form.Label>{conversionRateyear6}</Form.Label>
//                         </div>
//                         <div style={{ flex: 1, textAlign: "center" }}>
//                           <Form.Label>Year 7</Form.Label><br />
//                           <Form.Label>{conversionRateyear7}</Form.Label>
//                         </div>
//                       </div>

//                     ) : (
//                       <Form.Control
//                         type="text" readOnly value={conversionRate} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })}
//                         onChange={(e) => setconversionRate(e.target.value)} aria-label="conversionRate" />
//                     )}
//                   </Col>
//                 </Row>
//               </section>
              
//               {/* <Financial Table & Doc Upload> */}
//               <section style={{ position: 'relative', border: '2px solid #ccc', paddingLeft: '15px', paddingRight: '15px'}}>
//                   <div className="p-2">
//                     {/* <div className="mt-1 mb-1 d-flex justify-content-end">
//                       <Button variant="outline-success" className="m-1" onClick={handleSaveFinancialTable}><MDBIcon fas icon="floppy-disk" size='lg' /></Button>
//                     </div> */}
//                     <style>
//                       {`
//                         @keyframes blinkBorder {
//                           0%   { box-shadow: 0 0 0 3px red; }
//                           50%  { box-shadow: 0 0 0 3px transparent; }
//                           100% { box-shadow: 0 0 0 3px red; }
//                         }

//                         .blink-border {
//                           animation: blinkBorder 1s infinite;
//                         }
//                       `}
//                     </style>
//                       <Table bordered hover size="sm" className="text-center align-middle" style={{ fontSize: "0.85rem" }}>
//                         <thead>
//                           <tr>
//                             <th>Currency</th>
//                             <th>Particulars</th>
//                             {columnNames.map((col, i) => (<th key={i}>{col}</th>))}
//                             <th>Action</th>
//                           </tr>
//                         </thead>
                      
//                         <tbody>
//                           {rows.map((row) => (
//                             <tr key={row.id}>
//                               <td>
//                                 {row.name === "Total" ? (<strong style={{ fontSize: "0.9rem" }}>INR</strong>) : (
//                                   <Form.Select value={row?.currency} disabled={isReadOnly} onChange={(e) => handleRowCurrencyChange(row.id, e.target.value)} 
//                                   aria-label="Row Currency" style={{ fontSize: "0.8rem" }}>
//                                     {renderCurrencyOptions()}
//                                   </Form.Select>
//                                 )}
//                               </td>

//                               <td><strong>{row.name}</strong></td>

//                               {row.name === "Total"
//                                 ? [
//                                     ...totalValues.map((t, i) => (
//                                       <td key={i}>
//                                         <strong>
//                                           {i === totalValues.length - 1
//                                             ? `${t}%`
//                                             : new Intl.NumberFormat('en-IN').format(t)}
//                                         </strong>
//                                       </td>
//                                     )),
//                                     <td className={dirtyFCTable ? "blink-border" : ""} style={{backgroundColor: dirtyFCTable ? "#ffcccc" : "transparent"}} key="action">
//                                       <Button variant="success" disabled={isReadOnly} size="sm" onClick={() => handleSaveFinancialTable()}>
//                                         Save
//                                       </Button>
//                                     </td>,
//                                   ]
//                                 : row.values.map((val, i) => (
//                                     <td key={i}>
//                                       <input
//                                         type="text"
//                                         value={editingCell?.rowId === row.id && editingCell?.colIndex === i
//                                             ? editingValue 
//                                             : i === totalValues.length - 1
//                                               ? `${val.amount} %`
//                                               : new Intl.NumberFormat('en-IN').format(val.amount)
//                                         }
//                                         disabled={isReadOnly}
//                                         onChange={(e) => {
//                                           const value = e.target.value.replace(/,/g, "");
//                                           if (/^\d*$/.test(value)) {
//                                             setEditingValue(value);
//                                           }
//                                         }}
//                                         onFocus={() => {
//                                           setEditingCell({ rowId: row.id, colIndex: i });
//                                           setEditingValue(String(val.amount));
//                                         }}
//                                         onBlur={() => {
//                                           handleValueChange(row.id, i, editingValue);
//                                           setEditingCell(null);
//                                           setEditingValue("");
//                                         }}
//                                         style={{ width: "100%", fontSize: "0.8rem" }}
//                                       />
//                                     </td>
//                                 ))
//                               }

//                               {!["Year 1", "Year 2", "Year 3", "Total"].includes(row.name) && (
//                                 <td>
//                                   <Button variant="danger" disabled={isReadOnly} size="sm" onClick={() => removeRow(row.id)}>
//                                     Delete
//                                   </Button>
//                                 </td>
//                               )}

//                             </tr>
//                           ))}
//                         </tbody>
//                       </Table>

//                       {/* Add Row Buttons */}
//                       <div className="mt-3">
//                         {extraRowNames.map((name, i) => (<Button key={i} size="sm" className="m-1" onClick={() => addRow(name)} disabled={isReadOnly || rows.some((row) => row.name === name)}> {name} </Button>))}
//                       </div>
                      
//                   </div>
//                   {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && (
//                   <Row className="mt-1 mb-1" data-row-name="Upload Document-5 [ Upload Business Finance Doc ]">
//                         <Col md="5" className="customformlabel"><Form.Label>Upload Business Finance Doc
//                           {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName5} disabled={isReadOnly} aria-label="Upload Document-5" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile5(e)} style={{ display: 'none' }} id="file-input-5" />
//                             <Button variant="outline-primary" id="file-del-5" onClick={() => { document.getElementById('file-input-5').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile5} disabled={!fileName5 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile5}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                   </Row>
//                   )}
//                   {(sessionStorage.getItem('role') === 'EXPORT COMPLIANCE' || sessionStorage.getItem('role') === 'ADMIN') && (
//                       <Row className="mb-1" data-row-name="Upload Document-6 [ Upload Ex-Comp Doc ]">
//                         <Col md="5" className="customformlabel"><Form.Label> Upload Ex-Comp Doc
//                           <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName6} disabled={isReadOnly} aria-label="Upload Document-4" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile6(e)} style={{ display: 'none' }} id="file-input-6" />
//                             <Button variant="outline-primary" id="file-del-6" onClick={() => document.getElementById('file-input-6').click()}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile6} disabled={!fileName6}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile6}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                       </Row>
//                       )}
//               </section> 
              
//               {/* <Payment Terms & Expected Dates> */}
//               <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }}>
//                 <Row className="mb-1" data-row-name="Vendor Payment Terms">
//                   <Col md="5" className="d-flex align-items-center justify-content-between customformlabel">
//                     <Form.Label className="mb-0"> Vendor Payment Terms
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label>

//                     <Button variant="primary" size="sm" type="button" onClick={() => {setIsVendorPaymentTermModalOpen(true)}}>
//                       Payment Terms <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Button>
//                   </Col>

//                   <Col md="7" className="d-flex align-items-center justify-content-between">
//                     <Form.Control type="text" disabled={isReadOnly} readOnly={true} value={vendorPaymentTerms} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
//                     onChange={(e) => setvendorPaymentTerms(e.target.value)} aria-label="vendorPaymentTerms" />

//                     {/* <Button variant="warning" size="sm" className="mb-2" onClick={recalculateAllVendorPaymentTermValues}>
//                       <i className="fa-solid fa-rotate"></i> Recal
//                     </Button> */}
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Customer Payment Terms">
//                   <Col md="5" className=" d-flex align-items-center justify-content-between customformlabel">
//                     <Form.Label> Customer Payment Terms
//                     <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label>
                    
//                     <Button variant="primary" size="sm" type="button" onClick={() => setIsCustomerPaymentTermModalOpen(true)} >
//                       Payment Terms <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Button>
//                   </Col>
//                   <Col md="7" className="d-flex align-items-center justify-content-between">
//                     <Form.Control type="text" disabled={isReadOnly} readOnly={true} value={customerPaymentTerms} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
//                     onChange={(e) => setcustomerPaymentTerms(e.target.value)} aria-label="customerPaymentTerms" />

//                     {/* <Button variant="warning" size="sm" className="mb-2" onClick={recalculateAllCustomerPaymentTermValues}>
//                       <i className="fa-solid fa-rotate"></i> Recal
//                     </Button> */}
//                   </Col>
//                 </Row>
//                 {showMarginRemarksRow == true && (
//                   <Row className="mb-1" data-row-name="Reason if its Margin goes less than 6%">
//                     <Col md="5" className="customformlabel">
//                       <Form.Label> Reason if its Margin goes less than 6%</Form.Label>
//                     </Col>
//                     <Col md="7">
//                       <Form.Control type="text" disabled={isReadOnly} readOnly={isReadOnly} maxLength={300} value={lowMarginReason} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
//                       onChange={(e) => setLowMarginReason(e.target.value)} aria-label="LowMarginReason" />
//                       <div className="text-end text-muted small">{lowMarginReason.length}/300</div>
//                     </Col>
//                 </Row>
//                 )}

//                 {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && totalSellingValue > 5000000 && (
//                   <Row className="mb-1" data-row-name="Deal Type">
//                       <Col md="5" className="customformlabel"><Form.Label>Select Deal Type
//                         <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                       <Col md="7">
//                         <Form.Select value={dealType} disabled={isReadOnly} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => setDealType(e.target.value)} aria-label="Deal Type">
//                           <option value='' disabled> Select Deal type</option>
//                           <option value="Gross">Gross</option>      
//                           <option value="Net-off">Net-off</option>
//                         </Form.Select>
//                       </Col>
//                   </Row>
//                 )}
//                 <Row className="mb-1" data-row-name="Remarks if any">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label> Remarks if any</Form.Label>
//                   </Col>
//                   <Col md="7">
//                     <Form.Control type="text" disabled={isReadOnly} readOnly={isReadOnly} maxLength={300} value={remarksIfAny} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
//                     onChange={(e) => {setremarksIfAny(e.target.value);}}aria-label="remarksIfAny" />
//                     <div className="text-end text-muted small">{remarksIfAny.length}/300</div>
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Expected date of Customer Recipt">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label> Expected date of Customer Recipt</Form.Label>
//                   </Col>
//                   <Col md="7">
//                     <Form.Control type="date" value={expectedDtCustomerRecipt} disabled={isReadOnly} readOnly={true} onFocus={(e) => e.target.blur()} onKeyDown={(e) => e.preventDefault()}
//                       onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} aria-label="expectedDtCustomerRecipt"/>
//                     {/* <Form.Control type="date" readOnly={isReadOnly} value={expectedDtCustomerRecipt} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
//                     onChange={(e) => setexpectedDtCustomerRecipt(e.target.value)} aria-label="expectedDtCustomerRecipt" /> */}
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Expected date of Vendor Payment">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label> Expected date of Vendor Payment</Form.Label>
//                   </Col>
//                   <Col md="7">
//                   <Form.Control type="date" disabled={isReadOnly} readOnly={true} value={expectedDtVendorPayment} onFocus={(e) => e.target.blur()} onKeyDown={(e) => e.preventDefault()} 
//                     onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} onChange={(e) => {}} aria-label="expectedDtVendorPayment" />
//                     {/* <Form.Control type="date" readOnly={isReadOnly} value={expectedDtVendorPayment} onBlur={(e) => handleAutoSave({ event: e, fromButton: false })} 
//                     onChange={(e) => setexpectedDtVendorPayment(e.target.value)} aria-label="expectedDtVendorPayment" /> */}
//                   </Col>
//                 </Row>
                
//               </section>

//               {/* <Expert Advices> */}
//               <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }}>
//                 <Row className="mb-1" data-row-name="Expert advice from Company's Cashflow Prospective">
//                   <Col md="5" className="customformlabel"><Form.Label>Expert advice from Company's Cashflow Prospective</Form.Label></Col>
//                   <Col md="7">
//                     <Form.Control as="textarea" type="text" row={2} disabled={isReadOnly} readOnly value={cashFlowExpertAdvice}
//                       onChange={(e) => setcashFlowExpertAdvice(e.target.value)}
//                       className={ cashFlowExpertAdvice === "It's favourable to Hitachi" ? 'cashFlowExpertAdvicefavourable'
//                           : cashFlowExpertAdvice === "It's become FC Impacted deal" ? 'cashFlowExpertAdviceimpacted'
//                             : cashFlowExpertAdvice === "" ? 'cashFlowExpertAdvicedefault' : null
//                       }/>
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="Expert advice from Company's Margin Prospective">
//                   <Col md="5" className="customformlabel"><Form.Label>Expert advice from Company's Margin Prospective</Form.Label></Col>
//                   <Col md="7">
//                     <Form.Control as="textarea" type="text" rows={2} disabled={isReadOnly} readOnly value={marginExpertAdvice} 
//                       onChange={(e) => setmarginExpertAdvice(e.target.value)}
//                       className={ marginExpertAdvice === "Margin Above the Threshold" ? 'cashFlowExpertAdvicefavourable'
//                           : marginExpertAdvice === "Margin Below the Threshold" ? 'cashFlowExpertAdviceimpacted'
//                             : marginExpertAdvice === "" ? 'cashFlowExpertAdvicedefault' : null
//                       } />
//                   </Col>
//                 </Row>
//               </section>

//               {/* <Select Functional Heads> */}
//               <section style={{ position: 'relative', border: '2px solid #ccc', padding: '15px', paddingRight: '4px' }}>
//                 <Row className="mb-1" data-row-name="FunctionalHead-1">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label>Functional Head - 1</Form.Label>
//                   </Col>

//                   <Col md="7">
//                     <Select components={{ Input: CustomInput }} fieldName="Functional Head -1" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
//                       options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
//                       value={functionalHead1ID ? { label: functionalHead1Name, value: functionalHead1ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -1" noOptionsMessage={() => "No results found"}
//                       filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
//                       onChange={(selected) => {setFunctionalHead1ID(selected?.value || ""); setFunctionalHead1Name(selected?.empName || "");}}/>
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="FunctionalHead-2">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label>Functional Head - 2</Form.Label>
//                   </Col>
//                   <Col md="7">
//                     <Select components={{ Input: CustomInput }} fieldName="Functional Head -2" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
//                       options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
//                       value={functionalHead2ID ? { label: functionalHead2Name, value: functionalHead2ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -2" noOptionsMessage={() => "No results found"}
//                       filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
//                       onChange={(selected) => {setFunctionalHead2ID(selected?.value || ""); setFunctionalHead2Name(selected?.empName || "");}}/>
//                   </Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="FunctionalHead-3">
//                   <Col md="5" className="customformlabel">
//                     <Form.Label>Functional Head - 3</Form.Label>
//                   </Col>

//                   <Col md="7">
//                     <Select components={{ Input: CustomInput }} fieldName="Functional Head -3" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
//                       options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
//                       value={functionalHead3ID ? { label: functionalHead3Name, value: functionalHead3ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -3" noOptionsMessage={() => "No results found"}
//                       filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
//                       onChange={(selected) => {setFunctionalHead3ID(selected?.value || ""); setFunctionalHead3Name(selected?.empName || "");}}/>
//                   </Col>
//                 </Row> 
//                 {(sessionStorage.getItem('role') === 'BUSINESS FINANCE' || sessionStorage.getItem('role') === 'ADMIN') && (
//                   <>
//                     <Row className="mb-1" data-row-name="FunctionalHead-4">
//                     <Col md="5" className="customformlabel">
//                       <Form.Label>Functional Head - 4</Form.Label>
//                     </Col>

//                     <Col md="7">
//                       <Select components={{ Input: CustomInput }} fieldName="Functional Head -4" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
//                         options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
//                         value={functionalHead4ID ? { label: functionalHead4Name, value: functionalHead4ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -4" noOptionsMessage={() => "No results found"}
//                         filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
//                         onChange={(selected) => {setFunctionalHead4ID(selected?.value || ""); setFunctionalHead4Name(selected?.empName || "");}}/>
//                     </Col>
//                     </Row>
//                     <Row className="mb-1" data-row-name="FunctionalHead-5">
//                       <Col md="5" className="customformlabel">
//                         <Form.Label>Functional Head - 5</Form.Label>
//                       </Col>

//                       <Col md="7">
//                         <Select components={{ Input: CustomInput }} fieldName="Functional Head -5" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
//                           options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
//                           value={functionalHead5ID ? { label: functionalHead5Name, value: functionalHead5ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -5" noOptionsMessage={() => "No results found"}
//                           filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
//                           onChange={(selected) => {setFunctionalHead5ID(selected?.value || ""); setFunctionalHead5Name(selected?.empName || "");}}/>
//                       </Col>
//                     </Row>
//                     <Row className="mb-1" data-row-name="FunctionalHead-6">
//                       <Col md="5" className="customformlabel">
//                         <Form.Label>Functional Head - 6</Form.Label>
//                       </Col>

//                       <Col md="7">
//                         <Select components={{ Input: CustomInput }} fieldName="Functional Head -6" styles={{ menu: (provided) => ({ ...provided, zIndex: 9999 }), menuPortal: (provided) => ({ ...provided, zIndex: 9999 })}} menuPortalTarget={document.body}
//                           options={[{ label: "Not Applicable", value: "NA", empName: "NA", empEmail: "NA" }, ...allFunctionalHeadList.map((item) => ({label: `${item.empName} - ${item.empEmail}`, value: item.empId, empName: item.empName, empEmail: item.empEmail,})),]}
//                           value={functionalHead6ID ? { label: functionalHead6Name, value: functionalHead6ID } : null} isDisabled={isReadOnly} isSearchable placeholder="Select Functional Head -6" noOptionsMessage={() => "No results found"}
//                           filterOption={(option, inputValue) => {const query = inputValue.toLowerCase(); return (option.data.empName.toLowerCase().includes(query) || option.data.empEmail.toLowerCase().includes(query));}}
//                           onChange={(selected) => {setFunctionalHead6ID(selected?.value || ""); setFunctionalHead6Name(selected?.empName || "");}}/>
//                       </Col>
//                     </Row>
//                   </>
//                 )}
//               </section>

//               {/* <Attachments - File Management> */}
//               <section style={{ position: 'relative', border: '2px solid #ccc', paddingLeft: '15px', paddingRight: '15px', marginBottom: '25px' }}>
                    
//                       <Row className="mt-2 mb-1" data-row-name="Upload Document-1 [ Customer accepted proposal copy ]">
//                         <Col md="5" className="customformlabel"><Form.Label> Customer Proposal
//                           <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName1} disabled={isReadOnly} aria-label="Upload Document-1" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile1(e)} style={{ display: 'none' }} id="file-input-1" />
//                             <Button variant="outline-primary" id="file-del-1" onClick={() => { document.getElementById('file-input-1').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile1} disabled={!fileName1 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile1}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                       </Row>
//                       <Row className="mb-1" data-row-name="Upload Document-2 [ Vendor TP Doc ]">
//                         <Col md="5" className="customformlabel"><Form.Label> Vendor TP with their payment terms and delivery timeline of that product
//                           <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName2} disabled={isReadOnly} aria-label="Upload Document-2" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile2(e)} style={{ display: 'none' }} id="file-input-2" />
//                             <Button variant="outline-primary" id="file-del-2" onClick={() => document.getElementById('file-input-2').click()} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile2} disabled={!fileName2 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile2}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                       </Row>
//                       <Row className="mb-1" data-row-name="Upload Document-3 [ Purchase Order ]">
//                         <Col md="5" className="customformlabel"><Form.Label> Purchase Order
//                           {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName3} disabled={isReadOnly} aria-label="Upload Document-3" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile3(e)} style={{ display: 'none' }} id="file-input-3" />
//                             <Button variant="outline-primary" id="file-del-3" onClick={() => document.getElementById('file-input-3').click()} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile3} disabled={!fileName3 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile3}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                       </Row>
//                       <Row className="mt-2 mb-1" data-row-name="Upload Document-7 [Additional Document-1 ] ">
//                         <Col md="5" className="customformlabel"><Form.Label> Additional Document-1
//                           {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName7} disabled={isReadOnly} aria-label="Upload Document-7" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile7(e)} style={{ display: 'none' }} id="file-input-7" />
//                             <Button variant="outline-primary" id="file-del-7" onClick={() => { document.getElementById('file-input-7').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile7} disabled={!fileName7 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile7}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                       </Row>
//                       <Row className="mt-2 mb-1" data-row-name="Upload Document-8 [Additional Document-2 ] ">
//                         <Col md="5" className="customformlabel"><Form.Label> Additional Document-2
//                           {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName8} disabled={isReadOnly} aria-label="Upload Document-8" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile8(e)} style={{ display: 'none' }} id="file-input-8" />
//                             <Button variant="outline-primary" id="file-del-7" onClick={() => { document.getElementById('file-input-8').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile8} disabled={!fileName8 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile8}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                       </Row>
//                       <Row className="mt-2 mb-1" data-row-name="Upload Document-9 [Additional Document-3 ] ">
//                         <Col md="5" className="customformlabel"><Form.Label> Additional Document-3
//                           {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName9} disabled={isReadOnly} aria-label="Upload Document-9" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile9(e)} style={{ display: 'none' }} id="file-input-9" />
//                             <Button variant="outline-primary" id="file-del-9" onClick={() => { document.getElementById('file-input-9').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile9} disabled={!fileName9 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile9}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                       </Row>
//                       <Row className="mt-2 mb-1" data-row-name="Upload Document-10 [Additional Document-4 ] ">
//                         <Col md="5" className="customformlabel"><Form.Label> Additional Document-4
//                           {/* <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} /> */}
//                         </Form.Label></Col>
//                         <Col md="7">
//                           <InputGroup>
//                             <Form.Control type="text" value={fileName10} disabled={isReadOnly} aria-label="Upload Document-10" readOnly />
//                             <Form.Control type="file" onChange={(e) => handleSelectFile10(e)} style={{ display: 'none' }} id="file-input-10" />
//                             <Button variant="outline-primary" id="file-del-10" onClick={() => { document.getElementById('file-input-10').click(); }} disabled={isReadOnly}><MDBIcon fas icon="file-upload" size='lg' /></Button>
//                             <Button variant="outline-danger" onClick={handleRemoveFile10} disabled={!fileName10 || isReadOnly}><MDBIcon fas icon="trash" /></Button>
//                             <Button variant="outline-success" onClick={handleViewFile10}><MDBIcon fas icon="file-download" /></Button>
//                           </InputGroup>
//                         </Col>
//                       </Row>
                      
//               </section>

//               {( sendForAppv == true && (
//                 <section style={{ border: '2px solid #ccc', padding: '15px', paddingRight: '4px', marginBottom: '20px' }}>
//                 <Row className="mb-1" data-row-name="ExCompQues1">
//                     <Col md="5" className="customformlabel"><Form.Label>End User & Billing Customer Name is Same
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques1} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues2">
//                     <Col md="5" className="customformlabel"><Form.Label>Customer Billing Location is Domestic
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques2} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues3">
//                     <Col md="5" className="customformlabel"><Form.Label>Customer Billing Location is International,(if any)
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques3} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQue4s">
//                     <Col md="5" className="customformlabel"><Form.Label>Customer PO Issuance from International Location
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques4} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues5">
//                     <Col md="5" className="customformlabel"><Form.Label>End User Location is Domestic
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques5} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues6">
//                     <Col md="5" className="customformlabel"><Form.Label>End User Location is International, (if any)
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques6} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues7">
//                     <Col md="5" className="customformlabel"><Form.Label>PO Issued in INR
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques7} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues8">
//                     <Col md="5" className="customformlabel"><Form.Label>We Are Selling Following Product/Service :- 
//                       (AI-Tool/CCTV Camera/ Drone / Surveillance Camera/Nvidia Graphic Card)
//                     <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques8} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues9">
//                     <Col md="5" className="customformlabel"><Form.Label>We Are Selling Following OEM's Product :-
//                       (Hikvision, Dhaua, Huawei, Kaspersky Or Any Chinese Camera Manufacturer)
//                     <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                     </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques9} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues10">
//                     <Col md="5" className="customformlabel"><Form.Label>Customer is Related To WMD (Weapons of Mass Destruction)/ Military/Defence/Nuclear/Aerospace
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques10} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues12">
//                     <Col md="5" className="customformlabel"><Form.Label>Customer/End Customer is Fall Under Category:- State Govt./Central Govt./PSU
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques12} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues13">
//                     <Col md="5" className="customformlabel"><Form.Label>This deal is related to Tender
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques13} readOnly /></Col>
//                 </Row>
//                 <Row className="mb-1" data-row-name="ExCompQues14">
//                     <Col md="5" className="customformlabel"><Form.Label>Is customer having Global (Out of India) Presence
//                       <i className="fa-solid fa-star-of-life" style={{ color: 'red', fontSize: '10px', paddingLeft: '2px' }} />
//                       </Form.Label></Col>
//                     <Col md="7"><Form.Control type="text" value={ques14} readOnly /></Col>
//                 </Row>
//                 </section>
//                 ))}
//         </Form>
//         </Container>

//         <div style={{width: "24%", position: "fixed", right: 0, top: 52, height: "84vh", zIndex: 100, display: "flex", 
//           justifyContent: "center", alignItems: "center", textAlign: "center"}}>
//           {/* backgroundColor: "#8be2ec" */}
//           {/* <Row className="mb-4" data-row-name="logo & crmbutton" style={{ justifyContent: "center", 
//             border: "1px solid black" ,alignItems: "center", width: "100%" }} >
//             <Col md="auto"><h1>Costsheet</h1></Col>
//             <Col md="auto"><h1>Enterprise</h1></Col>
//             <Col md="auto"><h1>Form</h1></Col>
//             <Col md="auto"><h1>Empty</h1></Col>
//             <Col md="auto"><h1>Space</h1></Col>
//             <Col md="auto"><h1>For</h1></Col>
//             <Col md="auto"><h1>AI</h1></Col>
//           </Row> */}
//         </div>
//       </div>
//         </>
//   );
// };

// export default CostSheetEntForm;
